// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"fwA1h":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _vue = require("vue");
var _chartAppVue = require("./components/ChartApp.vue");
var _chartAppVueDefault = parcelHelpers.interopDefault(_chartAppVue);
const charts = document.querySelectorAll(".js-chart-app");
Array.prototype.forEach.call(charts, (el)=>{
    //gather props from data-attributes
    const loadingSlot = el.querySelector("[data-vue-slot='loading']");
    const permalink = JSON.parse(el.dataset.permalink);
    const title = JSON.parse(el.dataset.title);
    const subtitle = JSON.parse(el.dataset.subtitle);
    const slug = JSON.parse(el.dataset.slug);
    const jsonUrl = JSON.parse(el.dataset.jsonUrl);
    const data = JSON.parse(el.dataset.data);
    const buttonTitles = JSON.parse(el.dataset.buttonTitles);
    const chartMargin = JSON.parse(el.dataset.chartMargin);
    const showLegend = JSON.parse(el.dataset.showLegend);
    const legendId = JSON.parse(el.dataset.legendId);
    const downloads = JSON.parse(el.dataset.downloads);
    const app = (0, _vue.createApp)({
        components: {
            ChartApp: (0, _chartAppVueDefault.default)
        },
        render: function() {
            return (0, _vue.h)("article", {
                class: el.classList.value,
                ref: "chartApp"
            }, [
                (0, _vue.h)((0, _chartAppVueDefault.default), {
                    permalink: permalink,
                    title: title,
                    subtitle: subtitle,
                    slug: slug,
                    jsonUrl: jsonUrl,
                    data: data,
                    buttonTitles: buttonTitles,
                    chartMargin: chartMargin,
                    showLegend: showLegend,
                    legendId: legendId,
                    downloads: downloads
                }, {
                    loading: ()=>(0, _vue.h)(loadingSlot.tagName, {
                            class: Array.from(loadingSlot.classList),
                            innerHTML: loadingSlot.innerHTML
                        })
                })
            ]);
        }
    });
    app.mount(el);
});

},{"vue":"2IF1a","./components/ChartApp.vue":"64lpT","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2IF1a":[function(require,module,exports) {
/**
* vue v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compile", ()=>compile);
var _runtimeDom = require("@vue/runtime-dom");
parcelHelpers.exportAll(_runtimeDom, exports);
function initDev() {
    (0, _runtimeDom.initCustomFormatter)();
}
const compile = ()=>{};

},{"@vue/runtime-dom":"lgHax","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lgHax":[function(require,module,exports) {
/**
* @vue/runtime-dom v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transition", ()=>Transition);
parcelHelpers.export(exports, "TransitionGroup", ()=>TransitionGroup);
parcelHelpers.export(exports, "VueElement", ()=>VueElement);
parcelHelpers.export(exports, "createApp", ()=>createApp);
parcelHelpers.export(exports, "createSSRApp", ()=>createSSRApp);
parcelHelpers.export(exports, "defineCustomElement", ()=>defineCustomElement);
parcelHelpers.export(exports, "defineSSRCustomElement", ()=>defineSSRCustomElement);
parcelHelpers.export(exports, "hydrate", ()=>hydrate);
parcelHelpers.export(exports, "initDirectivesForSSR", ()=>initDirectivesForSSR);
parcelHelpers.export(exports, "render", ()=>render);
parcelHelpers.export(exports, "useCssModule", ()=>useCssModule);
parcelHelpers.export(exports, "useCssVars", ()=>useCssVars);
parcelHelpers.export(exports, "useHost", ()=>useHost);
parcelHelpers.export(exports, "useShadowRoot", ()=>useShadowRoot);
parcelHelpers.export(exports, "vModelCheckbox", ()=>vModelCheckbox);
parcelHelpers.export(exports, "vModelDynamic", ()=>vModelDynamic);
parcelHelpers.export(exports, "vModelRadio", ()=>vModelRadio);
parcelHelpers.export(exports, "vModelSelect", ()=>vModelSelect);
parcelHelpers.export(exports, "vModelText", ()=>vModelText);
parcelHelpers.export(exports, "vShow", ()=>vShow);
parcelHelpers.export(exports, "withKeys", ()=>withKeys);
parcelHelpers.export(exports, "withModifiers", ()=>withModifiers);
var _runtimeCore = require("@vue/runtime-core");
parcelHelpers.exportAll(_runtimeCore, exports);
var _shared = require("@vue/shared");
let policy = void 0;
const tt = typeof window !== "undefined" && window.trustedTypes;
if (tt) try {
    policy = /* @__PURE__ */ tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const unsafeToTrustedHTML = policy ? (val)=>policy.createHTML(val) : (val)=>val;
const svgNS = "http://www.w3.org/2000/svg";
const mathmlNS = "http://www.w3.org/1998/Math/MathML";
const doc = typeof document !== "undefined" ? document : null;
const templateContainer = doc && /* @__PURE__ */ doc.createElement("template");
const nodeOps = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? doc.createElementNS(svgNS, tag) : namespace === "mathml" ? doc.createElementNS(mathmlNS, tag) : is ? doc.createElement(tag, {
            is
        }) : doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>doc.createTextNode(text),
    createComment: (text)=>doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            templateContainer.innerHTML = unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const TRANSITION = "transition";
const ANIMATION = "animation";
const vtcKey = Symbol("_vtc");
const DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const TransitionPropsValidators = /* @__PURE__ */ (0, _shared.extend)({}, (0, _runtimeCore.BaseTransitionPropsValidators), DOMTransitionPropsValidators);
const decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = TransitionPropsValidators;
    return t;
};
const Transition = /* @__PURE__ */ decorate$1((props, { slots })=>(0, _runtimeCore.h)((0, _runtimeCore.BaseTransition), resolveTransitionProps(props), slots));
const callHook = (hook, args = [])=>{
    if ((0, _shared.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const hasExplicitCallback = (hook)=>{
    return hook ? (0, _shared.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name = "v", type, duration, enterFromClass = `${name}-enter-from`, enterActiveClass = `${name}-enter-active`, enterToClass = `${name}-enter-to`, appearFromClass = enterFromClass, appearActiveClass = enterActiveClass, appearToClass = enterToClass, leaveFromClass = `${name}-leave-from`, leaveActiveClass = `${name}-leave-active`, leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter, onEnter, onEnterCancelled, onLeave, onLeaveCancelled, onBeforeAppear = onBeforeEnter, onAppear = onEnter, onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done)=>{
        removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        removeTransitionClass(el, leaveFromClass);
        removeTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            callHook(hook, [
                el,
                resolve
            ]);
            nextFrame(()=>{
                removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!hasExplicitCallback(hook)) whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, _shared.extend)(baseProps, {
        onBeforeEnter (el) {
            callHook(onBeforeEnter, [
                el
            ]);
            addTransitionClass(el, enterFromClass);
            addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            callHook(onBeforeAppear, [
                el
            ]);
            addTransitionClass(el, appearFromClass);
            addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            addTransitionClass(el, leaveFromClass);
            addTransitionClass(el, leaveActiveClass);
            forceReflow();
            nextFrame(()=>{
                if (!el._isLeaving) return;
                removeTransitionClass(el, leaveFromClass);
                addTransitionClass(el, leaveToClass);
                if (!hasExplicitCallback(onLeave)) whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false);
            callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true);
            callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, _shared.isObject)(duration)) return [
        NumberOf(duration.enter),
        NumberOf(duration.leave)
    ];
    else {
        const n = NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function NumberOf(val) {
    const res = (0, _shared.toNumber)(val);
    return res;
}
function addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[vtcKey] || (el[vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[vtcKey] = void 0;
    }
}
function nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let endId = 0;
function whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type, timeout, propCount } = getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${TRANSITION}Duration`);
    const transitionTimeout = getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${ANIMATION}Duration`);
    const animationTimeout = getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === TRANSITION) {
        if (transitionTimeout > 0) {
            type = TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === ANIMATION) {
        if (animationTimeout > 0) {
            type = ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? TRANSITION : ANIMATION : null;
        propCount = type ? type === TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties(`${TRANSITION}Property`).toString());
    return {
        type,
        timeout,
        propCount,
        hasTransform
    };
}
function getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>toMs(d) + toMs(delays[i])));
}
function toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function forceReflow() {
    return document.body.offsetHeight;
}
function patchClass(el, value, isSVG) {
    const transitionClasses = el[vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const vShowOriginalDisplay = Symbol("_vod");
const vShowHidden = Symbol("_vsh");
const vShow = {
    beforeMount (el, { value }, { transition }) {
        el[vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else setDisplay(el, value);
    },
    mounted (el, { value }, { transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value, oldValue }, { transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                setDisplay(el, false);
            });
        } else setDisplay(el, value);
    },
    beforeUnmount (el, { value }) {
        setDisplay(el, value);
    }
};
function setDisplay(el, value) {
    el.style.display = value ? el[vShowOriginalDisplay] : "none";
    el[vShowHidden] = !value;
}
function initVShowForSSR() {
    vShow.getSSRProps = ({ value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const CSS_VAR_TEXT = Symbol("");
function useCssVars(getter) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) setVarsOnNode(instance.ce, vars);
        else setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, _runtimeCore.onBeforeMount)(()=>{
        (0, _runtimeCore.watchPostEffect)(setVars);
    });
    (0, _runtimeCore.onMounted)(()=>{
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, _runtimeCore.onUnmounted)(()=>ob.disconnect());
    });
}
function setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, _runtimeCore.Fragment)) vnode.children.forEach((c)=>setVarsOnVNode(c, vars));
    else if (vnode.type === (0, _runtimeCore.Static)) {
        let { el, anchor } = vnode;
        while(el){
            setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            style.setProperty(`--${key}`, vars[key]);
            cssText += `--${key}: ${vars[key]};`;
        }
        style[CSS_VAR_TEXT] = cssText;
    }
}
const displayRE = /(^|;)\s*display\s*:/;
function patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, _shared.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, _shared.isString)(prev)) {
                for(const key in prev)if (next[key] == null) setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if (vShowOriginalDisplay in el) {
        el[vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[vShowHidden]) style.display = "none";
    }
}
const semicolonRE = /[^\\];\s*$/;
const importantRE = /\s*!important$/;
function setStyle(style, name, val) {
    if ((0, _shared.isArray)(val)) val.forEach((v)=>setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = autoPrefix(style, name);
            if (importantRE.test(val)) style.setProperty((0, _shared.hyphenate)(prefixed), val.replace(importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const prefixCache = {};
function autoPrefix(style, rawName) {
    const cached = prefixCache[rawName];
    if (cached) return cached;
    let name = (0, _runtimeCore.camelize)(rawName);
    if (name !== "filter" && name in style) return prefixCache[rawName] = name;
    name = (0, _shared.capitalize)(name);
    for(let i = 0; i < prefixes.length; i++){
        const prefixed = prefixes[i] + name;
        if (prefixed in style) return prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const xlinkNS = "http://www.w3.org/1999/xlink";
function patchAttr(el, key, value, isSVG, instance, isBoolean = (0, _shared.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS(xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS(xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, _shared.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, _shared.isSymbol)(value) ? String(value) : value);
}
function patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, _shared.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const veiKey = Symbol("_vei");
function patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[veiKey] || (el[veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = createInvoker(nextValue, instance);
            addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const optionsModifierRE = /(?:Once|Passive|Capture)$/;
function parseName(name) {
    let options;
    if (optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match(optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, _shared.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let cachedNow = 0;
const p = /* @__PURE__ */ Promise.resolve();
const getNow = ()=>cachedNow || (p.then(()=>cachedNow = 0), cachedNow = Date.now());
function createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, _runtimeCore.callWithAsyncErrorHandling)(patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = getNow();
    return invoker;
}
function sanitizeEventValue(value, propName) {
    if ((0, _shared.isFunction)(value) || (0, _shared.isArray)(value)) return value;
    (0, _runtimeCore.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, _shared.NOOP;
}
function patchStopImmediatePropagation(e, value) {
    if ((0, _shared.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const patchProp = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") patchClass(el, nextValue, isSVG);
    else if (key === "style") patchStyle(el, prevValue, nextValue);
    else if ((0, _shared.isOn)(key)) {
        if (!(0, _shared.isModelListener)(key)) patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : shouldSetAsProp(el, key, nextValue, isSVG)) {
        patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, _shared.isString)(nextValue))) patchDOMProp(el, (0, _shared.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        patchAttr(el, key, nextValue, isSVG);
    }
};
function shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && isNativeOn(key) && (0, _shared.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if (isNativeOn(key) && (0, _shared.isString)(value)) return false;
    return key in el;
}
const REMOVAL = {};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineCustomElement(options, extraOptions, _createApp) {
    const Comp = (0, _runtimeCore.defineComponent)(options, extraOptions);
    if ((0, _shared.isPlainObject)(Comp)) (0, _shared.extend)(Comp, extraOptions);
    class VueCustomElement extends VueElement {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
/*! #__NO_SIDE_EFFECTS__ */ const defineSSRCustomElement = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ defineCustomElement(options, extraOptions, createSSRApp);
};
const BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class VueElement extends BaseClass {
    constructor(_def, _props = {}, _createApp = createApp){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== createApp) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow({
                mode: "open"
            });
            this._root = this.shadowRoot;
        } else this._root = this;
        if (!this._def.__asyncLoader) this._resolveProps(this._def);
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) {
                this._setParent();
                this._update();
            } else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._instance.provides = parent._instance.provides;
        }
    }
    disconnectedCallback() {
        this._connected = false;
        (0, _runtimeCore.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
            }
        });
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver((mutations)=>{
            for (const m of mutations)this._setAttr(m.attributeName);
        });
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props, styles } = def;
            let numberProps;
            if (props && !(0, _shared.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, _shared.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, _shared.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            if (isAsync) this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>resolve(this._def = def, true));
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, _shared.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, _runtimeCore.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props } = def;
        const declaredPropKeys = (0, _shared.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, _shared.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, true);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : REMOVAL;
        const camelKey = (0, _shared.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, _shared.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            if (val === REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                if (val === true) this.setAttribute((0, _shared.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, _shared.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, _shared.hyphenate)(key));
            }
        }
    }
    _update() {
        render(this._createVNode(), this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, _runtimeCore.createVNode)(this._def, (0, _shared.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, _shared.isPlainObject)(args[0]) ? (0, _shared.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, _shared.hyphenate)(event) !== event) dispatch((0, _shared.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = (this._teleportTarget || this).querySelectorAll("slot");
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function useHost(caller) {
    const instance = (0, _runtimeCore.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, _runtimeCore.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, _runtimeCore.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function useShadowRoot() {
    const el = useHost();
    return el && el.shadowRoot;
}
function useCssModule(name = "$style") {
    {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        if (!instance) return 0, _shared.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, _shared.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, _shared.EMPTY_OBJ;
        return mod;
    }
}
const positionMap = /* @__PURE__ */ new WeakMap();
const newPositionMap = /* @__PURE__ */ new WeakMap();
const moveCbKey = Symbol("_moveCb");
const enterCbKey = Symbol("_enterCb");
const decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const TransitionGroupImpl = /* @__PURE__ */ decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, _shared.extend)({}, TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots }) {
        const instance = (0, _runtimeCore.getCurrentInstance)();
        const state = (0, _runtimeCore.useTransitionState)();
        let prevChildren;
        let children;
        (0, _runtimeCore.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach(callPendingCbs);
            prevChildren.forEach(recordPosition);
            const movedChildren = prevChildren.filter(applyTranslation);
            forceReflow();
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el[moveCbKey] = null;
                        removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return ()=>{
            const rawProps = (0, _runtimeCore.toRaw)(props);
            const cssTransitionProps = resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, _runtimeCore.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    positionMap.set(child, child.el.getBoundingClientRect());
                }
            }
            children = slots.default ? (0, _runtimeCore.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, _runtimeCore.setTransitionHooks)(child, (0, _runtimeCore.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, _runtimeCore.createVNode)(tag, null, children);
        };
    }
});
const TransitionGroup = TransitionGroupImpl;
function callPendingCbs(c) {
    const el = c.el;
    if (el[moveCbKey]) el[moveCbKey]();
    if (el[enterCbKey]) el[enterCbKey]();
}
function recordPosition(c) {
    newPositionMap.set(c, c.el.getBoundingClientRect());
}
function applyTranslation(c) {
    const oldPos = positionMap.get(c);
    const newPos = newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const s = c.el.style;
        s.transform = s.webkitTransform = `translate(${dx}px,${dy}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform } = getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, _shared.isArray)(fn) ? (value)=>(0, _shared.invokeArrayFns)(fn, value) : fn;
};
function onCompositionStart(e) {
    e.target.composing = true;
}
function onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const assignKey = Symbol("_assign");
const vModelText = {
    created (el, { modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            let domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, _shared.looseToNumber)(domValue);
            el[assignKey](domValue);
        });
        if (trim) addEventListener(el, "change", ()=>{
            el.value = el.value.trim();
        });
        if (!lazy) {
            addEventListener(el, "compositionstart", onCompositionStart);
            addEventListener(el, "compositionend", onCompositionEnd);
            addEventListener(el, "change", onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value, oldValue, modifiers: { lazy, trim, number } }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, _shared.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const vModelCheckbox = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = getValue(el);
            const checked = el.checked;
            const assign = el[assignKey];
            if ((0, _shared.isArray)(modelValue)) {
                const index = (0, _shared.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, _shared.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign(getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: setChecked,
    beforeUpdate (el, binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        setChecked(el, binding, vnode);
    }
};
function setChecked(el, { value, oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, _shared.isArray)(value)) checked = (0, _shared.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, _shared.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, _shared.looseEqual)(value, getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const vModelRadio = {
    created (el, { value }, vnode) {
        el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
        el[assignKey] = getModelAssigner(vnode);
        addEventListener(el, "change", ()=>{
            el[assignKey](getValue(el));
        });
    },
    beforeUpdate (el, { value, oldValue }, vnode) {
        el[assignKey] = getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, _shared.looseEqual)(value, vnode.props.value);
    }
};
const vModelSelect = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value, modifiers: { number } }, vnode) {
        const isSetModel = (0, _shared.isSet)(value);
        addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, _shared.looseToNumber)(getValue(o)) : getValue(o));
            el[assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, _runtimeCore.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[assignKey] = getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value }) {
        setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[assignKey] = getModelAssigner(vnode);
    },
    updated (el, { value }) {
        if (!el._assigning) setSelected(el, value);
    }
};
function setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, _shared.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, _shared.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, _shared.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, _shared.looseEqual)(getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const vModelDynamic = {
    created (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return vModelSelect;
        case "TEXTAREA":
            return vModelText;
        default:
            switch(type){
                case "checkbox":
                    return vModelCheckbox;
                case "radio":
                    return vModelRadio;
                default:
                    return vModelText;
            }
    }
}
function callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function initVModelForSSR() {
    vModelText.getSSRProps = ({ value })=>({
            value
        });
    vModelRadio.getSSRProps = ({ value }, vnode)=>{
        if (vnode.props && (0, _shared.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    vModelCheckbox.getSSRProps = ({ value }, vnode)=>{
        if ((0, _shared.isArray)(value)) {
            if (vnode.props && (0, _shared.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, _shared.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    vModelDynamic.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const withModifiers = (fn, modifiers)=>{
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const withKeys = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, _shared.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || keyNames[k] === eventKey)) return fn(event);
    });
};
const rendererOptions = /* @__PURE__ */ (0, _shared.extend)({
    patchProp
}, nodeOps);
let renderer;
let enabledHydration = false;
function ensureRenderer() {
    return renderer || (renderer = (0, _runtimeCore.createRenderer)(rendererOptions));
}
function ensureHydrationRenderer() {
    renderer = enabledHydration ? renderer : (0, _runtimeCore.createHydrationRenderer)(rendererOptions);
    enabledHydration = true;
    return renderer;
}
const render = (...args)=>{
    ensureRenderer().render(...args);
};
const hydrate = (...args)=>{
    ensureHydrationRenderer().hydrate(...args);
};
const createApp = (...args)=>{
    const app = ensureRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, _shared.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const createSSRApp = (...args)=>{
    const app = ensureHydrationRenderer().createApp(...args);
    const { mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, resolveRootNamespace(container));
    };
    return app;
};
function resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, _shared.isHTMLTag)(tag) || (0, _shared.isSVGTag)(tag) || (0, _shared.isMathMLTag)(tag),
        writable: false
    });
}
function injectCompilerOptionsCheck(app) {
    if ((0, _runtimeCore.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, _runtimeCore.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, _runtimeCore.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, _runtimeCore.warn)(msg);
            }
        });
    }
}
function normalizeContainer(container) {
    if ((0, _shared.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let ssrDirectiveInitialized = false;
const initDirectivesForSSR = ()=>{
    if (!ssrDirectiveInitialized) {
        ssrDirectiveInitialized = true;
        initVModelForSSR();
        initVShowForSSR();
    }
};

},{"@vue/runtime-core":"jG196","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jG196":[function(require,module,exports) {
/**
* @vue/runtime-core v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EffectScope", ()=>(0, _reactivity.EffectScope));
parcelHelpers.export(exports, "ReactiveEffect", ()=>(0, _reactivity.ReactiveEffect));
parcelHelpers.export(exports, "TrackOpTypes", ()=>(0, _reactivity.TrackOpTypes));
parcelHelpers.export(exports, "TriggerOpTypes", ()=>(0, _reactivity.TriggerOpTypes));
parcelHelpers.export(exports, "customRef", ()=>(0, _reactivity.customRef));
parcelHelpers.export(exports, "effect", ()=>(0, _reactivity.effect));
parcelHelpers.export(exports, "effectScope", ()=>(0, _reactivity.effectScope));
parcelHelpers.export(exports, "getCurrentScope", ()=>(0, _reactivity.getCurrentScope));
parcelHelpers.export(exports, "getCurrentWatcher", ()=>(0, _reactivity.getCurrentWatcher));
parcelHelpers.export(exports, "isProxy", ()=>(0, _reactivity.isProxy));
parcelHelpers.export(exports, "isReactive", ()=>(0, _reactivity.isReactive));
parcelHelpers.export(exports, "isReadonly", ()=>(0, _reactivity.isReadonly));
parcelHelpers.export(exports, "isRef", ()=>(0, _reactivity.isRef));
parcelHelpers.export(exports, "isShallow", ()=>(0, _reactivity.isShallow));
parcelHelpers.export(exports, "markRaw", ()=>(0, _reactivity.markRaw));
parcelHelpers.export(exports, "onScopeDispose", ()=>(0, _reactivity.onScopeDispose));
parcelHelpers.export(exports, "onWatcherCleanup", ()=>(0, _reactivity.onWatcherCleanup));
parcelHelpers.export(exports, "proxyRefs", ()=>(0, _reactivity.proxyRefs));
parcelHelpers.export(exports, "reactive", ()=>(0, _reactivity.reactive));
parcelHelpers.export(exports, "readonly", ()=>(0, _reactivity.readonly));
parcelHelpers.export(exports, "ref", ()=>(0, _reactivity.ref));
parcelHelpers.export(exports, "shallowReactive", ()=>(0, _reactivity.shallowReactive));
parcelHelpers.export(exports, "shallowReadonly", ()=>(0, _reactivity.shallowReadonly));
parcelHelpers.export(exports, "shallowRef", ()=>(0, _reactivity.shallowRef));
parcelHelpers.export(exports, "stop", ()=>(0, _reactivity.stop));
parcelHelpers.export(exports, "toRaw", ()=>(0, _reactivity.toRaw));
parcelHelpers.export(exports, "toRef", ()=>(0, _reactivity.toRef));
parcelHelpers.export(exports, "toRefs", ()=>(0, _reactivity.toRefs));
parcelHelpers.export(exports, "toValue", ()=>(0, _reactivity.toValue));
parcelHelpers.export(exports, "triggerRef", ()=>(0, _reactivity.triggerRef));
parcelHelpers.export(exports, "unref", ()=>(0, _reactivity.unref));
parcelHelpers.export(exports, "camelize", ()=>(0, _shared.camelize));
parcelHelpers.export(exports, "capitalize", ()=>(0, _shared.capitalize));
parcelHelpers.export(exports, "normalizeClass", ()=>(0, _shared.normalizeClass));
parcelHelpers.export(exports, "normalizeProps", ()=>(0, _shared.normalizeProps));
parcelHelpers.export(exports, "normalizeStyle", ()=>(0, _shared.normalizeStyle));
parcelHelpers.export(exports, "toDisplayString", ()=>(0, _shared.toDisplayString));
parcelHelpers.export(exports, "toHandlerKey", ()=>(0, _shared.toHandlerKey));
parcelHelpers.export(exports, "BaseTransition", ()=>BaseTransition);
parcelHelpers.export(exports, "BaseTransitionPropsValidators", ()=>BaseTransitionPropsValidators);
parcelHelpers.export(exports, "Comment", ()=>Comment);
parcelHelpers.export(exports, "DeprecationTypes", ()=>DeprecationTypes);
parcelHelpers.export(exports, "ErrorCodes", ()=>ErrorCodes);
parcelHelpers.export(exports, "ErrorTypeStrings", ()=>ErrorTypeStrings);
parcelHelpers.export(exports, "Fragment", ()=>Fragment);
parcelHelpers.export(exports, "KeepAlive", ()=>KeepAlive);
parcelHelpers.export(exports, "Static", ()=>Static);
parcelHelpers.export(exports, "Suspense", ()=>Suspense);
parcelHelpers.export(exports, "Teleport", ()=>Teleport);
parcelHelpers.export(exports, "Text", ()=>Text);
parcelHelpers.export(exports, "assertNumber", ()=>assertNumber);
parcelHelpers.export(exports, "callWithAsyncErrorHandling", ()=>callWithAsyncErrorHandling);
parcelHelpers.export(exports, "callWithErrorHandling", ()=>callWithErrorHandling);
parcelHelpers.export(exports, "cloneVNode", ()=>cloneVNode);
parcelHelpers.export(exports, "compatUtils", ()=>compatUtils);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "createBlock", ()=>createBlock);
parcelHelpers.export(exports, "createCommentVNode", ()=>createCommentVNode);
parcelHelpers.export(exports, "createElementBlock", ()=>createElementBlock);
parcelHelpers.export(exports, "createElementVNode", ()=>createBaseVNode);
parcelHelpers.export(exports, "createHydrationRenderer", ()=>createHydrationRenderer);
parcelHelpers.export(exports, "createPropsRestProxy", ()=>createPropsRestProxy);
parcelHelpers.export(exports, "createRenderer", ()=>createRenderer);
parcelHelpers.export(exports, "createSlots", ()=>createSlots);
parcelHelpers.export(exports, "createStaticVNode", ()=>createStaticVNode);
parcelHelpers.export(exports, "createTextVNode", ()=>createTextVNode);
parcelHelpers.export(exports, "createVNode", ()=>createVNode);
parcelHelpers.export(exports, "defineAsyncComponent", ()=>defineAsyncComponent);
parcelHelpers.export(exports, "defineComponent", ()=>defineComponent);
parcelHelpers.export(exports, "defineEmits", ()=>defineEmits);
parcelHelpers.export(exports, "defineExpose", ()=>defineExpose);
parcelHelpers.export(exports, "defineModel", ()=>defineModel);
parcelHelpers.export(exports, "defineOptions", ()=>defineOptions);
parcelHelpers.export(exports, "defineProps", ()=>defineProps);
parcelHelpers.export(exports, "defineSlots", ()=>defineSlots);
parcelHelpers.export(exports, "devtools", ()=>devtools);
parcelHelpers.export(exports, "getCurrentInstance", ()=>getCurrentInstance);
parcelHelpers.export(exports, "getTransitionRawChildren", ()=>getTransitionRawChildren);
parcelHelpers.export(exports, "guardReactiveProps", ()=>guardReactiveProps);
parcelHelpers.export(exports, "h", ()=>h);
parcelHelpers.export(exports, "handleError", ()=>handleError);
parcelHelpers.export(exports, "hasInjectionContext", ()=>hasInjectionContext);
parcelHelpers.export(exports, "hydrateOnIdle", ()=>hydrateOnIdle);
parcelHelpers.export(exports, "hydrateOnInteraction", ()=>hydrateOnInteraction);
parcelHelpers.export(exports, "hydrateOnMediaQuery", ()=>hydrateOnMediaQuery);
parcelHelpers.export(exports, "hydrateOnVisible", ()=>hydrateOnVisible);
parcelHelpers.export(exports, "initCustomFormatter", ()=>initCustomFormatter);
parcelHelpers.export(exports, "inject", ()=>inject);
parcelHelpers.export(exports, "isMemoSame", ()=>isMemoSame);
parcelHelpers.export(exports, "isRuntimeOnly", ()=>isRuntimeOnly);
parcelHelpers.export(exports, "isVNode", ()=>isVNode);
parcelHelpers.export(exports, "mergeDefaults", ()=>mergeDefaults);
parcelHelpers.export(exports, "mergeModels", ()=>mergeModels);
parcelHelpers.export(exports, "mergeProps", ()=>mergeProps);
parcelHelpers.export(exports, "nextTick", ()=>nextTick);
parcelHelpers.export(exports, "onActivated", ()=>onActivated);
parcelHelpers.export(exports, "onBeforeMount", ()=>onBeforeMount);
parcelHelpers.export(exports, "onBeforeUnmount", ()=>onBeforeUnmount);
parcelHelpers.export(exports, "onBeforeUpdate", ()=>onBeforeUpdate);
parcelHelpers.export(exports, "onDeactivated", ()=>onDeactivated);
parcelHelpers.export(exports, "onErrorCaptured", ()=>onErrorCaptured);
parcelHelpers.export(exports, "onMounted", ()=>onMounted);
parcelHelpers.export(exports, "onRenderTracked", ()=>onRenderTracked);
parcelHelpers.export(exports, "onRenderTriggered", ()=>onRenderTriggered);
parcelHelpers.export(exports, "onServerPrefetch", ()=>onServerPrefetch);
parcelHelpers.export(exports, "onUnmounted", ()=>onUnmounted);
parcelHelpers.export(exports, "onUpdated", ()=>onUpdated);
parcelHelpers.export(exports, "openBlock", ()=>openBlock);
parcelHelpers.export(exports, "popScopeId", ()=>popScopeId);
parcelHelpers.export(exports, "provide", ()=>provide);
parcelHelpers.export(exports, "pushScopeId", ()=>pushScopeId);
parcelHelpers.export(exports, "queuePostFlushCb", ()=>queuePostFlushCb);
parcelHelpers.export(exports, "registerRuntimeCompiler", ()=>registerRuntimeCompiler);
parcelHelpers.export(exports, "renderList", ()=>renderList);
parcelHelpers.export(exports, "renderSlot", ()=>renderSlot);
parcelHelpers.export(exports, "resolveComponent", ()=>resolveComponent);
parcelHelpers.export(exports, "resolveDirective", ()=>resolveDirective);
parcelHelpers.export(exports, "resolveDynamicComponent", ()=>resolveDynamicComponent);
parcelHelpers.export(exports, "resolveFilter", ()=>resolveFilter);
parcelHelpers.export(exports, "resolveTransitionHooks", ()=>resolveTransitionHooks);
parcelHelpers.export(exports, "setBlockTracking", ()=>setBlockTracking);
parcelHelpers.export(exports, "setDevtoolsHook", ()=>setDevtoolsHook);
parcelHelpers.export(exports, "setTransitionHooks", ()=>setTransitionHooks);
parcelHelpers.export(exports, "ssrContextKey", ()=>ssrContextKey);
parcelHelpers.export(exports, "ssrUtils", ()=>ssrUtils);
parcelHelpers.export(exports, "toHandlers", ()=>toHandlers);
parcelHelpers.export(exports, "transformVNodeArgs", ()=>transformVNodeArgs);
parcelHelpers.export(exports, "useAttrs", ()=>useAttrs);
parcelHelpers.export(exports, "useId", ()=>useId);
parcelHelpers.export(exports, "useModel", ()=>useModel);
parcelHelpers.export(exports, "useSSRContext", ()=>useSSRContext);
parcelHelpers.export(exports, "useSlots", ()=>useSlots);
parcelHelpers.export(exports, "useTemplateRef", ()=>useTemplateRef);
parcelHelpers.export(exports, "useTransitionState", ()=>useTransitionState);
parcelHelpers.export(exports, "version", ()=>version);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "watch", ()=>watch);
parcelHelpers.export(exports, "watchEffect", ()=>watchEffect);
parcelHelpers.export(exports, "watchPostEffect", ()=>watchPostEffect);
parcelHelpers.export(exports, "watchSyncEffect", ()=>watchSyncEffect);
parcelHelpers.export(exports, "withAsyncContext", ()=>withAsyncContext);
parcelHelpers.export(exports, "withCtx", ()=>withCtx);
parcelHelpers.export(exports, "withDefaults", ()=>withDefaults);
parcelHelpers.export(exports, "withDirectives", ()=>withDirectives);
parcelHelpers.export(exports, "withMemo", ()=>withMemo);
parcelHelpers.export(exports, "withScopeId", ()=>withScopeId);
var _reactivity = require("@vue/reactivity");
var _shared = require("@vue/shared");
const stack = [];
function pushWarningContext(vnode) {
    stack.push(vnode);
}
function popWarningContext() {
    stack.pop();
}
let isWarning = false;
function warn$1(msg, ...args) {
    if (isWarning) return;
    isWarning = true;
    (0, _reactivity.pauseTracking)();
    const instance = stack.length ? stack[stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = getComponentTrace();
    if (appWarnHandler) callWithErrorHandling(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode })=>`at <${formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, _reactivity.resetTracking)();
    isWarning = false;
}
function getComponentTrace() {
    let currentVNode = stack[stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...formatTraceEntry(entry));
    });
    return logs;
}
function formatTraceEntry({ vnode, recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function formatProp(key, value, raw) {
    if ((0, _shared.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, _reactivity.isRef)(value)) {
        value = formatProp(key, (0, _reactivity.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, _shared.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, _reactivity.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function assertNumber(val, type) {
    return;
}
const ErrorCodes = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function callWithErrorHandling(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        handleError(err, instance, type);
    }
}
function callWithAsyncErrorHandling(fn, instance, type, args) {
    if ((0, _shared.isFunction)(fn)) {
        const res = callWithErrorHandling(fn, instance, type, args);
        if (res && (0, _shared.isPromise)(res)) res.catch((err)=>{
            handleError(err, instance, type);
        });
        return res;
    }
    if ((0, _shared.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push(callWithAsyncErrorHandling(fn[i], instance, type, args));
        return values;
    }
}
function handleError(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler, throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, _shared.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, _reactivity.pauseTracking)();
            callWithErrorHandling(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, _reactivity.resetTracking)();
            return;
        }
    }
    logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const queue = [];
let flushIndex = -1;
const pendingPostFlushCbs = [];
let activePostFlushCbs = null;
let postFlushIndex = 0;
const resolvedPromise = /* @__PURE__ */ Promise.resolve();
let currentFlushPromise = null;
const RECURSION_LIMIT = 100;
function nextTick(fn) {
    const p = currentFlushPromise || resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function findInsertionIndex(id) {
    let start = flushIndex + 1;
    let end = queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = queue[middle];
        const middleJobId = getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = getId(job);
        const lastJob = queue[queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= getId(lastJob)) queue.push(job);
        else queue.splice(findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        queueFlush();
    }
}
function queueFlush() {
    if (!currentFlushPromise) currentFlushPromise = resolvedPromise.then(flushJobs);
}
function queuePostFlushCb(cb) {
    if (!(0, _shared.isArray)(cb)) {
        if (activePostFlushCbs && cb.id === -1) activePostFlushCbs.splice(postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else pendingPostFlushCbs.push(...cb);
    queueFlush();
}
function flushPreFlushCbs(instance, seen, i = flushIndex + 1) {
    for(; i < queue.length; i++){
        const cb = queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function flushPostFlushCbs(seen) {
    if (pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set(pendingPostFlushCbs)
        ].sort((a, b)=>getId(a) - getId(b));
        pendingPostFlushCbs.length = 0;
        if (activePostFlushCbs) {
            activePostFlushCbs.push(...deduped);
            return;
        }
        activePostFlushCbs = deduped;
        for(postFlushIndex = 0; postFlushIndex < activePostFlushCbs.length; postFlushIndex++){
            const cb = activePostFlushCbs[postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        activePostFlushCbs = null;
        postFlushIndex = 0;
    }
}
const getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function flushJobs(seen) {
    const check = (0, _shared.NOOP);
    try {
        for(flushIndex = 0; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                callWithErrorHandling(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; flushIndex < queue.length; flushIndex++){
            const job = queue[flushIndex];
            if (job) job.flags &= -2;
        }
        flushIndex = -1;
        queue.length = 0;
        flushPostFlushCbs(seen);
        currentFlushPromise = null;
        if (queue.length || pendingPostFlushCbs.length) flushJobs(seen);
    }
}
function checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && getComponentName(instance.type);
        handleError(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let isHmrUpdating = false;
const hmrDirtyComponents = /* @__PURE__ */ new Map();
const map = /* @__PURE__ */ new Map();
function registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = map.get(id);
    if (!record) {
        createRecord(id, instance.type);
        record = map.get(id);
    }
    record.instances.add(instance);
}
function unregisterHMR(instance) {
    map.get(instance.type.__hmrId).instances.delete(instance);
}
function createRecord(id, initialDef) {
    if (map.has(id)) return false;
    map.set(id, {
        initialDef: normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function normalizeClassComponent(component) {
    return isClassComponent(component) ? component.__vccOpts : component;
}
function rerender(id, newRender) {
    const record = map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        isHmrUpdating = true;
        instance.update();
        isHmrUpdating = false;
    });
}
function reload(id, newComp) {
    const record = map.get(id);
    if (!record) return;
    newComp = normalizeClassComponent(newComp);
    updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = normalizeClassComponent(instance.type);
        let dirtyInstances = hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) updateComponentDef(oldComp, newComp);
            hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) queueJob(()=>{
            isHmrUpdating = true;
            instance.parent.update();
            isHmrUpdating = false;
            dirtyInstances.delete(instance);
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    queuePostFlushCb(()=>{
        hmrDirtyComponents.clear();
    });
}
function updateComponentDef(oldComp, newComp) {
    (0, _shared.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let devtools$1;
let buffer = [];
let devtoolsNotInstalled = false;
function emit$1(event, ...args) {
    if (devtools$1) devtools$1.emit(event, ...args);
    else if (!devtoolsNotInstalled) buffer.push({
        event,
        args
    });
}
function setDevtoolsHook$1(hook, target) {
    var _a, _b;
    devtools$1 = hook;
    if (devtools$1) {
        devtools$1.enabled = true;
        buffer.forEach(({ event, args })=>devtools$1.emit(event, ...args));
        buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                devtoolsNotInstalled = true;
                buffer = [];
            }
        }, 3e3);
    } else {
        devtoolsNotInstalled = true;
        buffer = [];
    }
}
function devtoolsInitApp(app, version) {
    emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment,
        Text,
        Comment,
        Static
    });
}
function devtoolsUnmountApp(app) {
    emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const devtoolsComponentAdded = /* @__PURE__ */ createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const devtoolsComponentUpdated = /* @__PURE__ */ createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const _devtoolsComponentRemoved = /* @__PURE__ */ createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const devtoolsComponentRemoved = (component)=>{
    if (devtools$1 && typeof devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !devtools$1.cleanupBuffer(component)) _devtoolsComponentRemoved(component);
};
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function createDevtoolsComponentHook(hook) {
    return (component)=>{
        emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const devtoolsPerfStart = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const devtoolsPerfEnd = /* @__PURE__ */ createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function devtoolsComponentEmit(component, event, params) {
    emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let currentRenderingInstance = null;
let currentScopeId = null;
function setCurrentRenderingInstance(instance) {
    const prev = currentRenderingInstance;
    currentRenderingInstance = instance;
    currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function pushScopeId(id) {
    currentScopeId = id;
}
function popScopeId() {
    currentScopeId = null;
}
const withScopeId = (_id)=>withCtx;
function withCtx(fn, ctx = currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) setBlockTracking(-1);
        const prevInstance = setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) setBlockTracking(1);
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function validateDirectiveName(name) {
    if ((0, _shared.isBuiltInDirective)(name)) warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function withDirectives(vnode, directives) {
    if (currentRenderingInstance === null) return vnode;
    const instance = getComponentPublicInstance(currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, _shared.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, _shared.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, _reactivity.traverse)(value);
            bindings.push({
                dir,
                instance,
                value,
                oldValue: void 0,
                arg,
                modifiers
            });
        }
    }
    return vnode;
}
function invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, _reactivity.pauseTracking)();
            callWithAsyncErrorHandling(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, _reactivity.resetTracking)();
        }
    }
}
const TeleportEndKey = Symbol("_vte");
const isTeleport = (type)=>type.__isTeleport;
const isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, _shared.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert, querySelector, createText, createComment } } = internals;
        const disabled = isTeleportDisabled(n2.props);
        let { shapeFlag, children, dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) {
                    if (parentComponent && parentComponent.isCE) parentComponent.ce._teleportTarget = container2;
                    mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                }
            };
            const mountToTarget = ()=>{
                const target = n2.target = resolveTarget(n2.props, querySelector);
                const targetAnchor = prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && isTargetMathML(target)) namespace = "mathml";
                    if (!disabled) {
                        mount(target, targetAnchor);
                        updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                updateCssVars(n2, true);
            }
            if (isTeleportDeferred(n2.props)) queuePostRenderEffect(mountToTarget, parentSuspense);
            else mountToTarget();
        } else {
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = resolveTarget(n2.props, querySelector);
                    if (nextTarget) moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag, children, anchor, targetStart, targetAnchor, target, props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: moveTeleport,
    hydrate: hydrateTeleport
};
function moveTeleport(vnode, container, parentAnchor, { o: { insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el, anchor, shapeFlag, children, props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling, parentNode, querySelector, insert, createText } }, hydrateChildren) {
    const target = vnode.target = resolveTarget(vnode.props, querySelector);
    if (target) {
        const disabled = isTeleportDisabled(vnode.props);
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetStart = targetNode;
                vnode.targetAnchor = targetNode && nextSibling(targetNode);
            } else {
                vnode.anchor = nextSibling(node);
                let targetAnchor = targetNode;
                while(targetAnchor){
                    if (targetAnchor && targetAnchor.nodeType === 8) {
                        if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                        else if (targetAnchor.data === "teleport anchor") {
                            vnode.targetAnchor = targetAnchor;
                            target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                            break;
                        }
                    }
                    targetAnchor = nextSibling(targetAnchor);
                }
                if (!vnode.targetAnchor) prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        updateCssVars(vnode, disabled);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const Teleport = TeleportImpl;
function updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function prepareAnchor(target, vnode, createText, insert) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target);
        insert(targetAnchor, target);
    }
    return targetAnchor;
}
const leaveCbKey = Symbol("_leaveCb");
const enterCbKey = Symbol("_enterCb");
function useTransitionState() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    onMounted(()=>{
        state.isMounted = true;
    });
    onBeforeUnmount(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const TransitionHookValidator = [
    Function,
    Array
];
const BaseTransitionPropsValidators = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: TransitionHookValidator,
    onEnter: TransitionHookValidator,
    onAfterEnter: TransitionHookValidator,
    onEnterCancelled: TransitionHookValidator,
    // leave
    onBeforeLeave: TransitionHookValidator,
    onLeave: TransitionHookValidator,
    onAfterLeave: TransitionHookValidator,
    onLeaveCancelled: TransitionHookValidator,
    // appear
    onBeforeAppear: TransitionHookValidator,
    onAppear: TransitionHookValidator,
    onAfterAppear: TransitionHookValidator,
    onAppearCancelled: TransitionHookValidator
};
const recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? recursiveGetSubtree(subTree.component) : subTree;
};
const BaseTransitionImpl = {
    name: `BaseTransition`,
    props: BaseTransitionPropsValidators,
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const state = useTransitionState();
        return ()=>{
            const children = slots.default && getTransitionRawChildren(slots.default(), true);
            if (!children || !children.length) return;
            const child = findNonCommentChild(children);
            const rawProps = (0, _reactivity.toRaw)(props);
            const { mode } = rawProps;
            if (state.isLeaving) return emptyPlaceholder(child);
            const innerChild = getInnerChild$1(child);
            if (!innerChild) return emptyPlaceholder(child);
            let enterHooks = resolveTransitionHooks(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== Comment) setTransitionHooks(innerChild, enterHooks);
            const oldChild = instance.subTree;
            const oldInnerChild = oldChild && getInnerChild$1(oldChild);
            if (oldInnerChild && oldInnerChild.type !== Comment && !isSameVNodeType(innerChild, oldInnerChild) && recursiveGetSubtree(instance).type !== Comment) {
                const leavingHooks = resolveTransitionHooks(oldInnerChild, rawProps, state, instance);
                setTransitionHooks(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== Comment) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                    };
                    return emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== Comment) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[leaveCbKey] = ()=>{
                        earlyRemove();
                        el[leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
function findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== Comment) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const BaseTransition = BaseTransitionImpl;
function getLeavingNodesForType(state, vnode) {
    const { leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function resolveTransitionHooks(vnode, props, state, instance, postClone) {
    const { appear, mode, persisted = false, onBeforeEnter, onEnter, onAfterEnter, onEnterCancelled, onBeforeLeave, onLeave, onAfterLeave, onLeaveCancelled, onBeforeAppear, onAppear, onAfterAppear, onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && callWithAsyncErrorHandling(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, _shared.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode,
        persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[leaveCbKey]) el[leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[leaveCbKey]) leavingVNode.el[leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            const done = el[enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[enterCbKey] = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[enterCbKey]) el[enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            const done = el[leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = resolveTransitionHooks(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function emptyPlaceholder(vnode) {
    if (isKeepAlive(vnode)) {
        vnode = cloneVNode(vnode);
        vnode.children = null;
        return vnode;
    }
}
function getInnerChild$1(vnode) {
    if (!isKeepAlive(vnode)) {
        if (isTeleport(vnode.type) && vnode.children) return findNonCommentChild(vnode.children);
        return vnode;
    }
    const { shapeFlag, children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, _shared.isFunction)(children.default)) return children.default();
    }
}
function setTransitionHooks(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        setTransitionHooks(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function getTransitionRawChildren(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === Fragment) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat(getTransitionRawChildren(child.children, keepComment, key));
        } else if (keepComment || child.type !== Comment) ret.push(key != null ? cloneVNode(child, {
            key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineComponent(options, extraOptions) {
    return (0, _shared.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, _shared.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function useId() {
    const i = getCurrentInstance();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function useTemplateRef(key) {
    const i = getCurrentInstance();
    const r = (0, _reactivity.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, _shared.EMPTY_OBJ) ? i.refs = {} : i.refs;
        let desc;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, _shared.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>setRef(r, oldRawRef && ((0, _shared.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if (isAsyncWrapper(vnode) && !isUnmount) return;
    const refValue = vnode.shapeFlag & 4 ? getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, _shared.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, _reactivity.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, _shared.EMPTY_OBJ) ? ()=>false : (key)=>{
        return (0, _shared.hasOwn)(rawSetupState, key);
    };
    if (oldRef != null && oldRef !== ref) {
        if ((0, _shared.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, _reactivity.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, _shared.isFunction)(ref)) callWithErrorHandling(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, _shared.isString)(ref);
        const _isRef = (0, _reactivity.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, _shared.isArray)(existing) && (0, _shared.remove)(existing, refValue);
                    else {
                        if (!(0, _shared.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                doSet.id = -1;
                queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
let hasLoggedMismatchError = false;
const logMismatchError = ()=>{
    if (hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    hasLoggedMismatchError = true;
};
const isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if (isSVGContainer(container)) return "svg";
    if (isMathMLContainer(container)) return "mathml";
    return void 0;
};
const isComment = (node)=>node.nodeType === 8;
function createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp, createText, nextSibling, parentNode, remove, insert, createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type, ref, shapeFlag, patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(node, "__vnode", vnode, true);
            (0, _shared.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case Text:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case Comment:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case Static:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case Fragment:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if (isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, getContainerType(container), optimized);
                    if (isAsyncWrapper(vnode)) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = createVNode(Fragment);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? createTextVNode("") : createVNode("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type, props, patchFlag, shapeFlag, dirs, transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) transition.beforeEnter(content);
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                if (el.textContent !== clientText) {
                    if (!isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${el.textContent}
  - expected on client: ${vnode.children}`);
                        logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && propHasMismatch(el, key, props[key], vnode, parentComponent)) logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, _shared.isOn)(key) && !(0, _shared.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, _reactivity.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) queueEffectWithSuspense(()=>{
                vnodeHooks && invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = normalizeVNode(children[i]);
            const isText = vnode.type === Text;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && normalizeVNode(children[i + 1]).type === Text) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, getContainerType(container), slotScopeIds);
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        actual = el.getAttribute("class");
        expected = (0, _shared.normalizeClass)(clientValue);
        if (!isSetEqual(toClassSet(actual || ""), toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, _shared.isString)(clientValue) ? clientValue : (0, _shared.stringifyStyle)((0, _shared.normalizeStyle)(clientValue));
        const actualMap = toStyleMap(actual);
        const expectedMap = toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir, value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) resolveCssVars(instance, vnode, expectedMap);
        if (!isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, _shared.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, _shared.isBooleanAttr)(key) || (0, _shared.isKnownHtmlAttr)(key))) {
        if ((0, _shared.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, _shared.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, _shared.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === Fragment && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars)expectedMap.set(`--${(0, _shared.getEscapedCssVarName)(key, false)}`, String(cssVars[key]));
    }
    if (vnode === root && instance.parent) resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const allowMismatchAttr = "data-allow-mismatch";
const MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute(allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute(allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return allowedAttr.split(",").includes(MismatchTypeString[allowedType]);
    }
}
const requestIdleCallback = (0, _shared.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const cancelIdleCallback = (0, _shared.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const hydrateOnIdle = (timeout = 1e4)=>(hydrate)=>{
        const id = requestIdleCallback(hydrate, {
            timeout
        });
        return ()=>cancelIdleCallback(id);
    };
function elementIsVisibleInViewport(el) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const hydrateOnVisible = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if (elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const hydrateOnMediaQuery = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const hydrateOnInteraction = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, _shared.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function forEachElement(node, cb) {
    if (isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if (isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
function defineAsyncComponent(source) {
    if ((0, _shared.isFunction)(source)) source = {
        loader: source
    };
    const { loader, loadingComponent, errorComponent, delay = 200, hydrate: hydrateStrategy, timeout, // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return defineComponent({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(hydrate, (cb)=>forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : hydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = currentInstance;
            markAsyncBoundary(instance);
            if (resolvedComp) return ()=>createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                handleError(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? createVNode(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, _reactivity.ref)(false);
            const error = (0, _reactivity.ref)();
            const delayed = (0, _reactivity.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return createVNode(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return createVNode(loadingComponent);
            };
        }
    });
}
function createInnerComp(comp, parent) {
    const { ref: ref2, props, children, ce } = parent.vnode;
    const vnode = createVNode(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots }) {
        const instance = getCurrentInstance();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, _shared.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            invalidateMount(instance2.m);
            invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            queuePostRenderEffect(()=>{
                if (instance2.da) (0, _shared.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = getComponentName(vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !isSameVNodeType(cached, current))) unmount(cached);
            else if (current) resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        watch(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>matches(include, name));
            exclude && pruneCache((name)=>!matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if (isSuspense(instance.subTree.type)) queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, getInnerChild(instance.subTree));
            }
        };
        onMounted(cacheSubtree);
        onUpdated(cacheSubtree);
        onBeforeUnmount(()=>{
            cache.forEach((cached)=>{
                const { subTree, suspense } = instance;
                const vnode = getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!isVNode(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = getInnerChild(rawVNode);
            if (vnode.type === Comment) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = getComponentName(isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include, exclude, max } = props;
            if (include && (!name || !matches(include, name)) || exclude && name && matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = cloneVNode(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) setTransitionHooks(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const KeepAlive = KeepAliveImpl;
function matches(pattern, name) {
    if ((0, _shared.isArray)(pattern)) return pattern.some((p)=>matches(p, name));
    else if ((0, _shared.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, _shared.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function onActivated(hook, target) {
    registerKeepAliveHook(hook, "a", target);
}
function onDeactivated(hook, target) {
    registerKeepAliveHook(hook, "da", target);
}
function registerKeepAliveHook(hook, type, target = currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if (isKeepAlive(current.parent.vnode)) injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = injectHook(type, hook, keepAliveRoot, true);
    onUnmounted(()=>{
        (0, _shared.remove)(keepAliveRoot[type], injected);
    }, target);
}
function resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function injectHook(type, hook, target = currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, _reactivity.pauseTracking)();
            const reset = setCurrentInstance(target);
            const res = callWithAsyncErrorHandling(hook, target, type, args);
            reset();
            (0, _reactivity.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const createHook = (lifecycle)=>(hook, target = currentInstance)=>{
        if (!isInSSRComponentSetup || lifecycle === "sp") injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const onBeforeMount = createHook("bm");
const onMounted = createHook("m");
const onBeforeUpdate = createHook("bu");
const onUpdated = createHook("u");
const onBeforeUnmount = createHook("bum");
const onUnmounted = createHook("um");
const onServerPrefetch = createHook("sp");
const onRenderTriggered = createHook("rtg");
const onRenderTracked = createHook("rtc");
function onErrorCaptured(hook, target = currentInstance) {
    injectHook("ec", hook, target);
}
const COMPONENTS = "components";
const DIRECTIVES = "directives";
function resolveComponent(name, maybeSelfReference) {
    return resolveAsset(COMPONENTS, name, true, maybeSelfReference) || name;
}
const NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function resolveDynamicComponent(component) {
    if ((0, _shared.isString)(component)) return resolveAsset(COMPONENTS, component, false) || component;
    else return component || NULL_DYNAMIC_COMPONENT;
}
function resolveDirective(name) {
    return resolveAsset(DIRECTIVES, name);
}
function resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = currentRenderingInstance || currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === COMPONENTS) {
            const selfName = getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, _shared.camelize)(name) || selfName === (0, _shared.capitalize)((0, _shared.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        resolve(instance[type] || Component[type], name) || // global registration
        resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function resolve(registry, name) {
    return registry && (registry[name] || registry[(0, _shared.camelize)(name)] || registry[(0, _shared.capitalize)((0, _shared.camelize)(name))]);
}
function renderList(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, _shared.isArray)(source);
    if (sourceIsArray || (0, _shared.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, _reactivity.isReactive)(source);
        let needsWrap = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, _reactivity.isShallow)(source);
            source = (0, _reactivity.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? (0, _reactivity.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, _shared.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function createSlots(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, _shared.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function renderSlot(slots, name, props = {}, fallback, noSlotted) {
    if (currentRenderingInstance.ce || currentRenderingInstance.parent && isAsyncWrapper(currentRenderingInstance.parent) && currentRenderingInstance.parent.ce) {
        if (name !== "default") props.name = name;
        return openBlock(), createBlock(Fragment, null, [
            createVNode("slot", props, fallback && fallback())
        ], 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    openBlock();
    const validSlotContent = slot && ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = createBlock(Fragment, {
        key: (slotKey && !(0, _shared.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!isVNode(child)) return true;
        if (child.type === Comment) return false;
        if (child.type === Fragment && !ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function toHandlers(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, _shared.toHandlerKey)(key)] = obj[key];
    return ret;
}
const getPublicInstance = (i)=>{
    if (!i) return null;
    if (isStatefulComponent(i)) return getComponentPublicInstance(i);
    return getPublicInstance(i.parent);
};
const publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, _shared.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>getPublicInstance(i.parent),
    $root: (i)=>getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = nextTick.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? instanceWatch.bind(i) : (0, _shared.NOOP)
});
const isReservedPrefix = (key)=>key === "_" || key === "$";
const hasSetupBinding = (state, key)=>state !== (0, _shared.EMPTY_OBJ) && !state.__isScriptSetup && (0, _shared.hasOwn)(state, key);
const PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx, setupState, data, props, accessCache, type, appContext } = instance;
        let normalizedProps;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if (hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, _reactivity.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, _shared.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data, setupState, ctx } = instance;
        if (hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, _shared.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data, setupState, accessCache, ctx, appContext, propsOptions } }, key) {
        let normalizedProps;
        return !!accessCache[key] || data !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasOwn)(data, key) || hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, _shared.hasOwn)(normalizedProps, key) || (0, _shared.hasOwn)(ctx, key) || (0, _shared.hasOwn)(publicPropertiesMap, key) || (0, _shared.hasOwn)(appContext.config.globalProperties, key);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, _shared.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var target;
const RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, _shared.extend)({}, PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, _shared.isGloballyAllowed)(key);
        return has;
    }
});
function createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys(publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, _shared.NOOP)
        });
    });
    return target;
}
function exposePropsOnRenderContext(instance) {
    const { ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, _shared.NOOP)
        });
    });
}
function exposeSetupStateOnRenderContext(instance) {
    const { ctx, setupState } = instance;
    Object.keys((0, _reactivity.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if (isReservedPrefix(key[0])) {
                warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, _shared.NOOP)
            });
        }
    });
}
const warnRuntimeUsage = (method)=>warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function defineProps() {
    return null;
}
function defineEmits() {
    return null;
}
function defineExpose(exposed) {}
function defineOptions(options) {}
function defineSlots() {
    return null;
}
function defineModel() {}
function withDefaults(props, defaults) {
    return null;
}
function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    const i = getCurrentInstance();
    return i.setupContext || (i.setupContext = createSetupContext(i));
}
function normalizePropsOrEmits(props) {
    return (0, _shared.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function mergeDefaults(raw, defaults) {
    const props = normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function mergeModels(a, b) {
    if (!a || !b) return a || b;
    if ((0, _shared.isArray)(a) && (0, _shared.isArray)(b)) return a.concat(b);
    return (0, _shared.extend)({}, normalizePropsOrEmits(a), normalizePropsOrEmits(b));
}
function createPropsRestProxy(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function withAsyncContext(getAwaitable) {
    const ctx = getCurrentInstance();
    let awaitable = getAwaitable();
    unsetCurrentInstance();
    if ((0, _shared.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>setCurrentInstance(ctx)
    ];
}
function createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let shouldCacheAccess = true;
function applyOptions(instance) {
    const options = resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    shouldCacheAccess = false;
    if (options.beforeCreate) callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, // lifecycle
    created, beforeMount, mounted, beforeUpdate, updated, activated, deactivated, beforeDestroy, beforeUnmount, destroyed, unmounted, render, renderTracked, renderTriggered, errorCaptured, serverPrefetch, // public API
    expose, inheritAttrs, // assets
    components, directives, filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, _shared.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, _shared.isObject)(data)) ;
        else instance.data = (0, _reactivity.reactive)(data);
    }
    shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, _shared.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, _shared.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, _shared.NOOP);
        const set = !(0, _shared.isFunction)(opt) && (0, _shared.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, _shared.NOOP);
        const c = computed({
            get,
            set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, _shared.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            provide(key, provides[key]);
        });
    }
    if (created) callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, _shared.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook(onBeforeMount, beforeMount);
    registerLifecycleHook(onMounted, mounted);
    registerLifecycleHook(onBeforeUpdate, beforeUpdate);
    registerLifecycleHook(onUpdated, updated);
    registerLifecycleHook(onActivated, activated);
    registerLifecycleHook(onDeactivated, deactivated);
    registerLifecycleHook(onErrorCaptured, errorCaptured);
    registerLifecycleHook(onRenderTracked, renderTracked);
    registerLifecycleHook(onRenderTriggered, renderTriggered);
    registerLifecycleHook(onBeforeUnmount, beforeUnmount);
    registerLifecycleHook(onUnmounted, unmounted);
    registerLifecycleHook(onServerPrefetch, serverPrefetch);
    if ((0, _shared.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, _shared.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) markAsyncBoundary(instance);
}
function resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, _shared.NOOP)) {
    if ((0, _shared.isArray)(injectOptions)) injectOptions = normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, _shared.isObject)(opt)) {
            if ("default" in opt) injected = inject(opt.from || key, opt.default, true);
            else injected = inject(opt.from || key);
        } else injected = inject(opt);
        if ((0, _reactivity.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function callHook(hook, instance, type) {
    callWithAsyncErrorHandling((0, _shared.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, _shared.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, _shared.isFunction)(handler)) watch(getter, handler);
    } else if ((0, _shared.isFunction)(raw)) watch(getter, raw.bind(publicThis));
    else if ((0, _shared.isObject)(raw)) {
        if ((0, _shared.isArray)(raw)) raw.forEach((r)=>createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, _shared.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, _shared.isFunction)(handler)) watch(getter, handler, raw);
        }
    } else ;
}
function resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>mergeOptions(resolved, m, optionMergeStrategies, true));
        mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, _shared.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function mergeOptions(to, from, strats, asMixin = false) {
    const { mixins, extends: extendsOptions } = from;
    if (extendsOptions) mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const internalOptionMergeStrats = {
    data: mergeDataFn,
    props: mergeEmitsOrPropsOptions,
    emits: mergeEmitsOrPropsOptions,
    // objects
    methods: mergeObjectOptions,
    computed: mergeObjectOptions,
    // lifecycle
    beforeCreate: mergeAsArray,
    created: mergeAsArray,
    beforeMount: mergeAsArray,
    mounted: mergeAsArray,
    beforeUpdate: mergeAsArray,
    updated: mergeAsArray,
    beforeDestroy: mergeAsArray,
    beforeUnmount: mergeAsArray,
    destroyed: mergeAsArray,
    unmounted: mergeAsArray,
    activated: mergeAsArray,
    deactivated: mergeAsArray,
    errorCaptured: mergeAsArray,
    serverPrefetch: mergeAsArray,
    // assets
    components: mergeObjectOptions,
    directives: mergeObjectOptions,
    // watch
    watch: mergeWatchOptions,
    // provide / inject
    provide: mergeDataFn,
    inject: mergeInject
};
function mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, _shared.extend)((0, _shared.isFunction)(to) ? to.call(this, this) : to, (0, _shared.isFunction)(from) ? from.call(this, this) : from);
    };
}
function mergeInject(to, from) {
    return mergeObjectOptions(normalizeInject(to), normalizeInject(from));
}
function normalizeInject(raw) {
    if ((0, _shared.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function mergeObjectOptions(to, from) {
    return to ? (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, _shared.isArray)(to) && (0, _shared.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, _shared.extend)(/* @__PURE__ */ Object.create(null), normalizePropsOrEmits(to), normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, _shared.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = mergeAsArray(to[key], from[key]);
    return merged;
}
function createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, _shared.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let uid$1 = 0;
function createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, _shared.isFunction)(rootComponent)) rootComponent = (0, _shared.extend)({}, rootComponent);
        if (rootProps != null && !(0, _shared.isObject)(rootProps)) rootProps = null;
        const context = createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, _shared.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, _shared.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || createVNode(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        devtoolsInitApp(app, version);
                    }
                    return getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    callWithAsyncErrorHandling(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = currentApp;
                currentApp = app;
                try {
                    return fn();
                } finally{
                    currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let currentApp = null;
function provide(key, value) {
    if (!currentInstance) ;
    else {
        let provides = currentInstance.provides;
        const parentProvides = currentInstance.parent && currentInstance.parent.provides;
        if (parentProvides === provides) provides = currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function inject(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = currentInstance || currentRenderingInstance;
    if (instance || currentApp) {
        const provides = currentApp ? currentApp._context.provides : instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, _shared.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function hasInjectionContext() {
    return !!(currentInstance || currentRenderingInstance || currentApp);
}
const internalObjectProto = {};
const createInternalObject = ()=>Object.create(internalObjectProto);
const isInternalObject = (obj)=>Object.getPrototypeOf(obj) === internalObjectProto;
function initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, _reactivity.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props, attrs, vnode: { patchFlag } } = instance;
    const rawCurrentProps = (0, _reactivity.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if (isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, _shared.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, _shared.camelize)(key);
                        props[camelizedKey] = resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if (setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, _shared.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, _shared.hyphenate)(key)) === key || !(0, _shared.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, _shared.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, _reactivity.trigger)(instance.attrs, "set", "");
}
function setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, _shared.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, _shared.hasOwn)(options, camelKey = (0, _shared.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, _reactivity.toRaw)(props);
        const castValues = rawCastValues || (0, _shared.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, _shared.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, _shared.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, _shared.isFunction)(defaultValue)) {
                const { propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, _shared.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const mixinPropsCache = /* @__PURE__ */ new WeakMap();
function normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = normalizePropsOptions(raw2, appContext, true);
            (0, _shared.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, (0, _shared.EMPTY_ARR));
        return 0, _shared.EMPTY_ARR;
    }
    if ((0, _shared.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, _shared.camelize)(raw[i]);
        if (validatePropName(normalizedKey)) normalized[normalizedKey] = (0, _shared.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, _shared.camelize)(key);
        if (validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, _shared.isArray)(opt) || (0, _shared.isFunction)(opt) ? {
                type: opt
            } : (0, _shared.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, _shared.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, _shared.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, _shared.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, _shared.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, _shared.isObject)(comp)) cache.set(comp, res);
    return res;
}
function validatePropName(key) {
    if (key[0] !== "$" && !(0, _shared.isReservedProp)(key)) return true;
    return false;
}
function getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function validateProps(rawProps, props, instance) {
    const resolvedValues = (0, _reactivity.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, _shared.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function validateProp(name, value, prop, props, isAbsent) {
    const { type, required, validator, skipCheck } = prop;
    if (required && isAbsent) {
        warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, _shared.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid, expectedType } = assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            warn$1(getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const isSimpleType = /* @__PURE__ */ (0, _shared.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function assertType(value, type) {
    let valid;
    const expectedType = getType(type);
    if (expectedType === "null") valid = value === null;
    else if (isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, _shared.isObject)(value);
    else if (expectedType === "Array") valid = (0, _shared.isArray)(value);
    else valid = value instanceof type;
    return {
        valid,
        expectedType
    };
}
function getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, _shared.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, _shared.toRawType)(value);
    const expectedValue = styleValue(value, expectedType);
    const receivedValue = styleValue(value, receivedType);
    if (expectedTypes.length === 1 && isExplicable(expectedType) && !isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if (isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const isInternalKey = (key)=>key[0] === "_" || key === "$stable";
const normalizeSlotValue = (value)=>(0, _shared.isArray)(value) ? value.map(normalizeVNode) : [
        normalizeVNode(value)
    ];
const normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = withCtx((...args)=>{
        return normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if (isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, _shared.isFunction)(value)) slots[key] = normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const normalizeVNodeSlots = (instance, children)=>{
    const normalized = normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || key !== "_") slots[key] = children[key];
};
const initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            assignSlots(slots, children, optimized);
            if (optimized) (0, _shared.def)(slots, "_", type, true);
        } else normalizeObjectSlots(children, slots);
    } else if (children) normalizeVNodeSlots(instance, children);
};
const updateSlots = (instance, children, optimized)=>{
    const { vnode, slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, _shared.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let supported;
let perf;
function startMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfStart(instance, type, isSupported() ? perf.now() : Date.now());
}
function endMeasure(instance, type) {
    if (instance.appContext.config.performance && isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        perf.mark(endTag);
        perf.measure(`<${formatComponentName(instance, instance.type)}> ${type}`, startTag, endTag);
        perf.clearMarks(startTag);
        perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsPerfEnd(instance, type, isSupported() ? perf.now() : Date.now());
}
function isSupported() {
    if (supported !== void 0) return supported;
    if (typeof window !== "undefined" && window.performance) {
        supported = true;
        perf = window.performance;
    } else supported = false;
    return supported;
}
function initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, _shared.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const queuePostRenderEffect = queueEffectWithSuspense;
function createRenderer(options) {
    return baseCreateRenderer(options);
}
function createHydrationRenderer(options) {
    return baseCreateRenderer(options, createHydrationFunctions);
}
function baseCreateRenderer(options, createHydrationFns) {
    initFeatureFlags();
    const target = (0, _shared.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, _shared.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type, ref, shapeFlag } = n2;
        switch(type){
            case Text:
                processText(n1, n2, container, anchor);
                break;
            case Comment:
                processCommentNode(n1, n2, container, anchor);
                break;
            case Static:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case Fragment:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el, anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el, anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props, shapeFlag, transition, dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, _shared.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, _shared.def)(el, "__vnode", vnode, true);
            (0, _shared.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? cloneIfMounted(children[i]) : normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag, dynamicChildren, dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, _shared.EMPTY_OBJ);
        const newProps = n2.props || (0, _shared.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === Fragment || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, _shared.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, _shared.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, _shared.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag, dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if (isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = createVNode(Comment);
                processCommentNode(null, placeholder, container, anchor);
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if (shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el, props } = initialVNode;
                const { bm, m, parent, root, type } = instance;
                const isAsyncWrapperVNode = isAsyncWrapper(initialVNode);
                toggleRecurse(instance, false);
                if (bm) (0, _shared.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) invokeVNodeHook(vnodeHook, parent, initialVNode);
                toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next, bu, u, parent, vnode } = instance;
                {
                    const nonHydratedAsyncRoot = locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            if (!instance.isUnmounted) componentUpdateFn();
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, _shared.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) invokeVNodeHook(vnodeHook, parent, next, vnode);
                toggleRecurse(instance, true);
                const nextTree = renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) updateHOCHostEl(instance, nextTree.el);
                if (u) queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) queuePostRenderEffect(()=>invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, _reactivity.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>queueJob(job);
        toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        updateProps(instance, nextVNode.props, prevProps, optimized);
        updateSlots(instance, nextVNode.children, optimized);
        (0, _reactivity.pauseTracking)();
        flushPreFlushCbs(instance);
        (0, _reactivity.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag, shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, _shared.EMPTY_ARR);
        c2 = c2 || (0, _shared.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? cloneIfMounted(c2[e2]) : normalizeVNode(c2[e2]);
            if (isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? cloneIfMounted(c2[i]) : normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? getSequence(newIndexToOldIndexMap) : (0, _shared.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchor = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el, type, transition, children, shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === Fragment) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === Static) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave, delayLeave, afterLeave } = transition;
                const remove2 = ()=>hostInsert(el, container, anchor);
                const performLeave = ()=>{
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type, props, ref, children, dynamicChildren, shapeFlag, patchFlag, dirs, cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) setRef(ref, null, parentSuspense, vnode, true);
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== Fragment || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === Fragment && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) queuePostRenderEffect(()=>{
            vnodeHook && invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type, el, anchor, transition } = vnode;
        if (type === Fragment) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === Static) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave, delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum, scope, job, subTree, um, m, a } = instance;
        invalidateMount(m);
        invalidateMount(a);
        if (bum) (0, _shared.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) queuePostRenderEffect(um, parentSuspense);
        queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            flushPreFlushCbs();
            flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render,
        hydrate,
        createApp: createAppAPI(render, hydrate)
    };
}
function resolveChildrenNamespace({ type, props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function toggleRecurse({ effect, job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, _shared.isArray)(ch1) && (0, _shared.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) traverseStaticChildren(c1, c2);
        }
        if (c2.type === Text) c2.el = c1.el;
    }
}
function getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return locateNonHydratedAsyncRoot(subComponent);
    }
}
function invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
const ssrContextKey = Symbol.for("v-scx");
const useSSRContext = ()=>{
    {
        const ctx = inject(ssrContextKey);
        ctx;
        return ctx;
    }
};
function watchEffect(effect, options) {
    return doWatch(effect, null, options);
}
function watchPostEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "post"
    });
}
function watchSyncEffect(effect, options) {
    return doWatch(effect, null, {
        flush: "sync"
    });
}
function watch(source, cb, options) {
    return doWatch(source, cb, options);
}
function doWatch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, flush, once } = options;
    const baseWatchOptions = (0, _shared.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if (isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = useSSRContext();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, _shared.NOOP);
            watchStopHandle.resume = (0, _shared.NOOP);
            watchStopHandle.pause = (0, _shared.NOOP);
            return watchStopHandle;
        }
    }
    const instance = currentInstance;
    baseWatchOptions.call = (fn, type, args)=>callWithAsyncErrorHandling(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, _reactivity.watch)(source, cb, baseWatchOptions);
    if (isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, _shared.isString)(source) ? source.includes(".") ? createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, _shared.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = setCurrentInstance(this);
    const res = doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function useModel(props, name, options = (0, _shared.EMPTY_OBJ)) {
    const i = getCurrentInstance();
    const camelizedName = (0, _shared.camelize)(name);
    const hyphenatedName = (0, _shared.hyphenate)(name);
    const modifiers = getModelModifiers(props, camelizedName);
    const res = (0, _reactivity.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, _shared.EMPTY_OBJ);
        let prevEmittedValue;
        watchSyncEffect(()=>{
            const propValue = props[camelizedName];
            if ((0, _shared.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, _shared.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, _shared.EMPTY_OBJ) && (0, _shared.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, _shared.hasChanged)(value, emittedValue) && (0, _shared.hasChanged)(value, prevSetValue) && !(0, _shared.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, _shared.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, _shared.camelize)(modelName)}Modifiers`] || props[`${(0, _shared.hyphenate)(modelName)}Modifiers`];
};
function emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, _shared.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, _shared.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, _shared.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, _shared.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, _shared.toHandlerKey)((0, _shared.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, _shared.toHandlerKey)((0, _shared.hyphenate)(event))];
    if (handler) callWithAsyncErrorHandling(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        callWithAsyncErrorHandling(onceHandler, instance, 6, args);
    }
}
function normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, _shared.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, _shared.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, _shared.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, _shared.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, _shared.extend)(normalized, raw);
    if ((0, _shared.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function isEmitListener(options, key) {
    if (!options || !(0, _shared.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, _shared.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, _shared.hasOwn)(options, (0, _shared.hyphenate)(key)) || (0, _shared.hasOwn)(options, key);
}
let accessedAttrs = false;
function markAttrsAccessed() {
    accessedAttrs = true;
}
function renderComponentRoot(instance) {
    const { type: Component, vnode, proxy, withProxy, propsOptions: [propsOptions], slots, attrs, emit, render, renderCache, props, data, setupState, ctx, inheritAttrs } = instance;
    const prev = setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = normalizeVNode(render2.length > 1 ? render2(props, {
                attrs,
                slots,
                emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        blockStack.length = 0;
        handleError(err, instance, 1);
        result = createVNode(Comment);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, _shared.isModelListener))) fallthroughAttrs = filterModelListeners(fallthroughAttrs, propsOptions);
                root = cloneVNode(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = cloneVNode(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) setTransitionHooks(root, vnode.transition);
    result = root;
    setCurrentRenderingInstance(prev);
    return result;
}
const getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        normalizeVNode(childRoot),
        setRoot
    ];
};
function filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if (isVNode(child)) {
            if (child.type !== Comment || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, _shared.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, _shared.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === Comment;
};
function shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function updateHOCHostEl({ vnode, parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const isSuspense = (type)=>type.__isSuspense;
let suspenseId = 0;
const SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: hydrateSuspense,
    normalize: normalizeSuspenseChildren
};
const Suspense = SuspenseImpl;
function triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, _shared.isFunction)(eventListener)) eventListener();
}
function mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        triggerEvent(vnode, "onPending");
        triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch, pendingBranch, isInFallback, isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if (isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        setActiveBranch(suspense, newBranch);
    } else {
        triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout, pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let hasWarned = false;
function createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode, remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, _shared.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode,
        parent: parentSuspense,
        parentComponent,
        namespace,
        container,
        hiddenContainer,
        deps: 0,
        pendingId: suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch, pendingBranch, pendingId, effects, parentComponent: parentComponent2, container: container2 } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        queuePostFlushCb(effects);
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) queuePostFlushCb(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                handleError(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) remove(placeholder);
                updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function normalizeSuspenseChildren(vnode) {
    const { shapeFlag, children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? normalizeSuspenseSlot(children.fallback) : createVNode(Comment);
}
function normalizeSuspenseSlot(s) {
    let block;
    if ((0, _shared.isFunction)(s)) {
        const trackBlock = isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            openBlock();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = currentBlock;
            closeBlock();
        }
    }
    if ((0, _shared.isArray)(s)) {
        const singleChild = filterSingleRoot(s);
        s = singleChild;
    }
    s = normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, _shared.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else queuePostFlushCb(fn);
}
function setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode, parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        updateHOCHostEl(parentComponent, el);
    }
}
function isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const Fragment = Symbol.for("v-fgt");
const Text = Symbol.for("v-txt");
const Comment = Symbol.for("v-cmt");
const Static = Symbol.for("v-stc");
const blockStack = [];
let currentBlock = null;
function openBlock(disableTracking = false) {
    blockStack.push(currentBlock = disableTracking ? null : []);
}
function closeBlock() {
    blockStack.pop();
    currentBlock = blockStack[blockStack.length - 1] || null;
}
let isBlockTreeEnabled = 1;
function setBlockTracking(value) {
    isBlockTreeEnabled += value;
    if (value < 0 && currentBlock) currentBlock.hasOnce = true;
}
function setupBlock(vnode) {
    vnode.dynamicChildren = isBlockTreeEnabled > 0 ? currentBlock || (0, _shared.EMPTY_ARR) : null;
    closeBlock();
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(vnode);
    return vnode;
}
function createElementBlock(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return setupBlock(createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function createBlock(type, props, children, patchFlag, dynamicProps) {
    return setupBlock(createVNode(type, props, children, patchFlag, dynamicProps, true));
}
function isVNode(value) {
    return value ? value.__v_isVNode === true : false;
}
function isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let vnodeArgsTransformer;
function transformVNodeArgs(transformer) {
    vnodeArgsTransformer = transformer;
}
const createVNodeWithArgsTransform = (...args)=>{
    return _createVNode(...vnodeArgsTransformer ? vnodeArgsTransformer(args, currentRenderingInstance) : args);
};
const normalizeKey = ({ key })=>key != null ? key : null;
const normalizeRef = ({ ref, ref_key, ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, _shared.isString)(ref) || (0, _reactivity.isRef)(ref) || (0, _shared.isFunction)(ref) ? {
        i: currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function createBaseVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === Fragment ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type,
        props,
        key: props && normalizeKey(props),
        ref: props && normalizeRef(props),
        scopeId: currentScopeId,
        slotScopeIds: null,
        children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag,
        patchFlag,
        dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, _shared.isString)(children) ? 8 : 16;
    if (isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) currentBlock.push(vnode);
    return vnode;
}
const createVNode = _createVNode;
function _createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === NULL_DYNAMIC_COMPONENT) type = Comment;
    if (isVNode(type)) {
        const cloned = cloneVNode(type, props, true);
        if (children) normalizeChildren(cloned, children);
        if (isBlockTreeEnabled > 0 && !isBlockNode && currentBlock) {
            if (cloned.shapeFlag & 6) currentBlock[currentBlock.indexOf(type)] = cloned;
            else currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if (isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = guardReactiveProps(props);
        let { class: klass, style } = props;
        if (klass && !(0, _shared.isString)(klass)) props.class = (0, _shared.normalizeClass)(klass);
        if ((0, _shared.isObject)(style)) {
            if ((0, _reactivity.isProxy)(style) && !(0, _shared.isArray)(style)) style = (0, _shared.extend)({}, style);
            props.style = (0, _shared.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, _shared.isString)(type) ? 1 : isSuspense(type) ? 128 : isTeleport(type) ? 64 : (0, _shared.isObject)(type) ? 4 : (0, _shared.isFunction)(type) ? 2 : 0;
    return createBaseVNode(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function guardReactiveProps(props) {
    if (!props) return null;
    return (0, _reactivity.isProxy)(props) || isInternalObject(props) ? (0, _shared.extend)({}, props) : props;
}
function cloneVNode(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props, ref, patchFlag, children, transition } = vnode;
    const mergedProps = extraProps ? mergeProps(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, _shared.isArray)(ref) ? ref.concat(normalizeRef(extraProps)) : [
            ref,
            normalizeRef(extraProps)
        ] : normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== Fragment ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && cloneVNode(vnode.ssContent),
        ssFallback: vnode.ssFallback && cloneVNode(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) setTransitionHooks(cloned, transition.clone(cloned));
    return cloned;
}
function deepCloneVNode(vnode) {
    const cloned = cloneVNode(vnode);
    if ((0, _shared.isArray)(vnode.children)) cloned.children = vnode.children.map(deepCloneVNode);
    return cloned;
}
function createTextVNode(text = " ", flag = 0) {
    return createVNode(Text, null, text, flag);
}
function createStaticVNode(content, numberOfNodes) {
    const vnode = createVNode(Static, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function createCommentVNode(text = "", asBlock = false) {
    return asBlock ? (openBlock(), createBlock(Comment, null, text)) : createVNode(Comment, null, text);
}
function normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return createVNode(Comment);
    else if ((0, _shared.isArray)(child)) return createVNode(Fragment, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (isVNode(child)) return cloneIfMounted(child);
    else return createVNode(Text, null, String(child));
}
function cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : cloneVNode(child);
}
function normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, _shared.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !isInternalObject(children)) children._ctx = currentRenderingInstance;
            else if (slotFlag === 3 && currentRenderingInstance) {
                if (currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, _shared.isFunction)(children)) {
        children = {
            default: children,
            _ctx: currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                createTextVNode(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function mergeProps(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, _shared.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, _shared.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, _shared.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, _shared.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    callWithAsyncErrorHandling(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const emptyAppContext = createAppContext();
let uid = 0;
function createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || emptyAppContext;
    const instance = {
        uid: uid++,
        vnode,
        type,
        parent,
        appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, _reactivity.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: normalizePropsOptions(type, appContext),
        emitsOptions: normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, _shared.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, _shared.EMPTY_OBJ),
        data: (0, _shared.EMPTY_OBJ),
        props: (0, _shared.EMPTY_OBJ),
        attrs: (0, _shared.EMPTY_OBJ),
        slots: (0, _shared.EMPTY_OBJ),
        refs: (0, _shared.EMPTY_OBJ),
        setupState: (0, _shared.EMPTY_OBJ),
        setupContext: null,
        // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let currentInstance = null;
const getCurrentInstance = ()=>currentInstance || currentRenderingInstance;
let internalSetCurrentInstance;
let setInSSRSetupState;
{
    const g = (0, _shared.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>currentInstance = v1);
    setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>isInSSRComponentSetup = v1);
}const setCurrentInstance = (instance)=>{
    const prev = currentInstance;
    internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        internalSetCurrentInstance(prev);
    };
};
const unsetCurrentInstance = ()=>{
    currentInstance && currentInstance.scope.off();
    internalSetCurrentInstance(null);
};
const isBuiltInTag = /* @__PURE__ */ (0, _shared.makeMap)("slot,component");
function validateComponentName(name, { isNativeTag }) {
    if (isBuiltInTag(name) || isNativeTag(name)) warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let isInSSRComponentSetup = false;
function setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && setInSSRSetupState(isSSR);
    const { props, children } = instance.vnode;
    const isStateful = isStatefulComponent(instance);
    initProps(instance, props, isStateful, isSSR);
    initSlots(instance, children, optimized);
    const setupResult = isStateful ? setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && setInSSRSetupState(false);
    return setupResult;
}
function setupStatefulComponent(instance, isSSR) {
    var _a;
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, PublicInstanceProxyHandlers);
    const { setup } = Component;
    if (setup) {
        (0, _reactivity.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? createSetupContext(instance) : null;
        const reset = setCurrentInstance(instance);
        const setupResult = callWithErrorHandling(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, _shared.isPromise)(setupResult);
        (0, _reactivity.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !isAsyncWrapper(instance)) markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then(unsetCurrentInstance, unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                handleError(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else handleSetupResult(instance, setupResult, isSSR);
    } else finishComponentSetup(instance, isSSR);
}
function handleSetupResult(instance, setupResult, isSSR) {
    if ((0, _shared.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, _shared.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, _reactivity.proxyRefs)(setupResult);
    }
    finishComponentSetup(instance, isSSR);
}
let compile;
let installWithProxy;
function registerRuntimeCompiler(_compile) {
    compile = _compile;
    installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const isRuntimeOnly = ()=>!compile;
function finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && compile && !Component.render) {
            const template = Component.template || resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement, compilerOptions } = instance.appContext.config;
                const { delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, _shared.extend)((0, _shared.extend)({
                    isCustomElement,
                    delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, _shared.NOOP);
        if (installWithProxy) installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = setCurrentInstance(instance);
        (0, _reactivity.pauseTracking)();
        try {
            applyOptions(instance);
        } finally{
            (0, _reactivity.resetTracking)();
            reset();
        }
    }
}
const attrsProxyHandlers = {
    get (target, key) {
        (0, _reactivity.track)(target, "get", "");
        return target[key];
    }
};
function getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, _reactivity.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose
    };
}
function getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, _reactivity.proxyRefs)((0, _reactivity.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in publicPropertiesMap) return publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const classifyRE = /(?:^|[-_])(\w)/g;
const classify = (str)=>str.replace(classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function getComponentName(Component, includeInferred = true) {
    return (0, _shared.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function formatComponentName(instance, Component, isRoot = false) {
    let name = getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? classify(name) : isRoot ? `App` : `Anonymous`;
}
function isClassComponent(value) {
    return (0, _shared.isFunction)(value) && "__vccOpts" in value;
}
const computed = (getterOrOptions, debugOptions)=>{
    const c = (0, _reactivity.computed)(getterOrOptions, debugOptions, isInSSRComponentSetup);
    return c;
};
function h(type, propsOrChildren, children) {
    const l = arguments.length;
    if (l === 2) {
        if ((0, _shared.isObject)(propsOrChildren) && !(0, _shared.isArray)(propsOrChildren)) {
            if (isVNode(propsOrChildren)) return createVNode(type, null, [
                propsOrChildren
            ]);
            return createVNode(type, propsOrChildren);
        } else return createVNode(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && isVNode(children)) children = [
            children
        ];
        return createVNode(type, propsOrChildren, children);
    }
}
function initCustomFormatter() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, _reactivity.toRaw)(instance.props)));
        if (instance.setupState !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, _shared.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, _reactivity.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, _shared.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, _shared.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, _reactivity.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, _shared.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, _shared.isArray)(opts) && opts.includes(key) || (0, _shared.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, _reactivity.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function withMemo(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && isMemoSame(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function isMemoSame(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, _shared.hasChanged)(prev[i], memo[i])) return false;
    }
    if (isBlockTreeEnabled > 0 && currentBlock) currentBlock.push(cached);
    return true;
}
const version = "3.5.12";
const warn = (0, _shared.NOOP);
const ErrorTypeStrings = ErrorTypeStrings$1;
const devtools = devtools$1;
const setDevtoolsHook = setDevtoolsHook$1;
const _ssrUtils = {
    createComponentInstance,
    setupComponent,
    renderComponentRoot,
    setCurrentRenderingInstance,
    isVNode: isVNode,
    normalizeVNode,
    getComponentPublicInstance,
    ensureValidVNode,
    pushWarningContext,
    popWarningContext
};
const ssrUtils = _ssrUtils;
const resolveFilter = null;
const compatUtils = null;
const DeprecationTypes = null;

},{"@vue/reactivity":"7Rc3Y","@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7Rc3Y":[function(require,module,exports) {
/**
* @vue/reactivity v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ARRAY_ITERATE_KEY", ()=>ARRAY_ITERATE_KEY);
parcelHelpers.export(exports, "EffectFlags", ()=>EffectFlags);
parcelHelpers.export(exports, "EffectScope", ()=>EffectScope);
parcelHelpers.export(exports, "ITERATE_KEY", ()=>ITERATE_KEY);
parcelHelpers.export(exports, "MAP_KEY_ITERATE_KEY", ()=>MAP_KEY_ITERATE_KEY);
parcelHelpers.export(exports, "ReactiveEffect", ()=>ReactiveEffect);
parcelHelpers.export(exports, "ReactiveFlags", ()=>ReactiveFlags);
parcelHelpers.export(exports, "TrackOpTypes", ()=>TrackOpTypes);
parcelHelpers.export(exports, "TriggerOpTypes", ()=>TriggerOpTypes);
parcelHelpers.export(exports, "WatchErrorCodes", ()=>WatchErrorCodes);
parcelHelpers.export(exports, "computed", ()=>computed);
parcelHelpers.export(exports, "customRef", ()=>customRef);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "effectScope", ()=>effectScope);
parcelHelpers.export(exports, "enableTracking", ()=>enableTracking);
parcelHelpers.export(exports, "getCurrentScope", ()=>getCurrentScope);
parcelHelpers.export(exports, "getCurrentWatcher", ()=>getCurrentWatcher);
parcelHelpers.export(exports, "isProxy", ()=>isProxy);
parcelHelpers.export(exports, "isReactive", ()=>isReactive);
parcelHelpers.export(exports, "isReadonly", ()=>isReadonly);
parcelHelpers.export(exports, "isRef", ()=>isRef);
parcelHelpers.export(exports, "isShallow", ()=>isShallow);
parcelHelpers.export(exports, "markRaw", ()=>markRaw);
parcelHelpers.export(exports, "onEffectCleanup", ()=>onEffectCleanup);
parcelHelpers.export(exports, "onScopeDispose", ()=>onScopeDispose);
parcelHelpers.export(exports, "onWatcherCleanup", ()=>onWatcherCleanup);
parcelHelpers.export(exports, "pauseTracking", ()=>pauseTracking);
parcelHelpers.export(exports, "proxyRefs", ()=>proxyRefs);
parcelHelpers.export(exports, "reactive", ()=>reactive);
parcelHelpers.export(exports, "reactiveReadArray", ()=>reactiveReadArray);
parcelHelpers.export(exports, "readonly", ()=>readonly);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "resetTracking", ()=>resetTracking);
parcelHelpers.export(exports, "shallowReactive", ()=>shallowReactive);
parcelHelpers.export(exports, "shallowReadArray", ()=>shallowReadArray);
parcelHelpers.export(exports, "shallowReadonly", ()=>shallowReadonly);
parcelHelpers.export(exports, "shallowRef", ()=>shallowRef);
parcelHelpers.export(exports, "stop", ()=>stop);
parcelHelpers.export(exports, "toRaw", ()=>toRaw);
parcelHelpers.export(exports, "toReactive", ()=>toReactive);
parcelHelpers.export(exports, "toReadonly", ()=>toReadonly);
parcelHelpers.export(exports, "toRef", ()=>toRef);
parcelHelpers.export(exports, "toRefs", ()=>toRefs);
parcelHelpers.export(exports, "toValue", ()=>toValue);
parcelHelpers.export(exports, "track", ()=>track);
parcelHelpers.export(exports, "traverse", ()=>traverse);
parcelHelpers.export(exports, "trigger", ()=>trigger);
parcelHelpers.export(exports, "triggerRef", ()=>triggerRef);
parcelHelpers.export(exports, "unref", ()=>unref);
parcelHelpers.export(exports, "watch", ()=>watch);
var _shared = require("@vue/shared");
function warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let activeEffectScope;
class EffectScope {
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.parent = activeEffectScope;
        if (!detached && activeEffectScope) this.index = (activeEffectScope.scopes || (activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = activeEffectScope;
            try {
                activeEffectScope = this;
                return fn();
            } finally{
                activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        activeEffectScope = this;
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        activeEffectScope = this.parent;
    }
    stop(fromParent) {
        if (this._active) {
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
            this._active = false;
        }
    }
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn, failSilently = false) {
    if (activeEffectScope) activeEffectScope.cleanups.push(fn);
}
let activeSub;
const EffectFlags = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED"
};
const pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class ReactiveEffect {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if (activeEffectScope && activeEffectScope.active) activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if (pausedQueueEffects.has(this)) {
                pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        cleanupEffect(this);
        prepareDeps(this);
        const prevEffect = activeSub;
        const prevShouldTrack = shouldTrack;
        activeSub = this;
        shouldTrack = true;
        try {
            return this.fn();
        } finally{
            cleanupDeps(this);
            activeSub = prevEffect;
            shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)removeSub(link);
            this.deps = this.depsTail = void 0;
            cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if (isDirty(this)) this.run();
    }
    get dirty() {
        return isDirty(this);
    }
}
let batchDepth = 0;
let batchedSub;
let batchedComputed;
function batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = batchedComputed;
        batchedComputed = sub;
        return;
    }
    sub.next = batchedSub;
    batchedSub = sub;
}
function startBatch() {
    batchDepth++;
}
function endBatch() {
    if (--batchDepth > 0) return;
    if (batchedComputed) {
        let e = batchedComputed;
        batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while(batchedSub){
        let e = batchedSub;
        batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            removeSub(link);
            removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && (refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === globalVersion) return;
    computed.globalVersion = globalVersion;
    const dep = computed.dep;
    computed.flags |= 2;
    if (dep.version > 0 && !computed.isSSR && computed.deps && !isDirty(computed)) {
        computed.flags &= -3;
        return;
    }
    const prevSub = activeSub;
    const prevShouldTrack = shouldTrack;
    activeSub = computed;
    shouldTrack = true;
    try {
        prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, _shared.hasChanged)(value, computed._value)) {
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        activeSub = prevSub;
        shouldTrack = prevShouldTrack;
        cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function removeSub(link, soft = false) {
    const { dep, prevSub, nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function removeDep(link) {
    const { prevDep, nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function effect(fn, options) {
    if (fn.effect instanceof ReactiveEffect) fn = fn.effect.fn;
    const e = new ReactiveEffect(fn);
    if (options) (0, _shared.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function stop(runner) {
    runner.effect.stop();
}
let shouldTrack = true;
const trackStack = [];
function pauseTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = false;
}
function enableTracking() {
    trackStack.push(shouldTrack);
    shouldTrack = true;
}
function resetTracking() {
    const last = trackStack.pop();
    shouldTrack = last === void 0 ? true : last;
}
function onEffectCleanup(fn, failSilently = false) {
    if (activeSub instanceof ReactiveEffect) activeSub.cleanup = fn;
}
function cleanupEffect(e) {
    const { cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = activeSub;
        activeSub = void 0;
        try {
            cleanup();
        } finally{
            activeSub = prevSub;
        }
    }
}
let globalVersion = 0;
class Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class Dep {
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
    }
    track(debugInfo) {
        if (!activeSub || !shouldTrack || activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== activeSub) {
            link = this.activeLink = new Link(activeSub, this);
            if (!activeSub.deps) activeSub.deps = activeSub.depsTail = link;
            else {
                link.prevDep = activeSub.depsTail;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
            }
            addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = activeSub.depsTail;
                link.nextDep = void 0;
                activeSub.depsTail.nextDep = link;
                activeSub.depsTail = link;
                if (activeSub.deps === link) activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            endBatch();
        }
    }
}
function addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const targetMap = /* @__PURE__ */ new WeakMap();
const ITERATE_KEY = Symbol("");
const MAP_KEY_ITERATE_KEY = Symbol("");
const ARRAY_ITERATE_KEY = Symbol("");
function track(target, type, key) {
    if (shouldTrack && activeSub) {
        let depsMap = targetMap.get(target);
        if (!depsMap) targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = targetMap.get(target);
    if (!depsMap) {
        globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, _shared.isArray)(target);
        const isArrayIndex = targetIsArray && (0, _shared.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === ARRAY_ITERATE_KEY || !(0, _shared.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get(ARRAY_ITERATE_KEY));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get(ITERATE_KEY));
                        if ((0, _shared.isMap)(target)) run(depsMap.get(MAP_KEY_ITERATE_KEY));
                    }
                    break;
                case "set":
                    if ((0, _shared.isMap)(target)) run(depsMap.get(ITERATE_KEY));
                    break;
            }
        }
    }
    endBatch();
}
function getDepFromReactive(object, key) {
    const depMap = targetMap.get(object);
    return depMap && depMap.get(key);
}
function reactiveReadArray(array) {
    const raw = toRaw(array);
    if (raw === array) return raw;
    track(raw, "iterate", ARRAY_ITERATE_KEY);
    return isShallow(array) ? raw : raw.map(toReactive);
}
function shallowReadArray(arr) {
    track(arr = toRaw(arr), "iterate", ARRAY_ITERATE_KEY);
    return arr;
}
const arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return iterator(this, Symbol.iterator, toReactive);
    },
    concat (...args) {
        return reactiveReadArray(this).concat(...args.map((x)=>(0, _shared.isArray)(x) ? reactiveReadArray(x) : x));
    },
    entries () {
        return iterator(this, "entries", (value)=>{
            value[1] = toReactive(value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return apply(this, "filter", fn, thisArg, (v)=>v.map(toReactive), arguments);
    },
    find (fn, thisArg) {
        return apply(this, "find", fn, thisArg, toReactive, arguments);
    },
    findIndex (fn, thisArg) {
        return apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return apply(this, "findLast", fn, thisArg, toReactive, arguments);
    },
    findLastIndex (fn, thisArg) {
        return apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return reactiveReadArray(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimisation required
    lastIndexOf (...args) {
        return searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return noTracking(this, "pop");
    },
    push (...args) {
        return noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return noTracking(this, "splice", args);
    },
    toReversed () {
        return reactiveReadArray(this).toReversed();
    },
    toSorted (comparer) {
        return reactiveReadArray(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return reactiveReadArray(this).toSpliced(...args);
    },
    unshift (...args) {
        return noTracking(this, "unshift", args);
    },
    values () {
        return iterator(this, "values", toReactive);
    }
};
function iterator(self, method, wrapValue) {
    const arr = shallowReadArray(self);
    const iter = arr[method]();
    if (arr !== self && !isShallow(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (result.value) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const arrayProto = Array.prototype;
function apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = shallowReadArray(self);
    const needsWrap = arr !== self && !isShallow(self);
    const methodFn = arr[method];
    if (methodFn !== arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? toReactive(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, toReactive(item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function reduce(self, method, fn, args) {
    const arr = shallowReadArray(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!isShallow(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, toReactive(item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function searchProxy(self, method, args) {
    const arr = toRaw(self);
    track(arr, "iterate", ARRAY_ITERATE_KEY);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && isProxy(args[0])) {
        args[0] = toRaw(args[0]);
        return arr[method](...args);
    }
    return res;
}
function noTracking(self, method, args = []) {
    pauseTracking();
    startBatch();
    const res = toRaw(self)[method].apply(self, args);
    endBatch();
    resetTracking();
    return res;
}
const isNonTrackableKeys = /* @__PURE__ */ (0, _shared.makeMap)(`__proto__,__v_isRef,__isVue`);
const builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, _shared.isSymbol)));
function hasOwnProperty(key) {
    if (!(0, _shared.isSymbol)(key)) key = String(key);
    const obj = toRaw(this);
    track(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? shallowReadonlyMap : readonlyMap : isShallow2 ? shallowReactiveMap : reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, _shared.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        isRef(target) ? target : receiver);
        if ((0, _shared.isSymbol)(key) ? builtInSymbols.has(key) : isNonTrackableKeys(key)) return res;
        if (!isReadonly2) track(target, "get", key);
        if (isShallow2) return res;
        if (isRef(res)) return targetIsArray && (0, _shared.isIntegerKey)(key) ? res : res.value;
        if ((0, _shared.isObject)(res)) return isReadonly2 ? readonly(res) : reactive(res);
        return res;
    }
}
class MutableReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        if (!this._isShallow) {
            const isOldValueReadonly = isReadonly(oldValue);
            if (!isShallow(value) && !isReadonly(value)) {
                oldValue = toRaw(oldValue);
                value = toRaw(value);
            }
            if (!(0, _shared.isArray)(target) && isRef(oldValue) && !isRef(value)) {
                if (isOldValueReadonly) return false;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = (0, _shared.isArray)(target) && (0, _shared.isIntegerKey)(key) ? Number(key) < target.length : (0, _shared.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, isRef(target) ? target : receiver);
        if (target === toRaw(receiver)) {
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, _shared.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) trigger(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, _shared.isSymbol)(key) || !builtInSymbols.has(key)) track(target, "has", key);
        return result;
    }
    ownKeys(target) {
        track(target, "iterate", (0, _shared.isArray)(target) ? "length" : ITERATE_KEY);
        return Reflect.ownKeys(target);
    }
}
class ReadonlyReactiveHandler extends BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const mutableHandlers = /* @__PURE__ */ new MutableReactiveHandler();
const readonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler();
const shallowReactiveHandlers = /* @__PURE__ */ new MutableReactiveHandler(true);
const shallowReadonlyHandlers = /* @__PURE__ */ new ReadonlyReactiveHandler(true);
const toShallow = (value)=>value;
const getProto = (v)=>Reflect.getPrototypeOf(v);
function createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = toRaw(target);
        const targetIsMap = (0, _shared.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? toShallow : isReadonly2 ? toReadonly : toReactive;
        !isReadonly2 && track(rawTarget, "iterate", isKeyOnly ? MAP_KEY_ITERATE_KEY : ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value, done } = innerIterator.next();
                return done ? {
                    value,
                    done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "get", key);
                track(rawTarget, "get", rawKey);
            }
            const { has } = getProto(rawTarget);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && track(toRaw(target), "iterate", ITERATE_KEY);
            return Reflect.get(target, "size", target);
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = toRaw(target);
            const rawKey = toRaw(key);
            if (!readonly) {
                if ((0, _shared.hasChanged)(key, rawKey)) track(rawTarget, "has", key);
                track(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = toRaw(target);
            const wrap = shallow ? toShallow : readonly ? toReadonly : toReactive;
            !readonly && track(rawTarget, "iterate", ITERATE_KEY);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, _shared.extend)(instrumentations, readonly ? {
        add: createReadonlyMethod("add"),
        set: createReadonlyMethod("set"),
        delete: createReadonlyMethod("delete"),
        clear: createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            const target = toRaw(this);
            const proto = getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                trigger(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !isShallow(value) && !isReadonly(value)) value = toRaw(value);
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) trigger(target, "add", key, value);
            else if ((0, _shared.hasChanged)(value, oldValue)) trigger(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = toRaw(this);
            const { has, get } = getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = toRaw(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) trigger(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = toRaw(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) trigger(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, _shared.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const mutableCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, false)
};
const shallowCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(false, true)
};
const readonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, false)
};
const shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ createInstrumentationGetter(true, true)
};
function checkIdentityKeys(target, has, key) {
    const rawKey = toRaw(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, _shared.toRawType)(target);
        warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const reactiveMap = /* @__PURE__ */ new WeakMap();
const shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const readonlyMap = /* @__PURE__ */ new WeakMap();
const shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : targetTypeMap((0, _shared.toRawType)(value));
}
function reactive(target) {
    if (isReadonly(target)) return target;
    return createReactiveObject(target, false, mutableHandlers, mutableCollectionHandlers, reactiveMap);
}
function shallowReactive(target) {
    return createReactiveObject(target, false, shallowReactiveHandlers, shallowCollectionHandlers, shallowReactiveMap);
}
function readonly(target) {
    return createReactiveObject(target, true, readonlyHandlers, readonlyCollectionHandlers, readonlyMap);
}
function shallowReadonly(target) {
    return createReactiveObject(target, true, shallowReadonlyHandlers, shallowReadonlyCollectionHandlers, shallowReadonlyMap);
}
function createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, _shared.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function isReactive(value) {
    if (isReadonly(value)) return isReactive(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function isReadonly(value) {
    return !!(value && value["__v_isReadonly"]);
}
function isShallow(value) {
    return !!(value && value["__v_isShallow"]);
}
function isProxy(value) {
    return value ? !!value["__v_raw"] : false;
}
function toRaw(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? toRaw(raw) : observed;
}
function markRaw(value) {
    if (!(0, _shared.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, _shared.def)(value, "__v_skip", true);
    return value;
}
const toReactive = (value)=>(0, _shared.isObject)(value) ? reactive(value) : value;
const toReadonly = (value)=>(0, _shared.isObject)(value) ? readonly(value) : value;
function isRef(r) {
    return r ? r["__v_isRef"] === true : false;
}
function ref(value) {
    return createRef(value, false);
}
function shallowRef(value) {
    return createRef(value, true);
}
function createRef(rawValue, shallow) {
    if (isRef(rawValue)) return rawValue;
    return new RefImpl(rawValue, shallow);
}
class RefImpl {
    constructor(value, isShallow2){
        this.dep = new Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : toRaw(value);
        this._value = isShallow2 ? value : toReactive(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || isShallow(newValue) || isReadonly(newValue);
        newValue = useDirectValue ? newValue : toRaw(newValue);
        if ((0, _shared.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : toReactive(newValue);
            this.dep.trigger();
        }
    }
}
function triggerRef(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function unref(ref2) {
    return isRef(ref2) ? ref2.value : ref2;
}
function toValue(source) {
    return (0, _shared.isFunction)(source) ? source() : unref(source);
}
const shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : unref(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (isRef(oldValue) && !isRef(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function proxyRefs(objectWithRefs) {
    return isReactive(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, shallowUnwrapHandlers);
}
class CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new Dep();
        const { get, set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function customRef(factory) {
    return new CustomRefImpl(factory);
}
function toRefs(object) {
    const ret = (0, _shared.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = propertyToRef(object, key);
    return ret;
}
class ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
    }
    get value() {
        const val = this._object[this._key];
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        this._object[this._key] = newVal;
    }
    get dep() {
        return getDepFromReactive(toRaw(this._object), this._key);
    }
}
class GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
function toRef(source, key, defaultValue) {
    if (isRef(source)) return source;
    else if ((0, _shared.isFunction)(source)) return new GetterRefImpl(source);
    else if ((0, _shared.isObject)(source) && arguments.length > 1) return propertyToRef(source, key, defaultValue);
    else return ref(source);
}
function propertyToRef(source, key, defaultValue) {
    const val = source[key];
    return isRef(val) ? val : new ObjectRefImpl(source, key, defaultValue);
}
class ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        activeSub !== this) {
            batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
function computed(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, _shared.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const TrackOpTypes = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const TriggerOpTypes = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const ReactiveFlags = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const WatchErrorCodes = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const INITIAL_WATCHER_VALUE = {};
const cleanupMap = /* @__PURE__ */ new WeakMap();
let activeWatcher = void 0;
function getCurrentWatcher() {
    return activeWatcher;
}
function onWatcherCleanup(cleanupFn, failSilently = false, owner = activeWatcher) {
    if (owner) {
        let cleanups = cleanupMap.get(owner);
        if (!cleanups) cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function watch(source, cb, options = (0, _shared.EMPTY_OBJ)) {
    const { immediate, deep, once, scheduler, augmentJob, call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if (isShallow(source2) || deep === false || deep === 0) return traverse(source2, 1);
        return traverse(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if (isRef(source)) {
        getter = ()=>source.value;
        forceTrigger = isShallow(source);
    } else if (isReactive(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, _shared.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>isReactive(s) || isShallow(s));
        getter = ()=>source.map((s)=>{
                if (isRef(s)) return s.value;
                else if (isReactive(s)) return reactiveGetter(s);
                else if ((0, _shared.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, _shared.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                pauseTracking();
                try {
                    cleanup();
                } finally{
                    resetTracking();
                }
            }
            const currentEffect = activeWatcher;
            activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                activeWatcher = currentEffect;
            }
        };
    } else getter = (0, _shared.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>traverse(baseGetter(), depth);
    }
    const scope = getCurrentScope();
    const watchHandle = ()=>{
        effect.stop();
        if (scope) (0, _shared.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill(INITIAL_WATCHER_VALUE) : INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, _shared.hasChanged)(v, oldValue[i])) : (0, _shared.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = activeWatcher;
                activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                    oldValue = newValue;
                } finally{
                    activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new ReactiveEffect(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>onWatcherCleanup(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function traverse(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, _shared.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value)) return value;
    seen.add(value);
    depth--;
    if (isRef(value)) traverse(value.value, depth, seen);
    else if ((0, _shared.isArray)(value)) for(let i = 0; i < value.length; i++)traverse(value[i], depth, seen);
    else if ((0, _shared.isSet)(value) || (0, _shared.isMap)(value)) value.forEach((v)=>{
        traverse(v, depth, seen);
    });
    else if ((0, _shared.isPlainObject)(value)) {
        for(const key in value)traverse(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) traverse(value[key], depth, seen);
    }
    return value;
}

},{"@vue/shared":"aqBjR","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aqBjR":[function(require,module,exports) {
/**
* @vue/shared v3.5.12
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ /*! #__NO_SIDE_EFFECTS__ */ // @__NO_SIDE_EFFECTS__
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY_ARR", ()=>EMPTY_ARR);
parcelHelpers.export(exports, "EMPTY_OBJ", ()=>EMPTY_OBJ);
parcelHelpers.export(exports, "NO", ()=>NO);
parcelHelpers.export(exports, "NOOP", ()=>NOOP);
parcelHelpers.export(exports, "PatchFlagNames", ()=>PatchFlagNames);
parcelHelpers.export(exports, "PatchFlags", ()=>PatchFlags);
parcelHelpers.export(exports, "ShapeFlags", ()=>ShapeFlags);
parcelHelpers.export(exports, "SlotFlags", ()=>SlotFlags);
parcelHelpers.export(exports, "camelize", ()=>camelize);
parcelHelpers.export(exports, "capitalize", ()=>capitalize);
parcelHelpers.export(exports, "cssVarNameEscapeSymbolsRE", ()=>cssVarNameEscapeSymbolsRE);
parcelHelpers.export(exports, "def", ()=>def);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "escapeHtmlComment", ()=>escapeHtmlComment);
parcelHelpers.export(exports, "extend", ()=>extend);
parcelHelpers.export(exports, "genCacheKey", ()=>genCacheKey);
parcelHelpers.export(exports, "genPropsAccessExp", ()=>genPropsAccessExp);
parcelHelpers.export(exports, "generateCodeFrame", ()=>generateCodeFrame);
parcelHelpers.export(exports, "getEscapedCssVarName", ()=>getEscapedCssVarName);
parcelHelpers.export(exports, "getGlobalThis", ()=>getGlobalThis);
parcelHelpers.export(exports, "hasChanged", ()=>hasChanged);
parcelHelpers.export(exports, "hasOwn", ()=>hasOwn);
parcelHelpers.export(exports, "hyphenate", ()=>hyphenate);
parcelHelpers.export(exports, "includeBooleanAttr", ()=>includeBooleanAttr);
parcelHelpers.export(exports, "invokeArrayFns", ()=>invokeArrayFns);
parcelHelpers.export(exports, "isArray", ()=>isArray);
parcelHelpers.export(exports, "isBooleanAttr", ()=>isBooleanAttr);
parcelHelpers.export(exports, "isBuiltInDirective", ()=>isBuiltInDirective);
parcelHelpers.export(exports, "isDate", ()=>isDate);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
parcelHelpers.export(exports, "isGloballyAllowed", ()=>isGloballyAllowed);
parcelHelpers.export(exports, "isGloballyWhitelisted", ()=>isGloballyWhitelisted);
parcelHelpers.export(exports, "isHTMLTag", ()=>isHTMLTag);
parcelHelpers.export(exports, "isIntegerKey", ()=>isIntegerKey);
parcelHelpers.export(exports, "isKnownHtmlAttr", ()=>isKnownHtmlAttr);
parcelHelpers.export(exports, "isKnownMathMLAttr", ()=>isKnownMathMLAttr);
parcelHelpers.export(exports, "isKnownSvgAttr", ()=>isKnownSvgAttr);
parcelHelpers.export(exports, "isMap", ()=>isMap);
parcelHelpers.export(exports, "isMathMLTag", ()=>isMathMLTag);
parcelHelpers.export(exports, "isModelListener", ()=>isModelListener);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "isOn", ()=>isOn);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "isRegExp", ()=>isRegExp);
parcelHelpers.export(exports, "isRenderableAttrValue", ()=>isRenderableAttrValue);
parcelHelpers.export(exports, "isReservedProp", ()=>isReservedProp);
parcelHelpers.export(exports, "isSSRSafeAttrName", ()=>isSSRSafeAttrName);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
parcelHelpers.export(exports, "isSet", ()=>isSet);
parcelHelpers.export(exports, "isSpecialBooleanAttr", ()=>isSpecialBooleanAttr);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isSymbol", ()=>isSymbol);
parcelHelpers.export(exports, "isVoidTag", ()=>isVoidTag);
parcelHelpers.export(exports, "looseEqual", ()=>looseEqual);
parcelHelpers.export(exports, "looseIndexOf", ()=>looseIndexOf);
parcelHelpers.export(exports, "looseToNumber", ()=>looseToNumber);
parcelHelpers.export(exports, "makeMap", ()=>makeMap);
parcelHelpers.export(exports, "normalizeClass", ()=>normalizeClass);
parcelHelpers.export(exports, "normalizeProps", ()=>normalizeProps);
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "objectToString", ()=>objectToString);
parcelHelpers.export(exports, "parseStringStyle", ()=>parseStringStyle);
parcelHelpers.export(exports, "propsToAttrMap", ()=>propsToAttrMap);
parcelHelpers.export(exports, "remove", ()=>remove);
parcelHelpers.export(exports, "slotFlagsText", ()=>slotFlagsText);
parcelHelpers.export(exports, "stringifyStyle", ()=>stringifyStyle);
parcelHelpers.export(exports, "toDisplayString", ()=>toDisplayString);
parcelHelpers.export(exports, "toHandlerKey", ()=>toHandlerKey);
parcelHelpers.export(exports, "toNumber", ()=>toNumber);
parcelHelpers.export(exports, "toRawType", ()=>toRawType);
parcelHelpers.export(exports, "toTypeString", ()=>toTypeString);
var global = arguments[3];
function makeMap(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const EMPTY_OBJ = {};
const EMPTY_ARR = [];
const NOOP = ()=>{};
const NO = ()=>false;
const isOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const isModelListener = (key)=>key.startsWith("onUpdate:");
const extend = Object.assign;
const remove = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const hasOwnProperty = Object.prototype.hasOwnProperty;
const hasOwn = (val, key)=>hasOwnProperty.call(val, key);
const isArray = Array.isArray;
const isMap = (val)=>toTypeString(val) === "[object Map]";
const isSet = (val)=>toTypeString(val) === "[object Set]";
const isDate = (val)=>toTypeString(val) === "[object Date]";
const isRegExp = (val)=>toTypeString(val) === "[object RegExp]";
const isFunction = (val)=>typeof val === "function";
const isString = (val)=>typeof val === "string";
const isSymbol = (val)=>typeof val === "symbol";
const isObject = (val)=>val !== null && typeof val === "object";
const isPromise = (val)=>{
    return (isObject(val) || isFunction(val)) && isFunction(val.then) && isFunction(val.catch);
};
const objectToString = Object.prototype.toString;
const toTypeString = (value)=>objectToString.call(value);
const toRawType = (value)=>{
    return toTypeString(value).slice(8, -1);
};
const isPlainObject = (val)=>toTypeString(val) === "[object Object]";
const isIntegerKey = (key)=>isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const isReservedProp = /* @__PURE__ */ makeMap(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const isBuiltInDirective = /* @__PURE__ */ makeMap("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const camelizeRE = /-(\w)/g;
const camelize = cacheStringFunction((str)=>{
    return str.replace(camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = cacheStringFunction((str)=>str.replace(hyphenateRE, "-$1").toLowerCase());
const capitalize = cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const toHandlerKey = cacheStringFunction((str)=>{
    const s = str ? `on${capitalize(str)}` : ``;
    return s;
});
const hasChanged = (value, oldValue)=>!Object.is(value, oldValue);
const invokeArrayFns = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const def = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable,
        value
    });
};
const looseToNumber = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const toNumber = (val)=>{
    const n = isString(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let _globalThis;
const getGlobalThis = ()=>{
    return _globalThis || (_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : {});
};
const identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function genPropsAccessExp(name) {
    return identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function genCacheKey(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const PatchFlags = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const PatchFlagNames = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `HOISTED`,
    [-2]: `BAIL`
};
const ShapeFlags = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const SlotFlags = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const slotFlagsText = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const isGloballyAllowed = /* @__PURE__ */ makeMap(GLOBALS_ALLOWED);
const isGloballyWhitelisted = isGloballyAllowed;
const range = 2;
function generateCodeFrame(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - range; j <= i + range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function normalizeStyle(value) {
    if (isArray(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = isString(item) ? parseStringStyle(item) : normalizeStyle(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if (isString(value) || isObject(value)) return value;
}
const listDelimiterRE = /;(?![^(]*\))/g;
const propertyDelimiterRE = /:([^]+)/;
const styleCommentRE = /\/\*[^]*?\*\//g;
function parseStringStyle(cssText) {
    const ret = {};
    cssText.replace(styleCommentRE, "").split(listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split(propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function stringifyStyle(styles) {
    let ret = "";
    if (!styles || isString(styles)) return ret;
    for(const key in styles){
        const value = styles[key];
        if (isString(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : hyphenate(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function normalizeClass(value) {
    let res = "";
    if (isString(value)) res = value;
    else if (isArray(value)) for(let i = 0; i < value.length; i++){
        const normalized = normalizeClass(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if (isObject(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function normalizeProps(props) {
    if (!props) return null;
    let { class: klass, style } = props;
    if (klass && !isString(klass)) props.class = normalizeClass(klass);
    if (style) props.style = normalizeStyle(style);
    return props;
}
const HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const isHTMLTag = /* @__PURE__ */ makeMap(HTML_TAGS);
const isSVGTag = /* @__PURE__ */ makeMap(SVG_TAGS);
const isMathMLTag = /* @__PURE__ */ makeMap(MATH_TAGS);
const isVoidTag = /* @__PURE__ */ makeMap(VOID_TAGS);
const specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const isSpecialBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs);
const isBooleanAttr = /* @__PURE__ */ makeMap(specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function includeBooleanAttr(value) {
    return !!value || value === "";
}
const unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const attrValidationCache = {};
function isSSRSafeAttrName(name) {
    if (attrValidationCache.hasOwnProperty(name)) return attrValidationCache[name];
    const isUnsafe = unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return attrValidationCache[name] = !isUnsafe;
}
const propsToAttrMap = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const isKnownHtmlAttr = /* @__PURE__ */ makeMap(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const isKnownSvgAttr = /* @__PURE__ */ makeMap(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const isKnownMathMLAttr = /* @__PURE__ */ makeMap(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function isRenderableAttrValue(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const escapeRE = /["'&<>]/;
function escapeHtml(string) {
    const str = "" + string;
    const match = escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function escapeHtmlComment(src) {
    return src.replace(commentStripRE, "");
}
const cssVarNameEscapeSymbolsRE = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function getEscapedCssVarName(key, doubleEscape) {
    return key.replace(cssVarNameEscapeSymbolsRE, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = looseEqual(a[i], b[i]);
    return equal;
}
function looseEqual(a, b) {
    if (a === b) return true;
    let aValidType = isDate(a);
    let bValidType = isDate(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = isSymbol(a);
    bValidType = isSymbol(b);
    if (aValidType || bValidType) return a === b;
    aValidType = isArray(a);
    bValidType = isArray(b);
    if (aValidType || bValidType) return aValidType && bValidType ? looseCompareArrays(a, b) : false;
    aValidType = isObject(a);
    bValidType = isObject(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !looseEqual(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function looseIndexOf(arr, val) {
    return arr.findIndex((item)=>looseEqual(item, val));
}
const isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const toDisplayString = (val)=>{
    return isString(val) ? val : val == null ? "" : isArray(val) || isObject(val) && (val.toString === objectToString || !isFunction(val.toString)) ? isRef(val) ? toDisplayString(val.value) : JSON.stringify(val, replacer, 2) : String(val);
};
const replacer = (_key, val)=>{
    if (isRef(val)) return replacer(_key, val.value);
    else if (isMap(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if (isSet(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>stringifySymbol(v))
    };
    else if (isSymbol(val)) return stringifySymbol(val);
    else if (isObject(val) && !isArray(val) && !isPlainObject(val)) return String(val);
    return val;
};
const stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    isSymbol(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"k3151":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"64lpT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("6b121dd5925f3cd3");
    if (script.__esModule) script = script.default;
    script.render = require("9271bc85f329317f").render;
    require("f5f51fc8a06939ca").default(script);
    script.__scopeId = "data-v-73d2e3";
    script.__file = "ChartApp.vue";
};
initialize();
exports.default = script;

},{"6b121dd5925f3cd3":"470YD","9271bc85f329317f":"8vJM0","f5f51fc8a06939ca":"hlYYQ","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"470YD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
var _chartVue = require("./Chart.vue");
var _chartVueDefault = parcelHelpers.interopDefault(_chartVue);
var _tabsVue = require("./Tabs.vue");
var _tabsVueDefault = parcelHelpers.interopDefault(_tabsVue);
var _tabTableVue = require("./TabTable.vue");
var _tabTableVueDefault = parcelHelpers.interopDefault(_tabTableVue);
//template refs
exports.default = {
    __name: "ChartApp",
    props: {
        permalink: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String
        },
        slug: {
            type: String,
            required: true
        },
        jsonUrl: {
            type: String,
            required: true
        },
        data: {
            type: [
                Object,
                String
            ]
        },
        buttonTitles: {
            type: Array,
            default: ()=>[]
        },
        chartMargin: {
            type: Object,
            default: ()=>({})
        },
        showLegend: {
            type: Boolean,
            default: true
        },
        legendId: {
            type: String,
            required: true
        },
        downloads: {
            type: Array,
            default: ()=>[]
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const chart = (0, _vue.ref)(null);
        //props
        const props = __props;
        //data
        const state = (0, _vue.reactive)({
            tabs: [
                {
                    index: 0,
                    title: "View Chart"
                },
                {
                    index: 1,
                    title: "View Table"
                }
            ],
            activeTableIndex: 0
        });
        const overlayClustered = (0, _vue.ref)(null);
        //lifecycle
        (0, _vue.onMounted)(()=>{});
        //methods
        const tabChanged = function(index) {
            state.activeTableIndex = index;
        };
        const takeSnapshot = function() {
            chart.value.snapshot();
        };
        //computed
        const __returned__ = {
            chart,
            props,
            state,
            overlayClustered,
            tabChanged,
            takeSnapshot,
            computed: (0, _vue.computed),
            markRaw: (0, _vue.markRaw),
            onMounted: (0, _vue.onMounted),
            nextTick: (0, _vue.nextTick),
            reactive: (0, _vue.reactive),
            ref: (0, _vue.ref),
            watch: (0, _vue.watch),
            Chart: (0, _chartVueDefault.default),
            Tabs: (0, _tabsVueDefault.default),
            TabTable: (0, _tabTableVueDefault.default)
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"2IF1a","./Chart.vue":"91xns","./Tabs.vue":"sMIDW","./TabTable.vue":"aCkvK","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"91xns":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("3d77c1dcdf82606d");
    if (script.__esModule) script = script.default;
    script.render = require("db8144676b186321").render;
    script.__cssModules = require("9d89cdefc51a9737").default;
    require("64429af774c431c7").default(script);
    script.__scopeId = "data-v-e3782e";
    script.__file = "Chart.vue";
};
initialize();
exports.default = script;

},{"3d77c1dcdf82606d":"53KQo","db8144676b186321":"9oDve","9d89cdefc51a9737":"e1yDx","64429af774c431c7":"1f6Gv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"53KQo":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _chesapeakeProgressCharts = require("chesapeake-progress-charts");
var _progressChartsCss = require("chesapeake-progress-charts/dist/progress-charts.css");
var _vue = require("vue");
exports.default = {
    __name: "Chart",
    props: {
        srcUrl: {
            type: String,
            default: null
        },
        slug: {
            type: String
        },
        margin: {
            default: ()=>({}),
            type: Object
        },
        width: {
            default: "",
            type: String
        },
        height: {
            default: "",
            type: String
        },
        dataObj: {
            default: ()=>({}),
            type: Object
        }
    },
    setup (__props, { expose: __expose }) {
        const defaultMargin = {
            top: 20,
            right: 5,
            bottom: 50,
            left: 65
        };
        const camera = new (0, _chesapeakeProgressCharts.Snapshot)();
        const snapshotTarget = (0, _vue.ref)(null);
        //template refs
        const chartDiv = (0, _vue.ref)(null);
        const props = __props;
        //lifecycle
        (0, _vue.onMounted)(()=>{
            const instance = (0, _vue.getCurrentInstance)();
            snapshotTarget.value = instance.root.refs.chartApp;
            const chartData = {
                url: props.srcUrl,
                data: props.dataObj
            };
            if (Object.keys(props.dataObj).length === 0) delete chartData.data;
            const chartOptions = {
                data: chartData,
                margin: mergedMargin.value,
                width: props.width,
                height: props.height
            };
            if (props.width === "") delete chartOptions.width;
            if (props.height === "") delete chartOptions.height;
            new (0, _chesapeakeProgressCharts.ChartCreator)(chartDiv.value, chartOptions);
        });
        //computed
        const mergedMargin = (0, _vue.computed)(()=>{
            return {
                ...defaultMargin,
                ...props.margin
            };
        });
        //methods
        const snapshot = async function() {
            const options = {
                allowTaint: true,
                useCORS: true,
                logging: false
            };
            await camera.snap(snapshotTarget.value, props.slug, options);
        };
        __expose({
            snapshot
        });
        const __returned__ = {
            defaultMargin,
            camera,
            snapshotTarget,
            chartDiv,
            props,
            mergedMargin,
            snapshot,
            get ChartCreator () {
                return 0, _chesapeakeProgressCharts.ChartCreator;
            },
            get Snapshot () {
                return 0, _chesapeakeProgressCharts.Snapshot;
            },
            computed: (0, _vue.computed),
            getCurrentInstance: (0, _vue.getCurrentInstance),
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref)
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"chesapeake-progress-charts":"kVXBB","chesapeake-progress-charts/dist/progress-charts.css":"8FW5d","vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kVXBB":[function(require,module,exports) {
/*! For license information please see progress-charts.js.LICENSE.txt */ !function(A, t) {
    var e, n;
    module.exports = t();
}(self, function() {
    return (()=>{
        var __webpack_modules__ = {
            1112: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>re
                });
                var n = e(8602), r = e(3228);
                function a(A) {
                    return "string" == typeof A ? new r.Y1([
                        document.querySelectorAll(A)
                    ], [
                        document.documentElement
                    ]) : new r.Y1([
                        null == A ? [] : A
                    ], r.Jz);
                }
                var i, o, s = e(4017), c = e(5109), l = e(6216), u = e(8716), f = e(399), h = e.n(f), B = e(1654), d = e(2626), g = 0, w = 0, p = 0, Q = 0, U = 0, v = 0, y = "object" == typeof performance && performance.now ? performance : Date, C = "object" == typeof window && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(A) {
                    setTimeout(A, 17);
                };
                function m() {
                    return U || (C(E), U = y.now() + v);
                }
                function E() {
                    U = 0;
                }
                function F() {
                    this._call = this._time = this._next = null;
                }
                function _(A, t, e) {
                    var n = new F;
                    return n.restart(A, t, e), n;
                }
                function b() {
                    U = (Q = y.now()) + v, g = w = 0;
                    try {
                        !function() {
                            m(), ++g;
                            for(var A, t = i; t;)(A = U - t._time) >= 0 && t._call.call(null, A), t = t._next;
                            --g;
                        }();
                    } finally{
                        g = 0, function() {
                            for(var A, t, e = i, n = 1 / 0; e;)e._call ? (n > e._time && (n = e._time), A = e, e = e._next) : (t = e._next, e._next = null, e = A ? A._next = t : i = t);
                            o = A, N(n);
                        }(), U = 0;
                    }
                }
                function H() {
                    var A = y.now(), t = A - Q;
                    t > 1e3 && (v -= t, Q = A);
                }
                function N(A) {
                    g || (w && (w = clearTimeout(w)), A - U > 24 ? (A < 1 / 0 && (w = setTimeout(b, A - y.now() - v)), p && (p = clearInterval(p))) : (p || (Q = y.now(), p = setInterval(H, 1e3)), g = 1, C(b)));
                }
                function I(A, t, e) {
                    var n = new F;
                    return t = null == t ? 0 : +t, n.restart(function(e) {
                        n.stop(), A(e + t);
                    }, t, e), n;
                }
                F.prototype = _.prototype = {
                    constructor: F,
                    restart: function(A, t, e) {
                        if ("function" != typeof A) throw new TypeError("callback is not a function");
                        e = (null == e ? m() : +e) + (null == t ? 0 : +t), this._next || o === this || (o ? o._next = this : i = this, o = this), this._call = A, this._time = e, N();
                    },
                    stop: function() {
                        this._call && (this._call = null, this._time = 1 / 0, N());
                    }
                };
                var M = (0, d.Z)("start", "end", "cancel", "interrupt"), T = [];
                function x(A, t, e, n, r, a) {
                    var i = A.__transition;
                    if (i) {
                        if (e in i) return;
                    } else A.__transition = {};
                    !function(A, t, e) {
                        var n, r = A.__transition;
                        function a(s) {
                            var c, l, u, f;
                            if (1 !== e.state) return o();
                            for(c in r)if ((f = r[c]).name === e.name) {
                                if (3 === f.state) return I(a);
                                4 === f.state ? (f.state = 6, f.timer.stop(), f.on.call("interrupt", A, A.__data__, f.index, f.group), delete r[c]) : +c < t && (f.state = 6, f.timer.stop(), f.on.call("cancel", A, A.__data__, f.index, f.group), delete r[c]);
                            }
                            if (I(function() {
                                3 === e.state && (e.state = 4, e.timer.restart(i, e.delay, e.time), i(s));
                            }), e.state = 2, e.on.call("start", A, A.__data__, e.index, e.group), 2 === e.state) {
                                for(e.state = 3, n = new Array(u = e.tween.length), c = 0, l = -1; c < u; ++c)(f = e.tween[c].value.call(A, A.__data__, e.index, e.group)) && (n[++l] = f);
                                n.length = l + 1;
                            }
                        }
                        function i(t) {
                            for(var r = t < e.duration ? e.ease.call(null, t / e.duration) : (e.timer.restart(o), e.state = 5, 1), a = -1, i = n.length; ++a < i;)n[a].call(A, r);
                            5 === e.state && (e.on.call("end", A, A.__data__, e.index, e.group), o());
                        }
                        function o() {
                            for(var n in e.state = 6, e.timer.stop(), delete r[t], r)return;
                            delete A.__transition;
                        }
                        r[t] = e, e.timer = _(function(A) {
                            e.state = 1, e.timer.restart(a, e.delay, e.time), e.delay <= A && a(A - e.delay);
                        }, 0, e.time);
                    }(A, e, {
                        name: t,
                        index: n,
                        group: r,
                        on: M,
                        tween: T,
                        time: a.time,
                        delay: a.delay,
                        duration: a.duration,
                        ease: a.ease,
                        timer: null,
                        state: 0
                    });
                }
                function K(A, t) {
                    var e = S(A, t);
                    if (e.state > 0) throw new Error("too late; already scheduled");
                    return e;
                }
                function O(A, t) {
                    var e = S(A, t);
                    if (e.state > 3) throw new Error("too late; already running");
                    return e;
                }
                function S(A, t) {
                    var e = A.__transition;
                    if (!e || !(e = e[t])) throw new Error("transition not found");
                    return e;
                }
                var L, k, P, D, R = e(3626), z = 180 / Math.PI, X = {
                    translateX: 0,
                    translateY: 0,
                    rotate: 0,
                    skewX: 0,
                    scaleX: 1,
                    scaleY: 1
                };
                function V(A, t, e, n, r, a) {
                    var i, o, s;
                    return (i = Math.sqrt(A * A + t * t)) && (A /= i, t /= i), (s = A * e + t * n) && (e -= A * s, n -= t * s), (o = Math.sqrt(e * e + n * n)) && (e /= o, n /= o, s /= o), A * n < t * e && (A = -A, t = -t, s = -s, i = -i), {
                        translateX: r,
                        translateY: a,
                        rotate: Math.atan2(t, A) * z,
                        skewX: Math.atan(s) * z,
                        scaleX: i,
                        scaleY: o
                    };
                }
                function Y(A, t, e, n) {
                    function r(A) {
                        return A.length ? A.pop() + " " : "";
                    }
                    return function(a, i) {
                        var o = [], s = [];
                        return a = A(a), i = A(i), function(A, n, r, a, i, o) {
                            if (A !== r || n !== a) {
                                var s = i.push("translate(", null, t, null, e);
                                o.push({
                                    i: s - 4,
                                    x: (0, R.Z)(A, r)
                                }, {
                                    i: s - 2,
                                    x: (0, R.Z)(n, a)
                                });
                            } else (r || a) && i.push("translate(" + r + t + a + e);
                        }(a.translateX, a.translateY, i.translateX, i.translateY, o, s), function(A, t, e, a) {
                            A !== t ? (A - t > 180 ? t += 360 : t - A > 180 && (A += 360), a.push({
                                i: e.push(r(e) + "rotate(", null, n) - 2,
                                x: (0, R.Z)(A, t)
                            })) : t && e.push(r(e) + "rotate(" + t + n);
                        }(a.rotate, i.rotate, o, s), function(A, t, e, a) {
                            A !== t ? a.push({
                                i: e.push(r(e) + "skewX(", null, n) - 2,
                                x: (0, R.Z)(A, t)
                            }) : t && e.push(r(e) + "skewX(" + t + n);
                        }(a.skewX, i.skewX, o, s), function(A, t, e, n, a, i) {
                            if (A !== e || t !== n) {
                                var o = a.push(r(a) + "scale(", null, ",", null, ")");
                                i.push({
                                    i: o - 4,
                                    x: (0, R.Z)(A, e)
                                }, {
                                    i: o - 2,
                                    x: (0, R.Z)(t, n)
                                });
                            } else 1 === e && 1 === n || a.push(r(a) + "scale(" + e + "," + n + ")");
                        }(a.scaleX, a.scaleY, i.scaleX, i.scaleY, o, s), a = i = null, function(A) {
                            for(var t, e = -1, n = s.length; ++e < n;)o[(t = s[e]).i] = t.x(A);
                            return o.join("");
                        };
                    };
                }
                var G = Y(function(A) {
                    return "none" === A ? X : (L || (L = document.createElement("DIV"), k = document.documentElement, P = document.defaultView), L.style.transform = A, A = P.getComputedStyle(k.appendChild(L), null).getPropertyValue("transform"), k.removeChild(L), V(+(A = A.slice(7, -1).split(","))[0], +A[1], +A[2], +A[3], +A[4], +A[5]));
                }, "px, ", "px)", "deg)"), J = Y(function(A) {
                    return null == A ? X : (D || (D = document.createElementNS("http://www.w3.org/2000/svg", "g")), D.setAttribute("transform", A), (A = D.transform.baseVal.consolidate()) ? V((A = A.matrix).a, A.b, A.c, A.d, A.e, A.f) : X);
                }, ", ", ")", ")"), W = e(3888);
                function j(A, t) {
                    var e, n;
                    return function() {
                        var r = O(this, A), a = r.tween;
                        if (a !== e) {
                            for(var i = 0, o = (n = e = a).length; i < o; ++i)if (n[i].name === t) {
                                (n = n.slice()).splice(i, 1);
                                break;
                            }
                        }
                        r.tween = n;
                    };
                }
                function Z(A, t, e) {
                    var n, r;
                    if ("function" != typeof e) throw new Error;
                    return function() {
                        var a = O(this, A), i = a.tween;
                        if (i !== n) {
                            r = (n = i).slice();
                            for(var o = {
                                name: t,
                                value: e
                            }, s = 0, c = r.length; s < c; ++s)if (r[s].name === t) {
                                r[s] = o;
                                break;
                            }
                            s === c && r.push(o);
                        }
                        a.tween = r;
                    };
                }
                function q(A, t, e) {
                    var n = A._id;
                    return A.each(function() {
                        var A = O(this, n);
                        (A.value || (A.value = {}))[t] = e.apply(this, arguments);
                    }), function(A) {
                        return S(A, n).value[t];
                    };
                }
                var $ = e(2650), AA = e(7765), tA = e(9843);
                function eA(A, t) {
                    var e;
                    return ("number" == typeof t ? R.Z : t instanceof $.ZP ? AA.ZP : (e = (0, $.ZP)(t)) ? (t = e, AA.ZP) : tA.Z)(A, t);
                }
                function nA(A) {
                    return function() {
                        this.removeAttribute(A);
                    };
                }
                function rA(A) {
                    return function() {
                        this.removeAttributeNS(A.space, A.local);
                    };
                }
                function aA(A, t, e) {
                    var n, r, a = e + "";
                    return function() {
                        var i = this.getAttribute(A);
                        return i === a ? null : i === n ? r : r = t(n = i, e);
                    };
                }
                function iA(A, t, e) {
                    var n, r, a = e + "";
                    return function() {
                        var i = this.getAttributeNS(A.space, A.local);
                        return i === a ? null : i === n ? r : r = t(n = i, e);
                    };
                }
                function oA(A, t, e) {
                    var n, r, a;
                    return function() {
                        var i, o, s = e(this);
                        if (null != s) return (i = this.getAttribute(A)) === (o = s + "") ? null : i === n && o === r ? a : (r = o, a = t(n = i, s));
                        this.removeAttribute(A);
                    };
                }
                function sA(A, t, e) {
                    var n, r, a;
                    return function() {
                        var i, o, s = e(this);
                        if (null != s) return (i = this.getAttributeNS(A.space, A.local)) === (o = s + "") ? null : i === n && o === r ? a : (r = o, a = t(n = i, s));
                        this.removeAttributeNS(A.space, A.local);
                    };
                }
                function cA(A, t) {
                    return function(e) {
                        this.setAttribute(A, t.call(this, e));
                    };
                }
                function lA(A, t) {
                    return function(e) {
                        this.setAttributeNS(A.space, A.local, t.call(this, e));
                    };
                }
                function uA(A, t) {
                    var e, n;
                    function r() {
                        var r = t.apply(this, arguments);
                        return r !== n && (e = (n = r) && lA(A, r)), e;
                    }
                    return r._value = t, r;
                }
                function fA(A, t) {
                    var e, n;
                    function r() {
                        var r = t.apply(this, arguments);
                        return r !== n && (e = (n = r) && cA(A, r)), e;
                    }
                    return r._value = t, r;
                }
                function hA(A, t) {
                    return function() {
                        K(this, A).delay = +t.apply(this, arguments);
                    };
                }
                function BA(A, t) {
                    return t = +t, function() {
                        K(this, A).delay = t;
                    };
                }
                function dA(A, t) {
                    return function() {
                        O(this, A).duration = +t.apply(this, arguments);
                    };
                }
                function gA(A, t) {
                    return t = +t, function() {
                        O(this, A).duration = t;
                    };
                }
                function wA(A, t) {
                    if ("function" != typeof t) throw new Error;
                    return function() {
                        O(this, A).ease = t;
                    };
                }
                var pA = e(3083);
                function QA(A, t, e) {
                    var n, r, a = function(A) {
                        return (A + "").trim().split(/^|\s+/).every(function(A) {
                            var t = A.indexOf(".");
                            return t >= 0 && (A = A.slice(0, t)), !A || "start" === A;
                        });
                    }(t) ? K : O;
                    return function() {
                        var i = a(this, A), o = i.on;
                        o !== n && (r = (n = o).copy()).on(t, e), i.on = r;
                    };
                }
                var UA = e(2634), vA = e(3545), yA = r.ZP.prototype.constructor, CA = e(9986);
                function mA(A) {
                    return function() {
                        this.style.removeProperty(A);
                    };
                }
                function EA(A, t, e) {
                    return function(n) {
                        this.style.setProperty(A, t.call(this, n), e);
                    };
                }
                function FA(A, t, e) {
                    var n, r;
                    function a() {
                        var a = t.apply(this, arguments);
                        return a !== r && (n = (r = a) && EA(A, a, e)), n;
                    }
                    return a._value = t, a;
                }
                function _A(A) {
                    return function(t) {
                        this.textContent = A.call(this, t);
                    };
                }
                function bA(A) {
                    var t, e;
                    function n() {
                        var n = A.apply(this, arguments);
                        return n !== e && (t = (e = n) && _A(n)), t;
                    }
                    return n._value = A, n;
                }
                var HA = 0;
                function NA(A, t, e, n) {
                    this._groups = A, this._parents = t, this._name = e, this._id = n;
                }
                function IA(A) {
                    return (0, r.ZP)().transition(A);
                }
                function MA() {
                    return ++HA;
                }
                var TA = r.ZP.prototype;
                NA.prototype = IA.prototype = {
                    constructor: NA,
                    select: function(A) {
                        var t = this._name, e = this._id;
                        "function" != typeof A && (A = (0, UA.Z)(A));
                        for(var n = this._groups, r = n.length, a = new Array(r), i = 0; i < r; ++i)for(var o, s, c = n[i], l = c.length, u = a[i] = new Array(l), f = 0; f < l; ++f)(o = c[f]) && (s = A.call(o, o.__data__, f, c)) && ("__data__" in o && (s.__data__ = o.__data__), u[f] = s, x(u[f], t, e, f, u, S(o, e)));
                        return new NA(a, this._parents, t, e);
                    },
                    selectAll: function(A) {
                        var t = this._name, e = this._id;
                        "function" != typeof A && (A = (0, vA.Z)(A));
                        for(var n = this._groups, r = n.length, a = [], i = [], o = 0; o < r; ++o)for(var s, c = n[o], l = c.length, u = 0; u < l; ++u)if (s = c[u]) {
                            for(var f, h = A.call(s, s.__data__, u, c), B = S(s, e), d = 0, g = h.length; d < g; ++d)(f = h[d]) && x(f, t, e, d, h, B);
                            a.push(h), i.push(s);
                        }
                        return new NA(a, i, t, e);
                    },
                    filter: function(A) {
                        "function" != typeof A && (A = (0, pA.Z)(A));
                        for(var t = this._groups, e = t.length, n = new Array(e), r = 0; r < e; ++r)for(var a, i = t[r], o = i.length, s = n[r] = [], c = 0; c < o; ++c)(a = i[c]) && A.call(a, a.__data__, c, i) && s.push(a);
                        return new NA(n, this._parents, this._name, this._id);
                    },
                    merge: function(A) {
                        if (A._id !== this._id) throw new Error;
                        for(var t = this._groups, e = A._groups, n = t.length, r = e.length, a = Math.min(n, r), i = new Array(n), o = 0; o < a; ++o)for(var s, c = t[o], l = e[o], u = c.length, f = i[o] = new Array(u), h = 0; h < u; ++h)(s = c[h] || l[h]) && (f[h] = s);
                        for(; o < n; ++o)i[o] = t[o];
                        return new NA(i, this._parents, this._name, this._id);
                    },
                    selection: function() {
                        return new yA(this._groups, this._parents);
                    },
                    transition: function() {
                        for(var A = this._name, t = this._id, e = MA(), n = this._groups, r = n.length, a = 0; a < r; ++a)for(var i, o = n[a], s = o.length, c = 0; c < s; ++c)if (i = o[c]) {
                            var l = S(i, t);
                            x(i, A, e, c, o, {
                                time: l.time + l.delay + l.duration,
                                delay: 0,
                                duration: l.duration,
                                ease: l.ease
                            });
                        }
                        return new NA(n, this._parents, A, e);
                    },
                    call: TA.call,
                    nodes: TA.nodes,
                    node: TA.node,
                    size: TA.size,
                    empty: TA.empty,
                    each: TA.each,
                    on: function(A, t) {
                        var e = this._id;
                        return arguments.length < 2 ? S(this.node(), e).on.on(A) : this.each(QA(e, A, t));
                    },
                    attr: function(A, t) {
                        var e = (0, W.Z)(A), n = "transform" === e ? J : eA;
                        return this.attrTween(A, "function" == typeof t ? (e.local ? sA : oA)(e, n, q(this, "attr." + A, t)) : null == t ? (e.local ? rA : nA)(e) : (e.local ? iA : aA)(e, n, t));
                    },
                    attrTween: function(A, t) {
                        var e = "attr." + A;
                        if (arguments.length < 2) return (e = this.tween(e)) && e._value;
                        if (null == t) return this.tween(e, null);
                        if ("function" != typeof t) throw new Error;
                        var n = (0, W.Z)(A);
                        return this.tween(e, (n.local ? uA : fA)(n, t));
                    },
                    style: function(A, t, e) {
                        var n = "transform" == (A += "") ? G : eA;
                        return null == t ? this.styleTween(A, function(A, t) {
                            var e, n, r;
                            return function() {
                                var a = (0, CA.S)(this, A), i = (this.style.removeProperty(A), (0, CA.S)(this, A));
                                return a === i ? null : a === e && i === n ? r : r = t(e = a, n = i);
                            };
                        }(A, n)).on("end.style." + A, mA(A)) : "function" == typeof t ? this.styleTween(A, function(A, t, e) {
                            var n, r, a;
                            return function() {
                                var i = (0, CA.S)(this, A), o = e(this), s = o + "";
                                return null == o && (this.style.removeProperty(A), s = o = (0, CA.S)(this, A)), i === s ? null : i === n && s === r ? a : (r = s, a = t(n = i, o));
                            };
                        }(A, n, q(this, "style." + A, t))).each(function(A, t) {
                            var e, n, r, a, i = "style." + t, o = "end." + i;
                            return function() {
                                var s = O(this, A), c = s.on, l = null == s.value[i] ? a || (a = mA(t)) : void 0;
                                c === e && r === l || (n = (e = c).copy()).on(o, r = l), s.on = n;
                            };
                        }(this._id, A)) : this.styleTween(A, function(A, t, e) {
                            var n, r, a = e + "";
                            return function() {
                                var i = (0, CA.S)(this, A);
                                return i === a ? null : i === n ? r : r = t(n = i, e);
                            };
                        }(A, n, t), e).on("end.style." + A, null);
                    },
                    styleTween: function(A, t, e) {
                        var n = "style." + (A += "");
                        if (arguments.length < 2) return (n = this.tween(n)) && n._value;
                        if (null == t) return this.tween(n, null);
                        if ("function" != typeof t) throw new Error;
                        return this.tween(n, FA(A, t, null == e ? "" : e));
                    },
                    text: function(A) {
                        return this.tween("text", "function" == typeof A ? function(A) {
                            return function() {
                                var t = A(this);
                                this.textContent = null == t ? "" : t;
                            };
                        }(q(this, "text", A)) : function(A) {
                            return function() {
                                this.textContent = A;
                            };
                        }(null == A ? "" : A + ""));
                    },
                    textTween: function(A) {
                        var t = "text";
                        if (arguments.length < 1) return (t = this.tween(t)) && t._value;
                        if (null == A) return this.tween(t, null);
                        if ("function" != typeof A) throw new Error;
                        return this.tween(t, bA(A));
                    },
                    remove: function() {
                        return this.on("end.remove", function(A) {
                            return function() {
                                var t = this.parentNode;
                                for(var e in this.__transition)if (+e !== A) return;
                                t && t.removeChild(this);
                            };
                        }(this._id));
                    },
                    tween: function(A, t) {
                        var e = this._id;
                        if (A += "", arguments.length < 2) {
                            for(var n, r = S(this.node(), e).tween, a = 0, i = r.length; a < i; ++a)if ((n = r[a]).name === A) return n.value;
                            return null;
                        }
                        return this.each((null == t ? j : Z)(e, A, t));
                    },
                    delay: function(A) {
                        var t = this._id;
                        return arguments.length ? this.each(("function" == typeof A ? hA : BA)(t, A)) : S(this.node(), t).delay;
                    },
                    duration: function(A) {
                        var t = this._id;
                        return arguments.length ? this.each(("function" == typeof A ? dA : gA)(t, A)) : S(this.node(), t).duration;
                    },
                    ease: function(A) {
                        var t = this._id;
                        return arguments.length ? this.each(wA(t, A)) : S(this.node(), t).ease;
                    },
                    end: function() {
                        var A, t, e = this, n = e._id, r = e.size();
                        return new Promise(function(a, i) {
                            var o = {
                                value: i
                            }, s = {
                                value: function() {
                                    0 == --r && a();
                                }
                            };
                            e.each(function() {
                                var e = O(this, n), r = e.on;
                                r !== A && ((t = (A = r).copy())._.cancel.push(o), t._.interrupt.push(o), t._.end.push(s)), e.on = t;
                            });
                        });
                    }
                };
                var xA = {
                    time: null,
                    delay: 0,
                    duration: 250,
                    ease: u.tw
                };
                function KA(A, t) {
                    for(var e; !(e = A.__transition) || !(e = e[t]);)if (!(A = A.parentNode)) return xA.time = m(), xA;
                    return e;
                }
                function OA(A) {
                    return (OA = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function SA(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function LA(A, t, e) {
                    return t in A ? Object.defineProperty(A, t, {
                        value: e,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : A[t] = e, A;
                }
                function kA(A) {
                    for(var t = 1; t < arguments.length; t++){
                        var e = null != arguments[t] ? arguments[t] : {}, n = Object.keys(e);
                        "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(e).filter(function(A) {
                            return Object.getOwnPropertyDescriptor(e, A).enumerable;
                        }))), n.forEach(function(t) {
                            LA(A, t, e[t]);
                        });
                    }
                    return A;
                }
                function PA(A, t) {
                    return function(A) {
                        if (Array.isArray(A)) return A;
                    }(A) || function(A, t) {
                        var e = [], n = !0, r = !1, a = void 0;
                        try {
                            for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                        } catch (A) {
                            r = !0, a = A;
                        } finally{
                            try {
                                n || null == o.return || o.return();
                            } finally{
                                if (r) throw a;
                            }
                        }
                        return e;
                    }(A, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }();
                }
                r.ZP.prototype.interrupt = function(A) {
                    return this.each(function() {
                        !function(A, t) {
                            var e, n, r, a = A.__transition, i = !0;
                            if (a) {
                                for(r in t = null == t ? null : t + "", a)(e = a[r]).name === t ? (n = e.state > 2 && e.state < 5, e.state = 6, e.timer.stop(), e.on.call(n ? "interrupt" : "cancel", A, A.__data__, e.index, e.group), delete a[r]) : i = !1;
                                i && delete A.__transition;
                            }
                        }(this, A);
                    });
                }, r.ZP.prototype.transition = function(A) {
                    var t, e;
                    A instanceof NA ? (t = A._id, A = A._name) : (t = MA(), (e = xA).time = m(), A = null == A ? null : A + "");
                    for(var n = this._groups, r = n.length, a = 0; a < r; ++a)for(var i, o = n[a], s = o.length, c = 0; c < s; ++c)(i = o[c]) && x(i, A, t, c, o, e || KA(i, t));
                    return new NA(n, this._parents, A, t);
                };
                var DA = function() {}, RA = {}, zA = {}, XA = {
                    mark: DA,
                    measure: DA
                };
                try {
                    "undefined" != typeof window && (RA = window), "undefined" != typeof document && (zA = document), "undefined" != typeof MutationObserver && MutationObserver, "undefined" != typeof performance && (XA = performance);
                } catch (A) {}
                var VA = (RA.navigator || {}).userAgent, YA = void 0 === VA ? "" : VA, GA = RA, JA = zA, WA = XA, jA = (GA.document, !!JA.documentElement && !!JA.head && "function" == typeof JA.addEventListener && "function" == typeof JA.createElement), ZA = (~YA.indexOf("MSIE") || YA.indexOf("Trident/"), "svg-inline--fa"), qA = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ], $A = qA.concat([
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20
                ]), At = {
                    GROUP: "group",
                    SWAP_OPACITY: "swap-opacity",
                    PRIMARY: "primary",
                    SECONDARY: "secondary"
                }, tt = ([
                    "xs",
                    "sm",
                    "lg",
                    "fw",
                    "ul",
                    "li",
                    "border",
                    "pull-left",
                    "pull-right",
                    "spin",
                    "pulse",
                    "rotate-90",
                    "rotate-180",
                    "rotate-270",
                    "flip-horizontal",
                    "flip-vertical",
                    "flip-both",
                    "stack",
                    "stack-1x",
                    "stack-2x",
                    "inverse",
                    "layers",
                    "layers-text",
                    "layers-counter",
                    At.GROUP,
                    At.SWAP_OPACITY,
                    At.PRIMARY,
                    At.SECONDARY
                ].concat(qA.map(function(A) {
                    return "".concat(A, "x");
                })).concat($A.map(function(A) {
                    return "w-".concat(A);
                })), GA.FontAwesomeConfig || {});
                JA && "function" == typeof JA.querySelector && [
                    [
                        "data-family-prefix",
                        "familyPrefix"
                    ],
                    [
                        "data-replacement-class",
                        "replacementClass"
                    ],
                    [
                        "data-auto-replace-svg",
                        "autoReplaceSvg"
                    ],
                    [
                        "data-auto-add-css",
                        "autoAddCss"
                    ],
                    [
                        "data-auto-a11y",
                        "autoA11y"
                    ],
                    [
                        "data-search-pseudo-elements",
                        "searchPseudoElements"
                    ],
                    [
                        "data-observe-mutations",
                        "observeMutations"
                    ],
                    [
                        "data-mutate-approach",
                        "mutateApproach"
                    ],
                    [
                        "data-keep-original-source",
                        "keepOriginalSource"
                    ],
                    [
                        "data-measure-performance",
                        "measurePerformance"
                    ],
                    [
                        "data-show-missing-icons",
                        "showMissingIcons"
                    ]
                ].forEach(function(A) {
                    var t = PA(A, 2), e = t[0], n = t[1], r = function(A) {
                        return "" === A || "false" !== A && ("true" === A || A);
                    }(function(A) {
                        var t = JA.querySelector("script[" + A + "]");
                        if (t) return t.getAttribute(A);
                    }(e));
                    null != r && (tt[n] = r);
                });
                var et = kA({}, {
                    familyPrefix: "fa",
                    replacementClass: ZA,
                    autoReplaceSvg: !0,
                    autoAddCss: !0,
                    autoA11y: !0,
                    searchPseudoElements: !1,
                    observeMutations: !0,
                    mutateApproach: "async",
                    keepOriginalSource: !0,
                    measurePerformance: !1,
                    showMissingIcons: !0
                }, tt);
                et.autoReplaceSvg || (et.observeMutations = !1);
                var nt = kA({}, et);
                GA.FontAwesomeConfig = nt;
                var rt = GA || {};
                rt.___FONT_AWESOME___ || (rt.___FONT_AWESOME___ = {}), rt.___FONT_AWESOME___.styles || (rt.___FONT_AWESOME___.styles = {}), rt.___FONT_AWESOME___.hooks || (rt.___FONT_AWESOME___.hooks = {}), rt.___FONT_AWESOME___.shims || (rt.___FONT_AWESOME___.shims = []);
                var at = rt.___FONT_AWESOME___, it = [];
                jA && ((JA.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(JA.readyState) || JA.addEventListener("DOMContentLoaded", function A() {
                    JA.removeEventListener("DOMContentLoaded", A), it.map(function(A) {
                        return A();
                    });
                }));
                var ot, st = "pending", ct = "settled", lt = "fulfilled", ut = "rejected", ft = function() {}, ht = void 0 !== e.g && void 0 !== e.g.process && "function" == typeof e.g.process.emit, Bt = "undefined" == typeof setImmediate ? setTimeout : setImmediate, dt = [];
                function gt() {
                    for(var A = 0; A < dt.length; A++)dt[A][0](dt[A][1]);
                    dt = [], ot = !1;
                }
                function wt(A, t) {
                    dt.push([
                        A,
                        t
                    ]), ot || (ot = !0, Bt(gt, 0));
                }
                function pt(A) {
                    var t = A.owner, e = t._state, n = t._data, r = A[e], a = A.then;
                    if ("function" == typeof r) {
                        e = lt;
                        try {
                            n = r(n);
                        } catch (A) {
                            yt(a, A);
                        }
                    }
                    Qt(a, n) || (e === lt && Ut(a, n), e === ut && yt(a, n));
                }
                function Qt(A, t) {
                    var e;
                    try {
                        if (A === t) throw new TypeError("A promises callback cannot return that same promise.");
                        if (t && ("function" == typeof t || "object" === OA(t))) {
                            var n = t.then;
                            if ("function" == typeof n) return n.call(t, function(n) {
                                e || (e = !0, t === n ? vt(A, n) : Ut(A, n));
                            }, function(t) {
                                e || (e = !0, yt(A, t));
                            }), !0;
                        }
                    } catch (t) {
                        return e || yt(A, t), !0;
                    }
                    return !1;
                }
                function Ut(A, t) {
                    A !== t && Qt(A, t) || vt(A, t);
                }
                function vt(A, t) {
                    A._state === st && (A._state = ct, A._data = t, wt(mt, A));
                }
                function yt(A, t) {
                    A._state === st && (A._state = ct, A._data = t, wt(Et, A));
                }
                function Ct(A) {
                    A._then = A._then.forEach(pt);
                }
                function mt(A) {
                    A._state = lt, Ct(A);
                }
                function Et(A) {
                    A._state = ut, Ct(A), !A._handled && ht && e.g.process.emit("unhandledRejection", A._data, A);
                }
                function Ft(A) {
                    e.g.process.emit("rejectionHandled", A);
                }
                function _t(A) {
                    if ("function" != typeof A) throw new TypeError("Promise resolver " + A + " is not a function");
                    if (this instanceof _t == 0) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
                    this._then = [], function(A, t) {
                        function e(A) {
                            yt(t, A);
                        }
                        try {
                            A(function(A) {
                                Ut(t, A);
                            }, e);
                        } catch (A) {
                            e(A);
                        }
                    }(A, this);
                }
                _t.prototype = {
                    constructor: _t,
                    _state: st,
                    _then: null,
                    _data: void 0,
                    _handled: !1,
                    then: function(A, t) {
                        var e = {
                            owner: this,
                            then: new this.constructor(ft),
                            fulfilled: A,
                            rejected: t
                        };
                        return !t && !A || this._handled || (this._handled = !0, this._state === ut && ht && wt(Ft, this)), this._state === lt || this._state === ut ? wt(pt, e) : this._then.push(e), e.then;
                    },
                    catch: function(A) {
                        return this.then(null, A);
                    }
                }, _t.all = function(A) {
                    if (!Array.isArray(A)) throw new TypeError("You must pass an array to Promise.all().");
                    return new _t(function(t, e) {
                        var n = [], r = 0;
                        function a(A) {
                            return r++, function(e) {
                                n[A] = e, --r || t(n);
                            };
                        }
                        for(var i, o = 0; o < A.length; o++)(i = A[o]) && "function" == typeof i.then ? i.then(a(o), e) : n[o] = i;
                        r || t(n);
                    });
                }, _t.race = function(A) {
                    if (!Array.isArray(A)) throw new TypeError("You must pass an array to Promise.race().");
                    return new _t(function(t, e) {
                        for(var n, r = 0; r < A.length; r++)(n = A[r]) && "function" == typeof n.then ? n.then(t, e) : t(n);
                    });
                }, _t.resolve = function(A) {
                    return A && "object" === OA(A) && A.constructor === _t ? A : new _t(function(t) {
                        t(A);
                    });
                }, _t.reject = function(A) {
                    return new _t(function(t, e) {
                        e(A);
                    });
                };
                var bt = {
                    size: 16,
                    x: 0,
                    y: 0,
                    rotate: 0,
                    flipX: !1,
                    flipY: !1
                };
                function Ht() {
                    for(var A = 12, t = ""; A-- > 0;)t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
                    return t;
                }
                function Nt(A) {
                    return "".concat(A).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                }
                function It(A) {
                    return Object.keys(A || {}).reduce(function(t, e) {
                        return t + "".concat(e, ": ").concat(A[e], ";");
                    }, "");
                }
                function Mt(A) {
                    return A.size !== bt.size || A.x !== bt.x || A.y !== bt.y || A.rotate !== bt.rotate || A.flipX || A.flipY;
                }
                function Tt(A) {
                    var t = A.transform, e = A.containerWidth, n = A.iconWidth, r = {
                        transform: "translate(".concat(e / 2, " 256)")
                    }, a = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "), i = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), o = "rotate(".concat(t.rotate, " 0 0)");
                    return {
                        outer: r,
                        inner: {
                            transform: "".concat(a, " ").concat(i, " ").concat(o)
                        },
                        path: {
                            transform: "translate(".concat(n / 2 * -1, " -256)")
                        }
                    };
                }
                var xt = {
                    x: 0,
                    y: 0,
                    width: "100%",
                    height: "100%"
                };
                function Kt(A) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    return A.attributes && (A.attributes.fill || t) && (A.attributes.fill = "black"), A;
                }
                function Ot(A) {
                    var t = A.icons, e = t.main, n = t.mask, r = A.prefix, a = A.iconName, i = A.transform, o = A.symbol, s = A.title, c = A.maskId, l = A.titleId, u = A.extra, f = A.watchable, h = void 0 !== f && f, B = n.found ? n : e, d = B.width, g = B.height, w = "fak" === r, p = w ? "" : "fa-w-".concat(Math.ceil(d / g * 16)), Q = [
                        nt.replacementClass,
                        a ? "".concat(nt.familyPrefix, "-").concat(a) : "",
                        p
                    ].filter(function(A) {
                        return -1 === u.classes.indexOf(A);
                    }).filter(function(A) {
                        return "" !== A || !!A;
                    }).concat(u.classes).join(" "), U = {
                        children: [],
                        attributes: kA({}, u.attributes, {
                            "data-prefix": r,
                            "data-icon": a,
                            class: Q,
                            role: u.attributes.role || "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 ".concat(d, " ").concat(g)
                        })
                    }, v = w && !~u.classes.indexOf("fa-fw") ? {
                        width: "".concat(d / g * 1, "em")
                    } : {};
                    h && (U.attributes["data-fa-i2svg"] = ""), s && U.children.push({
                        tag: "title",
                        attributes: {
                            id: U.attributes["aria-labelledby"] || "title-".concat(l || Ht())
                        },
                        children: [
                            s
                        ]
                    });
                    var y = kA({}, U, {
                        prefix: r,
                        iconName: a,
                        main: e,
                        mask: n,
                        maskId: c,
                        transform: i,
                        symbol: o,
                        styles: kA({}, v, u.styles)
                    }), C = n.found && e.found ? function(A) {
                        var t, e = A.children, n = A.attributes, r = A.main, a = A.mask, i = A.maskId, o = A.transform, s = r.width, c = r.icon, l = a.width, u = a.icon, f = Tt({
                            transform: o,
                            containerWidth: l,
                            iconWidth: s
                        }), h = {
                            tag: "rect",
                            attributes: kA({}, xt, {
                                fill: "white"
                            })
                        }, B = c.children ? {
                            children: c.children.map(Kt)
                        } : {}, d = {
                            tag: "g",
                            attributes: kA({}, f.inner),
                            children: [
                                Kt(kA({
                                    tag: c.tag,
                                    attributes: kA({}, c.attributes, f.path)
                                }, B))
                            ]
                        }, g = {
                            tag: "g",
                            attributes: kA({}, f.outer),
                            children: [
                                d
                            ]
                        }, w = "mask-".concat(i || Ht()), p = "clip-".concat(i || Ht()), Q = {
                            tag: "mask",
                            attributes: kA({}, xt, {
                                id: w,
                                maskUnits: "userSpaceOnUse",
                                maskContentUnits: "userSpaceOnUse"
                            }),
                            children: [
                                h,
                                g
                            ]
                        }, U = {
                            tag: "defs",
                            children: [
                                {
                                    tag: "clipPath",
                                    attributes: {
                                        id: p
                                    },
                                    children: (t = u, "g" === t.tag ? t.children : [
                                        t
                                    ])
                                },
                                Q
                            ]
                        };
                        return e.push(U, {
                            tag: "rect",
                            attributes: kA({
                                fill: "currentColor",
                                "clip-path": "url(#".concat(p, ")"),
                                mask: "url(#".concat(w, ")")
                            }, xt)
                        }), {
                            children: e,
                            attributes: n
                        };
                    }(y) : function(A) {
                        var t = A.children, e = A.attributes, n = A.main, r = A.transform, a = It(A.styles);
                        if (a.length > 0 && (e.style = a), Mt(r)) {
                            var i = Tt({
                                transform: r,
                                containerWidth: n.width,
                                iconWidth: n.width
                            });
                            t.push({
                                tag: "g",
                                attributes: kA({}, i.outer),
                                children: [
                                    {
                                        tag: "g",
                                        attributes: kA({}, i.inner),
                                        children: [
                                            {
                                                tag: n.icon.tag,
                                                children: n.icon.children,
                                                attributes: kA({}, n.icon.attributes, i.path)
                                            }
                                        ]
                                    }
                                ]
                            });
                        } else t.push(n.icon);
                        return {
                            children: t,
                            attributes: e
                        };
                    }(y), m = C.children, E = C.attributes;
                    return y.children = m, y.attributes = E, o ? function(A) {
                        var t = A.prefix, e = A.iconName, n = A.children, r = A.attributes, a = A.symbol;
                        return [
                            {
                                tag: "svg",
                                attributes: {
                                    style: "display: none;"
                                },
                                children: [
                                    {
                                        tag: "symbol",
                                        attributes: kA({}, r, {
                                            id: !0 === a ? "".concat(t, "-").concat(nt.familyPrefix, "-").concat(e) : a
                                        }),
                                        children: n
                                    }
                                ]
                            }
                        ];
                    }(y) : function(A) {
                        var t = A.children, e = A.main, n = A.mask, r = A.attributes, a = A.styles, i = A.transform;
                        if (Mt(i) && e.found && !n.found) {
                            var o = {
                                x: e.width / e.height / 2,
                                y: .5
                            };
                            r.style = It(kA({}, a, {
                                "transform-origin": "".concat(o.x + i.x / 16, "em ").concat(o.y + i.y / 16, "em")
                            }));
                        }
                        return [
                            {
                                tag: "svg",
                                attributes: r,
                                children: t
                            }
                        ];
                    }(y);
                }
                var St = (nt.measurePerformance && WA && WA.mark && WA.measure, function(A, t, e, n) {
                    var r, a, i, o = Object.keys(A), s = o.length, c = void 0 !== n ? function(A, t) {
                        return function(e, n, r, a) {
                            return A.call(t, e, n, r, a);
                        };
                    }(t, n) : t;
                    for(void 0 === e ? (r = 1, i = A[o[0]]) : (r = 0, i = e); r < s; r++)i = c(i, A[a = o[r]], a, A);
                    return i;
                });
                function Lt(A, t) {
                    var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, n = e.skipHooks, r = void 0 !== n && n, a = Object.keys(t).reduce(function(A, e) {
                        var n = t[e];
                        return n.icon ? A[n.iconName] = n.icon : A[e] = n, A;
                    }, {});
                    "function" != typeof at.hooks.addPack || r ? at.styles[A] = kA({}, at.styles[A] || {}, a) : at.hooks.addPack(A, a), "fas" === A && Lt("fa", t);
                }
                var kt = at.styles, Pt = at.shims, Dt = function() {
                    var A = function(A) {
                        return St(kt, function(t, e, n) {
                            return t[n] = St(e, A, {}), t;
                        }, {});
                    };
                    A(function(A, t, e) {
                        return t[3] && (A[t[3]] = e), A;
                    }), A(function(A, t, e) {
                        var n = t[2];
                        return A[e] = e, n.forEach(function(t) {
                            A[t] = e;
                        }), A;
                    });
                    var t = "far" in kt;
                    St(Pt, function(A, e) {
                        var n = e[0], r = e[1], a = e[2];
                        return "far" !== r || t || (r = "fas"), A[n] = {
                            prefix: r,
                            iconName: a
                        }, A;
                    }, {});
                };
                function Rt(A, t, e) {
                    if (A && A[t] && A[t][e]) return {
                        prefix: t,
                        iconName: e,
                        icon: A[t][e]
                    };
                }
                function zt(A) {
                    var t = A.tag, e = A.attributes, n = void 0 === e ? {} : e, r = A.children, a = void 0 === r ? [] : r;
                    return "string" == typeof A ? Nt(A) : "<".concat(t, " ").concat(function(A) {
                        return Object.keys(A || {}).reduce(function(t, e) {
                            return t + "".concat(e, '="').concat(Nt(A[e]), '" ');
                        }, "").trim();
                    }(n), ">").concat(a.map(zt).join(""), "</").concat(t, ">");
                }
                function Xt(A) {
                    this.name = "MissingIcon", this.message = A || "Icon unavailable", this.stack = (new Error).stack;
                }
                Dt(), at.styles, Xt.prototype = Object.create(Error.prototype), Xt.prototype.constructor = Xt;
                var Vt = {
                    fill: "currentColor"
                }, Yt = {
                    attributeType: "XML",
                    repeatCount: "indefinite",
                    dur: "2s"
                }, Gt = (kA({}, Vt, {
                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                }), kA({}, Yt, {
                    attributeName: "opacity"
                }));
                function Jt(A) {
                    var t = A[0], e = A[1], n = PA(A.slice(4), 1)[0];
                    return {
                        found: !0,
                        width: t,
                        height: e,
                        icon: Array.isArray(n) ? {
                            tag: "g",
                            attributes: {
                                class: "".concat(nt.familyPrefix, "-").concat(At.GROUP)
                            },
                            children: [
                                {
                                    tag: "path",
                                    attributes: {
                                        class: "".concat(nt.familyPrefix, "-").concat(At.SECONDARY),
                                        fill: "currentColor",
                                        d: n[0]
                                    }
                                },
                                {
                                    tag: "path",
                                    attributes: {
                                        class: "".concat(nt.familyPrefix, "-").concat(At.PRIMARY),
                                        fill: "currentColor",
                                        d: n[1]
                                    }
                                }
                            ]
                        } : {
                            tag: "path",
                            attributes: {
                                fill: "currentColor",
                                d: n
                            }
                        }
                    };
                }
                function Wt() {
                    nt.autoAddCss && !Ae && (function(A) {
                        if (A && jA) {
                            var t = JA.createElement("style");
                            t.setAttribute("type", "text/css"), t.innerHTML = A;
                            for(var e = JA.head.childNodes, n = null, r = e.length - 1; r > -1; r--){
                                var a = e[r], i = (a.tagName || "").toUpperCase();
                                [
                                    "STYLE",
                                    "LINK"
                                ].indexOf(i) > -1 && (n = a);
                            }
                            JA.head.insertBefore(t, n);
                        }
                    }(function() {
                        var A = "fa", t = ZA, e = nt.familyPrefix, n = nt.replacementClass, r = 'svg:not(:root).svg-inline--fa {\n  overflow: visible;\n}\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.225em;\n}\n.svg-inline--fa.fa-w-1 {\n  width: 0.0625em;\n}\n.svg-inline--fa.fa-w-2 {\n  width: 0.125em;\n}\n.svg-inline--fa.fa-w-3 {\n  width: 0.1875em;\n}\n.svg-inline--fa.fa-w-4 {\n  width: 0.25em;\n}\n.svg-inline--fa.fa-w-5 {\n  width: 0.3125em;\n}\n.svg-inline--fa.fa-w-6 {\n  width: 0.375em;\n}\n.svg-inline--fa.fa-w-7 {\n  width: 0.4375em;\n}\n.svg-inline--fa.fa-w-8 {\n  width: 0.5em;\n}\n.svg-inline--fa.fa-w-9 {\n  width: 0.5625em;\n}\n.svg-inline--fa.fa-w-10 {\n  width: 0.625em;\n}\n.svg-inline--fa.fa-w-11 {\n  width: 0.6875em;\n}\n.svg-inline--fa.fa-w-12 {\n  width: 0.75em;\n}\n.svg-inline--fa.fa-w-13 {\n  width: 0.8125em;\n}\n.svg-inline--fa.fa-w-14 {\n  width: 0.875em;\n}\n.svg-inline--fa.fa-w-15 {\n  width: 0.9375em;\n}\n.svg-inline--fa.fa-w-16 {\n  width: 1em;\n}\n.svg-inline--fa.fa-w-17 {\n  width: 1.0625em;\n}\n.svg-inline--fa.fa-w-18 {\n  width: 1.125em;\n}\n.svg-inline--fa.fa-w-19 {\n  width: 1.1875em;\n}\n.svg-inline--fa.fa-w-20 {\n  width: 1.25em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: 0.3em;\n  width: auto;\n}\n.svg-inline--fa.fa-border {\n  height: 1.5em;\n}\n.svg-inline--fa.fa-li {\n  width: 2em;\n}\n.svg-inline--fa.fa-fw {\n  width: 1.25em;\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: 0.25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-lg {\n  font-size: 1.3333333333em;\n  line-height: 0.75em;\n  vertical-align: -0.0667em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit;\n}\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: 0.1em;\n  padding: 0.2em 0.25em 0.15em;\n}\n\n.fa-pull-left {\n  float: left;\n}\n\n.fa-pull-right {\n  float: right;\n}\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: 0.3em;\n}\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: 0.3em;\n}\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear;\n}\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8);\n}\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both, .fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical,\n:root .fa-flip-both {\n  -webkit-filter: none;\n          filter: none;\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: #fff;\n}\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: 0.4;\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: 1;\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse {\n  color: #fff;\n}';
                        if (e !== A || n !== t) {
                            var a = new RegExp("\\.".concat(A, "\\-"), "g"), i = new RegExp("\\--".concat(A, "\\-"), "g"), o = new RegExp("\\.".concat(t), "g");
                            r = r.replace(a, ".".concat(e, "-")).replace(i, "--".concat(e, "-")).replace(o, ".".concat(n));
                        }
                        return r;
                    }()), Ae = !0);
                }
                function jt(A, t) {
                    return Object.defineProperty(A, "abstract", {
                        get: t
                    }), Object.defineProperty(A, "html", {
                        get: function() {
                            return A.abstract.map(function(A) {
                                return zt(A);
                            });
                        }
                    }), Object.defineProperty(A, "node", {
                        get: function() {
                            if (jA) {
                                var t = JA.createElement("div");
                                return t.innerHTML = A.html, t.children;
                            }
                        }
                    }), A;
                }
                function Zt(A) {
                    var t = A.prefix, e = void 0 === t ? "fa" : t, n = A.iconName;
                    if (n) return Rt($t.definitions, e, n) || Rt(at.styles, e, n);
                }
                kA({}, Vt, {
                    cx: "256",
                    cy: "364",
                    r: "28"
                }), kA({}, Yt, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                }), kA({}, Gt, {
                    values: "1;0;1;1;0;1;"
                }), kA({}, Vt, {
                    opacity: "1",
                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                }), kA({}, Gt, {
                    values: "1;0;0;0;0;1;"
                }), kA({}, Vt, {
                    opacity: "0",
                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                }), kA({}, Gt, {
                    values: "0;0;1;1;0;0;"
                }), at.styles, at.styles;
                var qt, $t = new (function() {
                    function A() {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.definitions = {};
                    }
                    var t, e;
                    return t = A, e = [
                        {
                            key: "add",
                            value: function() {
                                for(var A = this, t = arguments.length, e = new Array(t), n = 0; n < t; n++)e[n] = arguments[n];
                                var r = e.reduce(this._pullDefinitions, {});
                                Object.keys(r).forEach(function(t) {
                                    A.definitions[t] = kA({}, A.definitions[t] || {}, r[t]), Lt(t, r[t]), Dt();
                                });
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this.definitions = {};
                            }
                        },
                        {
                            key: "_pullDefinitions",
                            value: function(A, t) {
                                var e = t.prefix && t.iconName && t.icon ? {
                                    0: t
                                } : t;
                                return Object.keys(e).map(function(t) {
                                    var n = e[t], r = n.prefix, a = n.iconName, i = n.icon;
                                    A[r] || (A[r] = {}), A[r][a] = i;
                                }), A;
                            }
                        }
                    ], SA(t.prototype, e), A;
                }()), Ae = !1, te = (qt = function(A) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, e = t.transform, n = void 0 === e ? bt : e, r = t.symbol, a = void 0 !== r && r, i = t.mask, o = void 0 === i ? null : i, s = t.maskId, c = void 0 === s ? null : s, l = t.title, u = void 0 === l ? null : l, f = t.titleId, h = void 0 === f ? null : f, B = t.classes, d = void 0 === B ? [] : B, g = t.attributes, w = void 0 === g ? {} : g, p = t.styles, Q = void 0 === p ? {} : p;
                    if (A) {
                        var U = A.prefix, v = A.iconName, y = A.icon;
                        return jt(kA({
                            type: "icon"
                        }, A), function() {
                            return Wt(), nt.autoA11y && (u ? w["aria-labelledby"] = "".concat(nt.replacementClass, "-title-").concat(h || Ht()) : (w["aria-hidden"] = "true", w.focusable = "false")), Ot({
                                icons: {
                                    main: Jt(y),
                                    mask: o ? Jt(o.icon) : {
                                        found: !1,
                                        width: null,
                                        height: null,
                                        icon: {}
                                    }
                                },
                                prefix: U,
                                iconName: v,
                                transform: kA({}, bt, n),
                                symbol: a,
                                title: u,
                                maskId: c,
                                titleId: h,
                                extra: {
                                    attributes: w,
                                    styles: Q,
                                    classes: d
                                }
                            });
                        });
                    }
                }, function(A) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, e = (A || {}).icon ? A : Zt(A || {}), n = t.mask;
                    return n && (n = (n || {}).icon ? n : Zt(n || {})), qt(e, kA({}, t, {
                        mask: n
                    }));
                }), ee = {
                    prefix: "fas",
                    iconName: "check",
                    icon: [
                        512,
                        512,
                        [],
                        "f00c",
                        "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                    ]
                };
                function ne(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                var re = function() {
                    function A(t, e, a, i, o) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A);
                        var c = this;
                        this._data = t, this._dataIndex = 0, this.container = e, this.selector = a, this.legend = i, this.svg = o, this.tip = (function() {
                            var A = function() {
                                return "n";
                            }, t = function() {
                                return [
                                    0,
                                    0
                                ];
                            }, e = function() {
                                return " ";
                            }, n = document.body, a = h(), i = null, o = null, c = null;
                            function l(A) {
                                (i = function(A) {
                                    var t = A.node();
                                    return t ? "svg" === t.tagName.toLowerCase() ? t : t.ownerSVGElement : null;
                                }(A)) && (o = i.createSVGPoint(), n.appendChild(a));
                            }
                            l.show = function() {
                                var r = Array.prototype.slice.call(arguments);
                                r[r.length - 1] instanceof SVGElement && (c = r.pop());
                                var a, i = e.apply(this, r), o = t.apply(this, r), s = A.apply(this, r), h = d(), B = f.length, g = document.documentElement.scrollTop || n.scrollTop, w = document.documentElement.scrollLeft || n.scrollLeft;
                                for(h.html(i).style("opacity", 1).style("pointer-events", "all"); B--;)h.classed(f[B], !1);
                                return a = u.get(s).apply(this), h.classed(s, !0).style("top", a.top + o[0] + g + "px").style("left", a.left + o[1] + w + "px"), l;
                            }, l.hide = function() {
                                return d().style("opacity", 0).style("pointer-events", "none"), l;
                            }, l.attr = function(A, t) {
                                if (arguments.length < 2 && "string" == typeof A) return d().attr(A);
                                var e = Array.prototype.slice.call(arguments);
                                return r.ZP.prototype.attr.apply(d(), e), l;
                            }, l.style = function(A, t) {
                                if (arguments.length < 2 && "string" == typeof A) return d().style(A);
                                var e = Array.prototype.slice.call(arguments);
                                return r.ZP.prototype.style.apply(d(), e), l;
                            }, l.direction = function(t) {
                                return arguments.length ? (A = null == t ? t : w(t), l) : A;
                            }, l.offset = function(A) {
                                return arguments.length ? (t = null == A ? A : w(A), l) : t;
                            }, l.html = function(A) {
                                return arguments.length ? (e = null == A ? A : w(A), l) : e;
                            }, l.rootElement = function(A) {
                                return arguments.length ? (n = null == A ? A : w(A), l) : n;
                            }, l.destroy = function() {
                                return a && (d().remove(), a = null), l;
                            };
                            var u = (0, B.UI)({
                                n: function() {
                                    var A = g(this);
                                    return {
                                        top: A.n.y - a.offsetHeight,
                                        left: A.n.x - a.offsetWidth / 2
                                    };
                                },
                                s: function() {
                                    var A = g(this);
                                    return {
                                        top: A.s.y,
                                        left: A.s.x - a.offsetWidth / 2
                                    };
                                },
                                e: function() {
                                    var A = g(this);
                                    return {
                                        top: A.e.y - a.offsetHeight / 2,
                                        left: A.e.x
                                    };
                                },
                                w: function() {
                                    var A = g(this);
                                    return {
                                        top: A.w.y - a.offsetHeight / 2,
                                        left: A.w.x - a.offsetWidth
                                    };
                                },
                                nw: function() {
                                    var A = g(this);
                                    return {
                                        top: A.nw.y - a.offsetHeight,
                                        left: A.nw.x - a.offsetWidth
                                    };
                                },
                                ne: function() {
                                    var A = g(this);
                                    return {
                                        top: A.ne.y - a.offsetHeight,
                                        left: A.ne.x
                                    };
                                },
                                sw: function() {
                                    var A = g(this);
                                    return {
                                        top: A.sw.y,
                                        left: A.sw.x - a.offsetWidth
                                    };
                                },
                                se: function() {
                                    var A = g(this);
                                    return {
                                        top: A.se.y,
                                        left: A.se.x
                                    };
                                }
                            }), f = u.keys();
                            function h() {
                                var A = (0, s.Z)(document.createElement("div"));
                                return A.style("position", "absolute").style("top", 0).style("opacity", 0).style("pointer-events", "none").style("box-sizing", "border-box"), A.node();
                            }
                            function d() {
                                return null == a && (a = h(), n.appendChild(a)), (0, s.Z)(a);
                            }
                            function g(A) {
                                for(var t = c || A; null == t.getScreenCTM && null != t.parentNode;)t = t.parentNode;
                                var e = {}, n = t.getScreenCTM(), r = t.getBBox(), a = r.width, i = r.height, s = r.x, l = r.y;
                                return o.x = s, o.y = l, e.nw = o.matrixTransform(n), o.x += a, e.ne = o.matrixTransform(n), o.y += i, e.se = o.matrixTransform(n), o.x -= a, e.sw = o.matrixTransform(n), o.y -= i / 2, e.w = o.matrixTransform(n), o.x += a, e.e = o.matrixTransform(n), o.x -= a / 2, o.y -= i / 2, e.n = o.matrixTransform(n), o.y += i, e.s = o.matrixTransform(n), e;
                            }
                            function w(A) {
                                return "function" == typeof A ? A : function() {
                                    return A;
                                };
                            }
                            return l;
                        })().attr("class", "d3-tip").offset([
                            -12,
                            0
                        ]).html(function(A) {
                            return c.data.prependToValue + A + c.data.appendToValue;
                        }), this.f = (0, n.WU)(","), this.drawSVG = this.drawSVG.bind(this), this.width = this.container.w - (this.container.margin.left + this.container.margin.right), this.height = this.container.h - (this.container.margin.top + this.container.margin.bottom), this.draw = this.draw.bind(this), this.axisCall = {
                            axisTop: l.F5,
                            axisRight: l.Kh,
                            axisBottom: l.LL,
                            axisLeft: l.y4
                        };
                    }
                    var t, e;
                    return t = A, e = [
                        {
                            key: "data",
                            get: function() {
                                return this._data[this.dataIndex];
                            },
                            set: function(A) {
                                this._data = A;
                            }
                        },
                        {
                            key: "dataIndex",
                            get: function() {
                                return this._dataIndex;
                            },
                            set: function(A) {
                                this._dataIndex = A, this.update(!0);
                            }
                        },
                        {
                            key: "drawSVG",
                            value: function() {
                                var A = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = (0, s.Z)(this.selector).node().parentNode;
                                return (0, s.Z)(e).selectAll(".chart-switcher").on("click change", function(t, e, n) {
                                    var r = e;
                                    a(n).classed("activeView", function(A, t) {
                                        return t === r;
                                    }), c.B.preventDefault(), c.B.stopImmediatePropagation(), c.B.stopPropagation(), A.handleMenuChange(n[e].value);
                                }), (0, s.Z)(this.selector).selectAll("svg").remove(), (0, s.Z)(this.selector).append("svg").attr("width", this.container.w).attr("height", this.container.h).attr("class", t.join(" ")).attr("id", "chart-SVG-" + this.data.urlTitle).attr("xmlns", "http://www.w3.org/2000/svg").attr("xmlns:xlink", "http://www.w3.org/1999/xlink").append("g").attr("transform", "translate(" + this.container.margin.left + "," + this.container.margin.top + ")");
                            }
                        },
                        {
                            key: "drawLegend",
                            value: function() {
                                var A = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], e = this;
                                (0, s.Z)("#" + this._data[0].urlTitle + "-legend").selectAll("div").remove();
                                var n = (0, s.Z)("#" + this._data[0].urlTitle + "-legend").selectAll("div").data(A).enter().append("div").attr("class", function(n) {
                                    return A.length <= 1 || "line" === n.type || !t ? "legend-item" : e.filter && e.filter.includes(n.key) ? "legend-item checkable" : "legend-item checkable legend-checked";
                                }), r = n.append("div").attr("class", function(A) {
                                    return "line" === A.type ? "legend-color-square legend-color-line" : "legend-color-square";
                                }).attr("id", function(A) {
                                    return A.key.replace(" ", "-").replace(new RegExp("[^a-zA-Z0-9-]", "g"), "");
                                }).style("background-color", function(A) {
                                    return A.color;
                                });
                                r.html(function(A) {
                                    return "line" === A.type ? null : te(ee, {
                                        title: A.key + " Checked"
                                    }).html;
                                }), n.append("div").attr("class", "legend-key-text-container").append("span").attr("class", "legend-key-text-span").text(function(A) {
                                    return A.key;
                                }), n.each(function(A, t, n) {
                                    var r = n[t];
                                    r.classList.contains("checkable") && r.addEventListener("click", function(t) {
                                        t.stopImmediatePropagation(), r.classList.toggle("legend-checked"), e.filter = h()(e.filter, [
                                            A.key
                                        ]);
                                    });
                                });
                            }
                        },
                        {
                            key: "drawGoalLines",
                            value: function() {
                                this.goalLineArea = this.svg.append("g").attr("class", "goal-line-group").attr("transform", "translate(0, 0)"), this.updateGoalLines();
                            }
                        },
                        {
                            key: "updateGoalLines",
                            value: function() {
                                var A = this, t = this.data.goal, e = this, n = IA().duration(1e3).ease(u._e), r = this.goalLineArea.selectAll(".goalLineGroups").data(t);
                                r.exit().remove();
                                var a = r.enter().append("g").attr("class", "goalLineGroups").attr("width", this.width).attr("height", 14).attr("transform", function(A) {
                                    var t = e.range.y(A.goalValue) - 7;
                                    return "translate(0, ".concat(t, ")");
                                });
                                a.append("path").attr("stroke-width", 2).attr("stroke", function(A) {
                                    return A.goalColor;
                                }).attr("d", "M 0 ".concat(6, " H ").concat(this.width)), a.append("rect").attr("width", this.width).attr("height", 14).attr("opacity", "0").attr("x", 0).attr("y", 0).on("mouseover", function(A) {
                                    e.tip.show("".concat(A.goalName, ": ").concat(e.f(A.goalValue)), this);
                                }).on("mouseout", function(t) {
                                    return e.tip.hide(t, A);
                                });
                                var i = a.merge(r);
                                i.transition(n).attr("transform", function(A) {
                                    var t = e.range.y(A.goalValue) - 7;
                                    return A.goalValue > e.range.y.domain()[1] ? "translate(0, -100000)" : "translate(0, ".concat(t, ")");
                                }), i.selectAll("rect").attr("fill", function(A) {
                                    return A.goalColor;
                                }), i.selectAll("path").attr("id", function(A, t) {
                                    return "path_" + t + "_" + A.goalValue;
                                }).attr("stroke", function(A) {
                                    return A.goalColor;
                                });
                            }
                        },
                        {
                            key: "handleMenuChange",
                            value: function(A) {
                                this.dataIndex = A;
                            }
                        },
                        {
                            key: "drawSelectMenu",
                            value: function(A) {
                                var t = this;
                                (0, s.Z)("#" + this.data.urlTitle + "-select-menu").append("ul").on("change", function() {
                                    return t.handleMenuChange();
                                }).attr("class", "select-menu").data(A).enter().append("li").text(function(A) {
                                    return A;
                                }).attr("value", function(A) {
                                    return A;
                                });
                            }
                        },
                        {
                            key: "draw",
                            value: function() {
                                this.update();
                            }
                        },
                        {
                            key: "update",
                            value: function() {}
                        }
                    ], ne(t.prototype, e), A;
                }();
            },
            7969: (A, t, e)=>{
                "use strict";
                e.r(t), e.d(t, {
                    default: ()=>Q
                });
                var n = e(1108), r = e(3072);
                function a(A) {
                    this._context = A;
                }
                function i(A) {
                    return new a(A);
                }
                function o(A) {
                    return A[0];
                }
                function s(A) {
                    return A[1];
                }
                a.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        (this._line || 0 !== this._line && 1 === this._point) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(A, t) {
                        switch(A = +A, t = +t, this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(A, t) : this._context.moveTo(A, t);
                                break;
                            case 1:
                                this._point = 2;
                            default:
                                this._context.lineTo(A, t);
                        }
                    }
                };
                var c = e(4017), l = e(1078), u = e(2396), f = e(4653);
                function h(A) {
                    return (h = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function B(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function d(A, t) {
                    return (d = Object.setPrototypeOf || function(A, t) {
                        return A.__proto__ = t, A;
                    })(A, t);
                }
                function g(A, t) {
                    return !t || "object" !== h(t) && "function" != typeof t ? w(A) : t;
                }
                function w(A) {
                    if (void 0 === A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return A;
                }
                function p(A) {
                    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
                        return A.__proto__ || Object.getPrototypeOf(A);
                    })(A);
                }
                var Q = function(A) {
                    !function(A, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        A.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: A,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && d(A, t);
                    }(v, A);
                    var t, e, a, h, Q, U = (h = v, Q = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (A) {
                            return !1;
                        }
                    }(), function() {
                        var A, t = p(h);
                        if (Q) {
                            var e = p(this).constructor;
                            A = Reflect.construct(t, arguments, e);
                        } else A = t.apply(this, arguments);
                        return g(this, A);
                    });
                    function v(A, t, e, n, r) {
                        var a;
                        return function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, v), (a = U.call(this, A, t, e, n, r)).draw = a.draw.bind(w(a)), a.update = a.update.bind(w(a)), a;
                    }
                    return t = v, a = [
                        {
                            key: "createLine",
                            value: function(A) {
                                return (function() {
                                    var A = o, t = s, e = (0, r.Z)(!0), a = null, c = i, l = null;
                                    function u(r) {
                                        var i, o, s, u = r.length, f = !1;
                                        for(null == a && (l = c(s = (0, n.Z)())), i = 0; i <= u; ++i)!(i < u && e(o = r[i], i, r)) === f && ((f = !f) ? l.lineStart() : l.lineEnd()), f && l.point(+A(o, i, r), +t(o, i, r));
                                        if (s) return l = null, s + "" || null;
                                    }
                                    return u.x = function(t) {
                                        return arguments.length ? (A = "function" == typeof t ? t : (0, r.Z)(+t), u) : A;
                                    }, u.y = function(A) {
                                        return arguments.length ? (t = "function" == typeof A ? A : (0, r.Z)(+A), u) : t;
                                    }, u.defined = function(A) {
                                        return arguments.length ? (e = "function" == typeof A ? A : (0, r.Z)(!!A), u) : e;
                                    }, u.curve = function(A) {
                                        return arguments.length ? (c = A, null != a && (l = c(a)), u) : c;
                                    }, u.context = function(A) {
                                        return arguments.length ? (null == A ? a = l = null : l = c(a = A), u) : a;
                                    }, u;
                                })().x(function(t) {
                                    return A.x(t.x);
                                }).y(function(t) {
                                    return A.y(t.y);
                                });
                            }
                        }
                    ], e = [
                        {
                            key: "draw",
                            value: function() {
                                void 0 === this.svg && (this.svg = this.drawSVG([
                                    "line-chart",
                                    "scatterplot-chart"
                                ]));
                                var A = f.default.generateXY(this.data);
                                return this.chartData = A, this.setRange(0, this.width, 0, this.height), this.range.y.domain([
                                    this.data.minY,
                                    this.data.maxY
                                ]), this.range.x.domain(this.data.labels), this.drawAxis(), this.drawGridlines(), this.svg.call(this.tip), this.path = this.svg.append("path").datum(A).attr("stroke", "#197BD0").attr("class", "line").style("fill", "none"), this.wireSlider(), this.update(), this.svg;
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var A = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 99999, e = this, n = this.chartData.filter(function(e) {
                                    return A <= e.i && e.i <= t;
                                });
                                this.range.x.domain(n.map(function(A) {
                                    return A.x;
                                })), this.range.y.range([
                                    this.height,
                                    0
                                ]), this.updateAxis(!0);
                                var r = this.axisCall.axisBottom().tickFormat("").tickSize(-this.height).scale(this.range.x);
                                this.xGrid.call(r);
                                var a = this.axisCall[this.yPos]().tickFormat("").tickSize(-this.width).scale(this.range.y);
                                this.yGrid.call(a), this.xGrid.selectAll("line").attr("stroke", "#d3d3d3"), this.yGrid.selectAll("line").attr("stroke", "#d3d3d3");
                                var i = v.createLine(this.range);
                                this.path.datum(n).attr("d", i), this.svg.call(this.tip);
                                var o = this.svg.selectAll(".dot").data(n, function(A) {
                                    return A.x;
                                });
                                o.exit().remove();
                                var s = o.enter().append("circle").attr("class", "dot").attr("r", 3).attr("stroke", "#197BD0").attr("fill", "#197BD0").attr("stroke-width", "13px").attr("stroke-opacity", 0), f = s.merge(o).attr("cx", function(A) {
                                    return e.range.x(A.x);
                                }).attr("cy", function(A) {
                                    return e.range.y(A.y);
                                });
                                f.on("mouseover", function(A) {
                                    e.tip.show(e.f(A.y), this), (0, c.Z)(this).transition().ease(l._D).duration("500").attr("r", 9);
                                }).on("mouseout", function(A) {
                                    e.tip.hide(A, this), (0, c.Z)(this).transition().ease(u.Kl).delay("100").duration("200").attr("r", 3);
                                });
                            }
                        }
                    ], B(t.prototype, e), a && B(t, a), v;
                }(f.default);
            },
            554: (A, t, e)=>{
                "use strict";
                e.r(t), e.d(t, {
                    default: ()=>D
                });
                var n = e(3072);
                function r(A, t) {
                    return t < A ? -1 : t > A ? 1 : t >= A ? 0 : NaN;
                }
                function a(A) {
                    return A;
                }
                var i = Math.abs, o = Math.atan2, s = Math.cos, c = Math.max, l = Math.min, u = Math.sin, f = Math.sqrt, h = 1e-12, B = Math.PI, d = B / 2, g = 2 * B;
                function w(A) {
                    return A > 1 ? 0 : A < -1 ? B : Math.acos(A);
                }
                function p(A) {
                    return A >= 1 ? d : A <= -1 ? -d : Math.asin(A);
                }
                function Q() {
                    var A = a, t = r, e = null, i = (0, n.Z)(0), o = (0, n.Z)(g), s = (0, n.Z)(0);
                    function c(n) {
                        var r, a, c, l, u, f = n.length, h = 0, B = new Array(f), d = new Array(f), w = +i.apply(this, arguments), p = Math.min(g, Math.max(-g, o.apply(this, arguments) - w)), Q = Math.min(Math.abs(p) / f, s.apply(this, arguments)), U = Q * (p < 0 ? -1 : 1);
                        for(r = 0; r < f; ++r)(u = d[B[r] = r] = +A(n[r], r, n)) > 0 && (h += u);
                        for(null != t ? B.sort(function(A, e) {
                            return t(d[A], d[e]);
                        }) : null != e && B.sort(function(A, t) {
                            return e(n[A], n[t]);
                        }), r = 0, c = h ? (p - f * U) / h : 0; r < f; ++r, w = l)a = B[r], l = w + ((u = d[a]) > 0 ? u * c : 0) + U, d[a] = {
                            data: n[a],
                            index: r,
                            value: u,
                            startAngle: w,
                            endAngle: l,
                            padAngle: Q
                        };
                        return d;
                    }
                    return c.value = function(t) {
                        return arguments.length ? (A = "function" == typeof t ? t : (0, n.Z)(+t), c) : A;
                    }, c.sortValues = function(A) {
                        return arguments.length ? (t = A, e = null, c) : t;
                    }, c.sort = function(A) {
                        return arguments.length ? (e = A, t = null, c) : e;
                    }, c.startAngle = function(A) {
                        return arguments.length ? (i = "function" == typeof A ? A : (0, n.Z)(+A), c) : i;
                    }, c.endAngle = function(A) {
                        return arguments.length ? (o = "function" == typeof A ? A : (0, n.Z)(+A), c) : o;
                    }, c.padAngle = function(A) {
                        return arguments.length ? (s = "function" == typeof A ? A : (0, n.Z)(+A), c) : s;
                    }, c;
                }
                var U = e(1108);
                function v(A) {
                    return A.innerRadius;
                }
                function y(A) {
                    return A.outerRadius;
                }
                function C(A) {
                    return A.startAngle;
                }
                function m(A) {
                    return A.endAngle;
                }
                function E(A) {
                    return A && A.padAngle;
                }
                function F(A, t, e, n, r, a, i, o) {
                    var s = e - A, c = n - t, l = i - r, u = o - a, f = u * s - l * c;
                    if (!(f * f < h)) return [
                        A + (f = (l * (t - a) - u * (A - r)) / f) * s,
                        t + f * c
                    ];
                }
                function _(A, t, e, n, r, a, i) {
                    var o = A - e, s = t - n, l = (i ? a : -a) / f(o * o + s * s), u = l * s, h = -l * o, B = A + u, d = t + h, g = e + u, w = n + h, p = (B + g) / 2, Q = (d + w) / 2, U = g - B, v = w - d, y = U * U + v * v, C = r - a, m = B * w - g * d, E = (v < 0 ? -1 : 1) * f(c(0, C * C * y - m * m)), F = (m * v - U * E) / y, _ = (-m * U - v * E) / y, b = (m * v + U * E) / y, H = (-m * U + v * E) / y, N = F - p, I = _ - Q, M = b - p, T = H - Q;
                    return N * N + I * I > M * M + T * T && (F = b, _ = H), {
                        cx: F,
                        cy: _,
                        x01: -u,
                        y01: -h,
                        x11: F * (r / C - 1),
                        y11: _ * (r / C - 1)
                    };
                }
                function b() {
                    var A = v, t = y, e = (0, n.Z)(0), r = null, a = C, c = m, Q = E, b = null;
                    function H() {
                        var n, v, y = +A.apply(this, arguments), C = +t.apply(this, arguments), m = a.apply(this, arguments) - d, E = c.apply(this, arguments) - d, H = i(E - m), N = E > m;
                        if (b || (b = n = (0, U.Z)()), C < y && (v = C, C = y, y = v), C > h) {
                            if (H > g - h) b.moveTo(C * s(m), C * u(m)), b.arc(0, 0, C, m, E, !N), y > h && (b.moveTo(y * s(E), y * u(E)), b.arc(0, 0, y, E, m, N));
                            else {
                                var I, M, T = m, x = E, K = m, O = E, S = H, L = H, k = Q.apply(this, arguments) / 2, P = k > h && (r ? +r.apply(this, arguments) : f(y * y + C * C)), D = l(i(C - y) / 2, +e.apply(this, arguments)), R = D, z = D;
                                if (P > h) {
                                    var X = p(P / y * u(k)), V = p(P / C * u(k));
                                    (S -= 2 * X) > h ? (K += X *= N ? 1 : -1, O -= X) : (S = 0, K = O = (m + E) / 2), (L -= 2 * V) > h ? (T += V *= N ? 1 : -1, x -= V) : (L = 0, T = x = (m + E) / 2);
                                }
                                var Y = C * s(T), G = C * u(T), J = y * s(O), W = y * u(O);
                                if (D > h) {
                                    var j, Z = C * s(x), q = C * u(x), $ = y * s(K), AA = y * u(K);
                                    if (H < B && (j = F(Y, G, $, AA, Z, q, J, W))) {
                                        var tA = Y - j[0], eA = G - j[1], nA = Z - j[0], rA = q - j[1], aA = 1 / u(w((tA * nA + eA * rA) / (f(tA * tA + eA * eA) * f(nA * nA + rA * rA))) / 2), iA = f(j[0] * j[0] + j[1] * j[1]);
                                        R = l(D, (y - iA) / (aA - 1)), z = l(D, (C - iA) / (aA + 1));
                                    }
                                }
                                L > h ? z > h ? (I = _($, AA, Y, G, C, z, N), M = _(Z, q, J, W, C, z, N), b.moveTo(I.cx + I.x01, I.cy + I.y01), z < D ? b.arc(I.cx, I.cy, z, o(I.y01, I.x01), o(M.y01, M.x01), !N) : (b.arc(I.cx, I.cy, z, o(I.y01, I.x01), o(I.y11, I.x11), !N), b.arc(0, 0, C, o(I.cy + I.y11, I.cx + I.x11), o(M.cy + M.y11, M.cx + M.x11), !N), b.arc(M.cx, M.cy, z, o(M.y11, M.x11), o(M.y01, M.x01), !N))) : (b.moveTo(Y, G), b.arc(0, 0, C, T, x, !N)) : b.moveTo(Y, G), y > h && S > h ? R > h ? (I = _(J, W, Z, q, y, -R, N), M = _(Y, G, $, AA, y, -R, N), b.lineTo(I.cx + I.x01, I.cy + I.y01), R < D ? b.arc(I.cx, I.cy, R, o(I.y01, I.x01), o(M.y01, M.x01), !N) : (b.arc(I.cx, I.cy, R, o(I.y01, I.x01), o(I.y11, I.x11), !N), b.arc(0, 0, y, o(I.cy + I.y11, I.cx + I.x11), o(M.cy + M.y11, M.cx + M.x11), N), b.arc(M.cx, M.cy, R, o(M.y11, M.x11), o(M.y01, M.x01), !N))) : b.arc(0, 0, y, O, K, N) : b.lineTo(J, W);
                            }
                        } else b.moveTo(0, 0);
                        if (b.closePath(), n) return b = null, n + "" || null;
                    }
                    return H.centroid = function() {
                        var e = (+A.apply(this, arguments) + +t.apply(this, arguments)) / 2, n = (+a.apply(this, arguments) + +c.apply(this, arguments)) / 2 - B / 2;
                        return [
                            s(n) * e,
                            u(n) * e
                        ];
                    }, H.innerRadius = function(t) {
                        return arguments.length ? (A = "function" == typeof t ? t : (0, n.Z)(+t), H) : A;
                    }, H.outerRadius = function(A) {
                        return arguments.length ? (t = "function" == typeof A ? A : (0, n.Z)(+A), H) : t;
                    }, H.cornerRadius = function(A) {
                        return arguments.length ? (e = "function" == typeof A ? A : (0, n.Z)(+A), H) : e;
                    }, H.padRadius = function(A) {
                        return arguments.length ? (r = null == A ? null : "function" == typeof A ? A : (0, n.Z)(+A), H) : r;
                    }, H.startAngle = function(A) {
                        return arguments.length ? (a = "function" == typeof A ? A : (0, n.Z)(+A), H) : a;
                    }, H.endAngle = function(A) {
                        return arguments.length ? (c = "function" == typeof A ? A : (0, n.Z)(+A), H) : c;
                    }, H.padAngle = function(A) {
                        return arguments.length ? (Q = "function" == typeof A ? A : (0, n.Z)(+A), H) : Q;
                    }, H.context = function(A) {
                        return arguments.length ? (b = null == A ? null : A, H) : b;
                    }, H;
                }
                var H = e(9037), N = e(4017), I = 7.5625;
                function M(A) {
                    return (A = +A) < .36363636363636365 ? I * A * A : A < .7272727272727273 ? I * (A -= .5454545454545454) * A + .75 : A < .9090909090909091 ? I * (A -= .8181818181818182) * A + .9375 : I * (A -= .9545454545454546) * A + .984375;
                }
                var T = e(2396), x = e(3172);
                function K(A) {
                    return (K = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function O(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function S(A, t) {
                    return (S = Object.setPrototypeOf || function(A, t) {
                        return A.__proto__ = t, A;
                    })(A, t);
                }
                function L(A, t) {
                    return !t || "object" !== K(t) && "function" != typeof t ? k(A) : t;
                }
                function k(A) {
                    if (void 0 === A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return A;
                }
                function P(A) {
                    return (P = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
                        return A.__proto__ || Object.getPrototypeOf(A);
                    })(A);
                }
                var D = function(A) {
                    !function(A, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        A.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: A,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && S(A, t);
                    }(o, A);
                    var t, n, r, a, i = (r = o, a = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (A) {
                            return !1;
                        }
                    }(), function() {
                        var A, t = P(r);
                        if (a) {
                            var e = P(this).constructor;
                            A = Reflect.construct(t, arguments, e);
                        } else A = t.apply(this, arguments);
                        return L(this, A);
                    });
                    function o(A, t, e, n) {
                        var r;
                        return function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, o), (r = i.call(this, A, t, e, n)).draw = r.draw.bind(k(r)), r.update = r.update.bind(k(r)), r;
                    }
                    return t = o, n = [
                        {
                            key: "draw",
                            value: function() {
                                var A = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = this.width, e = this.height, n = Math.min(t, e) / 2.25, r = n * A, a = [
                                    "pie-chart"
                                ];
                                r > 0 && a.push("doughnut-chart"), this.svg = this.drawSVG(a), this.g = this.svg.append("g").attr("transform", "translate(".concat(t / 2, ", ").concat(1.1 * e / 2, ")")), this.g.call(this.tip), this.pie = Q().value(function(A) {
                                    return A.value;
                                }).sort(null), this.path = b().outerRadius(n).innerRadius(r), this.pathOver = b().outerRadius(1.075 * n).innerRadius(r);
                                for(var i = [], o = Math.PI / 8; o < 2 * Math.PI; o += Math.PI / 4)i.push(o);
                                return i.push(2 * Math.PI), this.pieBand = (0, H.ut)().domain(i).range([
                                    "n",
                                    "ne",
                                    "e",
                                    "se",
                                    "s",
                                    "sw",
                                    "w",
                                    "nw",
                                    "n"
                                ]), this.hoveredText = this.g.append("g").append("text").attr("class", "hovered-val").attr("opacity", 0), this.iRadius = r, this.radius = n, this.update(), this.svg;
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var A = this, t = this;
                                Promise.resolve().then(e.t.bind(e, 6767, 23)).then(function(e) {
                                    var n = e.default;
                                    if ("Yes" === A.legend) {
                                        var r = A.data.data.map(function(A) {
                                            return Object.assign({}, {
                                                key: A.label,
                                                color: A.color,
                                                type: "area"
                                            });
                                        });
                                        A.drawLegend(r, !1);
                                    }
                                    var a = A.g.selectAll(".arc").data(A.pie(A.data.data), function(A) {
                                        return A.data.color;
                                    }), i = a.enter().append("g").attr("class", "arc"), o = i.merge(a), s = 4;
                                    function c(A) {
                                        var e = (0, x.Z)(this._current, A);
                                        return this._current = e(0), function(A) {
                                            return t.path(e(A));
                                        };
                                    }
                                    A.iRadius > 0 && o.each(function(A) {
                                        t.hoveredText.text(t.data.prependToValue + A.value + t.data.appendToValue);
                                        var e = t.hoveredText.node().getBBox(), n = 1.25 * t.iRadius / e.width, r = 1.25 * t.iRadius / e.height, a = n < r ? n : r;
                                        a < s && (s = a);
                                    }), t.hoveredText.attr("transform", "scale(" + s + ", " + s + ")").text(""), i.append("path").attr("d", A.path).each(function() {
                                        this._current = {
                                            startAngle: 0,
                                            endAngle: 0
                                        };
                                    }).transition().duration(1e3).attrTween("d", c).attr("fill", function(A) {
                                        return A.data.color;
                                    }).attr("id", function(A, t) {
                                        return "arc-" + t;
                                    }), o.select("path").datum(function(A) {
                                        return A.data.colorObj = n(A.data.color), A;
                                    }), a.select("path").transition().duration(750).attrTween("d", c).attr("data", function(A) {
                                        return A.data.percentage = (A.endAngle - A.startAngle) / (2 * Math.PI) * 100, JSON.stringify(A.data);
                                    }), o.on("mouseover", function(A, e, n) {
                                        if ((0, N.Z)(this).select("path").transition().duration(200).ease(T.u4).attr("d", t.pathOver).attr("fill", function(A) {
                                            return A.data.colorObj.darken(.2);
                                        }), t.iRadius > 0) t.hoveredText.text(t.data.prependToValue + t.f(A.value) + t.data.appendToValue).transition().duration(200).ease(T.u4).attr("opacity", 1);
                                        else {
                                            var r, a, i = n[e].getBBox(), o = Math.abs((A.startAngle + A.endAngle) / 2);
                                            a = t.pieBand(o), r = A.endAngle <= Math.PI / 2 ? [
                                                i.height,
                                                i.x - i.width / 2
                                            ] : A.endAngle <= Math.PI ? [
                                                -i.y,
                                                i.x - i.width / 2
                                            ] : A.endAngle <= 1.5 * Math.PI ? [
                                                0,
                                                -(i.width / 2 + i.x)
                                            ] : [
                                                -i.y,
                                                -(i.width / 2 + i.x)
                                            ];
                                            var s = Math.sin((A.startAngle + A.endAngle - Math.PI) / 2) * (t.radius + 45), c = Math.cos((A.startAngle + A.endAngle - Math.PI) / 2) * (t.radius + 45);
                                            t.tip.offset(function() {
                                                return [
                                                    s + r[0],
                                                    c + r[1]
                                                ];
                                            }).attr("class", function() {
                                                return "d3-tip pie-tip _" + a;
                                            }).show(t.f(A.value), this);
                                        }
                                    }).on("mouseout", function() {
                                        (0, N.Z)(this).select("path").transition().duration(300).ease(M).attr("d", t.path).attr("fill", function(A) {
                                            return A.data.color;
                                        }), t.hoveredText.transition().duration(200).ease(T.u4).attr("opacity", 0).on("end", function() {
                                            t.hoveredText.text("");
                                        }), t.tip.hide();
                                    });
                                });
                            }
                        }
                    ], O(t.prototype, n), o;
                }(e(1112).Z);
            },
            4653: (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, {
                    default: ()=>Scatterplot
                });
                var d3_scale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9037), d3_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8602), d3_array__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2168), d3_selection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4017), d3_selection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5109), d3_axis__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6216), d3_ease__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1078), d3_ease__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2396), d3_drag__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5608), d3_interpolate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3172), _Chart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1112);
                function _typeof(A) {
                    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function _classCallCheck(A, t) {
                    if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function _createClass(A, t, e) {
                    return t && _defineProperties(A.prototype, t), e && _defineProperties(A, e), A;
                }
                function _inherits(A, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                    A.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: A,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && _setPrototypeOf(A, t);
                }
                function _setPrototypeOf(A, t) {
                    return (_setPrototypeOf = Object.setPrototypeOf || function(A, t) {
                        return A.__proto__ = t, A;
                    })(A, t);
                }
                function _createSuper(A) {
                    var t = _isNativeReflectConstruct();
                    return function() {
                        var e, n = _getPrototypeOf(A);
                        if (t) {
                            var r = _getPrototypeOf(this).constructor;
                            e = Reflect.construct(n, arguments, r);
                        } else e = n.apply(this, arguments);
                        return _possibleConstructorReturn(this, e);
                    };
                }
                function _possibleConstructorReturn(A, t) {
                    return !t || "object" !== _typeof(t) && "function" != typeof t ? _assertThisInitialized(A) : t;
                }
                function _assertThisInitialized(A) {
                    if (void 0 === A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return A;
                }
                function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (A) {
                        return !1;
                    }
                }
                function _getPrototypeOf(A) {
                    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
                        return A.__proto__ || Object.getPrototypeOf(A);
                    })(A);
                }
                var Scatterplot = function(_Chart) {
                    _inherits(Scatterplot, _Chart);
                    var _super = _createSuper(Scatterplot);
                    function Scatterplot(A, t, e, n, r) {
                        var a;
                        return _classCallCheck(this, Scatterplot), (a = _super.call(this, A, t, e, n, r)).draw = a.draw.bind(_assertThisInitialized(a)), a;
                    }
                    return _createClass(Scatterplot, [
                        {
                            key: "setRange",
                            value: function(A, t, e, n) {
                                var r = void 0 === this.data.xPadding ? 0 : this.data.xPadding;
                                this.range = {
                                    x: (0, d3_scale__WEBPACK_IMPORTED_MODULE_0__.q2)().range([
                                        A,
                                        t
                                    ]).padding(r).align(.5).round(0 !== r),
                                    y: (0, d3_scale__WEBPACK_IMPORTED_MODULE_0__.BY)().range([
                                        n,
                                        e
                                    ])
                                };
                            }
                        },
                        {
                            key: "drawAxis",
                            value: function() {
                                void 0 === this.data.xAxis && (this.data.xAxis = {
                                    show: !0
                                }), void 0 === this.data.yAxis && (this.data.yAxis = {
                                    show: !0
                                }), !0 === this.data.xAxis.show ? (this.xAxis = this.svg.append("g"), this.xAxisDesc = this.svg.append("g"), this.xAxisDesc.append("text").attr("class", "x-axis-description")) : this.xAxis = !1, !0 === this.data.yAxis.show ? (this.yPos = void 0 === this.data.yAxis.position ? "axisLeft" : this.data.yAxis.position, this.yAxis = this.svg.append("g"), this.yAxis.append("text").attr("class", "y-axis-label")) : (this.yAxis = !1, this.yPos = "axisLeft"), this.updateAxis(!0);
                            }
                        },
                        {
                            key: "updateAxis",
                            value: function() {
                                var A = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], t = this;
                                !1 !== this.xAxis && (this.updateXAxis(), this.xAxisDesc.select(".x-axis-description").attr("x", 10).attr("y", 0).attr("dy", "0.35em").attr("text-anchor", "middle").attr("fill", "#000").attr("transform", function() {
                                    return "translate(".concat(t.width / 2, ", ").concat(t.height + .75 * t.container.margin.bottom, ")");
                                }).text(this.data.xAxisLabel)), !1 !== this.yAxis && (this.updateYAxis(), this.yAxis.select(".y-axis-label").attr("x", 10).attr("y", 0).attr("dy", "0.35em").attr("text-anchor", "middle").attr("fill", "#000").attr("transform", function() {
                                    return "axisLeft" === t.yPos ? "translate(-".concat(t.container.margin.left - 5, ", ").concat(t.height / 2, ") rotate(-90)") : "translate(".concat(t.container.margin.right - 11, ", ").concat(t.height / 2, ") rotate(-90)");
                                }).text(this.data.yAxisLabel)), this.xAxis && A && this.wrapAxisLabels();
                            }
                        },
                        {
                            key: "updateXAxis",
                            value: function() {
                                this.xAxis.attr("transform", "translate(0, ".concat(this.height, ")")).attr("class", "axis axis--x axisBottom").call(this.axisCall.axisBottom(this.range.x));
                            }
                        },
                        {
                            key: "updateYAxis",
                            value: function() {
                                var A = this;
                                this.yAxis.attr("class", "axis axis--y " + this.yPos).attr("transform", function() {
                                    return "axisLeft" === A.yPos ? "translate(0, 0)" : "translate(".concat(A.width, ", 0)");
                                }).call(this.axisCall[this.yPos](this.range.y).tickFormat(function(A) {
                                    return (0, d3_format__WEBPACK_IMPORTED_MODULE_4__.jH)(".2~s", A)(A).match(/m$/) && A >= .01 ? A : (0, d3_format__WEBPACK_IMPORTED_MODULE_4__.WU)(".2~s")(A);
                                }));
                            }
                        },
                        {
                            key: "wrapAxisLabels",
                            value: function() {
                                var A = this, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                                if (!1 === t && (t = this.xAxis), !1 !== t) {
                                    !1 === e && (e = this.range.x);
                                    var n = 0, r = e.step() - e.step() * e.padding(), a = [];
                                    t.selectAll("text").each(function(A, t, e) {
                                        var n = e[t];
                                        n.textLength.baseVal.value > 0 ? a.push(n.textLength.baseVal.value) : a.push(n.getBBox().width);
                                    });
                                    var i = (0, d3_array__WEBPACK_IMPORTED_MODULE_1__.Fp)(a);
                                    if (a = [], i > r - 4) {
                                        if (i > 40) {
                                            n = this.wrapLabel(t, r);
                                            var o = t.selectAll("span");
                                            o._groups[0].length > 0 && (o.each(function(A, t, e) {
                                                var n = e[t].offsetWidth;
                                                a.push(n);
                                            }), (0, d3_array__WEBPACK_IMPORTED_MODULE_1__.Fp)(a) > r - 4 && (t.selectAll("foreignObject").remove(), n = this.rotateLabel(t)));
                                        } else n = this.rotateLabel(t);
                                    }
                                    if (0 === n) {
                                        var s = t.node().getBBox().height;
                                        s > n && (n = s);
                                    }
                                    this.container.margin.bottom < n && (this.container.margin.bottom += n, this.height = this.container.h - this.container.margin.bottom, setTimeout(function() {
                                        A.update(!0);
                                    }, 0));
                                }
                            }
                        },
                        {
                            key: "rotateLabel",
                            value: function(A) {
                                if (!1 === A && (A = this.xAxis), !1 !== A) return A.selectAll("text").style("text-anchor", "end").attr("class", "x-axis-text").attr("dx", "-.8em").attr("dy", "-.15em").attr("transform", "rotate(-65)"), 0;
                            }
                        },
                        {
                            key: "wrapLabel",
                            value: function(A, t) {
                                var e = 0;
                                if (!1 === A && (A = this.xAxis), !1 !== A) {
                                    var n = A.selectAll(".tick");
                                    if (Modernizr.svgforeignobject) {
                                        n.selectAll("foreignObject").remove();
                                        var r = n.insert("foreignObject", "text").attr("x", -t / 2).attr("y", "5").attr("class", "x-label-textArea").attr("width", t - 4).style("text-align", "center");
                                        r.append("xhtml:div").attr("xmlns", "http://www.w3.org/1999/xhtml").append("xhtml:span").attr("xmlns", "http://www.w3.org/1999/xhtml").html(function(A) {
                                            return A;
                                        }), r.each(function(A, t, n) {
                                            var r = (0, d3_selection__WEBPACK_IMPORTED_MODULE_5__.Z)(n[t]), a = r.select("div")._groups[0][0].getBoundingClientRect().height;
                                            a > e && (e = a), r.attr("height", a);
                                        });
                                    } else {
                                        var a = A.selectAll(".tick text").nodes();
                                        A.selectAll(".tick").append("title").text(function(A) {
                                            return A;
                                        }), -1 === navigator.userAgent.indexOf("MSIE") && -1 !== navigator.userAgent.indexOf("Trident/") && "line chart" === this.data.type ? this.rotateLabel(A) : a.each(function(A, e) {
                                            for(var n = e.getComputedTextLength(), r = e.textContent, a = t - 12; n > a && r.length > 0;)r = r.slice(0, -1), e.textContent = r + "...", n = e.getComputedTextLength();
                                        });
                                    }
                                    return e;
                                }
                            }
                        },
                        {
                            key: "drawGridlines",
                            value: function() {
                                var A = this, t = this.axisCall.axisBottom().tickFormat("").tickSize(-this.height).scale(this.range.x), e = this.axisCall[this.yPos]().tickFormat("").tickSize(-this.width).scale(this.range.y);
                                this.xGrid = this.svg.insert("g", ":first-child").attr("class", "grid x-grid").attr("transform", "translate(0, ".concat(this.height, ")")).call(t), this.yGrid = this.svg.insert("g", ":first-child").attr("class", "grid y-grid").attr("transform", function() {
                                    return "axisLeft" === A.yPos ? "translate(0, 0)" : "translate(".concat(A.width, ", 0)");
                                }).call(e);
                            }
                        },
                        {
                            key: "draw",
                            value: function() {
                                void 0 === this.svg && (this.svg = this.drawSVG([
                                    "scatterplot-chart"
                                ]));
                                var A = this.svg, t = Scatterplot.generateXY(this.data);
                                this.chartData = t, this.setRange(0, this.container.w, 0, this.container.h), this.drawGridlines(), this.range.y.domain([
                                    this.data.minY,
                                    this.data.maxY
                                ]), this.range.x.domain(this.data.labels), A.append("g").call((0, d3_axis__WEBPACK_IMPORTED_MODULE_2__.y4)(this.range.y)), this.xAxis = this.svg.append("g").attr("class", "x axis").attr("transform", "translate(0," + this.container.h + ")").call((0, d3_axis__WEBPACK_IMPORTED_MODULE_2__.LL)(this.range.x)), this.path = A.append("path").datum(t).attr("class", "line"), this.wireSlider(), this.update();
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var A = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 99999, e = this, n = this.chartData.filter(function(e) {
                                    return A <= e.i && e.i <= t;
                                });
                                this.range.x.domain(n.map(function(A) {
                                    return A.x;
                                })), this.xAxis.call((0, d3_axis__WEBPACK_IMPORTED_MODULE_2__.LL)(this.range.x));
                                var r = (0, d3_axis__WEBPACK_IMPORTED_MODULE_2__.LL)().tickFormat("").tickSize(-this.container.h).scale(this.range.x);
                                this.xGrid.call(r);
                                var a = LineChart.createLine(this.range);
                                this.path.attr("d", a).datum(n);
                                var i = this.svg.selectAll(".dot").data(n, function(A) {
                                    return A.x;
                                });
                                i.exit().remove();
                                var o = i.enter().append("circle").attr("class", "dot").attr("r", 3).attr("stroke", "#197BD0").attr("fill", "#197BD0").attr("stroke-width", "13px").attr("stroke-opacity", 0).on("mouseover", function(A, t) {
                                    (0, d3_selection__WEBPACK_IMPORTED_MODULE_5__.Z)(this).transition().ease(d3_ease__WEBPACK_IMPORTED_MODULE_6__._D).duration("500").attr("r", 9);
                                }).on("mouseout", function(A, t) {
                                    (0, d3_selection__WEBPACK_IMPORTED_MODULE_5__.Z)(this).transition().ease(d3_ease__WEBPACK_IMPORTED_MODULE_7__.Kl).delay("100").duration("200").attr("r", 3);
                                });
                                o.merge(i).attr("cx", function(A) {
                                    return e.range.x(A.x);
                                }).attr("cy", function(A) {
                                    return e.range.y(A.y);
                                });
                            }
                        },
                        {
                            key: "drawSlider",
                            value: function() {
                                var A = (0, d3_selection__WEBPACK_IMPORTED_MODULE_5__.Z)(this.selector).append("div").attr("class", "timeline-slider").attr("data-html2canvas-ignore", !0).attr("aria-describedby", "timeline-slider-" + this.data.urlTitle);
                                return A.append("span").style("margin-left", "".concat(this.container.margin.left, "px")).html("Select a date range:").attr("class", "mcopy").attr("id", "timeline-slider-" + this.data.urlTitle), A.append("svg").attr("width", this.container.w).attr("transform", "translate(0, 0)");
                            }
                        },
                        {
                            key: "wireSlider",
                            value: function wireSlider() {
                                if (!(this.data.labels.length < 11 || !1 === this.data.showSlider)) {
                                    var slider = this.drawSlider(), self1 = this, width = this.width, activeHandler = !1, isDragging = !1, xYearFirst = this.range.x.copy(), zero = xYearFirst.range()[0] + xYearFirst.step() * xYearFirst.padding();
                                    xYearFirst.invert = (domain = xYearFirst.domain(), range = xYearFirst.range(), scale = (0, d3_scale__WEBPACK_IMPORTED_MODULE_0__.aE)().domain(range).range(domain), function(A) {
                                        return scale(A);
                                    });
                                    var sliderYearFirst = slider.append("g").attr("class", "slider").attr("transform", "translate(".concat(this.container.margin.left, ", 50)"));
                                    sliderYearFirst.append("line").attr("class", "track").attr("x1", zero).attr("x2", xYearFirst.range()[1] - xYearFirst.step() * xYearFirst.padding()).select(function() {
                                        return this.parentNode.appendChild(this.cloneNode(!0));
                                    }).attr("class", "track-inset").select(function() {
                                        return this.parentNode.appendChild(this.cloneNode(!0));
                                    }).attr("class", "track-overlay").call((0, d3_drag__WEBPACK_IMPORTED_MODULE_8__.Z)().on("start.interrupt", function() {
                                        sliderYearFirst.interrupt();
                                    }).on("start drag", function() {
                                        !1 === isDragging ? (isDragging = !0, [
                                            handle1.attr("cx"),
                                            handle2.attr("cx")
                                        ].sort(function(A, t) {
                                            return Math.abs(d3_selection__WEBPACK_IMPORTED_MODULE_9__.B.x - A) - Math.abs(d3_selection__WEBPACK_IMPORTED_MODULE_9__.B.x - t);
                                        })[0] === handle1.attr("cx") ? (activeHandler = handle1, setHandlePos(xYearFirst.invert(d3_selection__WEBPACK_IMPORTED_MODULE_9__.B.x), handle1, !0)) : (activeHandler = handle2, setHandlePos(xYearFirst.invert(d3_selection__WEBPACK_IMPORTED_MODULE_9__.B.x), handle2, !0))) : setHandlePos(xYearFirst.invert(d3_selection__WEBPACK_IMPORTED_MODULE_9__.B.x), activeHandler, !0);
                                    }).on("end", function() {
                                        isDragging = !1;
                                    })), this.wrapAxisLabels(sliderYearFirst);
                                    var handle1 = sliderYearFirst.insert("g", ".track-overlay").attr("class", "handle1");
                                    this.buildHandle(handle1, xYearFirst.domain()[0], zero);
                                    var handle1TipValue = handle1.select("text"), handle2 = sliderYearFirst.insert("g", ".track-overlay").attr("class", "handle2");
                                    this.buildHandle(handle2, xYearFirst.domain()[0], zero);
                                    var handle2TipValue = handle2.select("text");
                                    activeHandler = handle2;
                                    var selection = sliderYearFirst.insert("line", ".handle1").attr("class", "selection").attr("x1", zero).attr("x2", zero);
                                    sliderYearFirst.transition().duration(1500).tween("hue", function() {
                                        var A = (0, d3_interpolate__WEBPACK_IMPORTED_MODULE_10__.Z)(0, width);
                                        return function(t) {
                                            setHandlePos(xYearFirst.invert(A(t)), handle2, !1);
                                        };
                                    }), slider.attr("height", sliderYearFirst.node().getBBox().height + 10);
                                }
                                var domain, range, scale;
                                function setHandlePos(h, handle) {
                                    var modChart = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], otherHandle, operator;
                                    handle === handle1 ? (otherHandle = handle2, operator = "<") : (otherHandle = handle1, operator = ">"), eval(otherHandle.attr("cx") + operator + xYearFirst(h)) ? (handle.attr("transform", "translate(".concat(otherHandle.attr("cx"), ", 0)")), handle.attr("cx", otherHandle.attr("cx"))) : (handle.attr("transform", "translate(".concat(xYearFirst(h), ", 0)")), handle.attr("cx", xYearFirst(h)));
                                    var handle1Pos = handle1.attr("cx"), handle2Pos = handle2.attr("cx");
                                    selection.attr("x1", handle1Pos).attr("x2", handle2Pos);
                                    var left = self1.chartData.find(function(A) {
                                        return A.x === xYearFirst.invert(handle1Pos);
                                    }), right = self1.chartData.find(function(A) {
                                        return A.x === xYearFirst.invert(handle2Pos);
                                    });
                                    if (handle1TipValue.text(left.x), handle2TipValue.text(right.x), !0 === modChart) {
                                        var _left = self1.chartData.find(function(A) {
                                            return A.x === xYearFirst.invert(handle1Pos);
                                        }), _right = self1.chartData.find(function(A) {
                                            return A.x === xYearFirst.invert(handle2Pos);
                                        });
                                        self1.update(_left.i, _right.i);
                                    }
                                }
                            }
                        },
                        {
                            key: "buildHandle",
                            value: function(A, t, e) {
                                var n = -45, r = A.insert("text").text(t).attr("fill", "#ffffff"), a = r.node().getBBox(), i = a.width + 10, o = a.height + 10;
                                return r.attr("x", -a.width / 2).attr("y", n + a.height + 2), A.insert("rect", ":first-child").attr("width", i).attr("height", o).attr("fill", "#000000").attr("fill-opacity", "0.8").attr("x", -i / 2).attr("y", n).attr("rx", 2), A.insert("circle").attr("class", "handle").attr("cx", e).attr("r", 9), A.insert("polygon").attr("points", "-6,".concat(n + o, " 6,").concat(n + o, " 0,").concat(n + o + 6)).attr("fill", "#000000").attr("fill-opacity", "0.8"), A;
                            }
                        }
                    ], [
                        {
                            key: "generateXY",
                            value: function(A) {
                                var t = A.dataset, e = A.labels;
                                return t.reduce(function(A, n, r) {
                                    return t[r].data.map(function(A, t) {
                                        return Object.assign({
                                            x: e[t],
                                            y: A,
                                            i: t + 1
                                        });
                                    }, {});
                                }, []);
                            }
                        }
                    ]), Scatterplot;
                }(_Chart__WEBPACK_IMPORTED_MODULE_3__.Z);
            },
            5303: (A, t, e)=>{
                "use strict";
                e.r(t), e.d(t, {
                    default: ()=>I
                });
                const n = function(A) {
                    for(var t = A.length / 6 | 0, e = new Array(t), n = 0; n < t;)e[n] = "#" + A.slice(6 * n, 6 * ++n);
                    return e;
                }("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
                var r = e(9037), a = e(399), i = e.n(a), o = Array.prototype.slice, s = e(3072);
                function c(A, t) {
                    if ((r = A.length) > 1) for(var e, n, r, a = 1, i = A[t[0]], o = i.length; a < r; ++a)for(n = i, i = A[t[a]], e = 0; e < o; ++e)i[e][1] += i[e][0] = isNaN(n[e][1]) ? n[e][0] : n[e][1];
                }
                function l(A) {
                    for(var t = A.length, e = new Array(t); --t >= 0;)e[t] = t;
                    return e;
                }
                function u(A, t) {
                    return A[t];
                }
                function f() {
                    var A = (0, s.Z)([]), t = l, e = c, n = u;
                    function r(r) {
                        var a, i, o = A.apply(this, arguments), s = r.length, c = o.length, l = new Array(c);
                        for(a = 0; a < c; ++a){
                            for(var u, f = o[a], h = l[a] = new Array(s), B = 0; B < s; ++B)h[B] = u = [
                                0,
                                +n(r[B], f, B, r)
                            ], u.data = r[B];
                            h.key = f;
                        }
                        for(a = 0, i = t(l); a < c; ++a)l[i[a]].index = a;
                        return e(l, i), l;
                    }
                    return r.keys = function(t) {
                        return arguments.length ? (A = "function" == typeof t ? t : (0, s.Z)(o.call(t)), r) : A;
                    }, r.value = function(A) {
                        return arguments.length ? (n = "function" == typeof A ? A : (0, s.Z)(+A), r) : n;
                    }, r.order = function(A) {
                        return arguments.length ? (t = null == A ? l : "function" == typeof A ? A : (0, s.Z)(o.call(A)), r) : t;
                    }, r.offset = function(A) {
                        return arguments.length ? (e = null == A ? c : A, r) : e;
                    }, r;
                }
                function h(A) {
                    return l(A).reverse();
                }
                var B = e(2168), d = e(8716), g = e(2396), w = e(4017);
                function p(A) {
                    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function Q(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function U(A, t) {
                    return (U = Object.setPrototypeOf || function(A, t) {
                        return A.__proto__ = t, A;
                    })(A, t);
                }
                function v(A, t) {
                    return !t || "object" !== p(t) && "function" != typeof t ? y(A) : t;
                }
                function y(A) {
                    if (void 0 === A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return A;
                }
                function C(A) {
                    return (C = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
                        return A.__proto__ || Object.getPrototypeOf(A);
                    })(A);
                }
                var m = function(A) {
                    !function(A, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        A.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: A,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && U(A, t);
                    }(s, A);
                    var t, e, n, a, i, o = (a = s, i = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (A) {
                            return !1;
                        }
                    }(), function() {
                        var A, t = C(a);
                        if (i) {
                            var e = C(this).constructor;
                            A = Reflect.construct(t, arguments, e);
                        } else A = t.apply(this, arguments);
                        return v(this, A);
                    });
                    function s(A, t, e, n) {
                        var r;
                        return function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, s), (r = o.call(this, A, t, e, n)).draw = r.draw.bind(y(r)), r;
                    }
                    return t = s, n = [
                        {
                            key: "setRange",
                            value: function(A, t, e, n) {
                                return {
                                    x: (0, r.ti)().rangeRound([
                                        A,
                                        t
                                    ], .05),
                                    y: (0, r.BY)().range([
                                        n,
                                        e
                                    ])
                                };
                            }
                        }
                    ], e = [
                        {
                            key: "draw",
                            value: function() {
                                return this.svg = this.drawSVG([
                                    "bar-chart",
                                    "scatterplot-chart"
                                ]), this.buildStacks(), this.drawAxis(), this.barsCont = this.svg.append("g"), this.drawGoalLines(), this.update(!0), this;
                            }
                        }
                    ], Q(t.prototype, e), n && Q(t, n), s;
                }(e(4653).default);
                function E(A) {
                    return (E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                        return typeof A;
                    } : function(A) {
                        return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                    })(A);
                }
                function F(A, t) {
                    for(var e = 0; e < t.length; e++){
                        var n = t[e];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                    }
                }
                function _(A, t) {
                    return (_ = Object.setPrototypeOf || function(A, t) {
                        return A.__proto__ = t, A;
                    })(A, t);
                }
                function b(A, t) {
                    return !t || "object" !== E(t) && "function" != typeof t ? H(A) : t;
                }
                function H(A) {
                    if (void 0 === A) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return A;
                }
                function N(A) {
                    return (N = Object.setPrototypeOf ? Object.getPrototypeOf : function(A) {
                        return A.__proto__ || Object.getPrototypeOf(A);
                    })(A);
                }
                e(6767);
                var I = function(A) {
                    !function(A, t) {
                        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                        A.prototype = Object.create(t && t.prototype, {
                            constructor: {
                                value: A,
                                writable: !0,
                                configurable: !0
                            }
                        }), t && _(A, t);
                    }(p, A);
                    var t, a, o, s, l, u = (s = p, l = function() {
                        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                        if (Reflect.construct.sham) return !1;
                        if ("function" == typeof Proxy) return !0;
                        try {
                            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                        } catch (A) {
                            return !1;
                        }
                    }(), function() {
                        var A, t = N(s);
                        if (l) {
                            var e = N(this).constructor;
                            A = Reflect.construct(t, arguments, e);
                        } else A = t.apply(this, arguments);
                        return b(this, A);
                    });
                    function p(A, t, e, n, r) {
                        var a;
                        return function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, p), (a = u.call(this, A, t, e, n, r)).draw = a.draw.bind(H(a)), a.drawGoalLines = a.drawGoalLines.bind(H(a)), a.updateGoalLines = a.updateGoalLines.bind(H(a)), a._filter = [], a.draw(), a;
                    }
                    return t = p, o = [
                        {
                            key: "setRange",
                            value: function(A, t, e, a) {
                                var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : n, o = (0, r.BY)().rangeRound([
                                    a,
                                    e
                                ]);
                                return {
                                    x: (0, r.ti)().rangeRound([
                                        A,
                                        t
                                    ]).padding(.2).align(.5),
                                    y: o,
                                    oldY: o.copy(),
                                    z: (0, r.PK)().range(i)
                                };
                            }
                        }
                    ], a = [
                        {
                            key: "filter",
                            get: function() {
                                return this._filter;
                            },
                            set: function(A) {
                                this._filter = A.slice(), this.update();
                            }
                        },
                        {
                            key: "filterStacks",
                            value: function(A) {
                                var t = this.data.stackedBarDataset.map(function(A) {
                                    return Object.assign({}, A);
                                });
                                return 0 === A.length ? t : t.map(function(t) {
                                    return A.forEach(function(A) {
                                        t.hasOwnProperty(A) && delete t[A];
                                    }), t;
                                });
                            }
                        },
                        {
                            key: "buildStacks",
                            value: function() {
                                var A, t, e, n = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], r = this.filterStacks(this.filter), a = this.data.stackedBarSegments, o = a.map(function(A) {
                                    return A.label;
                                }), s = this.filter.filter(function(A) {
                                    return o.includes(A);
                                }), l = i()(o, s), u = f().keys(function() {
                                    return l;
                                }).order(h).offset(c)(r), d = [];
                                for(A = 0; A < r.length; A++){
                                    for(t = 0, e = 0; t < l.length; t++)e += +r[A][l[t]];
                                    d[A] = e;
                                }
                                var g = 0 === d.length ? 0 : (0, B.Fp)(d), w = this.data.maxY && 0 === s.length ? this.data.maxY : 1.1 * g, Q = this.data.minY ? this.data.minY : 0;
                                if (n) {
                                    var U = a.map(function(A) {
                                        return A.fillColor;
                                    });
                                    this.range = p.setRange(0, this.width, 0, this.height, U);
                                }
                                return this.range.x.domain(r.map(function(A) {
                                    return A.label;
                                })), this.range.y.domain([
                                    Q,
                                    w
                                ]), this.range.z.domain(o), u;
                            }
                        },
                        {
                            key: "draw",
                            value: function() {
                                var A = this;
                                if (void 0 === this.svg && (this.svg = this.drawSVG([
                                    "bar-chart",
                                    "stacked-bar-chart",
                                    "scatterplot-chart"
                                ])), this.buildStacks(), this.drawAxis(), this.svg.call(this.tip), this.barsCont = this.svg.append("g").attr("class", "bars-container"), this.lineOverlay = !1, void 0 !== this.data.overlay) {
                                    var t = [];
                                    t.push(Object.assign(this.data.overlay[0], {
                                        yAxis: {
                                            show: !0,
                                            position: "axisRight"
                                        },
                                        xAxis: {
                                            show: !1
                                        },
                                        showSlider: !1,
                                        xPadding: .6
                                    })), Promise.resolve().then(e.bind(e, 7969)).then(function(e) {
                                        var n = e.default;
                                        A.lineOverlay = new n(t, A.container, A.selector, !1, A.svg), A.lineOverlay.draw();
                                    }).catch(function(A) {
                                        return console.log(A);
                                    });
                                }
                                return this.drawGoalLines(), this.update(!0), this;
                            }
                        },
                        {
                            key: "update",
                            value: function() {
                                var A = this, t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], n = this;
                                Promise.resolve().then(e.t.bind(e, 6767, 23)).then(function(e) {
                                    var r = e.default;
                                    A.lineOverlay && A.lineOverlay.update();
                                    var a, i = !0 === t ? [] : A.barsCont.selectAll(".stacked-bar").data().slice();
                                    i.length > 0 && A.range.oldY.domain([
                                        A.range.y.domain()[0],
                                        A.range.y.domain()[1]
                                    ]);
                                    var o = A.buildStacks(t);
                                    if (t && "Yes" === A.data.showLegend) {
                                        var s = A.range.z.domain().map(function(t, e) {
                                            return Object.assign({}, {
                                                key: t,
                                                color: A.range.z.range()[e],
                                                type: "area"
                                            });
                                        });
                                        A.lineOverlay && A.lineOverlay.data.dataset.forEach(function(A) {
                                            s.push({
                                                key: A.label,
                                                color: A.strokeColor,
                                                type: "line"
                                            });
                                        }), A.drawLegend(s);
                                    }
                                    setTimeout(function() {
                                        A.updateAxis(!0);
                                    }, 0), A.updateGoalLines();
                                    var c = A.barsCont.selectAll(".stacked-bar").data(o, function(A) {
                                        return A.key;
                                    });
                                    !0 === t ? c.exit().selectAll("rect").transition().duration(250).ease(d._e).attr("opacity", 0).on("end", function() {
                                        c.exit().remove();
                                    }) : c.exit().selectAll("rect").transition().duration(1e3).ease(d._e).attr("height", 0).attr("y", function(A) {
                                        return n.range.y(A[0]);
                                    }).on("end", function() {
                                        c.exit().remove();
                                    });
                                    var l = c.enter().append("g").attr("class", "stacked-bar").attr("fill", function(A, t) {
                                        return i.length > 0 && (a = t), n.range.z(A.key);
                                    }).merge(c).each(function(A) {
                                        A.colorObj = r(n.range.z(A.key));
                                    });
                                    A.data.stackedBarSegments.length > 1 && l.on("mouseover", function(A, t) {
                                        (0, w.Z)(this).transition().ease(g.Kl).duration(250).attr("fill", function(A) {
                                            return A.colorObj.darken(.2);
                                        });
                                    }).on("mouseout", function() {
                                        (0, w.Z)(this).transition().ease(g.u4).duration(250).attr("fill", function(A) {
                                            return n.range.z(A.key);
                                        });
                                    });
                                    var u = l.selectAll("rect").data(function(A) {
                                        return A;
                                    }), f = u.enter().append("rect").attr("width", A.range.x.bandwidth()).attr("x", function(A) {
                                        return n.range.x(A.data.label);
                                    }).attr("height", 0).attr("opacity", 1).attr("y", function(A, t) {
                                        return a === o.length - 1 || void 0 === i[a] || 0 === i.length ? n.range.y(0) : n.range.oldY(i[a][t][1]);
                                    }).merge(u);
                                    f.transition().duration(1e3).ease(d._e).attr("y", function(A) {
                                        return n.range.y(A[1]);
                                    }).attr("height", function(A) {
                                        return n.range.y(A[0]) - n.range.y(A[1]);
                                    }), 1 === A.data.stackedBarSegments.length ? (f.attr("fill", function(A) {
                                        A.colorObj = r(n.range.z(A.key));
                                    }), f.on("mouseover", function(A, t, e) {
                                        var r = (0, w.Z)(this.parentNode).data()[0].key;
                                        n.tip.show(n.f(A.data[r]), this), (0, w.Z)(this).transition().ease(g.Kl).duration(250).attr("fill", function(A) {
                                            return A.colorObj.darken(.2);
                                        });
                                    }).on("mouseout", function(A) {
                                        var t = (0, w.Z)(this.parentNode).data()[0].key;
                                        n.tip.hide(A.data[t], this), (0, w.Z)(this).transition().ease(g.u4).duration(250).attr("fill", function(A) {
                                            return A.colorObj.lighten(.2);
                                        });
                                    })) : f.on("mouseover", function(A, t, e) {
                                        var r = (0, w.Z)(this.parentNode).data()[0].key;
                                        n.tip.show(n.f(A.data[r]), this);
                                    }).on("mouseout", function(A) {
                                        var t = (0, w.Z)(this.parentNode).data()[0].key;
                                        n.tip.hide(A.data[t], this);
                                    });
                                });
                            }
                        }
                    ], F(t.prototype, a), o && F(t, o), p;
                }(m);
            },
            8168: (A, t, e)=>{
                var n = e(8874), r = {};
                for(var a in n)n.hasOwnProperty(a) && (r[n[a]] = a);
                var i = A.exports = {
                    rgb: {
                        channels: 3,
                        labels: "rgb"
                    },
                    hsl: {
                        channels: 3,
                        labels: "hsl"
                    },
                    hsv: {
                        channels: 3,
                        labels: "hsv"
                    },
                    hwb: {
                        channels: 3,
                        labels: "hwb"
                    },
                    cmyk: {
                        channels: 4,
                        labels: "cmyk"
                    },
                    xyz: {
                        channels: 3,
                        labels: "xyz"
                    },
                    lab: {
                        channels: 3,
                        labels: "lab"
                    },
                    lch: {
                        channels: 3,
                        labels: "lch"
                    },
                    hex: {
                        channels: 1,
                        labels: [
                            "hex"
                        ]
                    },
                    keyword: {
                        channels: 1,
                        labels: [
                            "keyword"
                        ]
                    },
                    ansi16: {
                        channels: 1,
                        labels: [
                            "ansi16"
                        ]
                    },
                    ansi256: {
                        channels: 1,
                        labels: [
                            "ansi256"
                        ]
                    },
                    hcg: {
                        channels: 3,
                        labels: [
                            "h",
                            "c",
                            "g"
                        ]
                    },
                    apple: {
                        channels: 3,
                        labels: [
                            "r16",
                            "g16",
                            "b16"
                        ]
                    },
                    gray: {
                        channels: 1,
                        labels: [
                            "gray"
                        ]
                    }
                };
                for(var o in i)if (i.hasOwnProperty(o)) {
                    if (!("channels" in i[o])) throw new Error("missing channels property: " + o);
                    if (!("labels" in i[o])) throw new Error("missing channel labels property: " + o);
                    if (i[o].labels.length !== i[o].channels) throw new Error("channel and label counts mismatch: " + o);
                    var s = i[o].channels, c = i[o].labels;
                    delete i[o].channels, delete i[o].labels, Object.defineProperty(i[o], "channels", {
                        value: s
                    }), Object.defineProperty(i[o], "labels", {
                        value: c
                    });
                }
                i.rgb.hsl = function(A) {
                    var t, e, n = A[0] / 255, r = A[1] / 255, a = A[2] / 255, i = Math.min(n, r, a), o = Math.max(n, r, a), s = o - i;
                    return o === i ? t = 0 : n === o ? t = (r - a) / s : r === o ? t = 2 + (a - n) / s : a === o && (t = 4 + (n - r) / s), (t = Math.min(60 * t, 360)) < 0 && (t += 360), e = (i + o) / 2, [
                        t,
                        100 * (o === i ? 0 : e <= .5 ? s / (o + i) : s / (2 - o - i)),
                        100 * e
                    ];
                }, i.rgb.hsv = function(A) {
                    var t, e, n, r, a, i = A[0] / 255, o = A[1] / 255, s = A[2] / 255, c = Math.max(i, o, s), l = c - Math.min(i, o, s), u = function(A) {
                        return (c - A) / 6 / l + .5;
                    };
                    return 0 === l ? r = a = 0 : (a = l / c, t = u(i), e = u(o), n = u(s), i === c ? r = n - e : o === c ? r = 1 / 3 + t - n : s === c && (r = 2 / 3 + e - t), r < 0 ? r += 1 : r > 1 && (r -= 1)), [
                        360 * r,
                        100 * a,
                        100 * c
                    ];
                }, i.rgb.hwb = function(A) {
                    var t = A[0], e = A[1], n = A[2];
                    return [
                        i.rgb.hsl(A)[0],
                        1 / 255 * Math.min(t, Math.min(e, n)) * 100,
                        100 * (n = 1 - 1 / 255 * Math.max(t, Math.max(e, n)))
                    ];
                }, i.rgb.cmyk = function(A) {
                    var t, e = A[0] / 255, n = A[1] / 255, r = A[2] / 255;
                    return [
                        100 * ((1 - e - (t = Math.min(1 - e, 1 - n, 1 - r))) / (1 - t) || 0),
                        100 * ((1 - n - t) / (1 - t) || 0),
                        100 * ((1 - r - t) / (1 - t) || 0),
                        100 * t
                    ];
                }, i.rgb.keyword = function(A) {
                    var t = r[A];
                    if (t) return t;
                    var e, a, i, o = 1 / 0;
                    for(var s in n)if (n.hasOwnProperty(s)) {
                        var c = (a = A, i = n[s], Math.pow(a[0] - i[0], 2) + Math.pow(a[1] - i[1], 2) + Math.pow(a[2] - i[2], 2));
                        c < o && (o = c, e = s);
                    }
                    return e;
                }, i.keyword.rgb = function(A) {
                    return n[A];
                }, i.rgb.xyz = function(A) {
                    var t = A[0] / 255, e = A[1] / 255, n = A[2] / 255;
                    return [
                        100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (e = e > .04045 ? Math.pow((e + .055) / 1.055, 2.4) : e / 12.92) + .1805 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92)),
                        100 * (.2126 * t + .7152 * e + .0722 * n),
                        100 * (.0193 * t + .1192 * e + .9505 * n)
                    ];
                }, i.rgb.lab = function(A) {
                    var t = i.rgb.xyz(A), e = t[0], n = t[1], r = t[2];
                    return n /= 100, r /= 108.883, e = (e /= 95.047) > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116, [
                        116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16,
                        500 * (e - n),
                        200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116))
                    ];
                }, i.hsl.rgb = function(A) {
                    var t, e, n, r, a, i = A[0] / 360, o = A[1] / 100, s = A[2] / 100;
                    if (0 === o) return [
                        a = 255 * s,
                        a,
                        a
                    ];
                    t = 2 * s - (e = s < .5 ? s * (1 + o) : s + o - s * o), r = [
                        0,
                        0,
                        0
                    ];
                    for(var c = 0; c < 3; c++)(n = i + 1 / 3 * -(c - 1)) < 0 && n++, n > 1 && n--, a = 6 * n < 1 ? t + 6 * (e - t) * n : 2 * n < 1 ? e : 3 * n < 2 ? t + (e - t) * (2 / 3 - n) * 6 : t, r[c] = 255 * a;
                    return r;
                }, i.hsl.hsv = function(A) {
                    var t = A[0], e = A[1] / 100, n = A[2] / 100, r = e, a = Math.max(n, .01);
                    return e *= (n *= 2) <= 1 ? n : 2 - n, r *= a <= 1 ? a : 2 - a, [
                        t,
                        100 * (0 === n ? 2 * r / (a + r) : 2 * e / (n + e)),
                        (n + e) / 2 * 100
                    ];
                }, i.hsv.rgb = function(A) {
                    var t = A[0] / 60, e = A[1] / 100, n = A[2] / 100, r = Math.floor(t) % 6, a = t - Math.floor(t), i = 255 * n * (1 - e), o = 255 * n * (1 - e * a), s = 255 * n * (1 - e * (1 - a));
                    switch(n *= 255, r){
                        case 0:
                            return [
                                n,
                                s,
                                i
                            ];
                        case 1:
                            return [
                                o,
                                n,
                                i
                            ];
                        case 2:
                            return [
                                i,
                                n,
                                s
                            ];
                        case 3:
                            return [
                                i,
                                o,
                                n
                            ];
                        case 4:
                            return [
                                s,
                                i,
                                n
                            ];
                        case 5:
                            return [
                                n,
                                i,
                                o
                            ];
                    }
                }, i.hsv.hsl = function(A) {
                    var t, e, n, r = A[0], a = A[1] / 100, i = A[2] / 100, o = Math.max(i, .01);
                    return n = (2 - a) * i, e = a * o, [
                        r,
                        100 * (e = (e /= (t = (2 - a) * o) <= 1 ? t : 2 - t) || 0),
                        100 * (n /= 2)
                    ];
                }, i.hwb.rgb = function(A) {
                    var t, e, n, r, a, i, o, s = A[0] / 360, c = A[1] / 100, l = A[2] / 100, u = c + l;
                    switch(u > 1 && (c /= u, l /= u), n = 6 * s - (t = Math.floor(6 * s)), 0 != (1 & t) && (n = 1 - n), r = c + n * ((e = 1 - l) - c), t){
                        default:
                        case 6:
                        case 0:
                            a = e, i = r, o = c;
                            break;
                        case 1:
                            a = r, i = e, o = c;
                            break;
                        case 2:
                            a = c, i = e, o = r;
                            break;
                        case 3:
                            a = c, i = r, o = e;
                            break;
                        case 4:
                            a = r, i = c, o = e;
                            break;
                        case 5:
                            a = e, i = c, o = r;
                    }
                    return [
                        255 * a,
                        255 * i,
                        255 * o
                    ];
                }, i.cmyk.rgb = function(A) {
                    var t = A[0] / 100, e = A[1] / 100, n = A[2] / 100, r = A[3] / 100;
                    return [
                        255 * (1 - Math.min(1, t * (1 - r) + r)),
                        255 * (1 - Math.min(1, e * (1 - r) + r)),
                        255 * (1 - Math.min(1, n * (1 - r) + r))
                    ];
                }, i.xyz.rgb = function(A) {
                    var t, e, n, r = A[0] / 100, a = A[1] / 100, i = A[2] / 100;
                    return e = -0.9689 * r + 1.8758 * a + .0415 * i, n = .0557 * r + -0.204 * a + 1.057 * i, t = (t = 3.2406 * r + -1.5372 * a + -0.4986 * i) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, e = e > .0031308 ? 1.055 * Math.pow(e, 1 / 2.4) - .055 : 12.92 * e, n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, [
                        255 * (t = Math.min(Math.max(0, t), 1)),
                        255 * (e = Math.min(Math.max(0, e), 1)),
                        255 * (n = Math.min(Math.max(0, n), 1))
                    ];
                }, i.xyz.lab = function(A) {
                    var t = A[0], e = A[1], n = A[2];
                    return e /= 100, n /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, [
                        116 * (e = e > .008856 ? Math.pow(e, 1 / 3) : 7.787 * e + 16 / 116) - 16,
                        500 * (t - e),
                        200 * (e - (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116))
                    ];
                }, i.lab.xyz = function(A) {
                    var t, e, n, r = A[0];
                    t = A[1] / 500 + (e = (r + 16) / 116), n = e - A[2] / 200;
                    var a = Math.pow(e, 3), i = Math.pow(t, 3), o = Math.pow(n, 3);
                    return e = a > .008856 ? a : (e - 16 / 116) / 7.787, t = i > .008856 ? i : (t - 16 / 116) / 7.787, n = o > .008856 ? o : (n - 16 / 116) / 7.787, [
                        t *= 95.047,
                        e *= 100,
                        n *= 108.883
                    ];
                }, i.lab.lch = function(A) {
                    var t, e = A[0], n = A[1], r = A[2];
                    return (t = 360 * Math.atan2(r, n) / 2 / Math.PI) < 0 && (t += 360), [
                        e,
                        Math.sqrt(n * n + r * r),
                        t
                    ];
                }, i.lch.lab = function(A) {
                    var t, e = A[0], n = A[1];
                    return t = A[2] / 360 * 2 * Math.PI, [
                        e,
                        n * Math.cos(t),
                        n * Math.sin(t)
                    ];
                }, i.rgb.ansi16 = function(A) {
                    var t = A[0], e = A[1], n = A[2], r = 1 in arguments ? arguments[1] : i.rgb.hsv(A)[2];
                    if (0 === (r = Math.round(r / 50))) return 30;
                    var a = 30 + (Math.round(n / 255) << 2 | Math.round(e / 255) << 1 | Math.round(t / 255));
                    return 2 === r && (a += 60), a;
                }, i.hsv.ansi16 = function(A) {
                    return i.rgb.ansi16(i.hsv.rgb(A), A[2]);
                }, i.rgb.ansi256 = function(A) {
                    var t = A[0], e = A[1], n = A[2];
                    return t === e && e === n ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(e / 255 * 5) + Math.round(n / 255 * 5);
                }, i.ansi16.rgb = function(A) {
                    var t = A % 10;
                    if (0 === t || 7 === t) return A > 50 && (t += 3.5), [
                        t = t / 10.5 * 255,
                        t,
                        t
                    ];
                    var e = .5 * (1 + ~~(A > 50));
                    return [
                        (1 & t) * e * 255,
                        (t >> 1 & 1) * e * 255,
                        (t >> 2 & 1) * e * 255
                    ];
                }, i.ansi256.rgb = function(A) {
                    if (A >= 232) {
                        var t = 10 * (A - 232) + 8;
                        return [
                            t,
                            t,
                            t
                        ];
                    }
                    var e;
                    return A -= 16, [
                        Math.floor(A / 36) / 5 * 255,
                        Math.floor((e = A % 36) / 6) / 5 * 255,
                        e % 6 / 5 * 255
                    ];
                }, i.rgb.hex = function(A) {
                    var t = (((255 & Math.round(A[0])) << 16) + ((255 & Math.round(A[1])) << 8) + (255 & Math.round(A[2]))).toString(16).toUpperCase();
                    return "000000".substring(t.length) + t;
                }, i.hex.rgb = function(A) {
                    var t = A.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                    if (!t) return [
                        0,
                        0,
                        0
                    ];
                    var e = t[0];
                    3 === t[0].length && (e = e.split("").map(function(A) {
                        return A + A;
                    }).join(""));
                    var n = parseInt(e, 16);
                    return [
                        n >> 16 & 255,
                        n >> 8 & 255,
                        255 & n
                    ];
                }, i.rgb.hcg = function(A) {
                    var t, e = A[0] / 255, n = A[1] / 255, r = A[2] / 255, a = Math.max(Math.max(e, n), r), i = Math.min(Math.min(e, n), r), o = a - i;
                    return t = o <= 0 ? 0 : a === e ? (n - r) / o % 6 : a === n ? 2 + (r - e) / o : 4 + (e - n) / o + 4, t /= 6, [
                        360 * (t %= 1),
                        100 * o,
                        100 * (o < 1 ? i / (1 - o) : 0)
                    ];
                }, i.hsl.hcg = function(A) {
                    var t, e = A[1] / 100, n = A[2] / 100, r = 0;
                    return (t = n < .5 ? 2 * e * n : 2 * e * (1 - n)) < 1 && (r = (n - .5 * t) / (1 - t)), [
                        A[0],
                        100 * t,
                        100 * r
                    ];
                }, i.hsv.hcg = function(A) {
                    var t = A[1] / 100, e = A[2] / 100, n = t * e, r = 0;
                    return n < 1 && (r = (e - n) / (1 - n)), [
                        A[0],
                        100 * n,
                        100 * r
                    ];
                }, i.hcg.rgb = function(A) {
                    var t = A[0] / 360, e = A[1] / 100, n = A[2] / 100;
                    if (0 === e) return [
                        255 * n,
                        255 * n,
                        255 * n
                    ];
                    var r, a = [
                        0,
                        0,
                        0
                    ], i = t % 1 * 6, o = i % 1, s = 1 - o;
                    switch(Math.floor(i)){
                        case 0:
                            a[0] = 1, a[1] = o, a[2] = 0;
                            break;
                        case 1:
                            a[0] = s, a[1] = 1, a[2] = 0;
                            break;
                        case 2:
                            a[0] = 0, a[1] = 1, a[2] = o;
                            break;
                        case 3:
                            a[0] = 0, a[1] = s, a[2] = 1;
                            break;
                        case 4:
                            a[0] = o, a[1] = 0, a[2] = 1;
                            break;
                        default:
                            a[0] = 1, a[1] = 0, a[2] = s;
                    }
                    return r = (1 - e) * n, [
                        255 * (e * a[0] + r),
                        255 * (e * a[1] + r),
                        255 * (e * a[2] + r)
                    ];
                }, i.hcg.hsv = function(A) {
                    var t = A[1] / 100, e = t + A[2] / 100 * (1 - t), n = 0;
                    return e > 0 && (n = t / e), [
                        A[0],
                        100 * n,
                        100 * e
                    ];
                }, i.hcg.hsl = function(A) {
                    var t = A[1] / 100, e = A[2] / 100 * (1 - t) + .5 * t, n = 0;
                    return e > 0 && e < .5 ? n = t / (2 * e) : e >= .5 && e < 1 && (n = t / (2 * (1 - e))), [
                        A[0],
                        100 * n,
                        100 * e
                    ];
                }, i.hcg.hwb = function(A) {
                    var t = A[1] / 100, e = t + A[2] / 100 * (1 - t);
                    return [
                        A[0],
                        100 * (e - t),
                        100 * (1 - e)
                    ];
                }, i.hwb.hcg = function(A) {
                    var t = A[1] / 100, e = 1 - A[2] / 100, n = e - t, r = 0;
                    return n < 1 && (r = (e - n) / (1 - n)), [
                        A[0],
                        100 * n,
                        100 * r
                    ];
                }, i.apple.rgb = function(A) {
                    return [
                        A[0] / 65535 * 255,
                        A[1] / 65535 * 255,
                        A[2] / 65535 * 255
                    ];
                }, i.rgb.apple = function(A) {
                    return [
                        A[0] / 255 * 65535,
                        A[1] / 255 * 65535,
                        A[2] / 255 * 65535
                    ];
                }, i.gray.rgb = function(A) {
                    return [
                        A[0] / 100 * 255,
                        A[0] / 100 * 255,
                        A[0] / 100 * 255
                    ];
                }, i.gray.hsl = i.gray.hsv = function(A) {
                    return [
                        0,
                        0,
                        A[0]
                    ];
                }, i.gray.hwb = function(A) {
                    return [
                        0,
                        100,
                        A[0]
                    ];
                }, i.gray.cmyk = function(A) {
                    return [
                        0,
                        0,
                        0,
                        A[0]
                    ];
                }, i.gray.lab = function(A) {
                    return [
                        A[0],
                        0,
                        0
                    ];
                }, i.gray.hex = function(A) {
                    var t = 255 & Math.round(A[0] / 100 * 255), e = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
                    return "000000".substring(e.length) + e;
                }, i.rgb.gray = function(A) {
                    return [
                        (A[0] + A[1] + A[2]) / 3 / 255 * 100
                    ];
                };
            },
            2085: (A, t, e)=>{
                var n = e(8168), r = e(4111), a = {};
                Object.keys(n).forEach(function(A) {
                    a[A] = {}, Object.defineProperty(a[A], "channels", {
                        value: n[A].channels
                    }), Object.defineProperty(a[A], "labels", {
                        value: n[A].labels
                    });
                    var t = r(A);
                    Object.keys(t).forEach(function(e) {
                        var n = t[e];
                        a[A][e] = function(A) {
                            var t = function(t) {
                                if (null == t) return t;
                                arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
                                var e = A(t);
                                if ("object" == typeof e) for(var n = e.length, r = 0; r < n; r++)e[r] = Math.round(e[r]);
                                return e;
                            };
                            return "conversion" in A && (t.conversion = A.conversion), t;
                        }(n), a[A][e].raw = function(A) {
                            var t = function(t) {
                                return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), A(t));
                            };
                            return "conversion" in A && (t.conversion = A.conversion), t;
                        }(n);
                    });
                }), A.exports = a;
            },
            4111: (A, t, e)=>{
                var n = e(8168);
                function r(A, t) {
                    return function(e) {
                        return t(A(e));
                    };
                }
                function a(A, t) {
                    for(var e = [
                        t[A].parent,
                        A
                    ], a = n[t[A].parent][A], i = t[A].parent; t[i].parent;)e.unshift(t[i].parent), a = r(n[t[i].parent][i], a), i = t[i].parent;
                    return a.conversion = e, a;
                }
                A.exports = function(A) {
                    for(var t = function(A) {
                        var t = function() {
                            for(var A = {}, t = Object.keys(n), e = t.length, r = 0; r < e; r++)A[t[r]] = {
                                distance: -1,
                                parent: null
                            };
                            return A;
                        }(), e = [
                            A
                        ];
                        for(t[A].distance = 0; e.length;)for(var r = e.pop(), a = Object.keys(n[r]), i = a.length, o = 0; o < i; o++){
                            var s = a[o], c = t[s];
                            -1 === c.distance && (c.distance = t[r].distance + 1, c.parent = r, e.unshift(s));
                        }
                        return t;
                    }(A), e = {}, r = Object.keys(t), i = r.length, o = 0; o < i; o++){
                        var s = r[o];
                        null !== t[s].parent && (e[s] = a(s, t));
                    }
                    return e;
                };
            },
            8874: (A)=>{
                "use strict";
                A.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            9818: (A, t, e)=>{
                var n = e(8874), r = e(6851), a = {};
                for(var i in n)n.hasOwnProperty(i) && (a[n[i]] = i);
                var o = A.exports = {
                    to: {},
                    get: {}
                };
                function s(A, t, e) {
                    return Math.min(Math.max(t, A), e);
                }
                function c(A) {
                    var t = A.toString(16).toUpperCase();
                    return t.length < 2 ? "0" + t : t;
                }
                o.get = function(A) {
                    var t, e;
                    switch(A.substring(0, 3).toLowerCase()){
                        case "hsl":
                            t = o.get.hsl(A), e = "hsl";
                            break;
                        case "hwb":
                            t = o.get.hwb(A), e = "hwb";
                            break;
                        default:
                            t = o.get.rgb(A), e = "rgb";
                    }
                    return t ? {
                        model: e,
                        value: t
                    } : null;
                }, o.get.rgb = function(A) {
                    if (!A) return null;
                    var t, e, r, a = [
                        0,
                        0,
                        0,
                        1
                    ];
                    if (t = A.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
                        for(r = t[2], t = t[1], e = 0; e < 3; e++){
                            var i = 2 * e;
                            a[e] = parseInt(t.slice(i, i + 2), 16);
                        }
                        r && (a[3] = parseInt(r, 16) / 255);
                    } else if (t = A.match(/^#([a-f0-9]{3,4})$/i)) {
                        for(r = (t = t[1])[3], e = 0; e < 3; e++)a[e] = parseInt(t[e] + t[e], 16);
                        r && (a[3] = parseInt(r + r, 16) / 255);
                    } else if (t = A.match(/^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/)) {
                        for(e = 0; e < 3; e++)a[e] = parseInt(t[e + 1], 0);
                        t[4] && (a[3] = parseFloat(t[4]));
                    } else {
                        if (!(t = A.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/))) return (t = A.match(/(\D+)/)) ? "transparent" === t[1] ? [
                            0,
                            0,
                            0,
                            0
                        ] : (a = n[t[1]]) ? (a[3] = 1, a) : null : null;
                        for(e = 0; e < 3; e++)a[e] = Math.round(2.55 * parseFloat(t[e + 1]));
                        t[4] && (a[3] = parseFloat(t[4]));
                    }
                    for(e = 0; e < 3; e++)a[e] = s(a[e], 0, 255);
                    return a[3] = s(a[3], 0, 1), a;
                }, o.get.hsl = function(A) {
                    if (!A) return null;
                    var t = A.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
                    if (t) {
                        var e = parseFloat(t[4]);
                        return [
                            (parseFloat(t[1]) + 360) % 360,
                            s(parseFloat(t[2]), 0, 100),
                            s(parseFloat(t[3]), 0, 100),
                            s(isNaN(e) ? 1 : e, 0, 1)
                        ];
                    }
                    return null;
                }, o.get.hwb = function(A) {
                    if (!A) return null;
                    var t = A.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/);
                    if (t) {
                        var e = parseFloat(t[4]);
                        return [
                            (parseFloat(t[1]) % 360 + 360) % 360,
                            s(parseFloat(t[2]), 0, 100),
                            s(parseFloat(t[3]), 0, 100),
                            s(isNaN(e) ? 1 : e, 0, 1)
                        ];
                    }
                    return null;
                }, o.to.hex = function() {
                    var A = r(arguments);
                    return "#" + c(A[0]) + c(A[1]) + c(A[2]) + (A[3] < 1 ? c(Math.round(255 * A[3])) : "");
                }, o.to.rgb = function() {
                    var A = r(arguments);
                    return A.length < 4 || 1 === A[3] ? "rgb(" + Math.round(A[0]) + ", " + Math.round(A[1]) + ", " + Math.round(A[2]) + ")" : "rgba(" + Math.round(A[0]) + ", " + Math.round(A[1]) + ", " + Math.round(A[2]) + ", " + A[3] + ")";
                }, o.to.rgb.percent = function() {
                    var A = r(arguments), t = Math.round(A[0] / 255 * 100), e = Math.round(A[1] / 255 * 100), n = Math.round(A[2] / 255 * 100);
                    return A.length < 4 || 1 === A[3] ? "rgb(" + t + "%, " + e + "%, " + n + "%)" : "rgba(" + t + "%, " + e + "%, " + n + "%, " + A[3] + ")";
                }, o.to.hsl = function() {
                    var A = r(arguments);
                    return A.length < 4 || 1 === A[3] ? "hsl(" + A[0] + ", " + A[1] + "%, " + A[2] + "%)" : "hsla(" + A[0] + ", " + A[1] + "%, " + A[2] + "%, " + A[3] + ")";
                }, o.to.hwb = function() {
                    var A = r(arguments), t = "";
                    return A.length >= 4 && 1 !== A[3] && (t = ", " + A[3]), "hwb(" + A[0] + ", " + A[1] + "%, " + A[2] + "%" + t + ")";
                }, o.to.keyword = function(A) {
                    return a[A.slice(0, 3)];
                };
            },
            6767: (A, t, e)=>{
                "use strict";
                var n = e(9818), r = e(2085), a = [].slice, i = [
                    "keyword",
                    "gray",
                    "hex"
                ], o = {};
                Object.keys(r).forEach(function(A) {
                    o[a.call(r[A].labels).sort().join("")] = A;
                });
                var s = {};
                function c(A, t) {
                    if (!(this instanceof c)) return new c(A, t);
                    if (t && t in i && (t = null), t && !(t in r)) throw new Error("Unknown model: " + t);
                    var e, l;
                    if (null == A) this.model = "rgb", this.color = [
                        0,
                        0,
                        0
                    ], this.valpha = 1;
                    else if (A instanceof c) this.model = A.model, this.color = A.color.slice(), this.valpha = A.valpha;
                    else if ("string" == typeof A) {
                        var u = n.get(A);
                        if (null === u) throw new Error("Unable to parse color from string: " + A);
                        this.model = u.model, l = r[this.model].channels, this.color = u.value.slice(0, l), this.valpha = "number" == typeof u.value[l] ? u.value[l] : 1;
                    } else if (A.length) {
                        this.model = t || "rgb", l = r[this.model].channels;
                        var f = a.call(A, 0, l);
                        this.color = h(f, l), this.valpha = "number" == typeof A[l] ? A[l] : 1;
                    } else if ("number" == typeof A) A &= 16777215, this.model = "rgb", this.color = [
                        A >> 16 & 255,
                        A >> 8 & 255,
                        255 & A
                    ], this.valpha = 1;
                    else {
                        this.valpha = 1;
                        var B = Object.keys(A);
                        "alpha" in A && (B.splice(B.indexOf("alpha"), 1), this.valpha = "number" == typeof A.alpha ? A.alpha : 0);
                        var d = B.sort().join("");
                        if (!(d in o)) throw new Error("Unable to parse color from object: " + JSON.stringify(A));
                        this.model = o[d];
                        var g = r[this.model].labels, w = [];
                        for(e = 0; e < g.length; e++)w.push(A[g[e]]);
                        this.color = h(w);
                    }
                    if (s[this.model]) for(l = r[this.model].channels, e = 0; e < l; e++){
                        var p = s[this.model][e];
                        p && (this.color[e] = p(this.color[e]));
                    }
                    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
                }
                function l(A, t, e) {
                    return (A = Array.isArray(A) ? A : [
                        A
                    ]).forEach(function(A) {
                        (s[A] || (s[A] = []))[t] = e;
                    }), A = A[0], function(n) {
                        var r;
                        return arguments.length ? (e && (n = e(n)), (r = this[A]()).color[t] = n, r) : (r = this[A]().color[t], e && (r = e(r)), r);
                    };
                }
                function u(A) {
                    return function(t) {
                        return Math.max(0, Math.min(A, t));
                    };
                }
                function f(A) {
                    return Array.isArray(A) ? A : [
                        A
                    ];
                }
                function h(A, t) {
                    for(var e = 0; e < t; e++)"number" != typeof A[e] && (A[e] = 0);
                    return A;
                }
                c.prototype = {
                    toString: function() {
                        return this.string();
                    },
                    toJSON: function() {
                        return this[this.model]();
                    },
                    string: function(A) {
                        var t = this.model in n.to ? this : this.rgb(), e = 1 === (t = t.round("number" == typeof A ? A : 1)).valpha ? t.color : t.color.concat(this.valpha);
                        return n.to[t.model](e);
                    },
                    percentString: function(A) {
                        var t = this.rgb().round("number" == typeof A ? A : 1), e = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
                        return n.to.rgb.percent(e);
                    },
                    array: function() {
                        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
                    },
                    object: function() {
                        for(var A = {}, t = r[this.model].channels, e = r[this.model].labels, n = 0; n < t; n++)A[e[n]] = this.color[n];
                        return 1 !== this.valpha && (A.alpha = this.valpha), A;
                    },
                    unitArray: function() {
                        var A = this.rgb().color;
                        return A[0] /= 255, A[1] /= 255, A[2] /= 255, 1 !== this.valpha && A.push(this.valpha), A;
                    },
                    unitObject: function() {
                        var A = this.rgb().object();
                        return A.r /= 255, A.g /= 255, A.b /= 255, 1 !== this.valpha && (A.alpha = this.valpha), A;
                    },
                    round: function(A) {
                        return A = Math.max(A || 0, 0), new c(this.color.map(function(A) {
                            return function(t) {
                                return function(A, t) {
                                    return Number(A.toFixed(t));
                                }(t, A);
                            };
                        }(A)).concat(this.valpha), this.model);
                    },
                    alpha: function(A) {
                        return arguments.length ? new c(this.color.concat(Math.max(0, Math.min(1, A))), this.model) : this.valpha;
                    },
                    red: l("rgb", 0, u(255)),
                    green: l("rgb", 1, u(255)),
                    blue: l("rgb", 2, u(255)),
                    hue: l([
                        "hsl",
                        "hsv",
                        "hsl",
                        "hwb",
                        "hcg"
                    ], 0, function(A) {
                        return (A % 360 + 360) % 360;
                    }),
                    saturationl: l("hsl", 1, u(100)),
                    lightness: l("hsl", 2, u(100)),
                    saturationv: l("hsv", 1, u(100)),
                    value: l("hsv", 2, u(100)),
                    chroma: l("hcg", 1, u(100)),
                    gray: l("hcg", 2, u(100)),
                    white: l("hwb", 1, u(100)),
                    wblack: l("hwb", 2, u(100)),
                    cyan: l("cmyk", 0, u(100)),
                    magenta: l("cmyk", 1, u(100)),
                    yellow: l("cmyk", 2, u(100)),
                    black: l("cmyk", 3, u(100)),
                    x: l("xyz", 0, u(100)),
                    y: l("xyz", 1, u(100)),
                    z: l("xyz", 2, u(100)),
                    l: l("lab", 0, u(100)),
                    a: l("lab", 1),
                    b: l("lab", 2),
                    keyword: function(A) {
                        return arguments.length ? new c(A) : r[this.model].keyword(this.color);
                    },
                    hex: function(A) {
                        return arguments.length ? new c(A) : n.to.hex(this.rgb().round().color);
                    },
                    rgbNumber: function() {
                        var A = this.rgb().color;
                        return (255 & A[0]) << 16 | (255 & A[1]) << 8 | 255 & A[2];
                    },
                    luminosity: function() {
                        for(var A = this.rgb().color, t = [], e = 0; e < A.length; e++){
                            var n = A[e] / 255;
                            t[e] = n <= .03928 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
                        }
                        return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
                    },
                    contrast: function(A) {
                        var t = this.luminosity(), e = A.luminosity();
                        return t > e ? (t + .05) / (e + .05) : (e + .05) / (t + .05);
                    },
                    level: function(A) {
                        var t = this.contrast(A);
                        return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
                    },
                    isDark: function() {
                        var A = this.rgb().color;
                        return (299 * A[0] + 587 * A[1] + 114 * A[2]) / 1e3 < 128;
                    },
                    isLight: function() {
                        return !this.isDark();
                    },
                    negate: function() {
                        for(var A = this.rgb(), t = 0; t < 3; t++)A.color[t] = 255 - A.color[t];
                        return A;
                    },
                    lighten: function(A) {
                        var t = this.hsl();
                        return t.color[2] += t.color[2] * A, t;
                    },
                    darken: function(A) {
                        var t = this.hsl();
                        return t.color[2] -= t.color[2] * A, t;
                    },
                    saturate: function(A) {
                        var t = this.hsl();
                        return t.color[1] += t.color[1] * A, t;
                    },
                    desaturate: function(A) {
                        var t = this.hsl();
                        return t.color[1] -= t.color[1] * A, t;
                    },
                    whiten: function(A) {
                        var t = this.hwb();
                        return t.color[1] += t.color[1] * A, t;
                    },
                    blacken: function(A) {
                        var t = this.hwb();
                        return t.color[2] += t.color[2] * A, t;
                    },
                    grayscale: function() {
                        var A = this.rgb().color, t = .3 * A[0] + .59 * A[1] + .11 * A[2];
                        return c.rgb(t, t, t);
                    },
                    fade: function(A) {
                        return this.alpha(this.valpha - this.valpha * A);
                    },
                    opaquer: function(A) {
                        return this.alpha(this.valpha + this.valpha * A);
                    },
                    rotate: function(A) {
                        var t = this.hsl(), e = t.color[0];
                        return e = (e = (e + A) % 360) < 0 ? 360 + e : e, t.color[0] = e, t;
                    },
                    mix: function(A, t) {
                        if (!A || !A.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof A);
                        var e = A.rgb(), n = this.rgb(), r = void 0 === t ? .5 : t, a = 2 * r - 1, i = e.alpha() - n.alpha(), o = ((a * i == -1 ? a : (a + i) / (1 + a * i)) + 1) / 2, s = 1 - o;
                        return c.rgb(o * e.red() + s * n.red(), o * e.green() + s * n.green(), o * e.blue() + s * n.blue(), e.alpha() * r + n.alpha() * (1 - r));
                    }
                }, Object.keys(r).forEach(function(A) {
                    if (-1 === i.indexOf(A)) {
                        var t = r[A].channels;
                        c.prototype[A] = function() {
                            if (this.model === A) return new c(this);
                            if (arguments.length) return new c(arguments, A);
                            var e = "number" == typeof arguments[t] ? t : this.valpha;
                            return new c(f(r[this.model][A].raw(this.color)).concat(e), A);
                        }, c[A] = function(e) {
                            return "number" == typeof e && (e = h(a.call(arguments), t)), new c(e, A);
                        };
                    }
                }), A.exports = c;
            },
            6014: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.LineBreaker = t.inlineBreakOpportunities = t.lineBreakAtIndex = t.codePointsToCharacterClasses = t.UnicodeTrie = t.BREAK_ALLOWED = t.BREAK_NOT_ALLOWED = t.BREAK_MANDATORY = t.classes = t.LETTER_NUMBER_MODIFIER = void 0;
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), a = function(A, t) {
                    if (Array.isArray(A)) return A;
                    if (Symbol.iterator in Object(A)) return function(A, t) {
                        var e = [], n = !0, r = !1, a = void 0;
                        try {
                            for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                        } catch (A) {
                            r = !0, a = A;
                        } finally{
                            try {
                                !n && o.return && o.return();
                            } finally{
                                if (r) throw a;
                            }
                        }
                        return e;
                    }(A, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, i = e(414), o = (n = e(8382)) && n.__esModule ? n : {
                    default: n
                }, s = e(632), c = t.LETTER_NUMBER_MODIFIER = 50, l = 10, u = 13, f = 15, h = 17, B = 18, d = 19, g = 20, w = 21, p = 22, Q = 24, U = 25, v = 26, y = 27, C = 28, m = 30, E = 32, F = 33, _ = 34, b = 35, H = 37, N = 38, I = 39, M = 40, T = 42, x = (t.classes = {
                    BK: 1,
                    CR: 2,
                    LF: 3,
                    CM: 4,
                    NL: 5,
                    SG: 6,
                    WJ: 7,
                    ZW: 8,
                    GL: 9,
                    SP: l,
                    ZWJ: 11,
                    B2: 12,
                    BA: u,
                    BB: 14,
                    HY: f,
                    CB: 16,
                    CL: h,
                    CP: B,
                    EX: d,
                    IN: g,
                    NS: w,
                    OP: p,
                    QU: 23,
                    IS: Q,
                    NU: U,
                    PO: v,
                    PR: y,
                    SY: C,
                    AI: 29,
                    AL: m,
                    CJ: 31,
                    EB: E,
                    EM: F,
                    H2: _,
                    H3: b,
                    HL: 36,
                    ID: H,
                    JL: N,
                    JV: I,
                    JT: M,
                    RI: 41,
                    SA: T,
                    XX: 43
                }, t.BREAK_MANDATORY = "!"), K = t.BREAK_NOT_ALLOWED = "\xd7", O = t.BREAK_ALLOWED = "\xf7", S = t.UnicodeTrie = (0, i.createTrieFromBase64)(o.default), L = [
                    m,
                    36
                ], k = [
                    1,
                    2,
                    3,
                    5
                ], P = [
                    l,
                    8
                ], D = [
                    y,
                    v
                ], R = k.concat(P), z = [
                    N,
                    I,
                    M,
                    _,
                    b
                ], X = [
                    f,
                    u
                ], V = t.codePointsToCharacterClasses = function(A) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "strict", e = [], n = [], r = [];
                    return A.forEach(function(A, a) {
                        var i = S.get(A);
                        if (i > c ? (r.push(!0), i -= c) : r.push(!1), -1 !== [
                            "normal",
                            "auto",
                            "loose"
                        ].indexOf(t) && -1 !== [
                            8208,
                            8211,
                            12316,
                            12448
                        ].indexOf(A)) return n.push(a), e.push(16);
                        if (4 === i || 11 === i) {
                            if (0 === a) return n.push(a), e.push(m);
                            var o = e[a - 1];
                            return -1 === R.indexOf(o) ? (n.push(n[a - 1]), e.push(o)) : (n.push(a), e.push(m));
                        }
                        return n.push(a), 31 === i ? e.push("strict" === t ? w : H) : i === T || 29 === i ? e.push(m) : 43 === i ? A >= 131072 && A <= 196605 || A >= 196608 && A <= 262141 ? e.push(H) : e.push(m) : void e.push(i);
                    }), [
                        n,
                        e,
                        r
                    ];
                }, Y = function(A, t, e, n) {
                    var r = n[e];
                    if (Array.isArray(A) ? -1 !== A.indexOf(r) : A === r) for(var a = e; a <= n.length;){
                        var i = n[++a];
                        if (i === t) return !0;
                        if (i !== l) break;
                    }
                    if (r === l) for(var o = e; o > 0;){
                        var s = n[--o];
                        if (Array.isArray(A) ? -1 !== A.indexOf(s) : A === s) for(var c = e; c <= n.length;){
                            var u = n[++c];
                            if (u === t) return !0;
                            if (u !== l) break;
                        }
                        if (s !== l) break;
                    }
                    return !1;
                }, G = function(A, t) {
                    for(var e = A; e >= 0;){
                        var n = t[e];
                        if (n !== l) return n;
                        e--;
                    }
                    return 0;
                }, J = function(A, t, e, n, r) {
                    if (0 === e[n]) return K;
                    var a = n - 1;
                    if (Array.isArray(r) && !0 === r[a]) return K;
                    var i = a - 1, o = a + 1, s = t[a], c = i >= 0 ? t[i] : 0, m = t[o];
                    if (2 === s && 3 === m) return K;
                    if (-1 !== k.indexOf(s)) return x;
                    if (-1 !== k.indexOf(m)) return K;
                    if (-1 !== P.indexOf(m)) return K;
                    if (8 === G(a, t)) return O;
                    if (11 === S.get(A[a]) && (m === H || m === E || m === F)) return K;
                    if (7 === s || 7 === m) return K;
                    if (9 === s) return K;
                    if (-1 === [
                        l,
                        u,
                        f
                    ].indexOf(s) && 9 === m) return K;
                    if (-1 !== [
                        h,
                        B,
                        d,
                        Q,
                        C
                    ].indexOf(m)) return K;
                    if (G(a, t) === p) return K;
                    if (Y(23, p, a, t)) return K;
                    if (Y([
                        h,
                        B
                    ], w, a, t)) return K;
                    if (Y(12, 12, a, t)) return K;
                    if (s === l) return O;
                    if (23 === s || 23 === m) return K;
                    if (16 === m || 16 === s) return O;
                    if (-1 !== [
                        u,
                        f,
                        w
                    ].indexOf(m) || 14 === s) return K;
                    if (36 === c && -1 !== X.indexOf(s)) return K;
                    if (s === C && 36 === m) return K;
                    if (m === g && -1 !== L.concat(g, d, U, H, E, F).indexOf(s)) return K;
                    if (-1 !== L.indexOf(m) && s === U || -1 !== L.indexOf(s) && m === U) return K;
                    if (s === y && -1 !== [
                        H,
                        E,
                        F
                    ].indexOf(m) || -1 !== [
                        H,
                        E,
                        F
                    ].indexOf(s) && m === v) return K;
                    if (-1 !== L.indexOf(s) && -1 !== D.indexOf(m) || -1 !== D.indexOf(s) && -1 !== L.indexOf(m)) return K;
                    if (-1 !== [
                        y,
                        v
                    ].indexOf(s) && (m === U || -1 !== [
                        p,
                        f
                    ].indexOf(m) && t[o + 1] === U) || -1 !== [
                        p,
                        f
                    ].indexOf(s) && m === U || s === U && -1 !== [
                        U,
                        C,
                        Q
                    ].indexOf(m)) return K;
                    if (-1 !== [
                        U,
                        C,
                        Q,
                        h,
                        B
                    ].indexOf(m)) for(var T = a; T >= 0;){
                        var R = t[T];
                        if (R === U) return K;
                        if (-1 === [
                            C,
                            Q
                        ].indexOf(R)) break;
                        T--;
                    }
                    if (-1 !== [
                        y,
                        v
                    ].indexOf(m)) for(var V = -1 !== [
                        h,
                        B
                    ].indexOf(s) ? i : a; V >= 0;){
                        var J = t[V];
                        if (J === U) return K;
                        if (-1 === [
                            C,
                            Q
                        ].indexOf(J)) break;
                        V--;
                    }
                    if (N === s && -1 !== [
                        N,
                        I,
                        _,
                        b
                    ].indexOf(m) || -1 !== [
                        I,
                        _
                    ].indexOf(s) && -1 !== [
                        I,
                        M
                    ].indexOf(m) || -1 !== [
                        M,
                        b
                    ].indexOf(s) && m === M) return K;
                    if (-1 !== z.indexOf(s) && -1 !== [
                        g,
                        v
                    ].indexOf(m) || -1 !== z.indexOf(m) && s === y) return K;
                    if (-1 !== L.indexOf(s) && -1 !== L.indexOf(m)) return K;
                    if (s === Q && -1 !== L.indexOf(m)) return K;
                    if (-1 !== L.concat(U).indexOf(s) && m === p || -1 !== L.concat(U).indexOf(m) && s === B) return K;
                    if (41 === s && 41 === m) {
                        for(var W = e[a], j = 1; W > 0 && 41 === t[--W];)j++;
                        if (j % 2 != 0) return K;
                    }
                    return s === E && m === F ? K : O;
                }, W = (t.lineBreakAtIndex = function(A, t) {
                    if (0 === t) return K;
                    if (t >= A.length) return x;
                    var e = V(A), n = a(e, 2), r = n[0], i = n[1];
                    return J(A, i, r, t);
                }, function(A, t) {
                    t || (t = {
                        lineBreak: "normal",
                        wordBreak: "normal"
                    });
                    var e = V(A, t.lineBreak), n = a(e, 3), r = n[0], i = n[1], o = n[2];
                    return "break-all" !== t.wordBreak && "break-word" !== t.wordBreak || (i = i.map(function(A) {
                        return -1 !== [
                            U,
                            m,
                            T
                        ].indexOf(A) ? H : A;
                    })), [
                        r,
                        i,
                        "keep-all" === t.wordBreak ? o.map(function(t, e) {
                            return t && A[e] >= 19968 && A[e] <= 40959;
                        }) : null
                    ];
                }), j = (t.inlineBreakOpportunities = function(A, t) {
                    var e = (0, s.toCodePoints)(A), n = K, r = W(e, t), i = a(r, 3), o = i[0], c = i[1], l = i[2];
                    return e.forEach(function(A, t) {
                        n += (0, s.fromCodePoint)(A) + (t >= e.length - 1 ? x : J(e, c, o, t + 1, l));
                    }), n;
                }, function() {
                    function A(t, e, n, r) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this._codePoints = t, this.required = e === x, this.start = n, this.end = r;
                    }
                    return r(A, [
                        {
                            key: "slice",
                            value: function() {
                                return s.fromCodePoint.apply(void 0, function(A) {
                                    if (Array.isArray(A)) {
                                        for(var t = 0, e = Array(A.length); t < A.length; t++)e[t] = A[t];
                                        return e;
                                    }
                                    return Array.from(A);
                                }(this._codePoints.slice(this.start, this.end)));
                            }
                        }
                    ]), A;
                }());
                t.LineBreaker = function(A, t) {
                    var e = (0, s.toCodePoints)(A), n = W(e, t), r = a(n, 3), i = r[0], o = r[1], c = r[2], l = e.length, u = 0, f = 0;
                    return {
                        next: function() {
                            if (f >= l) return {
                                done: !0
                            };
                            for(var A = K; f < l && (A = J(e, o, i, ++f, c)) === K;);
                            if (A !== K || f === l) {
                                var t = new j(e, A, u, f);
                                return u = f, {
                                    value: t,
                                    done: !1
                                };
                            }
                            return {
                                done: !0
                            };
                        }
                    };
                };
            },
            414: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Trie = t.createTrieFromBase64 = t.UTRIE2_INDEX_2_MASK = t.UTRIE2_INDEX_2_BLOCK_LENGTH = t.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = t.UTRIE2_INDEX_1_OFFSET = t.UTRIE2_UTF8_2B_INDEX_2_LENGTH = t.UTRIE2_UTF8_2B_INDEX_2_OFFSET = t.UTRIE2_INDEX_2_BMP_LENGTH = t.UTRIE2_LSCP_INDEX_2_LENGTH = t.UTRIE2_DATA_MASK = t.UTRIE2_DATA_BLOCK_LENGTH = t.UTRIE2_LSCP_INDEX_2_OFFSET = t.UTRIE2_SHIFT_1_2 = t.UTRIE2_INDEX_SHIFT = t.UTRIE2_SHIFT_1 = t.UTRIE2_SHIFT_2 = void 0;
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = e(632), a = t.UTRIE2_SHIFT_2 = 5, i = t.UTRIE2_SHIFT_1 = 11, o = t.UTRIE2_INDEX_SHIFT = 2, s = t.UTRIE2_SHIFT_1_2 = i - a, c = t.UTRIE2_LSCP_INDEX_2_OFFSET = 65536 >> a, l = t.UTRIE2_DATA_BLOCK_LENGTH = 1 << a, u = t.UTRIE2_DATA_MASK = l - 1, f = t.UTRIE2_LSCP_INDEX_2_LENGTH = 1024 >> a, h = t.UTRIE2_INDEX_2_BMP_LENGTH = c + f, B = t.UTRIE2_UTF8_2B_INDEX_2_OFFSET = h, d = t.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32, g = t.UTRIE2_INDEX_1_OFFSET = B + d, w = t.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 65536 >> i, p = t.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << s, Q = t.UTRIE2_INDEX_2_MASK = p - 1, U = (t.createTrieFromBase64 = function(A) {
                    var t = (0, r.decode)(A), e = Array.isArray(t) ? (0, r.polyUint32Array)(t) : new Uint32Array(t), n = Array.isArray(t) ? (0, r.polyUint16Array)(t) : new Uint16Array(t), a = n.slice(12, e[4] / 2), i = 2 === e[5] ? n.slice((24 + e[4]) / 2) : e.slice(Math.ceil((24 + e[4]) / 4));
                    return new U(e[0], e[1], e[2], e[3], a, i);
                }, t.Trie = function() {
                    function A(t, e, n, r, a, i) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.initialValue = t, this.errorValue = e, this.highStart = n, this.highValueIndex = r, this.index = a, this.data = i;
                    }
                    return n(A, [
                        {
                            key: "get",
                            value: function(A) {
                                var t = void 0;
                                if (A >= 0) {
                                    if (A < 55296 || A > 56319 && A <= 65535) return t = ((t = this.index[A >> a]) << o) + (A & u), this.data[t];
                                    if (A <= 65535) return t = ((t = this.index[c + (A - 55296 >> a)]) << o) + (A & u), this.data[t];
                                    if (A < this.highStart) return t = g - w + (A >> i), t = this.index[t], t += A >> a & Q, t = ((t = this.index[t]) << o) + (A & u), this.data[t];
                                    if (A <= 1114111) return this.data[this.highValueIndex];
                                }
                                return this.errorValue;
                            }
                        }
                    ]), A;
                }());
            },
            632: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.toCodePoints = function(A) {
                    for(var t = [], e = 0, n = A.length; e < n;){
                        var r = A.charCodeAt(e++);
                        if (r >= 55296 && r <= 56319 && e < n) {
                            var a = A.charCodeAt(e++);
                            56320 == (64512 & a) ? t.push(((1023 & r) << 10) + (1023 & a) + 65536) : (t.push(r), e--);
                        } else t.push(r);
                    }
                    return t;
                }, t.fromCodePoint = function() {
                    if (String.fromCodePoint) return String.fromCodePoint.apply(String, arguments);
                    var A = arguments.length;
                    if (!A) return "";
                    for(var t = [], e = -1, n = ""; ++e < A;){
                        var r = arguments.length <= e ? void 0 : arguments[e];
                        r <= 65535 ? t.push(r) : (r -= 65536, t.push(55296 + (r >> 10), r % 1024 + 56320)), (e + 1 === A || t.length > 16384) && (n += String.fromCharCode.apply(String, t), t.length = 0);
                    }
                    return n;
                };
                for(var e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256), r = 0; r < e.length; r++)n[e.charCodeAt(r)] = r;
                t.decode = function(A) {
                    var t = .75 * A.length, e = A.length, r = void 0, a = 0, i = void 0, o = void 0, s = void 0, c = void 0;
                    "=" === A[A.length - 1] && (t--, "=" === A[A.length - 2] && t--);
                    var l = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array && void 0 !== Uint8Array.prototype.slice ? new ArrayBuffer(t) : new Array(t), u = Array.isArray(l) ? l : new Uint8Array(l);
                    for(r = 0; r < e; r += 4)i = n[A.charCodeAt(r)], o = n[A.charCodeAt(r + 1)], s = n[A.charCodeAt(r + 2)], c = n[A.charCodeAt(r + 3)], u[a++] = i << 2 | o >> 4, u[a++] = (15 & o) << 4 | s >> 2, u[a++] = (3 & s) << 6 | 63 & c;
                    return l;
                }, t.polyUint16Array = function(A) {
                    for(var t = A.length, e = [], n = 0; n < t; n += 2)e.push(A[n + 1] << 8 | A[n]);
                    return e;
                }, t.polyUint32Array = function(A) {
                    for(var t = A.length, e = [], n = 0; n < t; n += 4)e.push(A[n + 3] << 24 | A[n + 2] << 16 | A[n + 1] << 8 | A[n]);
                    return e;
                };
            },
            2160: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = e(632);
                Object.defineProperty(t, "toCodePoints", {
                    enumerable: !0,
                    get: function() {
                        return n.toCodePoints;
                    }
                }), Object.defineProperty(t, "fromCodePoint", {
                    enumerable: !0,
                    get: function() {
                        return n.fromCodePoint;
                    }
                });
                var r = e(6014);
                Object.defineProperty(t, "LineBreaker", {
                    enumerable: !0,
                    get: function() {
                        return r.LineBreaker;
                    }
                });
            },
            8382: (A)=>{
                "use strict";
                A.exports = "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";
            },
            2168: (A, t, e)=>{
                "use strict";
                function n(A, t) {
                    return A < t ? -1 : A > t ? 1 : A >= t ? 0 : NaN;
                }
                var r, a;
                e.d(t, {
                    b4: ()=>i,
                    Fp: ()=>B,
                    w6: ()=>d,
                    G9: ()=>f,
                    ly: ()=>h,
                    sd: ()=>u
                });
                const i = (1 === (r = n).length && (a = r, r = function(A, t) {
                    return n(a(A), t);
                }), {
                    left: function(A, t, e, n) {
                        for(null == e && (e = 0), null == n && (n = A.length); e < n;){
                            var a = e + n >>> 1;
                            r(A[a], t) < 0 ? e = a + 1 : n = a;
                        }
                        return e;
                    },
                    right: function(A, t, e, n) {
                        for(null == e && (e = 0), null == n && (n = A.length); e < n;){
                            var a = e + n >>> 1;
                            r(A[a], t) > 0 ? n = a : e = a + 1;
                        }
                        return e;
                    }
                }).right;
                var o = Array.prototype, s = (o.slice, o.map, Math.sqrt(50)), c = Math.sqrt(10), l = Math.sqrt(2);
                function u(A, t, e) {
                    var n, r, a, i, o = -1;
                    if (e = +e, (A = +A) == (t = +t) && e > 0) return [
                        A
                    ];
                    if ((n = t < A) && (r = A, A = t, t = r), 0 === (i = f(A, t, e)) || !isFinite(i)) return [];
                    if (i > 0) for(A = Math.ceil(A / i), t = Math.floor(t / i), a = new Array(r = Math.ceil(t - A + 1)); ++o < r;)a[o] = (A + o) * i;
                    else for(A = Math.floor(A * i), t = Math.ceil(t * i), a = new Array(r = Math.ceil(A - t + 1)); ++o < r;)a[o] = (A - o) / i;
                    return n && a.reverse(), a;
                }
                function f(A, t, e) {
                    var n = (t - A) / Math.max(0, e), r = Math.floor(Math.log(n) / Math.LN10), a = n / Math.pow(10, r);
                    return r >= 0 ? (a >= s ? 10 : a >= c ? 5 : a >= l ? 2 : 1) * Math.pow(10, r) : -Math.pow(10, -r) / (a >= s ? 10 : a >= c ? 5 : a >= l ? 2 : 1);
                }
                function h(A, t, e) {
                    var n = Math.abs(t - A) / Math.max(0, e), r = Math.pow(10, Math.floor(Math.log(n) / Math.LN10)), a = n / r;
                    return a >= s ? r *= 10 : a >= c ? r *= 5 : a >= l && (r *= 2), t < A ? -r : r;
                }
                function B(A, t) {
                    var e, n, r = A.length, a = -1;
                    if (null == t) {
                        for(; ++a < r;)if (null != (e = A[a]) && e >= e) for(n = e; ++a < r;)null != (e = A[a]) && e > n && (n = e);
                    } else for(; ++a < r;)if (null != (e = t(A[a], a, A)) && e >= e) for(n = e; ++a < r;)null != (e = t(A[a], a, A)) && e > n && (n = e);
                    return n;
                }
                function d(A, t, e) {
                    A = +A, t = +t, e = (r = arguments.length) < 2 ? (t = A, A = 0, 1) : r < 3 ? 1 : +e;
                    for(var n = -1, r = 0 | Math.max(0, Math.ceil((t - A) / e)), a = new Array(r); ++n < r;)a[n] = A + n * e;
                    return a;
                }
            },
            6216: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    LL: ()=>B,
                    y4: ()=>d,
                    Kh: ()=>h,
                    F5: ()=>f
                });
                var n = Array.prototype.slice;
                function r(A) {
                    return A;
                }
                var a = 1e-6;
                function i(A) {
                    return "translate(" + (A + .5) + ",0)";
                }
                function o(A) {
                    return "translate(0," + (A + .5) + ")";
                }
                function s(A) {
                    return function(t) {
                        return +A(t);
                    };
                }
                function c(A) {
                    var t = Math.max(0, A.bandwidth() - 1) / 2;
                    return A.round() && (t = Math.round(t)), function(e) {
                        return +A(e) + t;
                    };
                }
                function l() {
                    return !this.__axis;
                }
                function u(A, t) {
                    var e = [], u = null, f = null, h = 6, B = 6, d = 3, g = 1 === A || 4 === A ? -1 : 1, w = 4 === A || 2 === A ? "x" : "y", p = 1 === A || 3 === A ? i : o;
                    function Q(n) {
                        var i = null == u ? t.ticks ? t.ticks.apply(t, e) : t.domain() : u, o = null == f ? t.tickFormat ? t.tickFormat.apply(t, e) : r : f, Q = Math.max(h, 0) + d, U = t.range(), v = +U[0] + .5, y = +U[U.length - 1] + .5, C = (t.bandwidth ? c : s)(t.copy()), m = n.selection ? n.selection() : n, E = m.selectAll(".domain").data([
                            null
                        ]), F = m.selectAll(".tick").data(i, t).order(), _ = F.exit(), b = F.enter().append("g").attr("class", "tick"), H = F.select("line"), N = F.select("text");
                        E = E.merge(E.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor")), F = F.merge(b), H = H.merge(b.append("line").attr("stroke", "currentColor").attr(w + "2", g * h)), N = N.merge(b.append("text").attr("fill", "currentColor").attr(w, g * Q).attr("dy", 1 === A ? "0em" : 3 === A ? "0.71em" : "0.32em")), n !== m && (E = E.transition(n), F = F.transition(n), H = H.transition(n), N = N.transition(n), _ = _.transition(n).attr("opacity", a).attr("transform", function(A) {
                            return isFinite(A = C(A)) ? p(A) : this.getAttribute("transform");
                        }), b.attr("opacity", a).attr("transform", function(A) {
                            var t = this.parentNode.__axis;
                            return p(t && isFinite(t = t(A)) ? t : C(A));
                        })), _.remove(), E.attr("d", 4 === A || 2 == A ? B ? "M" + g * B + "," + v + "H0.5V" + y + "H" + g * B : "M0.5," + v + "V" + y : B ? "M" + v + "," + g * B + "V0.5H" + y + "V" + g * B : "M" + v + ",0.5H" + y), F.attr("opacity", 1).attr("transform", function(A) {
                            return p(C(A));
                        }), H.attr(w + "2", g * h), N.attr(w, g * Q).text(o), m.filter(l).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", 2 === A ? "start" : 4 === A ? "end" : "middle"), m.each(function() {
                            this.__axis = C;
                        });
                    }
                    return Q.scale = function(A) {
                        return arguments.length ? (t = A, Q) : t;
                    }, Q.ticks = function() {
                        return e = n.call(arguments), Q;
                    }, Q.tickArguments = function(A) {
                        return arguments.length ? (e = null == A ? [] : n.call(A), Q) : e.slice();
                    }, Q.tickValues = function(A) {
                        return arguments.length ? (u = null == A ? null : n.call(A), Q) : u && u.slice();
                    }, Q.tickFormat = function(A) {
                        return arguments.length ? (f = A, Q) : f;
                    }, Q.tickSize = function(A) {
                        return arguments.length ? (h = B = +A, Q) : h;
                    }, Q.tickSizeInner = function(A) {
                        return arguments.length ? (h = +A, Q) : h;
                    }, Q.tickSizeOuter = function(A) {
                        return arguments.length ? (B = +A, Q) : B;
                    }, Q.tickPadding = function(A) {
                        return arguments.length ? (d = +A, Q) : d;
                    }, Q;
                }
                function f(A) {
                    return u(1, A);
                }
                function h(A) {
                    return u(2, A);
                }
                function B(A) {
                    return u(3, A);
                }
                function d(A) {
                    return u(4, A);
                }
            },
            1654: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    UI: ()=>i
                });
                var n = "$";
                function r() {}
                function a(A, t) {
                    var e = new r;
                    if (A instanceof r) A.each(function(A, t) {
                        e.set(t, A);
                    });
                    else if (Array.isArray(A)) {
                        var n, a = -1, i = A.length;
                        if (null == t) for(; ++a < i;)e.set(a, A[a]);
                        else for(; ++a < i;)e.set(t(n = A[a], a, A), n);
                    } else if (A) for(var o in A)e.set(o, A[o]);
                    return e;
                }
                r.prototype = a.prototype = {
                    constructor: r,
                    has: function(A) {
                        return n + A in this;
                    },
                    get: function(A) {
                        return this[n + A];
                    },
                    set: function(A, t) {
                        return this[n + A] = t, this;
                    },
                    remove: function(A) {
                        var t = n + A;
                        return t in this && delete this[t];
                    },
                    clear: function() {
                        for(var A in this)A[0] === n && delete this[A];
                    },
                    keys: function() {
                        var A = [];
                        for(var t in this)t[0] === n && A.push(t.slice(1));
                        return A;
                    },
                    values: function() {
                        var A = [];
                        for(var t in this)t[0] === n && A.push(this[t]);
                        return A;
                    },
                    entries: function() {
                        var A = [];
                        for(var t in this)t[0] === n && A.push({
                            key: t.slice(1),
                            value: this[t]
                        });
                        return A;
                    },
                    size: function() {
                        var A = 0;
                        for(var t in this)t[0] === n && ++A;
                        return A;
                    },
                    empty: function() {
                        for(var A in this)if (A[0] === n) return !1;
                        return !0;
                    },
                    each: function(A) {
                        for(var t in this)t[0] === n && A(this[t], t.slice(1), this);
                    }
                };
                const i = a;
                function o() {}
                var s = i.prototype;
                o.prototype = (function(A, t) {
                    var e = new o;
                    if (A instanceof o) A.each(function(A) {
                        e.add(A);
                    });
                    else if (A) {
                        var n = -1, r = A.length;
                        if (null == t) for(; ++n < r;)e.add(A[n]);
                        else for(; ++n < r;)e.add(t(A[n], n, A));
                    }
                    return e;
                }).prototype = {
                    constructor: o,
                    has: s.has,
                    add: function(A) {
                        return this[n + (A += "")] = A, this;
                    },
                    remove: s.remove,
                    clear: s.clear,
                    values: s.keys,
                    size: s.size,
                    empty: s.empty,
                    each: s.each
                };
            },
            2650: (A, t, e)=>{
                "use strict";
                function n(A, t, e) {
                    A.prototype = t.prototype = e, e.constructor = A;
                }
                function r(A, t) {
                    var e = Object.create(A.prototype);
                    for(var n in t)e[n] = t[n];
                    return e;
                }
                function a() {}
                e.d(t, {
                    ZP: ()=>v,
                    B8: ()=>E
                });
                var i = .7, o = 1 / i, s = "\\s*([+-]?\\d+)\\s*", c = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", l = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", u = /^#([0-9a-f]{3,8})$/, f = new RegExp("^rgb\\(" + [
                    s,
                    s,
                    s
                ] + "\\)$"), h = new RegExp("^rgb\\(" + [
                    l,
                    l,
                    l
                ] + "\\)$"), B = new RegExp("^rgba\\(" + [
                    s,
                    s,
                    s,
                    c
                ] + "\\)$"), d = new RegExp("^rgba\\(" + [
                    l,
                    l,
                    l,
                    c
                ] + "\\)$"), g = new RegExp("^hsl\\(" + [
                    c,
                    l,
                    l
                ] + "\\)$"), w = new RegExp("^hsla\\(" + [
                    c,
                    l,
                    l,
                    c
                ] + "\\)$"), p = {
                    aliceblue: 15792383,
                    antiquewhite: 16444375,
                    aqua: 65535,
                    aquamarine: 8388564,
                    azure: 15794175,
                    beige: 16119260,
                    bisque: 16770244,
                    black: 0,
                    blanchedalmond: 16772045,
                    blue: 255,
                    blueviolet: 9055202,
                    brown: 10824234,
                    burlywood: 14596231,
                    cadetblue: 6266528,
                    chartreuse: 8388352,
                    chocolate: 13789470,
                    coral: 16744272,
                    cornflowerblue: 6591981,
                    cornsilk: 16775388,
                    crimson: 14423100,
                    cyan: 65535,
                    darkblue: 139,
                    darkcyan: 35723,
                    darkgoldenrod: 12092939,
                    darkgray: 11119017,
                    darkgreen: 25600,
                    darkgrey: 11119017,
                    darkkhaki: 12433259,
                    darkmagenta: 9109643,
                    darkolivegreen: 5597999,
                    darkorange: 16747520,
                    darkorchid: 10040012,
                    darkred: 9109504,
                    darksalmon: 15308410,
                    darkseagreen: 9419919,
                    darkslateblue: 4734347,
                    darkslategray: 3100495,
                    darkslategrey: 3100495,
                    darkturquoise: 52945,
                    darkviolet: 9699539,
                    deeppink: 16716947,
                    deepskyblue: 49151,
                    dimgray: 6908265,
                    dimgrey: 6908265,
                    dodgerblue: 2003199,
                    firebrick: 11674146,
                    floralwhite: 16775920,
                    forestgreen: 2263842,
                    fuchsia: 16711935,
                    gainsboro: 14474460,
                    ghostwhite: 16316671,
                    gold: 16766720,
                    goldenrod: 14329120,
                    gray: 8421504,
                    green: 32768,
                    greenyellow: 11403055,
                    grey: 8421504,
                    honeydew: 15794160,
                    hotpink: 16738740,
                    indianred: 13458524,
                    indigo: 4915330,
                    ivory: 16777200,
                    khaki: 15787660,
                    lavender: 15132410,
                    lavenderblush: 16773365,
                    lawngreen: 8190976,
                    lemonchiffon: 16775885,
                    lightblue: 11393254,
                    lightcoral: 15761536,
                    lightcyan: 14745599,
                    lightgoldenrodyellow: 16448210,
                    lightgray: 13882323,
                    lightgreen: 9498256,
                    lightgrey: 13882323,
                    lightpink: 16758465,
                    lightsalmon: 16752762,
                    lightseagreen: 2142890,
                    lightskyblue: 8900346,
                    lightslategray: 7833753,
                    lightslategrey: 7833753,
                    lightsteelblue: 11584734,
                    lightyellow: 16777184,
                    lime: 65280,
                    limegreen: 3329330,
                    linen: 16445670,
                    magenta: 16711935,
                    maroon: 8388608,
                    mediumaquamarine: 6737322,
                    mediumblue: 205,
                    mediumorchid: 12211667,
                    mediumpurple: 9662683,
                    mediumseagreen: 3978097,
                    mediumslateblue: 8087790,
                    mediumspringgreen: 64154,
                    mediumturquoise: 4772300,
                    mediumvioletred: 13047173,
                    midnightblue: 1644912,
                    mintcream: 16121850,
                    mistyrose: 16770273,
                    moccasin: 16770229,
                    navajowhite: 16768685,
                    navy: 128,
                    oldlace: 16643558,
                    olive: 8421376,
                    olivedrab: 7048739,
                    orange: 16753920,
                    orangered: 16729344,
                    orchid: 14315734,
                    palegoldenrod: 15657130,
                    palegreen: 10025880,
                    paleturquoise: 11529966,
                    palevioletred: 14381203,
                    papayawhip: 16773077,
                    peachpuff: 16767673,
                    peru: 13468991,
                    pink: 16761035,
                    plum: 14524637,
                    powderblue: 11591910,
                    purple: 8388736,
                    rebeccapurple: 6697881,
                    red: 16711680,
                    rosybrown: 12357519,
                    royalblue: 4286945,
                    saddlebrown: 9127187,
                    salmon: 16416882,
                    sandybrown: 16032864,
                    seagreen: 3050327,
                    seashell: 16774638,
                    sienna: 10506797,
                    silver: 12632256,
                    skyblue: 8900331,
                    slateblue: 6970061,
                    slategray: 7372944,
                    slategrey: 7372944,
                    snow: 16775930,
                    springgreen: 65407,
                    steelblue: 4620980,
                    tan: 13808780,
                    teal: 32896,
                    thistle: 14204888,
                    tomato: 16737095,
                    turquoise: 4251856,
                    violet: 15631086,
                    wheat: 16113331,
                    white: 16777215,
                    whitesmoke: 16119285,
                    yellow: 16776960,
                    yellowgreen: 10145074
                };
                function Q() {
                    return this.rgb().formatHex();
                }
                function U() {
                    return this.rgb().formatRgb();
                }
                function v(A) {
                    var t, e;
                    return A = (A + "").trim().toLowerCase(), (t = u.exec(A)) ? (e = t[1].length, t = parseInt(t[1], 16), 6 === e ? y(t) : 3 === e ? new F(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, (15 & t) << 4 | 15 & t, 1) : 8 === e ? C(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (255 & t) / 255) : 4 === e ? C(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | 240 & t, ((15 & t) << 4 | 15 & t) / 255) : null) : (t = f.exec(A)) ? new F(t[1], t[2], t[3], 1) : (t = h.exec(A)) ? new F(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, 1) : (t = B.exec(A)) ? C(t[1], t[2], t[3], t[4]) : (t = d.exec(A)) ? C(255 * t[1] / 100, 255 * t[2] / 100, 255 * t[3] / 100, t[4]) : (t = g.exec(A)) ? N(t[1], t[2] / 100, t[3] / 100, 1) : (t = w.exec(A)) ? N(t[1], t[2] / 100, t[3] / 100, t[4]) : p.hasOwnProperty(A) ? y(p[A]) : "transparent" === A ? new F(NaN, NaN, NaN, 0) : null;
                }
                function y(A) {
                    return new F(A >> 16 & 255, A >> 8 & 255, 255 & A, 1);
                }
                function C(A, t, e, n) {
                    return n <= 0 && (A = t = e = NaN), new F(A, t, e, n);
                }
                function m(A) {
                    return A instanceof a || (A = v(A)), A ? new F((A = A.rgb()).r, A.g, A.b, A.opacity) : new F;
                }
                function E(A, t, e, n) {
                    return 1 === arguments.length ? m(A) : new F(A, t, e, null == n ? 1 : n);
                }
                function F(A, t, e, n) {
                    this.r = +A, this.g = +t, this.b = +e, this.opacity = +n;
                }
                function _() {
                    return "#" + H(this.r) + H(this.g) + H(this.b);
                }
                function b() {
                    var A = this.opacity;
                    return (1 === (A = isNaN(A) ? 1 : Math.max(0, Math.min(1, A))) ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (1 === A ? ")" : ", " + A + ")");
                }
                function H(A) {
                    return ((A = Math.max(0, Math.min(255, Math.round(A) || 0))) < 16 ? "0" : "") + A.toString(16);
                }
                function N(A, t, e, n) {
                    return n <= 0 ? A = t = e = NaN : e <= 0 || e >= 1 ? A = t = NaN : t <= 0 && (A = NaN), new M(A, t, e, n);
                }
                function I(A) {
                    if (A instanceof M) return new M(A.h, A.s, A.l, A.opacity);
                    if (A instanceof a || (A = v(A)), !A) return new M;
                    if (A instanceof M) return A;
                    var t = (A = A.rgb()).r / 255, e = A.g / 255, n = A.b / 255, r = Math.min(t, e, n), i = Math.max(t, e, n), o = NaN, s = i - r, c = (i + r) / 2;
                    return s ? (o = t === i ? (e - n) / s + 6 * (e < n) : e === i ? (n - t) / s + 2 : (t - e) / s + 4, s /= c < .5 ? i + r : 2 - i - r, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new M(o, s, c, A.opacity);
                }
                function M(A, t, e, n) {
                    this.h = +A, this.s = +t, this.l = +e, this.opacity = +n;
                }
                function T(A, t, e) {
                    return 255 * (A < 60 ? t + (e - t) * A / 60 : A < 180 ? e : A < 240 ? t + (e - t) * (240 - A) / 60 : t);
                }
                n(a, v, {
                    copy: function(A) {
                        return Object.assign(new this.constructor, this, A);
                    },
                    displayable: function() {
                        return this.rgb().displayable();
                    },
                    hex: Q,
                    formatHex: Q,
                    formatHsl: function() {
                        return I(this).formatHsl();
                    },
                    formatRgb: U,
                    toString: U
                }), n(F, E, r(a, {
                    brighter: function(A) {
                        return A = null == A ? o : Math.pow(o, A), new F(this.r * A, this.g * A, this.b * A, this.opacity);
                    },
                    darker: function(A) {
                        return A = null == A ? i : Math.pow(i, A), new F(this.r * A, this.g * A, this.b * A, this.opacity);
                    },
                    rgb: function() {
                        return this;
                    },
                    displayable: function() {
                        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
                    },
                    hex: _,
                    formatHex: _,
                    formatRgb: b,
                    toString: b
                })), n(M, function(A, t, e, n) {
                    return 1 === arguments.length ? I(A) : new M(A, t, e, null == n ? 1 : n);
                }, r(a, {
                    brighter: function(A) {
                        return A = null == A ? o : Math.pow(o, A), new M(this.h, this.s, this.l * A, this.opacity);
                    },
                    darker: function(A) {
                        return A = null == A ? i : Math.pow(i, A), new M(this.h, this.s, this.l * A, this.opacity);
                    },
                    rgb: function() {
                        var A = this.h % 360 + 360 * (this.h < 0), t = isNaN(A) || isNaN(this.s) ? 0 : this.s, e = this.l, n = e + (e < .5 ? e : 1 - e) * t, r = 2 * e - n;
                        return new F(T(A >= 240 ? A - 240 : A + 120, r, n), T(A, r, n), T(A < 120 ? A + 240 : A - 120, r, n), this.opacity);
                    },
                    displayable: function() {
                        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
                    },
                    formatHsl: function() {
                        var A = this.opacity;
                        return (1 === (A = isNaN(A) ? 1 : Math.max(0, Math.min(1, A))) ? "hsl(" : "hsla(") + (this.h || 0) + ", " + 100 * (this.s || 0) + "%, " + 100 * (this.l || 0) + "%" + (1 === A ? ")" : ", " + A + ")");
                    }
                }));
            },
            2626: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>c
                });
                var n = {
                    value: function() {}
                };
                function r() {
                    for(var A, t = 0, e = arguments.length, n = {}; t < e; ++t){
                        if (!(A = arguments[t] + "") || A in n || /[\s.]/.test(A)) throw new Error("illegal type: " + A);
                        n[A] = [];
                    }
                    return new a(n);
                }
                function a(A) {
                    this._ = A;
                }
                function i(A, t) {
                    return A.trim().split(/^|\s+/).map(function(A) {
                        var e = "", n = A.indexOf(".");
                        if (n >= 0 && (e = A.slice(n + 1), A = A.slice(0, n)), A && !t.hasOwnProperty(A)) throw new Error("unknown type: " + A);
                        return {
                            type: A,
                            name: e
                        };
                    });
                }
                function o(A, t) {
                    for(var e, n = 0, r = A.length; n < r; ++n)if ((e = A[n]).name === t) return e.value;
                }
                function s(A, t, e) {
                    for(var r = 0, a = A.length; r < a; ++r)if (A[r].name === t) {
                        A[r] = n, A = A.slice(0, r).concat(A.slice(r + 1));
                        break;
                    }
                    return null != e && A.push({
                        name: t,
                        value: e
                    }), A;
                }
                a.prototype = r.prototype = {
                    constructor: a,
                    on: function(A, t) {
                        var e, n = this._, r = i(A + "", n), a = -1, c = r.length;
                        if (!(arguments.length < 2)) {
                            if (null != t && "function" != typeof t) throw new Error("invalid callback: " + t);
                            for(; ++a < c;)if (e = (A = r[a]).type) n[e] = s(n[e], A.name, t);
                            else if (null == t) for(e in n)n[e] = s(n[e], A.name, null);
                            return this;
                        }
                        for(; ++a < c;)if ((e = (A = r[a]).type) && (e = o(n[e], A.name))) return e;
                    },
                    copy: function() {
                        var A = {}, t = this._;
                        for(var e in t)A[e] = t[e].slice();
                        return new a(A);
                    },
                    call: function(A, t) {
                        if ((e = arguments.length - 2) > 0) for(var e, n, r = new Array(e), a = 0; a < e; ++a)r[a] = arguments[a + 2];
                        if (!this._.hasOwnProperty(A)) throw new Error("unknown type: " + A);
                        for(a = 0, e = (n = this._[A]).length; a < e; ++a)n[a].value.apply(t, r);
                    },
                    apply: function(A, t, e) {
                        if (!this._.hasOwnProperty(A)) throw new Error("unknown type: " + A);
                        for(var n = this._[A], r = 0, a = n.length; r < a; ++r)n[r].value.apply(t, e);
                    }
                };
                const c = r;
            },
            5608: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>Q
                });
                var n = e(2626), r = e(5109);
                function a() {
                    for(var A, t = r.B; A = t.sourceEvent;)t = A;
                    return t;
                }
                function i(A, t) {
                    var e = A.ownerSVGElement || A;
                    if (e.createSVGPoint) {
                        var n = e.createSVGPoint();
                        return n.x = t.clientX, n.y = t.clientY, [
                            (n = n.matrixTransform(A.getScreenCTM().inverse())).x,
                            n.y
                        ];
                    }
                    var r = A.getBoundingClientRect();
                    return [
                        t.clientX - r.left - A.clientLeft,
                        t.clientY - r.top - A.clientTop
                    ];
                }
                function o(A) {
                    var t = a();
                    return t.changedTouches && (t = t.changedTouches[0]), i(A, t);
                }
                function s(A, t, e) {
                    arguments.length < 3 && (e = t, t = a().changedTouches);
                    for(var n, r = 0, o = t ? t.length : 0; r < o; ++r)if ((n = t[r]).identifier === e) return i(A, n);
                    return null;
                }
                var c = e(4017);
                function l() {
                    r.B.stopImmediatePropagation();
                }
                function u() {
                    r.B.preventDefault(), r.B.stopImmediatePropagation();
                }
                function f(A) {
                    var t = A.document.documentElement, e = (0, c.Z)(A).on("dragstart.drag", u, !0);
                    "onselectstart" in t ? e.on("selectstart.drag", u, !0) : (t.__noselect = t.style.MozUserSelect, t.style.MozUserSelect = "none");
                }
                function h(A) {
                    return function() {
                        return A;
                    };
                }
                function B(A, t, e, n, r, a, i, o, s, c) {
                    this.target = A, this.type = t, this.subject = e, this.identifier = n, this.active = r, this.x = a, this.y = i, this.dx = o, this.dy = s, this._ = c;
                }
                function d() {
                    return !r.B.ctrlKey && !r.B.button;
                }
                function g() {
                    return this.parentNode;
                }
                function w(A) {
                    return null == A ? {
                        x: r.B.x,
                        y: r.B.y
                    } : A;
                }
                function p() {
                    return navigator.maxTouchPoints || "ontouchstart" in this;
                }
                function Q() {
                    var A, t, e, a, i = d, Q = g, U = w, v = p, y = {}, C = (0, n.Z)("start", "drag", "end"), m = 0, E = 0;
                    function F(A) {
                        A.on("mousedown.drag", _).filter(v).on("touchstart.drag", N).on("touchmove.drag", I).on("touchend.drag touchcancel.drag", M).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
                    }
                    function _() {
                        if (!a && i.apply(this, arguments)) {
                            var n = T("mouse", Q.apply(this, arguments), o, this, arguments);
                            n && ((0, c.Z)(r.B.view).on("mousemove.drag", b, !0).on("mouseup.drag", H, !0), f(r.B.view), l(), e = !1, A = r.B.clientX, t = r.B.clientY, n("start"));
                        }
                    }
                    function b() {
                        if (u(), !e) {
                            var n = r.B.clientX - A, a = r.B.clientY - t;
                            e = n * n + a * a > E;
                        }
                        y.mouse("drag");
                    }
                    function H() {
                        var A, t, n, a;
                        (0, c.Z)(r.B.view).on("mousemove.drag mouseup.drag", null), A = r.B.view, t = e, n = A.document.documentElement, a = (0, c.Z)(A).on("dragstart.drag", null), t && (a.on("click.drag", u, !0), setTimeout(function() {
                            a.on("click.drag", null);
                        }, 0)), "onselectstart" in n ? a.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect), u(), y.mouse("end");
                    }
                    function N() {
                        if (i.apply(this, arguments)) {
                            var A, t, e = r.B.changedTouches, n = Q.apply(this, arguments), a = e.length;
                            for(A = 0; A < a; ++A)(t = T(e[A].identifier, n, s, this, arguments)) && (l(), t("start"));
                        }
                    }
                    function I() {
                        var A, t, e = r.B.changedTouches, n = e.length;
                        for(A = 0; A < n; ++A)(t = y[e[A].identifier]) && (u(), t("drag"));
                    }
                    function M() {
                        var A, t, e = r.B.changedTouches, n = e.length;
                        for(a && clearTimeout(a), a = setTimeout(function() {
                            a = null;
                        }, 500), A = 0; A < n; ++A)(t = y[e[A].identifier]) && (l(), t("end"));
                    }
                    function T(A, t, e, n, a) {
                        var i, o, s, c = e(t, A), l = C.copy();
                        if ((0, r._H)(new B(F, "beforestart", i, A, m, c[0], c[1], 0, 0, l), function() {
                            return null != (r.B.subject = i = U.apply(n, a)) && (o = i.x - c[0] || 0, s = i.y - c[1] || 0, !0);
                        })) return function u(f) {
                            var h, d = c;
                            switch(f){
                                case "start":
                                    y[A] = u, h = m++;
                                    break;
                                case "end":
                                    delete y[A], --m;
                                case "drag":
                                    c = e(t, A), h = m;
                            }
                            (0, r._H)(new B(F, f, i, A, h, c[0] + o, c[1] + s, c[0] - d[0], c[1] - d[1], l), l.apply, l, [
                                f,
                                n,
                                a
                            ]);
                        };
                    }
                    return F.filter = function(A) {
                        return arguments.length ? (i = "function" == typeof A ? A : h(!!A), F) : i;
                    }, F.container = function(A) {
                        return arguments.length ? (Q = "function" == typeof A ? A : h(A), F) : Q;
                    }, F.subject = function(A) {
                        return arguments.length ? (U = "function" == typeof A ? A : h(A), F) : U;
                    }, F.touchable = function(A) {
                        return arguments.length ? (v = "function" == typeof A ? A : h(!!A), F) : v;
                    }, F.on = function() {
                        var A = C.on.apply(C, arguments);
                        return A === C ? F : A;
                    }, F.clickDistance = function(A) {
                        return arguments.length ? (E = (A = +A) * A, F) : Math.sqrt(E);
                    }, F;
                }
                B.prototype.on = function() {
                    var A = this._.on.apply(this._, arguments);
                    return A === this._ ? this : A;
                };
            },
            8716: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return --A * A * A + 1;
                }
                function r(A) {
                    return ((A *= 2) <= 1 ? A * A * A : (A -= 2) * A * A + 2) / 2;
                }
                e.d(t, {
                    _e: ()=>n,
                    tw: ()=>r
                });
            },
            1078: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return 1.0009775171065494 * (Math.pow(2, -10 * A) - .0009765625);
                }
                e.d(t, {
                    _D: ()=>a
                });
                var r = 2 * Math.PI, a = (function A(t, e) {
                    var a = Math.asin(1 / (t = Math.max(1, t))) * (e /= r);
                    function i(A) {
                        return t * n(- --A) * Math.sin((a - A) / e);
                    }
                    return i.amplitude = function(t) {
                        return A(t, e * r);
                    }, i.period = function(e) {
                        return A(t, e);
                    }, i;
                }(1, .3), function A(t, e) {
                    var a = Math.asin(1 / (t = Math.max(1, t))) * (e /= r);
                    function i(A) {
                        return 1 - t * n(A = +A) * Math.sin((A + a) / e);
                    }
                    return i.amplitude = function(t) {
                        return A(t, e * r);
                    }, i.period = function(e) {
                        return A(t, e);
                    }, i;
                }(1, .3));
                !function A(t, e) {
                    var a = Math.asin(1 / (t = Math.max(1, t))) * (e /= r);
                    function i(A) {
                        return ((A = 2 * A - 1) < 0 ? t * n(-A) * Math.sin((a - A) / e) : 2 - t * n(A) * Math.sin((a + A) / e)) / 2;
                    }
                    return i.amplitude = function(t) {
                        return A(t, e * r);
                    }, i.period = function(e) {
                        return A(t, e);
                    }, i;
                }(1, .3);
            },
            2396: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return A * A;
                }
                function r(A) {
                    return A * (2 - A);
                }
                e.d(t, {
                    Kl: ()=>n,
                    u4: ()=>r
                });
            },
            8602: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    WU: ()=>u,
                    jH: ()=>f
                });
                var n, r = e(3085), a = e(6196), i = e(8885);
                function o(A, t) {
                    var e = (0, i.V)(A, t);
                    if (!e) return A + "";
                    var n = e[0], r = e[1];
                    return r < 0 ? "0." + new Array(-r).join("0") + n : n.length > r + 1 ? n.slice(0, r + 1) + "." + n.slice(r + 1) : n + new Array(r - n.length + 2).join("0");
                }
                const s = {
                    "%": function(A, t) {
                        return (100 * A).toFixed(t);
                    },
                    b: function(A) {
                        return Math.round(A).toString(2);
                    },
                    c: function(A) {
                        return A + "";
                    },
                    d: i.Z,
                    e: function(A, t) {
                        return A.toExponential(t);
                    },
                    f: function(A, t) {
                        return A.toFixed(t);
                    },
                    g: function(A, t) {
                        return A.toPrecision(t);
                    },
                    o: function(A) {
                        return Math.round(A).toString(8);
                    },
                    p: function(A, t) {
                        return o(100 * A, t);
                    },
                    r: o,
                    s: function(A, t) {
                        var e = (0, i.V)(A, t);
                        if (!e) return A + "";
                        var r = e[0], a = e[1], o = a - (n = 3 * Math.max(-8, Math.min(8, Math.floor(a / 3)))) + 1, s = r.length;
                        return o === s ? r : o > s ? r + new Array(o - s + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + (0, i.V)(A, Math.max(0, t + o - 1))[0];
                    },
                    X: function(A) {
                        return Math.round(A).toString(16).toUpperCase();
                    },
                    x: function(A) {
                        return Math.round(A).toString(16);
                    }
                };
                function c(A) {
                    return A;
                }
                var l, u, f, h = Array.prototype.map, B = [
                    "y",
                    "z",
                    "a",
                    "f",
                    "p",
                    "n",
                    "\xb5",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E",
                    "Z",
                    "Y"
                ];
                l = function(A) {
                    var t, e, i = void 0 === A.grouping || void 0 === A.thousands ? c : (t = h.call(A.grouping, Number), e = A.thousands + "", function(A, n) {
                        for(var r = A.length, a = [], i = 0, o = t[0], s = 0; r > 0 && o > 0 && (s + o + 1 > n && (o = Math.max(1, n - s)), a.push(A.substring(r -= o, r + o)), !((s += o + 1) > n));)o = t[i = (i + 1) % t.length];
                        return a.reverse().join(e);
                    }), o = void 0 === A.currency ? "" : A.currency[0] + "", l = void 0 === A.currency ? "" : A.currency[1] + "", u = void 0 === A.decimal ? "." : A.decimal + "", f = void 0 === A.numerals ? c : function(A) {
                        return function(t) {
                            return t.replace(/[0-9]/g, function(t) {
                                return A[+t];
                            });
                        };
                    }(h.call(A.numerals, String)), d = void 0 === A.percent ? "%" : A.percent + "", g = void 0 === A.minus ? "-" : A.minus + "", w = void 0 === A.nan ? "NaN" : A.nan + "";
                    function p(A) {
                        var t = (A = (0, a.Z)(A)).fill, e = A.align, r = A.sign, c = A.symbol, h = A.zero, p = A.width, Q = A.comma, U = A.precision, v = A.trim, y = A.type;
                        "n" === y ? (Q = !0, y = "g") : s[y] || (void 0 === U && (U = 12), v = !0, y = "g"), (h || "0" === t && "=" === e) && (h = !0, t = "0", e = "=");
                        var C = "$" === c ? o : "#" === c && /[boxX]/.test(y) ? "0" + y.toLowerCase() : "", m = "$" === c ? l : /[%p]/.test(y) ? d : "", E = s[y], F = /[defgprs%]/.test(y);
                        function _(A) {
                            var a, o, s, c = C, l = m;
                            if ("c" === y) l = E(A) + l, A = "";
                            else {
                                var d = (A = +A) < 0 || 1 / A < 0;
                                if (A = isNaN(A) ? w : E(Math.abs(A), U), v && (A = function(A) {
                                    A: for(var t, e = A.length, n = 1, r = -1; n < e; ++n)switch(A[n]){
                                        case ".":
                                            r = t = n;
                                            break;
                                        case "0":
                                            0 === r && (r = n), t = n;
                                            break;
                                        default:
                                            if (!+A[n]) break A;
                                            r > 0 && (r = 0);
                                    }
                                    return r > 0 ? A.slice(0, r) + A.slice(t + 1) : A;
                                }(A)), d && 0 == +A && "+" !== r && (d = !1), c = (d ? "(" === r ? r : g : "-" === r || "(" === r ? "" : r) + c, l = ("s" === y ? B[8 + n / 3] : "") + l + (d && "(" === r ? ")" : ""), F) {
                                    for(a = -1, o = A.length; ++a < o;)if (48 > (s = A.charCodeAt(a)) || s > 57) {
                                        l = (46 === s ? u + A.slice(a + 1) : A.slice(a)) + l, A = A.slice(0, a);
                                        break;
                                    }
                                }
                            }
                            Q && !h && (A = i(A, 1 / 0));
                            var _ = c.length + A.length + l.length, b = _ < p ? new Array(p - _ + 1).join(t) : "";
                            switch(Q && h && (A = i(b + A, b.length ? p - l.length : 1 / 0), b = ""), e){
                                case "<":
                                    A = c + A + l + b;
                                    break;
                                case "=":
                                    A = c + b + A + l;
                                    break;
                                case "^":
                                    A = b.slice(0, _ = b.length >> 1) + c + A + l + b.slice(_);
                                    break;
                                default:
                                    A = b + c + A + l;
                            }
                            return f(A);
                        }
                        return U = void 0 === U ? 6 : /[gprs]/.test(y) ? Math.max(1, Math.min(21, U)) : Math.max(0, Math.min(20, U)), _.toString = function() {
                            return A + "";
                        }, _;
                    }
                    return {
                        format: p,
                        formatPrefix: function(A, t) {
                            var e = p(((A = (0, a.Z)(A)).type = "f", A)), n = 3 * Math.max(-8, Math.min(8, Math.floor((0, r.Z)(t) / 3))), i = Math.pow(10, -n), o = B[8 + n / 3];
                            return function(A) {
                                return e(i * A) + o;
                            };
                        }
                    };
                }({
                    decimal: ".",
                    thousands: ",",
                    grouping: [
                        3
                    ],
                    currency: [
                        "$",
                        ""
                    ],
                    minus: "-"
                }), u = l.format, f = l.formatPrefix;
            },
            3085: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>r
                });
                var n = e(8885);
                function r(A) {
                    return (A = (0, n.V)(Math.abs(A))) ? A[1] : NaN;
                }
            },
            8885: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return Math.abs(A = Math.round(A)) >= 1e21 ? A.toLocaleString("en").replace(/,/g, "") : A.toString(10);
                }
                function r(A, t) {
                    if ((e = (A = t ? A.toExponential(t - 1) : A.toExponential()).indexOf("e")) < 0) return null;
                    var e, n = A.slice(0, e);
                    return [
                        n.length > 1 ? n[0] + n.slice(2) : n,
                        +A.slice(e + 1)
                    ];
                }
                e.d(t, {
                    Z: ()=>n,
                    V: ()=>r
                });
            },
            6196: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>r
                });
                var n = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
                function r(A) {
                    if (!(t = n.exec(A))) throw new Error("invalid format: " + A);
                    var t;
                    return new a({
                        fill: t[1],
                        align: t[2],
                        sign: t[3],
                        symbol: t[4],
                        zero: t[5],
                        width: t[6],
                        comma: t[7],
                        precision: t[8] && t[8].slice(1),
                        trim: t[9],
                        type: t[10]
                    });
                }
                function a(A) {
                    this.fill = void 0 === A.fill ? " " : A.fill + "", this.align = void 0 === A.align ? ">" : A.align + "", this.sign = void 0 === A.sign ? "-" : A.sign + "", this.symbol = void 0 === A.symbol ? "" : A.symbol + "", this.zero = !!A.zero, this.width = void 0 === A.width ? void 0 : +A.width, this.comma = !!A.comma, this.precision = void 0 === A.precision ? void 0 : +A.precision, this.trim = !!A.trim, this.type = void 0 === A.type ? "" : A.type + "";
                }
                r.prototype = a.prototype, a.prototype.toString = function() {
                    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (void 0 === this.width ? "" : Math.max(1, 0 | this.width)) + (this.comma ? "," : "") + (void 0 === this.precision ? "" : "." + Math.max(0, 0 | this.precision)) + (this.trim ? "~" : "") + this.type;
                };
            },
            5302: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return function() {
                        return A;
                    };
                }
                e.d(t, {
                    Z: ()=>n
                });
            },
            3626: (A, t, e)=>{
                "use strict";
                function n(A, t) {
                    return A = +A, t = +t, function(e) {
                        return A * (1 - e) + t * e;
                    };
                }
                e.d(t, {
                    Z: ()=>n
                });
            },
            7765: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    ZP: ()=>o
                });
                var n = e(2650);
                function r(A, t, e, n, r) {
                    var a = A * A, i = a * A;
                    return ((1 - 3 * A + 3 * a - i) * t + (4 - 6 * a + 3 * i) * e + (1 + 3 * A + 3 * a - 3 * i) * n + i * r) / 6;
                }
                var a = e(5302);
                function i(A, t) {
                    var e = t - A;
                    return e ? function(A, t) {
                        return function(e) {
                            return A + e * t;
                        };
                    }(A, e) : (0, a.Z)(isNaN(A) ? t : A);
                }
                const o = function A(t) {
                    var e = function(A) {
                        return 1 == (A = +A) ? i : function(t, e) {
                            return e - t ? function(A, t, e) {
                                return A = Math.pow(A, e), t = Math.pow(t, e) - A, e = 1 / e, function(n) {
                                    return Math.pow(A + n * t, e);
                                };
                            }(t, e, A) : (0, a.Z)(isNaN(t) ? e : t);
                        };
                    }(t);
                    function r(A, t) {
                        var r = e((A = (0, n.B8)(A)).r, (t = (0, n.B8)(t)).r), a = e(A.g, t.g), o = e(A.b, t.b), s = i(A.opacity, t.opacity);
                        return function(t) {
                            return A.r = r(t), A.g = a(t), A.b = o(t), A.opacity = s(t), A + "";
                        };
                    }
                    return r.gamma = A, r;
                }(1);
                function s(A) {
                    return function(t) {
                        var e, r, a = t.length, i = new Array(a), o = new Array(a), s = new Array(a);
                        for(e = 0; e < a; ++e)r = (0, n.B8)(t[e]), i[e] = r.r || 0, o[e] = r.g || 0, s[e] = r.b || 0;
                        return i = A(i), o = A(o), s = A(s), r.opacity = 1, function(A) {
                            return r.r = i(A), r.g = o(A), r.b = s(A), r + "";
                        };
                    };
                }
                s(function(A) {
                    var t = A.length - 1;
                    return function(e) {
                        var n = e <= 0 ? e = 0 : e >= 1 ? (e = 1, t - 1) : Math.floor(e * t), a = A[n], i = A[n + 1], o = n > 0 ? A[n - 1] : 2 * a - i, s = n < t - 1 ? A[n + 2] : 2 * i - a;
                        return r((e - n / t) * t, o, a, i, s);
                    };
                }), s(function(A) {
                    var t = A.length;
                    return function(e) {
                        var n = Math.floor(((e %= 1) < 0 ? ++e : e) * t), a = A[(n + t - 1) % t], i = A[n % t], o = A[(n + 1) % t], s = A[(n + 2) % t];
                        return r((e - n / t) * t, a, i, o, s);
                    };
                });
            },
            9843: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>i
                });
                var n = e(3626), r = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, a = new RegExp(r.source, "g");
                function i(A, t) {
                    var e, i, o, s = r.lastIndex = a.lastIndex = 0, c = -1, l = [], u = [];
                    for(A += "", t += ""; (e = r.exec(A)) && (i = a.exec(t));)(o = i.index) > s && (o = t.slice(s, o), l[c] ? l[c] += o : l[++c] = o), (e = e[0]) === (i = i[0]) ? l[c] ? l[c] += i : l[++c] = i : (l[++c] = null, u.push({
                        i: c,
                        x: (0, n.Z)(e, i)
                    })), s = a.lastIndex;
                    return s < t.length && (o = t.slice(s), l[c] ? l[c] += o : l[++c] = o), l.length < 2 ? u[0] ? function(A) {
                        return function(t) {
                            return A(t) + "";
                        };
                    }(u[0].x) : function(A) {
                        return function() {
                            return A;
                        };
                    }(t) : (t = u.length, function(A) {
                        for(var e, n = 0; n < t; ++n)l[(e = u[n]).i] = e.x(A);
                        return l.join("");
                    });
                }
            },
            3172: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>f
                });
                var n = e(2650), r = e(7765);
                function a(A, t) {
                    var e, n = t ? t.length : 0, r = A ? Math.min(n, A.length) : 0, a = new Array(r), i = new Array(n);
                    for(e = 0; e < r; ++e)a[e] = f(A[e], t[e]);
                    for(; e < n; ++e)i[e] = t[e];
                    return function(A) {
                        for(e = 0; e < r; ++e)i[e] = a[e](A);
                        return i;
                    };
                }
                function i(A, t) {
                    var e = new Date;
                    return A = +A, t = +t, function(n) {
                        return e.setTime(A * (1 - n) + t * n), e;
                    };
                }
                var o = e(3626);
                function s(A, t) {
                    var e, n = {}, r = {};
                    for(e in null !== A && "object" == typeof A || (A = {}), null !== t && "object" == typeof t || (t = {}), t)e in A ? n[e] = f(A[e], t[e]) : r[e] = t[e];
                    return function(A) {
                        for(e in n)r[e] = n[e](A);
                        return r;
                    };
                }
                var c = e(9843), l = e(5302);
                function u(A, t) {
                    t || (t = []);
                    var e, n = A ? Math.min(t.length, A.length) : 0, r = t.slice();
                    return function(a) {
                        for(e = 0; e < n; ++e)r[e] = A[e] * (1 - a) + t[e] * a;
                        return r;
                    };
                }
                function f(A, t) {
                    var e, f, h = typeof t;
                    return null == t || "boolean" === h ? (0, l.Z)(t) : ("number" === h ? o.Z : "string" === h ? (e = (0, n.ZP)(t)) ? (t = e, r.ZP) : c.Z : t instanceof n.ZP ? r.ZP : t instanceof Date ? i : (f = t, !ArrayBuffer.isView(f) || f instanceof DataView ? Array.isArray(t) ? a : "function" != typeof t.valueOf && "function" != typeof t.toString || isNaN(t) ? s : o.Z : u))(A, t);
                }
            },
            1108: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>c
                });
                var n = Math.PI, r = 2 * n, a = 1e-6, i = r - a;
                function o() {
                    this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
                }
                function s() {
                    return new o;
                }
                o.prototype = s.prototype = {
                    constructor: o,
                    moveTo: function(A, t) {
                        this._ += "M" + (this._x0 = this._x1 = +A) + "," + (this._y0 = this._y1 = +t);
                    },
                    closePath: function() {
                        null !== this._x1 && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
                    },
                    lineTo: function(A, t) {
                        this._ += "L" + (this._x1 = +A) + "," + (this._y1 = +t);
                    },
                    quadraticCurveTo: function(A, t, e, n) {
                        this._ += "Q" + +A + "," + +t + "," + (this._x1 = +e) + "," + (this._y1 = +n);
                    },
                    bezierCurveTo: function(A, t, e, n, r, a) {
                        this._ += "C" + +A + "," + +t + "," + +e + "," + +n + "," + (this._x1 = +r) + "," + (this._y1 = +a);
                    },
                    arcTo: function(A, t, e, r, i) {
                        A = +A, t = +t, e = +e, r = +r, i = +i;
                        var o = this._x1, s = this._y1, c = e - A, l = r - t, u = o - A, f = s - t, h = u * u + f * f;
                        if (i < 0) throw new Error("negative radius: " + i);
                        if (null === this._x1) this._ += "M" + (this._x1 = A) + "," + (this._y1 = t);
                        else if (h > a) {
                            if (Math.abs(f * c - l * u) > a && i) {
                                var B = e - o, d = r - s, g = c * c + l * l, w = B * B + d * d, p = Math.sqrt(g), Q = Math.sqrt(h), U = i * Math.tan((n - Math.acos((g + h - w) / (2 * p * Q))) / 2), v = U / Q, y = U / p;
                                Math.abs(v - 1) > a && (this._ += "L" + (A + v * u) + "," + (t + v * f)), this._ += "A" + i + "," + i + ",0,0," + +(f * B > u * d) + "," + (this._x1 = A + y * c) + "," + (this._y1 = t + y * l);
                            } else this._ += "L" + (this._x1 = A) + "," + (this._y1 = t);
                        }
                    },
                    arc: function(A, t, e, o, s, c) {
                        A = +A, t = +t, c = !!c;
                        var l = (e = +e) * Math.cos(o), u = e * Math.sin(o), f = A + l, h = t + u, B = 1 ^ c, d = c ? o - s : s - o;
                        if (e < 0) throw new Error("negative radius: " + e);
                        null === this._x1 ? this._ += "M" + f + "," + h : (Math.abs(this._x1 - f) > a || Math.abs(this._y1 - h) > a) && (this._ += "L" + f + "," + h), e && (d < 0 && (d = d % r + r), d > i ? this._ += "A" + e + "," + e + ",0,1," + B + "," + (A - l) + "," + (t - u) + "A" + e + "," + e + ",0,1," + B + "," + (this._x1 = f) + "," + (this._y1 = h) : d > a && (this._ += "A" + e + "," + e + ",0," + +(d >= n) + "," + B + "," + (this._x1 = A + e * Math.cos(s)) + "," + (this._y1 = t + e * Math.sin(s))));
                    },
                    rect: function(A, t, e, n) {
                        this._ += "M" + (this._x0 = this._x1 = +A) + "," + (this._y0 = this._y1 = +t) + "h" + +e + "v" + +n + "h" + -e + "Z";
                    },
                    toString: function() {
                        return this._;
                    }
                };
                const c = s;
            },
            9037: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    ti: ()=>u,
                    BY: ()=>N,
                    PK: ()=>l,
                    q2: ()=>h,
                    aE: ()=>I,
                    ut: ()=>M
                });
                var n = e(2168);
                function r(A, t) {
                    switch(arguments.length){
                        case 0:
                            break;
                        case 1:
                            this.range(A);
                            break;
                        default:
                            this.range(t).domain(A);
                    }
                    return this;
                }
                var a = e(1654), i = Array.prototype, o = i.map, s = i.slice, c = {
                    name: "implicit"
                };
                function l() {
                    var A = (0, a.UI)(), t = [], e = [], n = c;
                    function i(r) {
                        var a = r + "", i = A.get(a);
                        if (!i) {
                            if (n !== c) return n;
                            A.set(a, i = t.push(r));
                        }
                        return e[(i - 1) % e.length];
                    }
                    return i.domain = function(e) {
                        if (!arguments.length) return t.slice();
                        t = [], A = (0, a.UI)();
                        for(var n, r, o = -1, s = e.length; ++o < s;)A.has(r = (n = e[o]) + "") || A.set(r, t.push(n));
                        return i;
                    }, i.range = function(A) {
                        return arguments.length ? (e = s.call(A), i) : e.slice();
                    }, i.unknown = function(A) {
                        return arguments.length ? (n = A, i) : n;
                    }, i.copy = function() {
                        return l(t, e).unknown(n);
                    }, r.apply(i, arguments), i;
                }
                function u() {
                    var A, t, e = l().unknown(void 0), a = e.domain, i = e.range, o = [
                        0,
                        1
                    ], s = !1, c = 0, f = 0, h = .5;
                    function B() {
                        var e = a().length, r = o[1] < o[0], l = o[r - 0], u = o[1 - r];
                        A = (u - l) / Math.max(1, e - c + 2 * f), s && (A = Math.floor(A)), l += (u - l - A * (e - c)) * h, t = A * (1 - c), s && (l = Math.round(l), t = Math.round(t));
                        var B = (0, n.w6)(e).map(function(t) {
                            return l + A * t;
                        });
                        return i(r ? B.reverse() : B);
                    }
                    return delete e.unknown, e.domain = function(A) {
                        return arguments.length ? (a(A), B()) : a();
                    }, e.range = function(A) {
                        return arguments.length ? (o = [
                            +A[0],
                            +A[1]
                        ], B()) : o.slice();
                    }, e.rangeRound = function(A) {
                        return o = [
                            +A[0],
                            +A[1]
                        ], s = !0, B();
                    }, e.bandwidth = function() {
                        return t;
                    }, e.step = function() {
                        return A;
                    }, e.round = function(A) {
                        return arguments.length ? (s = !!A, B()) : s;
                    }, e.padding = function(A) {
                        return arguments.length ? (c = Math.min(1, f = +A), B()) : c;
                    }, e.paddingInner = function(A) {
                        return arguments.length ? (c = Math.min(1, A), B()) : c;
                    }, e.paddingOuter = function(A) {
                        return arguments.length ? (f = +A, B()) : f;
                    }, e.align = function(A) {
                        return arguments.length ? (h = Math.max(0, Math.min(1, A)), B()) : h;
                    }, e.copy = function() {
                        return u(a(), o).round(s).paddingInner(c).paddingOuter(f).align(h);
                    }, r.apply(B(), arguments);
                }
                function f(A) {
                    var t = A.copy;
                    return A.padding = A.paddingOuter, delete A.paddingInner, delete A.paddingOuter, A.copy = function() {
                        return f(t());
                    }, A;
                }
                function h() {
                    return f(u.apply(null, arguments).paddingInner(1));
                }
                var B = e(3172), d = e(3626);
                function g(A, t) {
                    return A = +A, t = +t, function(e) {
                        return Math.round(A * (1 - e) + t * e);
                    };
                }
                function w(A) {
                    return +A;
                }
                var p = [
                    0,
                    1
                ];
                function Q(A) {
                    return A;
                }
                function U(A, t) {
                    var e;
                    return (t -= A = +A) ? function(e) {
                        return (e - A) / t;
                    } : (e = isNaN(t) ? NaN : .5, function() {
                        return e;
                    });
                }
                function v(A) {
                    var t, e = A[0], n = A[A.length - 1];
                    return e > n && (t = e, e = n, n = t), function(A) {
                        return Math.max(e, Math.min(n, A));
                    };
                }
                function y(A, t, e) {
                    var n = A[0], r = A[1], a = t[0], i = t[1];
                    return r < n ? (n = U(r, n), a = e(i, a)) : (n = U(n, r), a = e(a, i)), function(A) {
                        return a(n(A));
                    };
                }
                function C(A, t, e) {
                    var r = Math.min(A.length, t.length) - 1, a = new Array(r), i = new Array(r), o = -1;
                    for(A[r] < A[0] && (A = A.slice().reverse(), t = t.slice().reverse()); ++o < r;)a[o] = U(A[o], A[o + 1]), i[o] = e(t[o], t[o + 1]);
                    return function(t) {
                        var e = (0, n.b4)(A, t, 1, r) - 1;
                        return i[e](a[e](t));
                    };
                }
                function m(A, t) {
                    return t.domain(A.domain()).range(A.range()).interpolate(A.interpolate()).clamp(A.clamp()).unknown(A.unknown());
                }
                function E(A, t) {
                    return (function() {
                        var A, t, e, n, r, a, i = p, c = p, l = B.Z, u = Q;
                        function f() {
                            return n = Math.min(i.length, c.length) > 2 ? C : y, r = a = null, h;
                        }
                        function h(t) {
                            return isNaN(t = +t) ? e : (r || (r = n(i.map(A), c, l)))(A(u(t)));
                        }
                        return h.invert = function(e) {
                            return u(t((a || (a = n(c, i.map(A), d.Z)))(e)));
                        }, h.domain = function(A) {
                            return arguments.length ? (i = o.call(A, w), u === Q || (u = v(i)), f()) : i.slice();
                        }, h.range = function(A) {
                            return arguments.length ? (c = s.call(A), f()) : c.slice();
                        }, h.rangeRound = function(A) {
                            return c = s.call(A), l = g, f();
                        }, h.clamp = function(A) {
                            return arguments.length ? (u = A ? v(i) : Q, h) : u !== Q;
                        }, h.interpolate = function(A) {
                            return arguments.length ? (l = A, f()) : l;
                        }, h.unknown = function(A) {
                            return arguments.length ? (e = A, h) : e;
                        }, function(e, n) {
                            return A = e, t = n, f();
                        };
                    })()(A, t);
                }
                var F = e(6196), _ = e(3085), b = e(8602);
                function H(A) {
                    var t = A.domain;
                    return A.ticks = function(A) {
                        var e = t();
                        return (0, n.sd)(e[0], e[e.length - 1], null == A ? 10 : A);
                    }, A.tickFormat = function(A, e) {
                        var r = t();
                        return function(A, t, e, r) {
                            var a, i = (0, n.ly)(A, t, e);
                            switch((r = (0, F.Z)(null == r ? ",f" : r)).type){
                                case "s":
                                    var o = Math.max(Math.abs(A), Math.abs(t));
                                    return null != r.precision || isNaN(a = function(A, t) {
                                        return Math.max(0, 3 * Math.max(-8, Math.min(8, Math.floor((0, _.Z)(t) / 3))) - (0, _.Z)(Math.abs(A)));
                                    }(i, o)) || (r.precision = a), (0, b.jH)(r, o);
                                case "":
                                case "e":
                                case "g":
                                case "p":
                                case "r":
                                    null != r.precision || isNaN(a = function(A, t) {
                                        return A = Math.abs(A), t = Math.abs(t) - A, Math.max(0, (0, _.Z)(t) - (0, _.Z)(A)) + 1;
                                    }(i, Math.max(Math.abs(A), Math.abs(t)))) || (r.precision = a - ("e" === r.type));
                                    break;
                                case "f":
                                case "%":
                                    null != r.precision || isNaN(a = function(A) {
                                        return Math.max(0, -(0, _.Z)(Math.abs(A)));
                                    }(i)) || (r.precision = a - 2 * ("%" === r.type));
                            }
                            return (0, b.WU)(r);
                        }(r[0], r[r.length - 1], null == A ? 10 : A, e);
                    }, A.nice = function(e) {
                        null == e && (e = 10);
                        var r, a = t(), i = 0, o = a.length - 1, s = a[i], c = a[o];
                        return c < s && (r = s, s = c, c = r, r = i, i = o, o = r), (r = (0, n.G9)(s, c, e)) > 0 ? (s = Math.floor(s / r) * r, c = Math.ceil(c / r) * r, r = (0, n.G9)(s, c, e)) : r < 0 && (s = Math.ceil(s * r) / r, c = Math.floor(c * r) / r, r = (0, n.G9)(s, c, e)), r > 0 ? (a[i] = Math.floor(s / r) * r, a[o] = Math.ceil(c / r) * r, t(a)) : r < 0 && (a[i] = Math.ceil(s * r) / r, a[o] = Math.floor(c * r) / r, t(a)), A;
                    }, A;
                }
                function N() {
                    var A = E(Q, Q);
                    return A.copy = function() {
                        return m(A, N());
                    }, r.apply(A, arguments), H(A);
                }
                function I() {
                    var A, t = 0, e = 1, a = 1, i = [
                        .5
                    ], o = [
                        0,
                        1
                    ];
                    function c(t) {
                        return t <= t ? o[(0, n.b4)(i, t, 0, a)] : A;
                    }
                    function l() {
                        var A = -1;
                        for(i = new Array(a); ++A < a;)i[A] = ((A + 1) * e - (A - a) * t) / (a + 1);
                        return c;
                    }
                    return c.domain = function(A) {
                        return arguments.length ? (t = +A[0], e = +A[1], l()) : [
                            t,
                            e
                        ];
                    }, c.range = function(A) {
                        return arguments.length ? (a = (o = s.call(A)).length - 1, l()) : o.slice();
                    }, c.invertExtent = function(A) {
                        var n = o.indexOf(A);
                        return n < 0 ? [
                            NaN,
                            NaN
                        ] : n < 1 ? [
                            t,
                            i[0]
                        ] : n >= a ? [
                            i[a - 1],
                            e
                        ] : [
                            i[n - 1],
                            i[n]
                        ];
                    }, c.unknown = function(t) {
                        return arguments.length ? (A = t, c) : c;
                    }, c.thresholds = function() {
                        return i.slice();
                    }, c.copy = function() {
                        return I().domain([
                            t,
                            e
                        ]).range(o).unknown(A);
                    }, r.apply(H(c), arguments);
                }
                function M() {
                    var A, t = [
                        .5
                    ], e = [
                        0,
                        1
                    ], a = 1;
                    function i(r) {
                        return r <= r ? e[(0, n.b4)(t, r, 0, a)] : A;
                    }
                    return i.domain = function(A) {
                        return arguments.length ? (t = s.call(A), a = Math.min(t.length, e.length - 1), i) : t.slice();
                    }, i.range = function(A) {
                        return arguments.length ? (e = s.call(A), a = Math.min(t.length, e.length - 1), i) : e.slice();
                    }, i.invertExtent = function(A) {
                        var n = e.indexOf(A);
                        return [
                            t[n - 1],
                            t[n]
                        ];
                    }, i.unknown = function(t) {
                        return arguments.length ? (A = t, i) : A;
                    }, i.copy = function() {
                        return M().domain(t).range(e).unknown(A);
                    }, r.apply(i, arguments);
                }
            },
            3083: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return function() {
                        return this.matches(A);
                    };
                }
                e.d(t, {
                    Z: ()=>n
                });
            },
            3888: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>r
                });
                var n = e(1986);
                function r(A) {
                    var t = A += "", e = t.indexOf(":");
                    return e >= 0 && "xmlns" !== (t = A.slice(0, e)) && (A = A.slice(e + 1)), n.Z.hasOwnProperty(t) ? {
                        space: n.Z[t],
                        local: A
                    } : A;
                }
            },
            1986: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    P: ()=>n,
                    Z: ()=>r
                });
                var n = "http://www.w3.org/1999/xhtml";
                const r = {
                    svg: "http://www.w3.org/2000/svg",
                    xhtml: n,
                    xlink: "http://www.w3.org/1999/xlink",
                    xml: "http://www.w3.org/XML/1998/namespace",
                    xmlns: "http://www.w3.org/2000/xmlns/"
                };
            },
            4017: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>r
                });
                var n = e(3228);
                function r(A) {
                    return "string" == typeof A ? new n.Y1([
                        [
                            document.querySelector(A)
                        ]
                    ], [
                        document.documentElement
                    ]) : new n.Y1([
                        [
                            A
                        ]
                    ], n.Jz);
                }
            },
            3228: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Y1: ()=>q,
                    ZP: ()=>AA,
                    Jz: ()=>Z
                });
                var n = e(2634), r = e(3545), a = e(3083);
                function i(A) {
                    return new Array(A.length);
                }
                function o(A, t) {
                    this.ownerDocument = A.ownerDocument, this.namespaceURI = A.namespaceURI, this._next = null, this._parent = A, this.__data__ = t;
                }
                function s(A, t, e, n, r, a) {
                    for(var i, s = 0, c = t.length, l = a.length; s < l; ++s)(i = t[s]) ? (i.__data__ = a[s], n[s] = i) : e[s] = new o(A, a[s]);
                    for(; s < c; ++s)(i = t[s]) && (r[s] = i);
                }
                function c(A, t, e, n, r, a, i) {
                    var s, c, l, u = {}, f = t.length, h = a.length, B = new Array(f);
                    for(s = 0; s < f; ++s)(c = t[s]) && (B[s] = l = "$" + i.call(c, c.__data__, s, t), l in u ? r[s] = c : u[l] = c);
                    for(s = 0; s < h; ++s)(c = u[l = "$" + i.call(A, a[s], s, a)]) ? (n[s] = c, c.__data__ = a[s], u[l] = null) : e[s] = new o(A, a[s]);
                    for(s = 0; s < f; ++s)(c = t[s]) && u[B[s]] === c && (r[s] = c);
                }
                function l(A, t) {
                    return A < t ? -1 : A > t ? 1 : A >= t ? 0 : NaN;
                }
                o.prototype = {
                    constructor: o,
                    appendChild: function(A) {
                        return this._parent.insertBefore(A, this._next);
                    },
                    insertBefore: function(A, t) {
                        return this._parent.insertBefore(A, t);
                    },
                    querySelector: function(A) {
                        return this._parent.querySelector(A);
                    },
                    querySelectorAll: function(A) {
                        return this._parent.querySelectorAll(A);
                    }
                };
                var u = e(3888);
                function f(A) {
                    return function() {
                        this.removeAttribute(A);
                    };
                }
                function h(A) {
                    return function() {
                        this.removeAttributeNS(A.space, A.local);
                    };
                }
                function B(A, t) {
                    return function() {
                        this.setAttribute(A, t);
                    };
                }
                function d(A, t) {
                    return function() {
                        this.setAttributeNS(A.space, A.local, t);
                    };
                }
                function g(A, t) {
                    return function() {
                        var e = t.apply(this, arguments);
                        null == e ? this.removeAttribute(A) : this.setAttribute(A, e);
                    };
                }
                function w(A, t) {
                    return function() {
                        var e = t.apply(this, arguments);
                        null == e ? this.removeAttributeNS(A.space, A.local) : this.setAttributeNS(A.space, A.local, e);
                    };
                }
                var p = e(9986);
                function Q(A) {
                    return function() {
                        delete this[A];
                    };
                }
                function U(A, t) {
                    return function() {
                        this[A] = t;
                    };
                }
                function v(A, t) {
                    return function() {
                        var e = t.apply(this, arguments);
                        null == e ? delete this[A] : this[A] = e;
                    };
                }
                function y(A) {
                    return A.trim().split(/^|\s+/);
                }
                function C(A) {
                    return A.classList || new m(A);
                }
                function m(A) {
                    this._node = A, this._names = y(A.getAttribute("class") || "");
                }
                function E(A, t) {
                    for(var e = C(A), n = -1, r = t.length; ++n < r;)e.add(t[n]);
                }
                function F(A, t) {
                    for(var e = C(A), n = -1, r = t.length; ++n < r;)e.remove(t[n]);
                }
                function _(A) {
                    return function() {
                        E(this, A);
                    };
                }
                function b(A) {
                    return function() {
                        F(this, A);
                    };
                }
                function H(A, t) {
                    return function() {
                        (t.apply(this, arguments) ? E : F)(this, A);
                    };
                }
                function N() {
                    this.textContent = "";
                }
                function I(A) {
                    return function() {
                        this.textContent = A;
                    };
                }
                function M(A) {
                    return function() {
                        var t = A.apply(this, arguments);
                        this.textContent = null == t ? "" : t;
                    };
                }
                function T() {
                    this.innerHTML = "";
                }
                function x(A) {
                    return function() {
                        this.innerHTML = A;
                    };
                }
                function K(A) {
                    return function() {
                        var t = A.apply(this, arguments);
                        this.innerHTML = null == t ? "" : t;
                    };
                }
                function O() {
                    this.nextSibling && this.parentNode.appendChild(this);
                }
                function S() {
                    this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
                }
                m.prototype = {
                    add: function(A) {
                        this._names.indexOf(A) < 0 && (this._names.push(A), this._node.setAttribute("class", this._names.join(" ")));
                    },
                    remove: function(A) {
                        var t = this._names.indexOf(A);
                        t >= 0 && (this._names.splice(t, 1), this._node.setAttribute("class", this._names.join(" ")));
                    },
                    contains: function(A) {
                        return this._names.indexOf(A) >= 0;
                    }
                };
                var L = e(1986);
                function k(A) {
                    return function() {
                        var t = this.ownerDocument, e = this.namespaceURI;
                        return e === L.P && t.documentElement.namespaceURI === L.P ? t.createElement(A) : t.createElementNS(e, A);
                    };
                }
                function P(A) {
                    return function() {
                        return this.ownerDocument.createElementNS(A.space, A.local);
                    };
                }
                function D(A) {
                    var t = (0, u.Z)(A);
                    return (t.local ? P : k)(t);
                }
                function R() {
                    return null;
                }
                function z() {
                    var A = this.parentNode;
                    A && A.removeChild(this);
                }
                function X() {
                    var A = this.cloneNode(!1), t = this.parentNode;
                    return t ? t.insertBefore(A, this.nextSibling) : A;
                }
                function V() {
                    var A = this.cloneNode(!0), t = this.parentNode;
                    return t ? t.insertBefore(A, this.nextSibling) : A;
                }
                var Y = e(5109), G = e(5021);
                function J(A, t, e) {
                    var n = (0, G.Z)(A), r = n.CustomEvent;
                    "function" == typeof r ? r = new r(t, e) : (r = n.document.createEvent("Event"), e ? (r.initEvent(t, e.bubbles, e.cancelable), r.detail = e.detail) : r.initEvent(t, !1, !1)), A.dispatchEvent(r);
                }
                function W(A, t) {
                    return function() {
                        return J(this, A, t);
                    };
                }
                function j(A, t) {
                    return function() {
                        return J(this, A, t.apply(this, arguments));
                    };
                }
                var Z = [
                    null
                ];
                function q(A, t) {
                    this._groups = A, this._parents = t;
                }
                function $() {
                    return new q([
                        [
                            document.documentElement
                        ]
                    ], Z);
                }
                q.prototype = $.prototype = {
                    constructor: q,
                    select: function(A) {
                        "function" != typeof A && (A = (0, n.Z)(A));
                        for(var t = this._groups, e = t.length, r = new Array(e), a = 0; a < e; ++a)for(var i, o, s = t[a], c = s.length, l = r[a] = new Array(c), u = 0; u < c; ++u)(i = s[u]) && (o = A.call(i, i.__data__, u, s)) && ("__data__" in i && (o.__data__ = i.__data__), l[u] = o);
                        return new q(r, this._parents);
                    },
                    selectAll: function(A) {
                        "function" != typeof A && (A = (0, r.Z)(A));
                        for(var t = this._groups, e = t.length, n = [], a = [], i = 0; i < e; ++i)for(var o, s = t[i], c = s.length, l = 0; l < c; ++l)(o = s[l]) && (n.push(A.call(o, o.__data__, l, s)), a.push(o));
                        return new q(n, a);
                    },
                    filter: function(A) {
                        "function" != typeof A && (A = (0, a.Z)(A));
                        for(var t = this._groups, e = t.length, n = new Array(e), r = 0; r < e; ++r)for(var i, o = t[r], s = o.length, c = n[r] = [], l = 0; l < s; ++l)(i = o[l]) && A.call(i, i.__data__, l, o) && c.push(i);
                        return new q(n, this._parents);
                    },
                    data: function(A, t) {
                        if (!A) return g = new Array(this.size()), f = -1, this.each(function(A) {
                            g[++f] = A;
                        }), g;
                        var e, n = t ? c : s, r = this._parents, a = this._groups;
                        "function" != typeof A && (e = A, A = function() {
                            return e;
                        });
                        for(var i = a.length, o = new Array(i), l = new Array(i), u = new Array(i), f = 0; f < i; ++f){
                            var h = r[f], B = a[f], d = B.length, g = A.call(h, h && h.__data__, f, r), w = g.length, p = l[f] = new Array(w), Q = o[f] = new Array(w);
                            n(h, B, p, Q, u[f] = new Array(d), g, t);
                            for(var U, v, y = 0, C = 0; y < w; ++y)if (U = p[y]) {
                                for(y >= C && (C = y + 1); !(v = Q[C]) && ++C < w;);
                                U._next = v || null;
                            }
                        }
                        return (o = new q(o, r))._enter = l, o._exit = u, o;
                    },
                    enter: function() {
                        return new q(this._enter || this._groups.map(i), this._parents);
                    },
                    exit: function() {
                        return new q(this._exit || this._groups.map(i), this._parents);
                    },
                    join: function(A, t, e) {
                        var n = this.enter(), r = this, a = this.exit();
                        return n = "function" == typeof A ? A(n) : n.append(A + ""), null != t && (r = t(r)), null == e ? a.remove() : e(a), n && r ? n.merge(r).order() : r;
                    },
                    merge: function(A) {
                        for(var t = this._groups, e = A._groups, n = t.length, r = e.length, a = Math.min(n, r), i = new Array(n), o = 0; o < a; ++o)for(var s, c = t[o], l = e[o], u = c.length, f = i[o] = new Array(u), h = 0; h < u; ++h)(s = c[h] || l[h]) && (f[h] = s);
                        for(; o < n; ++o)i[o] = t[o];
                        return new q(i, this._parents);
                    },
                    order: function() {
                        for(var A = this._groups, t = -1, e = A.length; ++t < e;)for(var n, r = A[t], a = r.length - 1, i = r[a]; --a >= 0;)(n = r[a]) && (i && 4 ^ n.compareDocumentPosition(i) && i.parentNode.insertBefore(n, i), i = n);
                        return this;
                    },
                    sort: function(A) {
                        function t(t, e) {
                            return t && e ? A(t.__data__, e.__data__) : !t - !e;
                        }
                        A || (A = l);
                        for(var e = this._groups, n = e.length, r = new Array(n), a = 0; a < n; ++a){
                            for(var i, o = e[a], s = o.length, c = r[a] = new Array(s), u = 0; u < s; ++u)(i = o[u]) && (c[u] = i);
                            c.sort(t);
                        }
                        return new q(r, this._parents).order();
                    },
                    call: function() {
                        var A = arguments[0];
                        return arguments[0] = this, A.apply(null, arguments), this;
                    },
                    nodes: function() {
                        var A = new Array(this.size()), t = -1;
                        return this.each(function() {
                            A[++t] = this;
                        }), A;
                    },
                    node: function() {
                        for(var A = this._groups, t = 0, e = A.length; t < e; ++t)for(var n = A[t], r = 0, a = n.length; r < a; ++r){
                            var i = n[r];
                            if (i) return i;
                        }
                        return null;
                    },
                    size: function() {
                        var A = 0;
                        return this.each(function() {
                            ++A;
                        }), A;
                    },
                    empty: function() {
                        return !this.node();
                    },
                    each: function(A) {
                        for(var t = this._groups, e = 0, n = t.length; e < n; ++e)for(var r, a = t[e], i = 0, o = a.length; i < o; ++i)(r = a[i]) && A.call(r, r.__data__, i, a);
                        return this;
                    },
                    attr: function(A, t) {
                        var e = (0, u.Z)(A);
                        if (arguments.length < 2) {
                            var n = this.node();
                            return e.local ? n.getAttributeNS(e.space, e.local) : n.getAttribute(e);
                        }
                        return this.each((null == t ? e.local ? h : f : "function" == typeof t ? e.local ? w : g : e.local ? d : B)(e, t));
                    },
                    style: p.Z,
                    property: function(A, t) {
                        return arguments.length > 1 ? this.each((null == t ? Q : "function" == typeof t ? v : U)(A, t)) : this.node()[A];
                    },
                    classed: function(A, t) {
                        var e = y(A + "");
                        if (arguments.length < 2) {
                            for(var n = C(this.node()), r = -1, a = e.length; ++r < a;)if (!n.contains(e[r])) return !1;
                            return !0;
                        }
                        return this.each(("function" == typeof t ? H : t ? _ : b)(e, t));
                    },
                    text: function(A) {
                        return arguments.length ? this.each(null == A ? N : ("function" == typeof A ? M : I)(A)) : this.node().textContent;
                    },
                    html: function(A) {
                        return arguments.length ? this.each(null == A ? T : ("function" == typeof A ? K : x)(A)) : this.node().innerHTML;
                    },
                    raise: function() {
                        return this.each(O);
                    },
                    lower: function() {
                        return this.each(S);
                    },
                    append: function(A) {
                        var t = "function" == typeof A ? A : D(A);
                        return this.select(function() {
                            return this.appendChild(t.apply(this, arguments));
                        });
                    },
                    insert: function(A, t) {
                        var e = "function" == typeof A ? A : D(A), r = null == t ? R : "function" == typeof t ? t : (0, n.Z)(t);
                        return this.select(function() {
                            return this.insertBefore(e.apply(this, arguments), r.apply(this, arguments) || null);
                        });
                    },
                    remove: function() {
                        return this.each(z);
                    },
                    clone: function(A) {
                        return this.select(A ? V : X);
                    },
                    datum: function(A) {
                        return arguments.length ? this.property("__data__", A) : this.node().__data__;
                    },
                    on: Y.ZP,
                    dispatch: function(A, t) {
                        return this.each(("function" == typeof t ? j : W)(A, t));
                    }
                };
                const AA = $;
            },
            5109: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    B: ()=>r,
                    ZP: ()=>l,
                    _H: ()=>u
                });
                var n = {}, r = null;
                function a(A, t, e) {
                    return A = i(A, t, e), function(t) {
                        var e = t.relatedTarget;
                        e && (e === this || 8 & e.compareDocumentPosition(this)) || A.call(this, t);
                    };
                }
                function i(A, t, e) {
                    return function(n) {
                        var a = r;
                        r = n;
                        try {
                            A.call(this, this.__data__, t, e);
                        } finally{
                            r = a;
                        }
                    };
                }
                function o(A) {
                    return A.trim().split(/^|\s+/).map(function(A) {
                        var t = "", e = A.indexOf(".");
                        return e >= 0 && (t = A.slice(e + 1), A = A.slice(0, e)), {
                            type: A,
                            name: t
                        };
                    });
                }
                function s(A) {
                    return function() {
                        var t = this.__on;
                        if (t) {
                            for(var e, n = 0, r = -1, a = t.length; n < a; ++n)e = t[n], A.type && e.type !== A.type || e.name !== A.name ? t[++r] = e : this.removeEventListener(e.type, e.listener, e.capture);
                            ++r ? t.length = r : delete this.__on;
                        }
                    };
                }
                function c(A, t, e) {
                    var r = n.hasOwnProperty(A.type) ? a : i;
                    return function(n, a, i) {
                        var o, s = this.__on, c = r(t, a, i);
                        if (s) {
                            for(var l = 0, u = s.length; l < u; ++l)if ((o = s[l]).type === A.type && o.name === A.name) return this.removeEventListener(o.type, o.listener, o.capture), this.addEventListener(o.type, o.listener = c, o.capture = e), void (o.value = t);
                        }
                        this.addEventListener(A.type, c, e), o = {
                            type: A.type,
                            name: A.name,
                            value: t,
                            listener: c,
                            capture: e
                        }, s ? s.push(o) : this.__on = [
                            o
                        ];
                    };
                }
                function l(A, t, e) {
                    var n, r, a = o(A + ""), i = a.length;
                    if (!(arguments.length < 2)) {
                        for(l = t ? c : s, null == e && (e = !1), n = 0; n < i; ++n)this.each(l(a[n], t, e));
                        return this;
                    }
                    var l = this.node().__on;
                    if (l) {
                        for(var u, f = 0, h = l.length; f < h; ++f)for(n = 0, u = l[f]; n < i; ++n)if ((r = a[n]).type === u.type && r.name === u.name) return u.value;
                    }
                }
                function u(A, t, e, n) {
                    var a = r;
                    A.sourceEvent = r, r = A;
                    try {
                        return t.apply(e, n);
                    } finally{
                        r = a;
                    }
                }
                "undefined" != typeof document && ("onmouseenter" in document.documentElement || (n = {
                    mouseenter: "mouseover",
                    mouseleave: "mouseout"
                }));
            },
            9986: (A, t, e)=>{
                "use strict";
                e.d(t, {
                    Z: ()=>o,
                    S: ()=>s
                });
                var n = e(5021);
                function r(A) {
                    return function() {
                        this.style.removeProperty(A);
                    };
                }
                function a(A, t, e) {
                    return function() {
                        this.style.setProperty(A, t, e);
                    };
                }
                function i(A, t, e) {
                    return function() {
                        var n = t.apply(this, arguments);
                        null == n ? this.style.removeProperty(A) : this.style.setProperty(A, n, e);
                    };
                }
                function o(A, t, e) {
                    return arguments.length > 1 ? this.each((null == t ? r : "function" == typeof t ? i : a)(A, t, null == e ? "" : e)) : s(this.node(), A);
                }
                function s(A, t) {
                    return A.style.getPropertyValue(t) || (0, n.Z)(A).getComputedStyle(A, null).getPropertyValue(t);
                }
            },
            2634: (A, t, e)=>{
                "use strict";
                function n() {}
                function r(A) {
                    return null == A ? n : function() {
                        return this.querySelector(A);
                    };
                }
                e.d(t, {
                    Z: ()=>r
                });
            },
            3545: (A, t, e)=>{
                "use strict";
                function n() {
                    return [];
                }
                function r(A) {
                    return null == A ? n : function() {
                        return this.querySelectorAll(A);
                    };
                }
                e.d(t, {
                    Z: ()=>r
                });
            },
            5021: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return A.ownerDocument && A.ownerDocument.defaultView || A.document && A || A.defaultView;
                }
                e.d(t, {
                    Z: ()=>n
                });
            },
            3072: (A, t, e)=>{
                "use strict";
                function n(A) {
                    return function() {
                        return A;
                    };
                }
                e.d(t, {
                    Z: ()=>n
                });
            },
            2466: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;
                t.parseAngle = function(A) {
                    var t = A.match(e);
                    if (t) {
                        var n = parseFloat(t[1]);
                        switch(t[2].toLowerCase()){
                            case "deg":
                                return Math.PI * n / 180;
                            case "grad":
                                return Math.PI / 200 * n;
                            case "rad":
                                return n;
                            case "turn":
                                return 2 * Math.PI * n;
                        }
                    }
                    return null;
                };
            },
            2140: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseBoundCurves = t.calculatePaddingBoxPath = t.calculateBorderBoxPath = t.parsePathForBorder = t.parseDocumentSize = t.calculateContentBox = t.calculatePaddingBox = t.parseBounds = t.Bounds = void 0;
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = i(e(9811)), a = i(e(3150));
                function i(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                var o = t.Bounds = function() {
                    function A(t, e, n, r) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.left = t, this.top = e, this.width = n, this.height = r;
                    }
                    return n(A, null, [
                        {
                            key: "fromClientRect",
                            value: function(t, e, n) {
                                return new A(t.left + e, t.top + n, t.width, t.height);
                            }
                        }
                    ]), A;
                }(), s = (t.parseBounds = function(A, t, e) {
                    return o.fromClientRect(A.getBoundingClientRect(), t, e);
                }, t.calculatePaddingBox = function(A, t) {
                    return new o(A.left + t[3].borderWidth, A.top + t[0].borderWidth, A.width - (t[1].borderWidth + t[3].borderWidth), A.height - (t[0].borderWidth + t[2].borderWidth));
                }, t.calculateContentBox = function(A, t, e) {
                    var n = t[0].value, r = t[1].value, a = t[2].value, i = t[3].value;
                    return new o(A.left + i + e[3].borderWidth, A.top + n + e[0].borderWidth, A.width - (e[1].borderWidth + e[3].borderWidth + i + r), A.height - (e[0].borderWidth + e[2].borderWidth + n + a));
                }, t.parseDocumentSize = function(A) {
                    var t = A.body, e = A.documentElement;
                    if (!t || !e) throw new Error("");
                    var n = Math.max(Math.max(t.scrollWidth, e.scrollWidth), Math.max(t.offsetWidth, e.offsetWidth), Math.max(t.clientWidth, e.clientWidth)), r = Math.max(Math.max(t.scrollHeight, e.scrollHeight), Math.max(t.offsetHeight, e.offsetHeight), Math.max(t.clientHeight, e.clientHeight));
                    return new o(0, 0, n, r);
                }, t.parsePathForBorder = function(A, t) {
                    switch(t){
                        case 0:
                            return s(A.topLeftOuter, A.topLeftInner, A.topRightOuter, A.topRightInner);
                        case 1:
                            return s(A.topRightOuter, A.topRightInner, A.bottomRightOuter, A.bottomRightInner);
                        case 2:
                            return s(A.bottomRightOuter, A.bottomRightInner, A.bottomLeftOuter, A.bottomLeftInner);
                        case 3:
                        default:
                            return s(A.bottomLeftOuter, A.bottomLeftInner, A.topLeftOuter, A.topLeftInner);
                    }
                }, function(A, t, e, n) {
                    var r = [];
                    return A instanceof a.default ? r.push(A.subdivide(.5, !1)) : r.push(A), e instanceof a.default ? r.push(e.subdivide(.5, !0)) : r.push(e), n instanceof a.default ? r.push(n.subdivide(.5, !0).reverse()) : r.push(n), t instanceof a.default ? r.push(t.subdivide(.5, !1).reverse()) : r.push(t), r;
                }), c = (t.calculateBorderBoxPath = function(A) {
                    return [
                        A.topLeftOuter,
                        A.topRightOuter,
                        A.bottomRightOuter,
                        A.bottomLeftOuter
                    ];
                }, t.calculatePaddingBoxPath = function(A) {
                    return [
                        A.topLeftInner,
                        A.topRightInner,
                        A.bottomRightInner,
                        A.bottomLeftInner
                    ];
                }, t.parseBoundCurves = function(A, t, e) {
                    var n = e[c.TOP_LEFT][0].getAbsoluteValue(A.width), a = e[c.TOP_LEFT][1].getAbsoluteValue(A.height), i = e[c.TOP_RIGHT][0].getAbsoluteValue(A.width), o = e[c.TOP_RIGHT][1].getAbsoluteValue(A.height), s = e[c.BOTTOM_RIGHT][0].getAbsoluteValue(A.width), u = e[c.BOTTOM_RIGHT][1].getAbsoluteValue(A.height), f = e[c.BOTTOM_LEFT][0].getAbsoluteValue(A.width), h = e[c.BOTTOM_LEFT][1].getAbsoluteValue(A.height), B = [];
                    B.push((n + i) / A.width), B.push((f + s) / A.width), B.push((a + h) / A.height), B.push((o + u) / A.height);
                    var d = Math.max.apply(Math, B);
                    d > 1 && (n /= d, a /= d, i /= d, o /= d, s /= d, u /= d, f /= d, h /= d);
                    var g = A.width - i, w = A.height - u, p = A.width - s, Q = A.height - h;
                    return {
                        topLeftOuter: n > 0 || a > 0 ? l(A.left, A.top, n, a, c.TOP_LEFT) : new r.default(A.left, A.top),
                        topLeftInner: n > 0 || a > 0 ? l(A.left + t[3].borderWidth, A.top + t[0].borderWidth, Math.max(0, n - t[3].borderWidth), Math.max(0, a - t[0].borderWidth), c.TOP_LEFT) : new r.default(A.left + t[3].borderWidth, A.top + t[0].borderWidth),
                        topRightOuter: i > 0 || o > 0 ? l(A.left + g, A.top, i, o, c.TOP_RIGHT) : new r.default(A.left + A.width, A.top),
                        topRightInner: i > 0 || o > 0 ? l(A.left + Math.min(g, A.width + t[3].borderWidth), A.top + t[0].borderWidth, g > A.width + t[3].borderWidth ? 0 : i - t[3].borderWidth, o - t[0].borderWidth, c.TOP_RIGHT) : new r.default(A.left + A.width - t[1].borderWidth, A.top + t[0].borderWidth),
                        bottomRightOuter: s > 0 || u > 0 ? l(A.left + p, A.top + w, s, u, c.BOTTOM_RIGHT) : new r.default(A.left + A.width, A.top + A.height),
                        bottomRightInner: s > 0 || u > 0 ? l(A.left + Math.min(p, A.width - t[3].borderWidth), A.top + Math.min(w, A.height + t[0].borderWidth), Math.max(0, s - t[1].borderWidth), u - t[2].borderWidth, c.BOTTOM_RIGHT) : new r.default(A.left + A.width - t[1].borderWidth, A.top + A.height - t[2].borderWidth),
                        bottomLeftOuter: f > 0 || h > 0 ? l(A.left, A.top + Q, f, h, c.BOTTOM_LEFT) : new r.default(A.left, A.top + A.height),
                        bottomLeftInner: f > 0 || h > 0 ? l(A.left + t[3].borderWidth, A.top + Q, Math.max(0, f - t[3].borderWidth), h - t[2].borderWidth, c.BOTTOM_LEFT) : new r.default(A.left + t[3].borderWidth, A.top + A.height - t[2].borderWidth)
                    };
                }, {
                    TOP_LEFT: 0,
                    TOP_RIGHT: 1,
                    BOTTOM_RIGHT: 2,
                    BOTTOM_LEFT: 3
                }), l = function(A, t, e, n, i) {
                    var o = (Math.sqrt(2) - 1) / 3 * 4, s = e * o, l = n * o, u = A + e, f = t + n;
                    switch(i){
                        case c.TOP_LEFT:
                            return new a.default(new r.default(A, f), new r.default(A, f - l), new r.default(u - s, t), new r.default(u, t));
                        case c.TOP_RIGHT:
                            return new a.default(new r.default(A, t), new r.default(A + s, t), new r.default(u, f - l), new r.default(u, f));
                        case c.BOTTOM_RIGHT:
                            return new a.default(new r.default(u, t), new r.default(u, t + l), new r.default(A + s, f), new r.default(A, f));
                        case c.BOTTOM_LEFT:
                        default:
                            return new a.default(new r.default(u, f), new r.default(u - s, f), new r.default(A, t + l), new r.default(A, t));
                    }
                };
            },
            8959: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.cloneWindow = t.DocumentCloner = void 0;
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = e(2140), a = e(8409), i = u(e(6248)), o = e(5627), s = e(389), c = u(e(6875)), l = e(3779);
                function u(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                var f = "data-html2canvas-ignore", h = t.DocumentCloner = function() {
                    function A(t, e, n, r, a) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.referenceElement = t, this.scrolledElements = [], this.copyStyles = r, this.inlineImages = r, this.logger = n, this.options = e, this.renderer = a, this.resourceLoader = new i.default(e, n, window), this.pseudoContentData = {
                            counters: {},
                            quoteDepth: 0
                        }, this.documentElement = this.cloneNode(t.ownerDocument.documentElement);
                    }
                    return n(A, [
                        {
                            key: "inlineAllImages",
                            value: function(A) {
                                var t = this;
                                if (this.inlineImages && A) {
                                    var e = A.style;
                                    Promise.all((0, s.parseBackgroundImage)(e.backgroundImage).map(function(A) {
                                        return "url" === A.method ? t.resourceLoader.inlineImage(A.args[0]).then(function(A) {
                                            return A && "string" == typeof A.src ? 'url("' + A.src + '")' : "none";
                                        }).catch(function(A) {}) : Promise.resolve("" + A.prefix + A.method + "(" + A.args.join(",") + ")");
                                    })).then(function(A) {
                                        A.length > 1 && (e.backgroundColor = ""), e.backgroundImage = A.join(",");
                                    }), A instanceof HTMLImageElement && this.resourceLoader.inlineImage(A.src).then(function(t) {
                                        if (t && A instanceof HTMLImageElement && A.parentNode) {
                                            var e = A.parentNode, n = (0, o.copyCSSStyles)(A.style, t.cloneNode(!1));
                                            e.replaceChild(n, A);
                                        }
                                    }).catch(function(A) {});
                                }
                            }
                        },
                        {
                            key: "inlineFonts",
                            value: function(A) {
                                var t = this;
                                return Promise.all(Array.from(A.styleSheets).map(function(t) {
                                    return t.href ? fetch(t.href).then(function(A) {
                                        return A.text();
                                    }).then(function(A) {
                                        return d(A, t.href);
                                    }).catch(function(A) {
                                        return [];
                                    }) : B(t, A);
                                })).then(function(A) {
                                    return A.reduce(function(A, t) {
                                        return A.concat(t);
                                    }, []);
                                }).then(function(A) {
                                    return Promise.all(A.map(function(A) {
                                        return fetch(A.formats[0].src).then(function(A) {
                                            return A.blob();
                                        }).then(function(A) {
                                            return new Promise(function(t, e) {
                                                var n = new FileReader;
                                                n.onerror = e, n.onload = function() {
                                                    var A = n.result;
                                                    t(A);
                                                }, n.readAsDataURL(A);
                                            });
                                        }).then(function(t) {
                                            return A.fontFace.setProperty("src", 'url("' + t + '")'), "@font-face {" + A.fontFace.cssText + " ";
                                        });
                                    }));
                                }).then(function(e) {
                                    var n = A.createElement("style");
                                    n.textContent = e.join("\n"), t.documentElement.appendChild(n);
                                });
                            }
                        },
                        {
                            key: "createElementClone",
                            value: function(A) {
                                var t = this;
                                if (this.copyStyles && A instanceof HTMLCanvasElement) {
                                    var e = A.ownerDocument.createElement("img");
                                    try {
                                        return e.src = A.toDataURL(), e;
                                    } catch (A) {}
                                }
                                if (A instanceof HTMLIFrameElement) {
                                    var n = A.cloneNode(!1), a = F();
                                    n.setAttribute("data-html2canvas-internal-iframe-key", a);
                                    var i = (0, r.parseBounds)(A, 0, 0), s = i.width, l = i.height;
                                    return this.resourceLoader.cache[a] = b(A, this.options).then(function(A) {
                                        return t.renderer(A, {
                                            async: t.options.async,
                                            allowTaint: t.options.allowTaint,
                                            backgroundColor: "#ffffff",
                                            canvas: null,
                                            imageTimeout: t.options.imageTimeout,
                                            logging: t.options.logging,
                                            proxy: t.options.proxy,
                                            removeContainer: t.options.removeContainer,
                                            scale: t.options.scale,
                                            foreignObjectRendering: t.options.foreignObjectRendering,
                                            useCORS: t.options.useCORS,
                                            target: new c.default,
                                            width: s,
                                            height: l,
                                            x: 0,
                                            y: 0,
                                            windowWidth: A.ownerDocument.defaultView.innerWidth,
                                            windowHeight: A.ownerDocument.defaultView.innerHeight,
                                            scrollX: A.ownerDocument.defaultView.pageXOffset,
                                            scrollY: A.ownerDocument.defaultView.pageYOffset
                                        }, t.logger.child(a));
                                    }).then(function(t) {
                                        return new Promise(function(e, r) {
                                            var a = document.createElement("img");
                                            a.onload = function() {
                                                return e(t);
                                            }, a.onerror = r, a.src = t.toDataURL(), n.parentNode && n.parentNode.replaceChild((0, o.copyCSSStyles)(A.ownerDocument.defaultView.getComputedStyle(A), a), n);
                                        });
                                    }), n;
                                }
                                if (A instanceof HTMLStyleElement && A.sheet && A.sheet.cssRules) {
                                    var u = [].slice.call(A.sheet.cssRules, 0).reduce(function(A, e) {
                                        try {
                                            return e && e.cssText ? A + e.cssText : A;
                                        } catch (n) {
                                            return t.logger.log("Unable to access cssText property", e.name), A;
                                        }
                                    }, ""), f = A.cloneNode(!1);
                                    return f.textContent = u, f;
                                }
                                return A.cloneNode(!1);
                            }
                        },
                        {
                            key: "cloneNode",
                            value: function(A) {
                                var t = A.nodeType === Node.TEXT_NODE ? document.createTextNode(A.nodeValue) : this.createElementClone(A), e = A.ownerDocument.defaultView, n = A instanceof e.HTMLElement ? e.getComputedStyle(A) : null, r = A instanceof e.HTMLElement ? e.getComputedStyle(A, ":before") : null, a = A instanceof e.HTMLElement ? e.getComputedStyle(A, ":after") : null;
                                this.referenceElement === A && t instanceof e.HTMLElement && (this.clonedReferenceElement = t), t instanceof e.HTMLBodyElement && C(t);
                                for(var i = (0, l.parseCounterReset)(n, this.pseudoContentData), s = (0, l.resolvePseudoContent)(A, r, this.pseudoContentData), c = A.firstChild; c; c = c.nextSibling)c.nodeType === Node.ELEMENT_NODE && ("SCRIPT" === c.nodeName || c.hasAttribute(f) || "function" == typeof this.options.ignoreElements && this.options.ignoreElements(c)) || this.copyStyles && "STYLE" === c.nodeName || t.appendChild(this.cloneNode(c));
                                var u = (0, l.resolvePseudoContent)(A, a, this.pseudoContentData);
                                if ((0, l.popCounters)(i, this.pseudoContentData), A instanceof e.HTMLElement && t instanceof e.HTMLElement) switch(r && this.inlineAllImages(w(A, t, r, s, p)), a && this.inlineAllImages(w(A, t, a, u, Q)), !n || !this.copyStyles || A instanceof HTMLIFrameElement || (0, o.copyCSSStyles)(n, t), this.inlineAllImages(t), 0 === A.scrollTop && 0 === A.scrollLeft || this.scrolledElements.push([
                                    t,
                                    A.scrollLeft,
                                    A.scrollTop
                                ]), A.nodeName){
                                    case "CANVAS":
                                        this.copyStyles || g(A, t);
                                        break;
                                    case "TEXTAREA":
                                    case "SELECT":
                                        t.value = A.value;
                                }
                                return t;
                            }
                        }
                    ]), A;
                }(), B = function(A, t) {
                    return (A.cssRules ? Array.from(A.cssRules) : []).filter(function(A) {
                        return A.type === CSSRule.FONT_FACE_RULE;
                    }).map(function(A) {
                        for(var e = (0, s.parseBackgroundImage)(A.style.getPropertyValue("src")), n = [], r = 0; r < e.length; r++)if ("url" === e[r].method && e[r + 1] && "format" === e[r + 1].method) {
                            var a = t.createElement("a");
                            a.href = e[r].args[0], t.body && t.body.appendChild(a);
                            var i = {
                                src: a.href,
                                format: e[r + 1].args[0]
                            };
                            n.push(i);
                        }
                        return {
                            formats: n.filter(function(A) {
                                return /^woff/i.test(A.format);
                            }),
                            fontFace: A.style
                        };
                    }).filter(function(A) {
                        return A.formats.length;
                    });
                }, d = function(A, t) {
                    var e = document.implementation.createHTMLDocument(""), n = document.createElement("base");
                    n.href = t;
                    var r = document.createElement("style");
                    return r.textContent = A, e.head && e.head.appendChild(n), e.body && e.body.appendChild(r), r.sheet ? B(r.sheet, e) : [];
                }, g = function(A, t) {
                    try {
                        if (t) {
                            t.width = A.width, t.height = A.height;
                            var e = A.getContext("2d"), n = t.getContext("2d");
                            e ? n.putImageData(e.getImageData(0, 0, A.width, A.height), 0, 0) : n.drawImage(A, 0, 0);
                        }
                    } catch (A) {}
                }, w = function(A, t, e, n, r) {
                    if (e && e.content && "none" !== e.content && "-moz-alt-content" !== e.content && "none" !== e.display) {
                        var a = t.ownerDocument.createElement("html2canvaspseudoelement");
                        if ((0, o.copyCSSStyles)(e, a), n) for(var i = n.length, c = 0; c < i; c++){
                            var u = n[c];
                            switch(u.type){
                                case l.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
                                    var f = t.ownerDocument.createElement("img");
                                    f.src = (0, s.parseBackgroundImage)("url(" + u.value + ")")[0].args[0], f.style.opacity = "1", a.appendChild(f);
                                    break;
                                case l.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
                                    a.appendChild(t.ownerDocument.createTextNode(u.value));
                            }
                        }
                        return a.className = U + " " + v, t.className += r === p ? " " + U : " " + v, r === p ? t.insertBefore(a, t.firstChild) : t.appendChild(a), a;
                    }
                }, p = ":before", Q = ":after", U = "___html2canvas___pseudoelement_before", v = "___html2canvas___pseudoelement_after", y = '{\n    content: "" !important;\n    display: none !important;\n}', C = function(A) {
                    m(A, "." + U + p + y + "\n         ." + v + Q + y);
                }, m = function(A, t) {
                    var e = A.ownerDocument.createElement("style");
                    e.innerHTML = t, A.appendChild(e);
                }, E = function(A) {
                    var t = function(A, t) {
                        if (Array.isArray(A)) return A;
                        if (Symbol.iterator in Object(A)) return function(A, t) {
                            var e = [], n = !0, r = !1, a = void 0;
                            try {
                                for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                            } catch (A) {
                                r = !0, a = A;
                            } finally{
                                try {
                                    !n && o.return && o.return();
                                } finally{
                                    if (r) throw a;
                                }
                            }
                            return e;
                        }(A, t);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }(A, 3), e = t[0], n = t[1], r = t[2];
                    e.scrollLeft = n, e.scrollTop = r;
                }, F = function() {
                    return Math.ceil(Date.now() + 1e7 * Math.random()).toString(16);
                }, _ = /^data:text\/(.+);(base64)?,(.*)$/i, b = function(A, t) {
                    try {
                        return Promise.resolve(A.contentWindow.document.documentElement);
                    } catch (e) {
                        return t.proxy ? (0, a.Proxy)(A.src, t).then(function(A) {
                            var t = A.match(_);
                            return t ? "base64" === t[2] ? window.atob(decodeURIComponent(t[3])) : decodeURIComponent(t[3]) : Promise.reject();
                        }).then(function(t) {
                            return H(A.ownerDocument, (0, r.parseBounds)(A, 0, 0)).then(function(A) {
                                var e = A.contentWindow.document;
                                e.open(), e.write(t);
                                var n = N(A).then(function() {
                                    return e.documentElement;
                                });
                                return e.close(), n;
                            });
                        }) : Promise.reject();
                    }
                }, H = function(A, t) {
                    var e = A.createElement("iframe");
                    return e.className = "html2canvas-container", e.style.visibility = "hidden", e.style.position = "fixed", e.style.left = "-10000px", e.style.top = "0px", e.style.border = "0", e.width = t.width.toString(), e.height = t.height.toString(), e.scrolling = "no", e.setAttribute(f, "true"), A.body ? (A.body.appendChild(e), Promise.resolve(e)) : Promise.reject("");
                }, N = function(A) {
                    var t = A.contentWindow, e = t.document;
                    return new Promise(function(n, r) {
                        t.onload = A.onload = e.onreadystatechange = function() {
                            var t = setInterval(function() {
                                e.body.childNodes.length > 0 && "complete" === e.readyState && (clearInterval(t), n(A));
                            }, 50);
                        };
                    });
                }, I = (t.cloneWindow = function(A, t, e, n, r, a) {
                    var i = new h(e, n, r, !1, a), o = A.defaultView.pageXOffset, s = A.defaultView.pageYOffset;
                    return H(A, t).then(function(r) {
                        var a = r.contentWindow, c = a.document, l = N(r).then(function() {
                            i.scrolledElements.forEach(E), a.scrollTo(t.left, t.top), !/(iPad|iPhone|iPod)/g.test(navigator.userAgent) || a.scrollY === t.top && a.scrollX === t.left || (c.documentElement.style.top = -t.top + "px", c.documentElement.style.left = -t.left + "px", c.documentElement.style.position = "absolute");
                            var e = Promise.resolve([
                                r,
                                i.clonedReferenceElement,
                                i.resourceLoader
                            ]), o = n.onclone;
                            return i.clonedReferenceElement instanceof a.HTMLElement || i.clonedReferenceElement instanceof A.defaultView.HTMLElement || i.clonedReferenceElement instanceof HTMLElement ? "function" == typeof o ? Promise.resolve().then(function() {
                                return o(c);
                            }).then(function() {
                                return e;
                            }) : e : Promise.reject("");
                        });
                        return c.open(), c.write(I(document.doctype) + "<html></html>"), function(A, t, e) {
                            !A.defaultView || t === A.defaultView.pageXOffset && e === A.defaultView.pageYOffset || A.defaultView.scrollTo(t, e);
                        }(e.ownerDocument, o, s), c.replaceChild(c.adoptNode(i.documentElement), c.documentElement), c.close(), l;
                    });
                }, function(A) {
                    var t = "";
                    return A && (t += "<!DOCTYPE ", A.name && (t += A.name), A.internalSubset && (t += A.internalSubset), A.publicId && (t += '"' + A.publicId + '"'), A.systemId && (t += '"' + A.systemId + '"'), t += ">"), t;
                });
            },
            8785: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), n = /^#([a-f0-9]{3})$/i, r = /^#([a-f0-9]{6})$/i, a = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/, i = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/, o = function() {
                    function A(t) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A);
                        var e, o = function(A, t) {
                            if (Array.isArray(A)) return A;
                            if (Symbol.iterator in Object(A)) return function(A, t) {
                                var e = [], n = !0, r = !1, a = void 0;
                                try {
                                    for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                                } catch (A) {
                                    r = !0, a = A;
                                } finally{
                                    try {
                                        !n && o.return && o.return();
                                    } finally{
                                        if (r) throw a;
                                    }
                                }
                                return e;
                            }(A, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance");
                        }(Array.isArray(t) ? (e = t, [
                            Math.min(e[0], 255),
                            Math.min(e[1], 255),
                            Math.min(e[2], 255),
                            e.length > 3 ? e[3] : null
                        ]) : function(A) {
                            var t = A.match(n);
                            return !!t && [
                                parseInt(t[1][0] + t[1][0], 16),
                                parseInt(t[1][1] + t[1][1], 16),
                                parseInt(t[1][2] + t[1][2], 16),
                                null
                            ];
                        }(t) || function(A) {
                            var t = A.match(a);
                            return !!t && [
                                Number(t[1]),
                                Number(t[2]),
                                Number(t[3]),
                                null
                            ];
                        }(t) || function(A) {
                            var t = A.match(i);
                            return !!(t && t.length > 4) && [
                                Number(t[1]),
                                Number(t[2]),
                                Number(t[3]),
                                Number(t[4])
                            ];
                        }(t) || s[t.toLowerCase()] || !1 || function(A) {
                            var t = A.match(r);
                            return !!t && [
                                parseInt(t[1].substring(0, 2), 16),
                                parseInt(t[1].substring(2, 4), 16),
                                parseInt(t[1].substring(4, 6), 16),
                                null
                            ];
                        }(t) || [
                            0,
                            0,
                            0,
                            null
                        ], 4), c = o[0], l = o[1], u = o[2], f = o[3];
                        this.r = c, this.g = l, this.b = u, this.a = f;
                    }
                    return e(A, [
                        {
                            key: "isTransparent",
                            value: function() {
                                return 0 === this.a;
                            }
                        },
                        {
                            key: "toString",
                            value: function() {
                                return null !== this.a && 1 !== this.a ? "rgba(" + this.r + "," + this.g + "," + this.b + "," + this.a + ")" : "rgb(" + this.r + "," + this.g + "," + this.b + ")";
                            }
                        }
                    ]), A;
                }();
                t.default = o;
                var s = {
                    transparent: [
                        0,
                        0,
                        0,
                        0
                    ],
                    aliceblue: [
                        240,
                        248,
                        255,
                        null
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215,
                        null
                    ],
                    aqua: [
                        0,
                        255,
                        255,
                        null
                    ],
                    aquamarine: [
                        127,
                        255,
                        212,
                        null
                    ],
                    azure: [
                        240,
                        255,
                        255,
                        null
                    ],
                    beige: [
                        245,
                        245,
                        220,
                        null
                    ],
                    bisque: [
                        255,
                        228,
                        196,
                        null
                    ],
                    black: [
                        0,
                        0,
                        0,
                        null
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205,
                        null
                    ],
                    blue: [
                        0,
                        0,
                        255,
                        null
                    ],
                    blueviolet: [
                        138,
                        43,
                        226,
                        null
                    ],
                    brown: [
                        165,
                        42,
                        42,
                        null
                    ],
                    burlywood: [
                        222,
                        184,
                        135,
                        null
                    ],
                    cadetblue: [
                        95,
                        158,
                        160,
                        null
                    ],
                    chartreuse: [
                        127,
                        255,
                        0,
                        null
                    ],
                    chocolate: [
                        210,
                        105,
                        30,
                        null
                    ],
                    coral: [
                        255,
                        127,
                        80,
                        null
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237,
                        null
                    ],
                    cornsilk: [
                        255,
                        248,
                        220,
                        null
                    ],
                    crimson: [
                        220,
                        20,
                        60,
                        null
                    ],
                    cyan: [
                        0,
                        255,
                        255,
                        null
                    ],
                    darkblue: [
                        0,
                        0,
                        139,
                        null
                    ],
                    darkcyan: [
                        0,
                        139,
                        139,
                        null
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11,
                        null
                    ],
                    darkgray: [
                        169,
                        169,
                        169,
                        null
                    ],
                    darkgreen: [
                        0,
                        100,
                        0,
                        null
                    ],
                    darkgrey: [
                        169,
                        169,
                        169,
                        null
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107,
                        null
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139,
                        null
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47,
                        null
                    ],
                    darkorange: [
                        255,
                        140,
                        0,
                        null
                    ],
                    darkorchid: [
                        153,
                        50,
                        204,
                        null
                    ],
                    darkred: [
                        139,
                        0,
                        0,
                        null
                    ],
                    darksalmon: [
                        233,
                        150,
                        122,
                        null
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143,
                        null
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139,
                        null
                    ],
                    darkslategray: [
                        47,
                        79,
                        79,
                        null
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79,
                        null
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209,
                        null
                    ],
                    darkviolet: [
                        148,
                        0,
                        211,
                        null
                    ],
                    deeppink: [
                        255,
                        20,
                        147,
                        null
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255,
                        null
                    ],
                    dimgray: [
                        105,
                        105,
                        105,
                        null
                    ],
                    dimgrey: [
                        105,
                        105,
                        105,
                        null
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255,
                        null
                    ],
                    firebrick: [
                        178,
                        34,
                        34,
                        null
                    ],
                    floralwhite: [
                        255,
                        250,
                        240,
                        null
                    ],
                    forestgreen: [
                        34,
                        139,
                        34,
                        null
                    ],
                    fuchsia: [
                        255,
                        0,
                        255,
                        null
                    ],
                    gainsboro: [
                        220,
                        220,
                        220,
                        null
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255,
                        null
                    ],
                    gold: [
                        255,
                        215,
                        0,
                        null
                    ],
                    goldenrod: [
                        218,
                        165,
                        32,
                        null
                    ],
                    gray: [
                        128,
                        128,
                        128,
                        null
                    ],
                    green: [
                        0,
                        128,
                        0,
                        null
                    ],
                    greenyellow: [
                        173,
                        255,
                        47,
                        null
                    ],
                    grey: [
                        128,
                        128,
                        128,
                        null
                    ],
                    honeydew: [
                        240,
                        255,
                        240,
                        null
                    ],
                    hotpink: [
                        255,
                        105,
                        180,
                        null
                    ],
                    indianred: [
                        205,
                        92,
                        92,
                        null
                    ],
                    indigo: [
                        75,
                        0,
                        130,
                        null
                    ],
                    ivory: [
                        255,
                        255,
                        240,
                        null
                    ],
                    khaki: [
                        240,
                        230,
                        140,
                        null
                    ],
                    lavender: [
                        230,
                        230,
                        250,
                        null
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245,
                        null
                    ],
                    lawngreen: [
                        124,
                        252,
                        0,
                        null
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205,
                        null
                    ],
                    lightblue: [
                        173,
                        216,
                        230,
                        null
                    ],
                    lightcoral: [
                        240,
                        128,
                        128,
                        null
                    ],
                    lightcyan: [
                        224,
                        255,
                        255,
                        null
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210,
                        null
                    ],
                    lightgray: [
                        211,
                        211,
                        211,
                        null
                    ],
                    lightgreen: [
                        144,
                        238,
                        144,
                        null
                    ],
                    lightgrey: [
                        211,
                        211,
                        211,
                        null
                    ],
                    lightpink: [
                        255,
                        182,
                        193,
                        null
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122,
                        null
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170,
                        null
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250,
                        null
                    ],
                    lightslategray: [
                        119,
                        136,
                        153,
                        null
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153,
                        null
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222,
                        null
                    ],
                    lightyellow: [
                        255,
                        255,
                        224,
                        null
                    ],
                    lime: [
                        0,
                        255,
                        0,
                        null
                    ],
                    limegreen: [
                        50,
                        205,
                        50,
                        null
                    ],
                    linen: [
                        250,
                        240,
                        230,
                        null
                    ],
                    magenta: [
                        255,
                        0,
                        255,
                        null
                    ],
                    maroon: [
                        128,
                        0,
                        0,
                        null
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170,
                        null
                    ],
                    mediumblue: [
                        0,
                        0,
                        205,
                        null
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211,
                        null
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219,
                        null
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113,
                        null
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238,
                        null
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154,
                        null
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204,
                        null
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133,
                        null
                    ],
                    midnightblue: [
                        25,
                        25,
                        112,
                        null
                    ],
                    mintcream: [
                        245,
                        255,
                        250,
                        null
                    ],
                    mistyrose: [
                        255,
                        228,
                        225,
                        null
                    ],
                    moccasin: [
                        255,
                        228,
                        181,
                        null
                    ],
                    navajowhite: [
                        255,
                        222,
                        173,
                        null
                    ],
                    navy: [
                        0,
                        0,
                        128,
                        null
                    ],
                    oldlace: [
                        253,
                        245,
                        230,
                        null
                    ],
                    olive: [
                        128,
                        128,
                        0,
                        null
                    ],
                    olivedrab: [
                        107,
                        142,
                        35,
                        null
                    ],
                    orange: [
                        255,
                        165,
                        0,
                        null
                    ],
                    orangered: [
                        255,
                        69,
                        0,
                        null
                    ],
                    orchid: [
                        218,
                        112,
                        214,
                        null
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170,
                        null
                    ],
                    palegreen: [
                        152,
                        251,
                        152,
                        null
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238,
                        null
                    ],
                    palevioletred: [
                        219,
                        112,
                        147,
                        null
                    ],
                    papayawhip: [
                        255,
                        239,
                        213,
                        null
                    ],
                    peachpuff: [
                        255,
                        218,
                        185,
                        null
                    ],
                    peru: [
                        205,
                        133,
                        63,
                        null
                    ],
                    pink: [
                        255,
                        192,
                        203,
                        null
                    ],
                    plum: [
                        221,
                        160,
                        221,
                        null
                    ],
                    powderblue: [
                        176,
                        224,
                        230,
                        null
                    ],
                    purple: [
                        128,
                        0,
                        128,
                        null
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153,
                        null
                    ],
                    red: [
                        255,
                        0,
                        0,
                        null
                    ],
                    rosybrown: [
                        188,
                        143,
                        143,
                        null
                    ],
                    royalblue: [
                        65,
                        105,
                        225,
                        null
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19,
                        null
                    ],
                    salmon: [
                        250,
                        128,
                        114,
                        null
                    ],
                    sandybrown: [
                        244,
                        164,
                        96,
                        null
                    ],
                    seagreen: [
                        46,
                        139,
                        87,
                        null
                    ],
                    seashell: [
                        255,
                        245,
                        238,
                        null
                    ],
                    sienna: [
                        160,
                        82,
                        45,
                        null
                    ],
                    silver: [
                        192,
                        192,
                        192,
                        null
                    ],
                    skyblue: [
                        135,
                        206,
                        235,
                        null
                    ],
                    slateblue: [
                        106,
                        90,
                        205,
                        null
                    ],
                    slategray: [
                        112,
                        128,
                        144,
                        null
                    ],
                    slategrey: [
                        112,
                        128,
                        144,
                        null
                    ],
                    snow: [
                        255,
                        250,
                        250,
                        null
                    ],
                    springgreen: [
                        0,
                        255,
                        127,
                        null
                    ],
                    steelblue: [
                        70,
                        130,
                        180,
                        null
                    ],
                    tan: [
                        210,
                        180,
                        140,
                        null
                    ],
                    teal: [
                        0,
                        128,
                        128,
                        null
                    ],
                    thistle: [
                        216,
                        191,
                        216,
                        null
                    ],
                    tomato: [
                        255,
                        99,
                        71,
                        null
                    ],
                    turquoise: [
                        64,
                        224,
                        208,
                        null
                    ],
                    violet: [
                        238,
                        130,
                        238,
                        null
                    ],
                    wheat: [
                        245,
                        222,
                        179,
                        null
                    ],
                    white: [
                        255,
                        255,
                        255,
                        null
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245,
                        null
                    ],
                    yellow: [
                        255,
                        255,
                        0,
                        null
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50,
                        null
                    ]
                };
                t.TRANSPARENT = new o([
                    0,
                    0,
                    0,
                    0
                ]);
            },
            46: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = e(378), r = function(A) {
                    return 0 === A[0] && 255 === A[1] && 0 === A[2] && 255 === A[3];
                }, a = {
                    get SUPPORT_RANGE_BOUNDS () {
                        var A1 = function(A) {
                            if (A.createRange) {
                                var t = A.createRange();
                                if (t.getBoundingClientRect) {
                                    var e = A.createElement("boundtest");
                                    e.style.height = "123px", e.style.display = "block", A.body.appendChild(e), t.selectNode(e);
                                    var n = t.getBoundingClientRect(), r = Math.round(n.height);
                                    if (A.body.removeChild(e), 123 === r) return !0;
                                }
                            }
                            return !1;
                        }(document);
                        return Object.defineProperty(a, "SUPPORT_RANGE_BOUNDS", {
                            value: A1
                        }), A1;
                    },
                    get SUPPORT_SVG_DRAWING () {
                        var A2 = function(A) {
                            var t = new Image, e = A.createElement("canvas"), n = e.getContext("2d");
                            t.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
                            try {
                                n.drawImage(t, 0, 0), e.toDataURL();
                            } catch (A) {
                                return !1;
                            }
                            return !0;
                        }(document);
                        return Object.defineProperty(a, "SUPPORT_SVG_DRAWING", {
                            value: A2
                        }), A2;
                    },
                    get SUPPORT_BASE64_DRAWING () {
                        return function(A) {
                            var t = function(A, t) {
                                var e = new Image, n = A.createElement("canvas"), r = n.getContext("2d");
                                return new Promise(function(A) {
                                    e.src = t;
                                    var a = function() {
                                        try {
                                            r.drawImage(e, 0, 0), n.toDataURL();
                                        } catch (t) {
                                            return A(!1);
                                        }
                                        return A(!0);
                                    };
                                    e.onload = a, e.onerror = function() {
                                        return A(!1);
                                    }, !0 === e.complete && setTimeout(function() {
                                        a();
                                    }, 500);
                                });
                            }(document, A);
                            return Object.defineProperty(a, "SUPPORT_BASE64_DRAWING", {
                                value: function() {
                                    return t;
                                }
                            }), t;
                        };
                    },
                    get SUPPORT_FOREIGNOBJECT_DRAWING () {
                        var A3 = "function" == typeof Array.from && "function" == typeof window.fetch ? function(A) {
                            var t = A.createElement("canvas"), e = 100;
                            t.width = e, t.height = e;
                            var a = t.getContext("2d");
                            a.fillStyle = "rgb(0, 255, 0)", a.fillRect(0, 0, e, e);
                            var i = new Image, o = t.toDataURL();
                            i.src = o;
                            var s = (0, n.createForeignObjectSVG)(e, e, 0, 0, i);
                            return a.fillStyle = "red", a.fillRect(0, 0, e, e), (0, n.loadSerializedSVG)(s).then(function(t) {
                                a.drawImage(t, 0, 0);
                                var i = a.getImageData(0, 0, e, e).data;
                                a.fillStyle = "red", a.fillRect(0, 0, e, e);
                                var s = A.createElement("div");
                                return s.style.backgroundImage = "url(" + o + ")", s.style.height = "100px", r(i) ? (0, n.loadSerializedSVG)((0, n.createForeignObjectSVG)(e, e, 0, 0, s)) : Promise.reject(!1);
                            }).then(function(A) {
                                return a.drawImage(A, 0, 0), r(a.getImageData(0, 0, e, e).data);
                            }).catch(function(A) {
                                return !1;
                            });
                        }(document) : Promise.resolve(!1);
                        return Object.defineProperty(a, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                            value: A3
                        }), A3;
                    },
                    get SUPPORT_CORS_IMAGES () {
                        var A4 = void 0 !== (new Image).crossOrigin;
                        return Object.defineProperty(a, "SUPPORT_CORS_IMAGES", {
                            value: A4
                        }), A4;
                    },
                    get SUPPORT_RESPONSE_TYPE () {
                        var A5 = "string" == typeof (new XMLHttpRequest).responseType;
                        return Object.defineProperty(a, "SUPPORT_RESPONSE_TYPE", {
                            value: A5
                        }), A5;
                    },
                    get SUPPORT_CORS_XHR () {
                        var A6 = "withCredentials" in new XMLHttpRequest;
                        return Object.defineProperty(a, "SUPPORT_CORS_XHR", {
                            value: A6
                        }), A6;
                    }
                };
                t.default = a;
            },
            9539: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.FontMetrics = void 0;
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = e(5627), a = "Hidden Text";
                t.FontMetrics = function() {
                    function A(t) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this._data = {}, this._document = t;
                    }
                    return n(A, [
                        {
                            key: "_parseMetrics",
                            value: function(A) {
                                var t = this._document.createElement("div"), e = this._document.createElement("img"), n = this._document.createElement("span"), i = this._document.body;
                                if (!i) throw new Error("");
                                t.style.visibility = "hidden", t.style.fontFamily = A.fontFamily, t.style.fontSize = A.fontSize, t.style.margin = "0", t.style.padding = "0", i.appendChild(t), e.src = r.SMALL_IMAGE, e.width = 1, e.height = 1, e.style.margin = "0", e.style.padding = "0", e.style.verticalAlign = "baseline", n.style.fontFamily = A.fontFamily, n.style.fontSize = A.fontSize, n.style.margin = "0", n.style.padding = "0", n.appendChild(this._document.createTextNode(a)), t.appendChild(n), t.appendChild(e);
                                var o = e.offsetTop - n.offsetTop + 2;
                                t.removeChild(n), t.appendChild(this._document.createTextNode(a)), t.style.lineHeight = "normal", e.style.verticalAlign = "super";
                                var s = e.offsetTop - t.offsetTop + 2;
                                return i.removeChild(t), {
                                    baseline: o,
                                    middle: s
                                };
                            }
                        },
                        {
                            key: "getMetrics",
                            value: function(A) {
                                var t = A.fontFamily + " " + A.fontSize;
                                return void 0 === this._data[t] && (this._data[t] = this._parseMetrics(A)), this._data[t];
                            }
                        }
                    ]), A;
                }();
            },
            6112: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.transformWebkitRadialGradientArgs = t.parseGradient = t.RadialGradient = t.LinearGradient = t.RADIAL_GRADIENT_SHAPE = t.GRADIENT_TYPE = void 0;
                var n = (s(e(6915)), e(2466)), r = s(e(8785)), a = e(175), i = s(a), o = e(5627);
                function s(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                function c(A, t) {
                    if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                var l = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i, u = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i, f = /(px)|%|( 0)$/i, h = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i, B = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i, d = t.GRADIENT_TYPE = {
                    LINEAR_GRADIENT: 0,
                    RADIAL_GRADIENT: 1
                }, g = t.RADIAL_GRADIENT_SHAPE = {
                    CIRCLE: 0,
                    ELLIPSE: 1
                }, w = {
                    left: new i.default("0%"),
                    top: new i.default("0%"),
                    center: new i.default("50%"),
                    right: new i.default("100%"),
                    bottom: new i.default("100%")
                }, p = t.LinearGradient = function A(t, e) {
                    c(this, A), this.type = d.LINEAR_GRADIENT, this.colorStops = t, this.direction = e;
                }, Q = t.RadialGradient = function A(t, e, n, r) {
                    c(this, A), this.type = d.RADIAL_GRADIENT, this.colorStops = t, this.shape = e, this.center = n, this.radius = r;
                }, U = (t.parseGradient = function(A, t, e) {
                    var n = t.args, r = t.method, a = t.prefix;
                    return "linear-gradient" === r ? v(n, e, !!a) : "gradient" === r && "linear" === n[0] ? v([
                        "to bottom"
                    ].concat(N(n.slice(3))), e, !!a) : "radial-gradient" === r ? y(A, "-webkit-" === a ? H(n) : n, e) : "gradient" === r && "radial" === n[0] ? y(A, N(H(n.slice(1))), e) : void 0;
                }, function(A, t, e) {
                    for(var n = [], a = t; a < A.length; a++){
                        var o = A[a], s = f.test(o), c = o.lastIndexOf(" "), l = new r.default(s ? o.substring(0, c) : o), u = s ? new i.default(o.substring(c + 1)) : a === t ? new i.default("0%") : a === A.length - 1 ? new i.default("100%") : null;
                        n.push({
                            color: l,
                            stop: u
                        });
                    }
                    for(var h = n.map(function(A) {
                        var t = A.color, n = A.stop;
                        return {
                            color: t,
                            stop: 0 === e ? 0 : n ? n.getAbsoluteValue(e) / e : null
                        };
                    }), B = h[0].stop, d = 0; d < h.length; d++)if (null !== B) {
                        var g = h[d].stop;
                        if (null === g) {
                            for(var w = d; null === h[w].stop;)w++;
                            for(var p = w - d + 1, Q = (h[w].stop - B) / p; d < w; d++)B = h[d].stop = B + Q;
                        } else B = g;
                    }
                    return h;
                }), v = function(A, t, e) {
                    var r = (0, n.parseAngle)(A[0]), a = l.test(A[0]), i = a || null !== r || u.test(A[0]), s = i ? null !== r ? C(e ? r - .5 * Math.PI : r, t) : a ? E(A[0], t) : F(A[0], t) : C(Math.PI, t), c = i ? 1 : 0, f = Math.min((0, o.distance)(Math.abs(s.x0) + Math.abs(s.x1), Math.abs(s.y0) + Math.abs(s.y1)), 2 * t.width, 2 * t.height);
                    return new p(U(A, c, f), s);
                }, y = function(A, t, e) {
                    var n = t[0].match(B), r = n && ("circle" === n[1] || void 0 !== n[3] && void 0 === n[5]) ? g.CIRCLE : g.ELLIPSE, i = {}, o = {};
                    n && (void 0 !== n[3] && (i.x = (0, a.calculateLengthFromValueWithUnit)(A, n[3], n[4]).getAbsoluteValue(e.width)), void 0 !== n[5] && (i.y = (0, a.calculateLengthFromValueWithUnit)(A, n[5], n[6]).getAbsoluteValue(e.height)), n[7] ? o.x = w[n[7].toLowerCase()] : void 0 !== n[8] && (o.x = (0, a.calculateLengthFromValueWithUnit)(A, n[8], n[9])), n[10] ? o.y = w[n[10].toLowerCase()] : void 0 !== n[11] && (o.y = (0, a.calculateLengthFromValueWithUnit)(A, n[11], n[12])));
                    var s = {
                        x: void 0 === o.x ? e.width / 2 : o.x.getAbsoluteValue(e.width),
                        y: void 0 === o.y ? e.height / 2 : o.y.getAbsoluteValue(e.height)
                    }, c = b(n && n[2] || "farthest-corner", r, s, i, e);
                    return new Q(U(t, n ? 1 : 0, Math.min(c.x, c.y)), r, s, c);
                }, C = function(A, t) {
                    var e = t.width, n = t.height, r = .5 * e, a = .5 * n, i = (Math.abs(e * Math.sin(A)) + Math.abs(n * Math.cos(A))) / 2, o = r + Math.sin(A) * i, s = a - Math.cos(A) * i;
                    return {
                        x0: o,
                        x1: e - o,
                        y0: s,
                        y1: n - s
                    };
                }, m = function(A) {
                    return Math.acos(A.width / 2 / ((0, o.distance)(A.width, A.height) / 2));
                }, E = function(A, t) {
                    switch(A){
                        case "bottom":
                        case "to top":
                            return C(0, t);
                        case "left":
                        case "to right":
                            return C(Math.PI / 2, t);
                        case "right":
                        case "to left":
                            return C(3 * Math.PI / 2, t);
                        case "top right":
                        case "right top":
                        case "to bottom left":
                        case "to left bottom":
                            return C(Math.PI + m(t), t);
                        case "top left":
                        case "left top":
                        case "to bottom right":
                        case "to right bottom":
                            return C(Math.PI - m(t), t);
                        case "bottom left":
                        case "left bottom":
                        case "to top right":
                        case "to right top":
                            return C(m(t), t);
                        case "bottom right":
                        case "right bottom":
                        case "to top left":
                        case "to left top":
                            return C(2 * Math.PI - m(t), t);
                        case "top":
                        case "to bottom":
                        default:
                            return C(Math.PI, t);
                    }
                }, F = function(A, t) {
                    var e = function(A, t) {
                        if (Array.isArray(A)) return A;
                        if (Symbol.iterator in Object(A)) return function(A, t) {
                            var e = [], n = !0, r = !1, a = void 0;
                            try {
                                for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                            } catch (A) {
                                r = !0, a = A;
                            } finally{
                                try {
                                    !n && o.return && o.return();
                                } finally{
                                    if (r) throw a;
                                }
                            }
                            return e;
                        }(A, t);
                        throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    }(A.split(" ").map(parseFloat), 2), n = e[0], r = e[1], a = n / 100 * t.width / (r / 100 * t.height);
                    return C(Math.atan(isNaN(a) ? 1 : a) + Math.PI / 2, t);
                }, _ = function(A, t, e, n) {
                    return [
                        {
                            x: 0,
                            y: 0
                        },
                        {
                            x: 0,
                            y: A.height
                        },
                        {
                            x: A.width,
                            y: 0
                        },
                        {
                            x: A.width,
                            y: A.height
                        }
                    ].reduce(function(A, r) {
                        var a = (0, o.distance)(t - r.x, e - r.y);
                        return (n ? a < A.optimumDistance : a > A.optimumDistance) ? {
                            optimumCorner: r,
                            optimumDistance: a
                        } : A;
                    }, {
                        optimumDistance: n ? 1 / 0 : -1 / 0,
                        optimumCorner: null
                    }).optimumCorner;
                }, b = function(A, t, e, n, r) {
                    var a = e.x, i = e.y, s = 0, c = 0;
                    switch(A){
                        case "closest-side":
                            t === g.CIRCLE ? s = c = Math.min(Math.abs(a), Math.abs(a - r.width), Math.abs(i), Math.abs(i - r.height)) : t === g.ELLIPSE && (s = Math.min(Math.abs(a), Math.abs(a - r.width)), c = Math.min(Math.abs(i), Math.abs(i - r.height)));
                            break;
                        case "closest-corner":
                            if (t === g.CIRCLE) s = c = Math.min((0, o.distance)(a, i), (0, o.distance)(a, i - r.height), (0, o.distance)(a - r.width, i), (0, o.distance)(a - r.width, i - r.height));
                            else if (t === g.ELLIPSE) {
                                var l = Math.min(Math.abs(i), Math.abs(i - r.height)) / Math.min(Math.abs(a), Math.abs(a - r.width)), u = _(r, a, i, !0);
                                c = l * (s = (0, o.distance)(u.x - a, (u.y - i) / l));
                            }
                            break;
                        case "farthest-side":
                            t === g.CIRCLE ? s = c = Math.max(Math.abs(a), Math.abs(a - r.width), Math.abs(i), Math.abs(i - r.height)) : t === g.ELLIPSE && (s = Math.max(Math.abs(a), Math.abs(a - r.width)), c = Math.max(Math.abs(i), Math.abs(i - r.height)));
                            break;
                        case "farthest-corner":
                            if (t === g.CIRCLE) s = c = Math.max((0, o.distance)(a, i), (0, o.distance)(a, i - r.height), (0, o.distance)(a - r.width, i), (0, o.distance)(a - r.width, i - r.height));
                            else if (t === g.ELLIPSE) {
                                var f = Math.max(Math.abs(i), Math.abs(i - r.height)) / Math.max(Math.abs(a), Math.abs(a - r.width)), h = _(r, a, i, !1);
                                c = f * (s = (0, o.distance)(h.x - a, (h.y - i) / f));
                            }
                            break;
                        default:
                            s = n.x || 0, c = void 0 !== n.y ? n.y : s;
                    }
                    return {
                        x: s,
                        y: c
                    };
                }, H = t.transformWebkitRadialGradientArgs = function(A) {
                    var t = "", e = "", n = "", r = "", a = 0, i = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i, o = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i, s = A[a].match(i);
                    s && a++;
                    var c = A[a].match(/^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i);
                    c && (t = c[1] || "", "contain" === (n = c[2] || "") ? n = "closest-side" : "cover" === n && (n = "farthest-corner"), a++);
                    var l = A[a].match(o);
                    l && a++;
                    var u = A[a].match(i);
                    u && a++;
                    var f = A[a].match(o);
                    f && a++;
                    var h = u || s;
                    h && h[1] && (r = h[1] + (/^\d+$/.test(h[1]) ? "px" : ""), h[2] && (r += " " + h[2] + (/^\d+$/.test(h[2]) ? "px" : "")));
                    var B = f || l;
                    return B && (e = B[0], B[1] || (e += "px")), !r || t || e || n || (e = r, r = ""), r && (r = "at " + r), [
                        [
                            t,
                            n,
                            e,
                            r
                        ].filter(function(A) {
                            return !!A;
                        }).join(" ")
                    ].concat(A.slice(a));
                }, N = function(A) {
                    return A.map(function(A) {
                        return A.match(h);
                    }).map(function(t, e) {
                        if (!t) return A[e];
                        switch(t[1]){
                            case "from":
                                return t[4] + " 0%";
                            case "to":
                                return t[4] + " 100%";
                            case "color-stop":
                                return "%" === t[3] ? t[4] + " " + t[2] : t[4] + " " + 100 * parseFloat(t[2]) + "%";
                        }
                    });
                };
            },
            3706: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.reformatInputBounds = t.inlineSelectElement = t.inlineTextAreaElement = t.inlineInputElement = t.getInputBorderRadius = t.INPUT_BACKGROUND = t.INPUT_BORDERS = t.INPUT_COLOR = void 0;
                var n = u(e(2204)), r = e(389), a = e(4591), i = u(e(2339)), o = u(e(9811)), s = u(e(8785)), c = u(e(175)), l = (e(2140), e(2295), e(5627));
                function u(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                t.INPUT_COLOR = new s.default([
                    42,
                    42,
                    42
                ]);
                var f = new s.default([
                    165,
                    165,
                    165
                ]), h = new s.default([
                    222,
                    222,
                    222
                ]), B = {
                    borderWidth: 1,
                    borderColor: f,
                    borderStyle: a.BORDER_STYLE.SOLID
                }, d = (t.INPUT_BORDERS = [
                    B,
                    B,
                    B,
                    B
                ], t.INPUT_BACKGROUND = {
                    backgroundColor: h,
                    backgroundImage: [],
                    backgroundClip: r.BACKGROUND_CLIP.PADDING_BOX,
                    backgroundOrigin: r.BACKGROUND_ORIGIN.PADDING_BOX
                }, new c.default("50%")), g = [
                    d,
                    d
                ], w = [
                    g,
                    g,
                    g,
                    g
                ], p = new c.default("3px"), Q = [
                    p,
                    p
                ], U = [
                    Q,
                    Q,
                    Q,
                    Q
                ], v = (t.getInputBorderRadius = function(A) {
                    return "radio" === A.type ? w : U;
                }, t.inlineInputElement = function(A, t) {
                    if ("radio" === A.type || "checkbox" === A.type) {
                        if (A.checked) {
                            var e = Math.min(t.bounds.width, t.bounds.height);
                            t.childNodes.push("checkbox" === A.type ? [
                                new o.default(t.bounds.left + .39363 * e, t.bounds.top + .79 * e),
                                new o.default(t.bounds.left + .16 * e, t.bounds.top + .5549 * e),
                                new o.default(t.bounds.left + .27347 * e, t.bounds.top + .44071 * e),
                                new o.default(t.bounds.left + .39694 * e, t.bounds.top + .5649 * e),
                                new o.default(t.bounds.left + .72983 * e, t.bounds.top + .23 * e),
                                new o.default(t.bounds.left + .84 * e, t.bounds.top + .34085 * e),
                                new o.default(t.bounds.left + .39363 * e, t.bounds.top + .79 * e)
                            ] : new i.default(t.bounds.left + e / 4, t.bounds.top + e / 4, e / 4));
                        }
                    } else v(y(A), A, t, !1);
                }, t.inlineTextAreaElement = function(A, t) {
                    v(A.value, A, t, !0);
                }, t.inlineSelectElement = function(A, t) {
                    var e = A.options[A.selectedIndex || 0];
                    v(e && e.text || "", A, t, !1);
                }, t.reformatInputBounds = function(A) {
                    return A.width > A.height ? (A.left += (A.width - A.height) / 2, A.width = A.height) : A.width < A.height && (A.top += (A.height - A.width) / 2, A.height = A.width), A;
                }, function(A, t, e, r) {
                    var a = t.ownerDocument.body;
                    if (A.length > 0 && a) {
                        var i = t.ownerDocument.createElement("html2canvaswrapper");
                        (0, l.copyCSSStyles)(t.ownerDocument.defaultView.getComputedStyle(t, null), i), i.style.position = "absolute", i.style.left = e.bounds.left + "px", i.style.top = e.bounds.top + "px", r || (i.style.whiteSpace = "nowrap");
                        var o = t.ownerDocument.createTextNode(A);
                        i.appendChild(o), a.appendChild(i), e.childNodes.push(n.default.fromTextNode(o, e)), a.removeChild(i);
                    }
                }), y = function(A) {
                    var t = "password" === A.type ? new Array(A.value.length + 1).join("\u2022") : A.value;
                    return 0 === t.length ? A.placeholder || "" : t;
                };
            },
            175: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.calculateLengthFromValueWithUnit = t.LENGTH_TYPE = void 0;
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }();
                (n = e(6915)) && n.__esModule;
                var a = t.LENGTH_TYPE = {
                    PX: 0,
                    PERCENTAGE: 1
                }, i = function() {
                    function A(t) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.type = "%" === t.substr(t.length - 1) ? a.PERCENTAGE : a.PX;
                        var e = parseFloat(t);
                        this.value = isNaN(e) ? 0 : e;
                    }
                    return r(A, [
                        {
                            key: "isPercentage",
                            value: function() {
                                return this.type === a.PERCENTAGE;
                            }
                        },
                        {
                            key: "getAbsoluteValue",
                            value: function(A) {
                                return this.isPercentage() ? A * (this.value / 100) : this.value;
                            }
                        }
                    ], [
                        {
                            key: "create",
                            value: function(t) {
                                return new A(t);
                            }
                        }
                    ]), A;
                }();
                t.default = i;
                var o = function A(t) {
                    var e = t.parent;
                    return e ? A(e) : parseFloat(t.style.font.fontSize);
                };
                t.calculateLengthFromValueWithUnit = function(A, t, e) {
                    switch(e){
                        case "px":
                        case "%":
                            return new i(t + e);
                        case "em":
                        case "rem":
                            var n = new i(t);
                            return n.value *= "em" === e ? parseFloat(A.style.font.fontSize) : o(A), n;
                        default:
                            return new i("0");
                    }
                };
            },
            5974: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.createCounterText = t.inlineListItemElement = t.getListOwner = void 0;
                var n = e(5627), r = s(e(6915)), a = s(e(2204)), i = e(2584), o = e(3381);
                function s(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                var c = [
                    "OL",
                    "UL",
                    "MENU"
                ], l = (t.getListOwner = function(A) {
                    var t = A.parent;
                    if (!t) return null;
                    do {
                        if (-1 !== c.indexOf(t.tagName)) return t;
                        t = t.parent;
                    }while (t);
                    return A.parent;
                }, t.inlineListItemElement = function(A, t, e) {
                    var o = t.style.listStyle;
                    if (o) {
                        var s = A.ownerDocument.defaultView.getComputedStyle(A, null), c = A.ownerDocument.createElement("html2canvaswrapper");
                        switch((0, n.copyCSSStyles)(s, c), c.style.position = "absolute", c.style.bottom = "auto", c.style.display = "block", c.style.letterSpacing = "normal", o.listStylePosition){
                            case i.LIST_STYLE_POSITION.OUTSIDE:
                                c.style.left = "auto", c.style.right = A.ownerDocument.defaultView.innerWidth - t.bounds.left - t.style.margin[1].getAbsoluteValue(t.bounds.width) + 7 + "px", c.style.textAlign = "right";
                                break;
                            case i.LIST_STYLE_POSITION.INSIDE:
                                c.style.left = t.bounds.left - t.style.margin[3].getAbsoluteValue(t.bounds.width) + "px", c.style.right = "auto", c.style.textAlign = "left";
                        }
                        var l = void 0, u = t.style.margin[0].getAbsoluteValue(t.bounds.width), f = o.listStyleImage;
                        if (f) {
                            if ("url" === f.method) {
                                var h = A.ownerDocument.createElement("img");
                                h.src = f.args[0], c.style.top = t.bounds.top - u + "px", c.style.width = "auto", c.style.height = "auto", c.appendChild(h);
                            } else {
                                var B = .5 * parseFloat(t.style.font.fontSize);
                                c.style.top = t.bounds.top - u + t.bounds.height - 1.5 * B + "px", c.style.width = B + "px", c.style.height = B + "px", c.style.backgroundImage = s.listStyleImage;
                            }
                        } else "number" == typeof t.listIndex && (l = A.ownerDocument.createTextNode(C(t.listIndex, o.listStyleType, !0)), c.appendChild(l), c.style.top = t.bounds.top - u + "px");
                        var d = A.ownerDocument.body;
                        d.appendChild(c), l ? (t.childNodes.push(a.default.fromTextNode(l, t)), d.removeChild(c)) : t.childNodes.push(new r.default(c, t, e, 0));
                    }
                }, {
                    integers: [
                        1e3,
                        900,
                        500,
                        400,
                        100,
                        90,
                        50,
                        40,
                        10,
                        9,
                        5,
                        4,
                        1
                    ],
                    values: [
                        "M",
                        "CM",
                        "D",
                        "CD",
                        "C",
                        "XC",
                        "L",
                        "XL",
                        "X",
                        "IX",
                        "V",
                        "IV",
                        "I"
                    ]
                }), u = {
                    integers: [
                        9e3,
                        8e3,
                        7e3,
                        6e3,
                        5e3,
                        4e3,
                        3e3,
                        2e3,
                        1e3,
                        900,
                        800,
                        700,
                        600,
                        500,
                        400,
                        300,
                        200,
                        100,
                        90,
                        80,
                        70,
                        60,
                        50,
                        40,
                        30,
                        20,
                        10,
                        9,
                        8,
                        7,
                        6,
                        5,
                        4,
                        3,
                        2,
                        1
                    ],
                    values: [
                        "\u0554",
                        "\u0553",
                        "\u0552",
                        "\u0551",
                        "\u0550",
                        "\u054F",
                        "\u054E",
                        "\u054D",
                        "\u054C",
                        "\u054B",
                        "\u054A",
                        "\u0549",
                        "\u0548",
                        "\u0547",
                        "\u0546",
                        "\u0545",
                        "\u0544",
                        "\u0543",
                        "\u0542",
                        "\u0541",
                        "\u0540",
                        "\u053F",
                        "\u053E",
                        "\u053D",
                        "\u053C",
                        "\u053B",
                        "\u053A",
                        "\u0539",
                        "\u0538",
                        "\u0537",
                        "\u0536",
                        "\u0535",
                        "\u0534",
                        "\u0533",
                        "\u0532",
                        "\u0531"
                    ]
                }, f = {
                    integers: [
                        1e4,
                        9e3,
                        8e3,
                        7e3,
                        6e3,
                        5e3,
                        4e3,
                        3e3,
                        2e3,
                        1e3,
                        400,
                        300,
                        200,
                        100,
                        90,
                        80,
                        70,
                        60,
                        50,
                        40,
                        30,
                        20,
                        19,
                        18,
                        17,
                        16,
                        15,
                        10,
                        9,
                        8,
                        7,
                        6,
                        5,
                        4,
                        3,
                        2,
                        1
                    ],
                    values: [
                        "\u05D9\u05F3",
                        "\u05D8\u05F3",
                        "\u05D7\u05F3",
                        "\u05D6\u05F3",
                        "\u05D5\u05F3",
                        "\u05D4\u05F3",
                        "\u05D3\u05F3",
                        "\u05D2\u05F3",
                        "\u05D1\u05F3",
                        "\u05D0\u05F3",
                        "\u05EA",
                        "\u05E9",
                        "\u05E8",
                        "\u05E7",
                        "\u05E6",
                        "\u05E4",
                        "\u05E2",
                        "\u05E1",
                        "\u05E0",
                        "\u05DE",
                        "\u05DC",
                        "\u05DB",
                        "\u05D9\u05D8",
                        "\u05D9\u05D7",
                        "\u05D9\u05D6",
                        "\u05D8\u05D6",
                        "\u05D8\u05D5",
                        "\u05D9",
                        "\u05D8",
                        "\u05D7",
                        "\u05D6",
                        "\u05D5",
                        "\u05D4",
                        "\u05D3",
                        "\u05D2",
                        "\u05D1",
                        "\u05D0"
                    ]
                }, h = {
                    integers: [
                        1e4,
                        9e3,
                        8e3,
                        7e3,
                        6e3,
                        5e3,
                        4e3,
                        3e3,
                        2e3,
                        1e3,
                        900,
                        800,
                        700,
                        600,
                        500,
                        400,
                        300,
                        200,
                        100,
                        90,
                        80,
                        70,
                        60,
                        50,
                        40,
                        30,
                        20,
                        10,
                        9,
                        8,
                        7,
                        6,
                        5,
                        4,
                        3,
                        2,
                        1
                    ],
                    values: [
                        "\u10F5",
                        "\u10F0",
                        "\u10EF",
                        "\u10F4",
                        "\u10EE",
                        "\u10ED",
                        "\u10EC",
                        "\u10EB",
                        "\u10EA",
                        "\u10E9",
                        "\u10E8",
                        "\u10E7",
                        "\u10E6",
                        "\u10E5",
                        "\u10E4",
                        "\u10F3",
                        "\u10E2",
                        "\u10E1",
                        "\u10E0",
                        "\u10DF",
                        "\u10DE",
                        "\u10DD",
                        "\u10F2",
                        "\u10DC",
                        "\u10DB",
                        "\u10DA",
                        "\u10D9",
                        "\u10D8",
                        "\u10D7",
                        "\u10F1",
                        "\u10D6",
                        "\u10D5",
                        "\u10D4",
                        "\u10D3",
                        "\u10D2",
                        "\u10D1",
                        "\u10D0"
                    ]
                }, B = function(A, t, e, n, r, a) {
                    return A < t || A > e ? C(A, r, a.length > 0) : n.integers.reduce(function(t, e, r) {
                        for(; A >= e;)A -= e, t += n.values[r];
                        return t;
                    }, "") + a;
                }, d = function(A, t, e, n) {
                    var r = "";
                    do e || A--, r = n(A) + r, A /= t;
                    while (A * t >= t);
                    return r;
                }, g = function(A, t, e, n, r) {
                    var a = e - t + 1;
                    return (A < 0 ? "-" : "") + (d(Math.abs(A), a, n, function(A) {
                        return (0, o.fromCodePoint)(Math.floor(A % a) + t);
                    }) + r);
                }, w = function(A, t) {
                    var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ". ", n = t.length;
                    return d(Math.abs(A), n, !1, function(A) {
                        return t[Math.floor(A % n)];
                    }) + e;
                }, p = function(A, t, e, r, a, o) {
                    if (A < -9999 || A > 9999) return C(A, i.LIST_STYLE_TYPE.CJK_DECIMAL, a.length > 0);
                    var s = Math.abs(A), c = a;
                    if (0 === s) return t[0] + c;
                    for(var l = 0; s > 0 && l <= 4; l++){
                        var u = s % 10;
                        0 === u && (0, n.contains)(o, 1) && "" !== c ? c = t[u] + c : u > 1 || 1 === u && 0 === l || 1 === u && 1 === l && (0, n.contains)(o, 2) || 1 === u && 1 === l && (0, n.contains)(o, 4) && A > 100 || 1 === u && l > 1 && (0, n.contains)(o, 8) ? c = t[u] + (l > 0 ? e[l - 1] : "") + c : 1 === u && l > 0 && (c = e[l - 1] + c), s = Math.floor(s / 10);
                    }
                    return (A < 0 ? r : "") + c;
                }, Q = "\u5341\u767E\u5343\u842C", U = "\u62FE\u4F70\u4EDF\u842C", v = "\u30DE\u30A4\u30CA\u30B9", y = "\uB9C8\uC774\uB108\uC2A4 ", C = t.createCounterText = function(A, t, e) {
                    var n = e ? ". " : "", r = e ? "\u3001" : "", a = e ? ", " : "";
                    switch(t){
                        case i.LIST_STYLE_TYPE.DISC:
                            return "\u2022";
                        case i.LIST_STYLE_TYPE.CIRCLE:
                            return "\u25E6";
                        case i.LIST_STYLE_TYPE.SQUARE:
                            return "\u25FE";
                        case i.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
                            var o = g(A, 48, 57, !0, n);
                            return o.length < 4 ? "0" + o : o;
                        case i.LIST_STYLE_TYPE.CJK_DECIMAL:
                            return w(A, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", r);
                        case i.LIST_STYLE_TYPE.LOWER_ROMAN:
                            return B(A, 1, 3999, l, i.LIST_STYLE_TYPE.DECIMAL, n).toLowerCase();
                        case i.LIST_STYLE_TYPE.UPPER_ROMAN:
                            return B(A, 1, 3999, l, i.LIST_STYLE_TYPE.DECIMAL, n);
                        case i.LIST_STYLE_TYPE.LOWER_GREEK:
                            return g(A, 945, 969, !1, n);
                        case i.LIST_STYLE_TYPE.LOWER_ALPHA:
                            return g(A, 97, 122, !1, n);
                        case i.LIST_STYLE_TYPE.UPPER_ALPHA:
                            return g(A, 65, 90, !1, n);
                        case i.LIST_STYLE_TYPE.ARABIC_INDIC:
                            return g(A, 1632, 1641, !0, n);
                        case i.LIST_STYLE_TYPE.ARMENIAN:
                        case i.LIST_STYLE_TYPE.UPPER_ARMENIAN:
                            return B(A, 1, 9999, u, i.LIST_STYLE_TYPE.DECIMAL, n);
                        case i.LIST_STYLE_TYPE.LOWER_ARMENIAN:
                            return B(A, 1, 9999, u, i.LIST_STYLE_TYPE.DECIMAL, n).toLowerCase();
                        case i.LIST_STYLE_TYPE.BENGALI:
                            return g(A, 2534, 2543, !0, n);
                        case i.LIST_STYLE_TYPE.CAMBODIAN:
                        case i.LIST_STYLE_TYPE.KHMER:
                            return g(A, 6112, 6121, !0, n);
                        case i.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
                            return w(A, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", r);
                        case i.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
                            return w(A, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", r);
                        case i.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
                        case i.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
                            return p(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", Q, "\u8CA0", r, 14);
                        case i.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
                            return p(A, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", U, "\u8CA0", r, 15);
                        case i.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
                            return p(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", Q, "\u8D1F", r, 14);
                        case i.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
                            return p(A, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", U, "\u8D1F", r, 15);
                        case i.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
                            return p(A, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", v, r, 0);
                        case i.LIST_STYLE_TYPE.JAPANESE_FORMAL:
                            return p(A, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", v, r, 7);
                        case i.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
                            return p(A, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", y, a, 7);
                        case i.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
                            return p(A, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", y, a, 0);
                        case i.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
                            return p(A, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", y, a, 7);
                        case i.LIST_STYLE_TYPE.DEVANAGARI:
                            return g(A, 2406, 2415, !0, n);
                        case i.LIST_STYLE_TYPE.GEORGIAN:
                            return B(A, 1, 19999, h, i.LIST_STYLE_TYPE.DECIMAL, n);
                        case i.LIST_STYLE_TYPE.GUJARATI:
                            return g(A, 2790, 2799, !0, n);
                        case i.LIST_STYLE_TYPE.GURMUKHI:
                            return g(A, 2662, 2671, !0, n);
                        case i.LIST_STYLE_TYPE.HEBREW:
                            return B(A, 1, 10999, f, i.LIST_STYLE_TYPE.DECIMAL, n);
                        case i.LIST_STYLE_TYPE.HIRAGANA:
                            return w(A, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
                        case i.LIST_STYLE_TYPE.HIRAGANA_IROHA:
                            return w(A, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
                        case i.LIST_STYLE_TYPE.KANNADA:
                            return g(A, 3302, 3311, !0, n);
                        case i.LIST_STYLE_TYPE.KATAKANA:
                            return w(A, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", r);
                        case i.LIST_STYLE_TYPE.KATAKANA_IROHA:
                            return w(A, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", r);
                        case i.LIST_STYLE_TYPE.LAO:
                            return g(A, 3792, 3801, !0, n);
                        case i.LIST_STYLE_TYPE.MONGOLIAN:
                            return g(A, 6160, 6169, !0, n);
                        case i.LIST_STYLE_TYPE.MYANMAR:
                            return g(A, 4160, 4169, !0, n);
                        case i.LIST_STYLE_TYPE.ORIYA:
                            return g(A, 2918, 2927, !0, n);
                        case i.LIST_STYLE_TYPE.PERSIAN:
                            return g(A, 1776, 1785, !0, n);
                        case i.LIST_STYLE_TYPE.TAMIL:
                            return g(A, 3046, 3055, !0, n);
                        case i.LIST_STYLE_TYPE.TELUGU:
                            return g(A, 3174, 3183, !0, n);
                        case i.LIST_STYLE_TYPE.THAI:
                            return g(A, 3664, 3673, !0, n);
                        case i.LIST_STYLE_TYPE.TIBETAN:
                            return g(A, 3872, 3881, !0, n);
                        case i.LIST_STYLE_TYPE.DECIMAL:
                        default:
                            return g(A, 48, 57, !0, n);
                    }
                };
            },
            8927: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), n = function() {
                    function A(t, e, n) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.enabled = "undefined" != typeof window && t, this.start = n || Date.now(), this.id = e;
                    }
                    return e(A, [
                        {
                            key: "child",
                            value: function(t) {
                                return new A(this.enabled, t, this.start);
                            }
                        },
                        {
                            key: "log",
                            value: function() {
                                if (this.enabled && window.console && window.console.log) {
                                    for(var A = arguments.length, t = Array(A), e = 0; e < A; e++)t[e] = arguments[e];
                                    Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [
                                        Date.now() - this.start + "ms",
                                        this.id ? "html2canvas (" + this.id + "):" : "html2canvas:"
                                    ].concat([].slice.call(t, 0)));
                                }
                            }
                        },
                        {
                            key: "error",
                            value: function() {
                                if (this.enabled && window.console && window.console.error) {
                                    for(var A = arguments.length, t = Array(A), e = 0; e < A; e++)t[e] = arguments[e];
                                    Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [
                                        Date.now() - this.start + "ms",
                                        this.id ? "html2canvas (" + this.id + "):" : "html2canvas:"
                                    ].concat([].slice.call(t, 0)));
                                }
                            }
                        }
                    ]), A;
                }();
                t.default = n;
            },
            6915: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), a = (n = e(8785)) && n.__esModule ? n : {
                    default: n
                }, i = e(5627), o = e(389), s = e(4591), c = e(4022), l = e(1040), u = e(8905), f = e(5299), h = e(8700), B = e(3198), d = e(2584), g = e(4944), w = e(2570), p = e(6489), Q = e(5685), U = e(1079), v = e(9083), y = e(8917), C = e(6997), m = e(5809), E = e(9897), F = e(9265), _ = e(4526), b = e(2140), H = e(3706), N = e(5974), I = [
                    "INPUT",
                    "TEXTAREA",
                    "SELECT"
                ], M = function() {
                    function A(t, e, n, r) {
                        var i = this;
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.parent = e, this.tagName = t.tagName, this.index = r, this.childNodes = [], this.listItems = [], "number" == typeof t.start && (this.listStart = t.start);
                        var M = t.ownerDocument.defaultView, x = M.pageXOffset, K = M.pageYOffset, O = M.getComputedStyle(t, null), S = (0, l.parseDisplay)(O.display), L = "radio" === t.type || "checkbox" === t.type, k = (0, U.parsePosition)(O.position);
                        if (this.style = {
                            background: L ? H.INPUT_BACKGROUND : (0, o.parseBackground)(O, n),
                            border: L ? H.INPUT_BORDERS : (0, s.parseBorder)(O),
                            borderRadius: (t instanceof M.HTMLInputElement || t instanceof HTMLInputElement) && L ? (0, H.getInputBorderRadius)(t) : (0, c.parseBorderRadius)(O),
                            color: L ? H.INPUT_COLOR : new a.default(O.color),
                            display: S,
                            float: (0, u.parseCSSFloat)(O.float),
                            font: (0, f.parseFont)(O),
                            letterSpacing: (0, h.parseLetterSpacing)(O.letterSpacing),
                            listStyle: S === l.DISPLAY.LIST_ITEM ? (0, d.parseListStyle)(O) : null,
                            lineBreak: (0, B.parseLineBreak)(O.lineBreak),
                            margin: (0, g.parseMargin)(O),
                            opacity: parseFloat(O.opacity),
                            overflow: -1 === I.indexOf(t.tagName) ? (0, w.parseOverflow)(O.overflow) : w.OVERFLOW.HIDDEN,
                            overflowWrap: (0, p.parseOverflowWrap)(O.overflowWrap ? O.overflowWrap : O.wordWrap),
                            padding: (0, Q.parsePadding)(O),
                            position: k,
                            textDecoration: (0, v.parseTextDecoration)(O),
                            textShadow: (0, y.parseTextShadow)(O.textShadow),
                            textTransform: (0, C.parseTextTransform)(O.textTransform),
                            transform: (0, m.parseTransform)(O),
                            visibility: (0, E.parseVisibility)(O.visibility),
                            wordBreak: (0, F.parseWordBreak)(O.wordBreak),
                            zIndex: (0, _.parseZIndex)(k !== U.POSITION.STATIC ? O.zIndex : "auto")
                        }, this.isTransformed() && (t.style.transform = "matrix(1,0,0,1,0,0)"), S === l.DISPLAY.LIST_ITEM) {
                            var P = (0, N.getListOwner)(this);
                            if (P) {
                                var D = P.listItems.length;
                                P.listItems.push(this), this.listIndex = t.hasAttribute("value") && "number" == typeof t.value ? t.value : 0 === D ? "number" == typeof P.listStart ? P.listStart : 1 : P.listItems[D - 1].listIndex + 1;
                            }
                        }
                        "IMG" === t.tagName && t.addEventListener("load", function() {
                            i.bounds = (0, b.parseBounds)(t, x, K), i.curvedBounds = (0, b.parseBoundCurves)(i.bounds, i.style.border, i.style.borderRadius);
                        }), this.image = T(t, n), this.bounds = L ? (0, H.reformatInputBounds)((0, b.parseBounds)(t, x, K)) : (0, b.parseBounds)(t, x, K), this.curvedBounds = (0, b.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);
                    }
                    return r(A, [
                        {
                            key: "getClipPaths",
                            value: function() {
                                var A = this.parent ? this.parent.getClipPaths() : [];
                                return this.style.overflow !== w.OVERFLOW.VISIBLE ? A.concat([
                                    (0, b.calculatePaddingBoxPath)(this.curvedBounds)
                                ]) : A;
                            }
                        },
                        {
                            key: "isInFlow",
                            value: function() {
                                return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
                            }
                        },
                        {
                            key: "isVisible",
                            value: function() {
                                return !(0, i.contains)(this.style.display, l.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === E.VISIBILITY.VISIBLE;
                            }
                        },
                        {
                            key: "isAbsolutelyPositioned",
                            value: function() {
                                return this.style.position !== U.POSITION.STATIC && this.style.position !== U.POSITION.RELATIVE;
                            }
                        },
                        {
                            key: "isPositioned",
                            value: function() {
                                return this.style.position !== U.POSITION.STATIC;
                            }
                        },
                        {
                            key: "isFloating",
                            value: function() {
                                return this.style.float !== u.FLOAT.NONE;
                            }
                        },
                        {
                            key: "isRootElement",
                            value: function() {
                                return null === this.parent;
                            }
                        },
                        {
                            key: "isTransformed",
                            value: function() {
                                return null !== this.style.transform;
                            }
                        },
                        {
                            key: "isPositionedWithZIndex",
                            value: function() {
                                return this.isPositioned() && !this.style.zIndex.auto;
                            }
                        },
                        {
                            key: "isInlineLevel",
                            value: function() {
                                return (0, i.contains)(this.style.display, l.DISPLAY.INLINE) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_BLOCK) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_FLEX) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_GRID) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_LIST_ITEM) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_TABLE);
                            }
                        },
                        {
                            key: "isInlineBlockOrInlineTable",
                            value: function() {
                                return (0, i.contains)(this.style.display, l.DISPLAY.INLINE_BLOCK) || (0, i.contains)(this.style.display, l.DISPLAY.INLINE_TABLE);
                            }
                        }
                    ]), A;
                }();
                t.default = M;
                var T = function(A, t) {
                    if (A instanceof A.ownerDocument.defaultView.SVGSVGElement || A instanceof SVGSVGElement) {
                        var e = new XMLSerializer;
                        return t.loadImage("data:image/svg+xml," + encodeURIComponent(e.serializeToString(A)));
                    }
                    switch(A.tagName){
                        case "IMG":
                            var n = A;
                            return t.loadImage(n.currentSrc || n.src);
                        case "CANVAS":
                            var r = A;
                            return t.loadCanvas(r);
                        case "IFRAME":
                            var a = A.getAttribute("data-html2canvas-internal-iframe-key");
                            if (a) return a;
                    }
                    return null;
                };
            },
            6292: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.NodeParser = void 0;
                var n = c(e(7791)), r = c(e(6915)), a = c(e(2204)), i = e(3706), o = e(5974), s = e(2584);
                function c(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                t.NodeParser = function(A, t, e) {
                    var a = 0, i = new r.default(A, null, t, a++), o = new n.default(i, null, !0);
                    return u(A, i, o, t, 1), o;
                };
                var l = [
                    "SCRIPT",
                    "HEAD",
                    "TITLE",
                    "OBJECT",
                    "BR",
                    "OPTION"
                ], u = function A(t, e, c, u, B) {
                    for(var d, g = t.firstChild; g; g = d){
                        d = g.nextSibling;
                        var w = g.ownerDocument.defaultView;
                        if (g instanceof w.Text || g instanceof Text || w.parent && g instanceof w.parent.Text) g.data.trim().length > 0 && e.childNodes.push(a.default.fromTextNode(g, e));
                        else if (g instanceof w.HTMLElement || g instanceof HTMLElement || w.parent && g instanceof w.parent.HTMLElement) {
                            if (-1 === l.indexOf(g.nodeName)) {
                                var p = new r.default(g, e, u, B++);
                                if (p.isVisible()) {
                                    "INPUT" === g.tagName ? (0, i.inlineInputElement)(g, p) : "TEXTAREA" === g.tagName ? (0, i.inlineTextAreaElement)(g, p) : "SELECT" === g.tagName ? (0, i.inlineSelectElement)(g, p) : p.style.listStyle && p.style.listStyle.listStyleType !== s.LIST_STYLE_TYPE.NONE && (0, o.inlineListItemElement)(g, p, u);
                                    var Q = "TEXTAREA" !== g.tagName, U = f(p, g);
                                    if (U || h(p)) {
                                        var v = U || p.isPositioned() ? c.getRealParentStackingContext() : c, y = new n.default(p, v, U);
                                        v.contexts.push(y), Q && A(g, p, y, u, B);
                                    } else c.children.push(p), Q && A(g, p, c, u, B);
                                }
                            }
                        } else if (g instanceof w.SVGSVGElement || g instanceof SVGSVGElement || w.parent && g instanceof w.parent.SVGSVGElement) {
                            var C = new r.default(g, e, u, B++), m = f(C, g);
                            if (m || h(C)) {
                                var E = m || C.isPositioned() ? c.getRealParentStackingContext() : c, F = new n.default(C, E, m);
                                E.contexts.push(F);
                            } else c.children.push(C);
                        }
                    }
                }, f = function(A, t) {
                    return A.isRootElement() || A.isPositionedWithZIndex() || A.style.opacity < 1 || A.isTransformed() || B(A, t);
                }, h = function(A) {
                    return A.isPositioned() || A.isFloating();
                }, B = function(A, t) {
                    return "BODY" === t.nodeName && A.parent instanceof r.default && A.parent.style.background.backgroundColor.isTransparent();
                };
            },
            8409: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Proxy = void 0;
                var n, r = (n = e(46)) && n.__esModule ? n : {
                    default: n
                };
                t.Proxy = function(A, t) {
                    if (!t.proxy) return Promise.reject(null);
                    var e = t.proxy;
                    return new Promise(function(n, a) {
                        var i = r.default.SUPPORT_CORS_XHR && r.default.SUPPORT_RESPONSE_TYPE ? "blob" : "text", o = r.default.SUPPORT_CORS_XHR ? new XMLHttpRequest : new XDomainRequest;
                        if (o.onload = function() {
                            if (o instanceof XMLHttpRequest) {
                                if (200 === o.status) {
                                    if ("text" === i) n(o.response);
                                    else {
                                        var A = new FileReader;
                                        A.addEventListener("load", function() {
                                            return n(A.result);
                                        }, !1), A.addEventListener("error", function(A) {
                                            return a(A);
                                        }, !1), A.readAsDataURL(o.response);
                                    }
                                } else a("");
                            } else n(o.responseText);
                        }, o.onerror = a, o.open("GET", e + "?url=" + encodeURIComponent(A) + "&responseType=" + i), "text" !== i && o instanceof XMLHttpRequest && (o.responseType = i), t.imageTimeout) {
                            var s = t.imageTimeout;
                            o.timeout = s, o.ontimeout = function() {
                                return a("");
                            };
                        }
                        o.send();
                    });
                };
            },
            3779: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseContent = t.resolvePseudoContent = t.popCounters = t.parseCounterReset = t.TOKEN_TYPE = t.PSEUDO_CONTENT_ITEM_TYPE = void 0;
                var n = function(A, t) {
                    if (Array.isArray(A)) return A;
                    if (Symbol.iterator in Object(A)) return function(A, t) {
                        var e = [], n = !0, r = !1, a = void 0;
                        try {
                            for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                        } catch (A) {
                            r = !0, a = A;
                        } finally{
                            try {
                                !n && o.return && o.return();
                            } finally{
                                if (r) throw a;
                            }
                        }
                        return e;
                    }(A, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, r = e(5974), a = e(2584), i = t.PSEUDO_CONTENT_ITEM_TYPE = {
                    TEXT: 0,
                    IMAGE: 1
                }, o = t.TOKEN_TYPE = {
                    STRING: 0,
                    ATTRIBUTE: 1,
                    URL: 2,
                    COUNTER: 3,
                    COUNTERS: 4,
                    OPENQUOTE: 5,
                    CLOSEQUOTE: 6
                }, s = (t.parseCounterReset = function(A, t) {
                    if (!A || !A.counterReset || "none" === A.counterReset) return [];
                    for(var e = [], r = A.counterReset.split(/\s*,\s*/), a = r.length, i = 0; i < a; i++){
                        var o = r[i].split(/\s+/), s = n(o, 2), c = s[0], l = s[1];
                        e.push(c);
                        var u = t.counters[c];
                        u || (u = t.counters[c] = []), u.push(parseInt(l || 0, 10));
                    }
                    return e;
                }, t.popCounters = function(A, t) {
                    for(var e = A.length, n = 0; n < e; n++)t.counters[A[n]].pop();
                }, t.resolvePseudoContent = function(A, t, e) {
                    if (!t || !t.content || "none" === t.content || "-moz-alt-content" === t.content || "none" === t.display) return null;
                    var r = s(t.content), a = r.length, c = [], f = "", h = t.counterIncrement;
                    if (h && "none" !== h) {
                        var B = h.split(/\s+/), d = n(B, 2), g = d[0], w = d[1], p = e.counters[g];
                        p && (p[p.length - 1] += void 0 === w ? 1 : parseInt(w, 10));
                    }
                    for(var Q = 0; Q < a; Q++){
                        var U = r[Q];
                        switch(U.type){
                            case o.STRING:
                                f += U.value || "";
                                break;
                            case o.ATTRIBUTE:
                                A instanceof HTMLElement && U.value && (f += A.getAttribute(U.value) || "");
                                break;
                            case o.COUNTER:
                                var v = e.counters[U.name || ""];
                                v && (f += u([
                                    v[v.length - 1]
                                ], "", U.format));
                                break;
                            case o.COUNTERS:
                                var y = e.counters[U.name || ""];
                                y && (f += u(y, U.glue, U.format));
                                break;
                            case o.OPENQUOTE:
                                f += l(t, !0, e.quoteDepth), e.quoteDepth++;
                                break;
                            case o.CLOSEQUOTE:
                                e.quoteDepth--, f += l(t, !1, e.quoteDepth);
                                break;
                            case o.URL:
                                f && (c.push({
                                    type: i.TEXT,
                                    value: f
                                }), f = ""), c.push({
                                    type: i.IMAGE,
                                    value: U.value || ""
                                });
                        }
                    }
                    return f && c.push({
                        type: i.TEXT,
                        value: f
                    }), c;
                }, t.parseContent = function(A, t) {
                    if (t && t[A]) return t[A];
                    for(var e = [], n = A.length, r = !1, a = !1, i = !1, s = "", l = "", u = [], f = 0; f < n; f++){
                        var h = A.charAt(f);
                        switch(h){
                            case "'":
                            case '"':
                                a ? s += h : (r = !r, i || r || (e.push({
                                    type: o.STRING,
                                    value: s
                                }), s = ""));
                                break;
                            case "\\":
                                a ? (s += h, a = !1) : a = !0;
                                break;
                            case "(":
                                r ? s += h : (i = !0, l = s, s = "", u = []);
                                break;
                            case ")":
                                if (r) s += h;
                                else if (i) {
                                    switch(s && u.push(s), l){
                                        case "attr":
                                            u.length > 0 && e.push({
                                                type: o.ATTRIBUTE,
                                                value: u[0]
                                            });
                                            break;
                                        case "counter":
                                            if (u.length > 0) {
                                                var B = {
                                                    type: o.COUNTER,
                                                    name: u[0]
                                                };
                                                u.length > 1 && (B.format = u[1]), e.push(B);
                                            }
                                            break;
                                        case "counters":
                                            if (u.length > 0) {
                                                var d = {
                                                    type: o.COUNTERS,
                                                    name: u[0]
                                                };
                                                u.length > 1 && (d.glue = u[1]), u.length > 2 && (d.format = u[2]), e.push(d);
                                            }
                                            break;
                                        case "url":
                                            u.length > 0 && e.push({
                                                type: o.URL,
                                                value: u[0]
                                            });
                                    }
                                    i = !1, s = "";
                                }
                                break;
                            case ",":
                                r ? s += h : i && (u.push(s), s = "");
                                break;
                            case " ":
                            case "	":
                                r ? s += h : s && (c(e, s), s = "");
                                break;
                            default:
                                s += h;
                        }
                        "\\" !== h && (a = !1);
                    }
                    return s && c(e, s), t && (t[A] = e), e;
                }), c = function(A, t) {
                    switch(t){
                        case "open-quote":
                            A.push({
                                type: o.OPENQUOTE
                            });
                            break;
                        case "close-quote":
                            A.push({
                                type: o.CLOSEQUOTE
                            });
                    }
                }, l = function(A, t, e) {
                    var n = A.quotes ? A.quotes.split(/\s+/) : [
                        "'\"'",
                        "'\"'"
                    ], r = 2 * e;
                    return r >= n.length && (r = n.length - 2), t || ++r, n[r].replace(/^["']|["']$/g, "");
                }, u = function(A, t, e) {
                    for(var n = A.length, i = "", o = 0; o < n; o++)o > 0 && (i += t || ""), i += (0, r.createCounterText)(A[o], (0, a.parseListStyleType)(e || "decimal"), !1);
                    return i;
                };
            },
            57: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n, r = function(A, t) {
                    if (Array.isArray(A)) return A;
                    if (Symbol.iterator in Object(A)) return function(A, t) {
                        var e = [], n = !0, r = !1, a = void 0;
                        try {
                            for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                        } catch (A) {
                            r = !0, a = A;
                        } finally{
                            try {
                                !n && o.return && o.return();
                            } finally{
                                if (r) throw a;
                            }
                        }
                        return e;
                    }(A, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                }, a = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), i = e(2140), o = (e(9539), e(6112)), s = (n = e(2204)) && n.__esModule ? n : {
                    default: n
                }, c = e(389), l = e(4591), u = function() {
                    function A(t, e) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.target = t, this.options = e, t.render(e);
                    }
                    return a(A, [
                        {
                            key: "renderNode",
                            value: function(A) {
                                A.isVisible() && (this.renderNodeBackgroundAndBorders(A), this.renderNodeContent(A));
                            }
                        },
                        {
                            key: "renderNodeContent",
                            value: function(A) {
                                var t = this, e = function() {
                                    if (A.childNodes.length && A.childNodes.forEach(function(e) {
                                        if (e instanceof s.default) {
                                            var n = e.parent.style;
                                            t.target.renderTextNode(e.bounds, n.color, n.font, n.textDecoration, n.textShadow);
                                        } else t.target.drawShape(e, A.style.color);
                                    }), A.image) {
                                        var e = t.options.imageStore.get(A.image);
                                        if (e) {
                                            var n = (0, i.calculateContentBox)(A.bounds, A.style.padding, A.style.border), r = "number" == typeof e.width && e.width > 0 ? e.width : n.width, a = "number" == typeof e.height && e.height > 0 ? e.height : n.height;
                                            r > 0 && a > 0 && t.target.clip([
                                                (0, i.calculatePaddingBoxPath)(A.curvedBounds)
                                            ], function() {
                                                t.target.drawImage(e, new i.Bounds(0, 0, r, a), n);
                                            });
                                        }
                                    }
                                }, n = A.getClipPaths();
                                n.length ? this.target.clip(n, e) : e();
                            }
                        },
                        {
                            key: "renderNodeBackgroundAndBorders",
                            value: function(A) {
                                var t = this, e = !A.style.background.backgroundColor.isTransparent() || A.style.background.backgroundImage.length, n = A.style.border.some(function(A) {
                                    return A.borderStyle !== l.BORDER_STYLE.NONE && !A.borderColor.isTransparent();
                                }), r = function() {
                                    var n = (0, c.calculateBackgroungPaintingArea)(A.curvedBounds, A.style.background.backgroundClip);
                                    e && t.target.clip([
                                        n
                                    ], function() {
                                        A.style.background.backgroundColor.isTransparent() || t.target.fill(A.style.background.backgroundColor), t.renderBackgroundImage(A);
                                    }), A.style.border.forEach(function(e, n) {
                                        e.borderStyle === l.BORDER_STYLE.NONE || e.borderColor.isTransparent() || t.renderBorder(e, n, A.curvedBounds);
                                    });
                                };
                                if (e || n) {
                                    var a = A.parent ? A.parent.getClipPaths() : [];
                                    a.length ? this.target.clip(a, r) : r();
                                }
                            }
                        },
                        {
                            key: "renderBackgroundImage",
                            value: function(A) {
                                var t = this;
                                A.style.background.backgroundImage.slice(0).reverse().forEach(function(e) {
                                    "url" === e.source.method && e.source.args.length ? t.renderBackgroundRepeat(A, e) : /gradient/i.test(e.source.method) && t.renderBackgroundGradient(A, e);
                                });
                            }
                        },
                        {
                            key: "renderBackgroundRepeat",
                            value: function(A, t) {
                                var e = this.options.imageStore.get(t.source.args[0]);
                                if (e) {
                                    var n = (0, c.calculateBackgroungPositioningArea)(A.style.background.backgroundOrigin, A.bounds, A.style.padding, A.style.border), r = (0, c.calculateBackgroundSize)(t, e, n), a = (0, c.calculateBackgroundPosition)(t.position, r, n), i = (0, c.calculateBackgroundRepeatPath)(t, a, r, n, A.bounds), o = Math.round(n.left + a.x), s = Math.round(n.top + a.y);
                                    this.target.renderRepeat(i, e, r, o, s);
                                }
                            }
                        },
                        {
                            key: "renderBackgroundGradient",
                            value: function(A, t) {
                                var e = (0, c.calculateBackgroungPositioningArea)(A.style.background.backgroundOrigin, A.bounds, A.style.padding, A.style.border), n = (0, c.calculateGradientBackgroundSize)(t, e), r = (0, c.calculateBackgroundPosition)(t.position, n, e), a = new i.Bounds(Math.round(e.left + r.x), Math.round(e.top + r.y), n.width, n.height), s = (0, o.parseGradient)(A, t.source, a);
                                if (s) switch(s.type){
                                    case o.GRADIENT_TYPE.LINEAR_GRADIENT:
                                        this.target.renderLinearGradient(a, s);
                                        break;
                                    case o.GRADIENT_TYPE.RADIAL_GRADIENT:
                                        this.target.renderRadialGradient(a, s);
                                }
                            }
                        },
                        {
                            key: "renderBorder",
                            value: function(A, t, e) {
                                this.target.drawShape((0, i.parsePathForBorder)(e, t), A.borderColor);
                            }
                        },
                        {
                            key: "renderStack",
                            value: function(A) {
                                var t = this;
                                if (A.container.isVisible()) {
                                    var e = A.getOpacity();
                                    e !== this._opacity && (this.target.setOpacity(A.getOpacity()), this._opacity = e);
                                    var n = A.container.style.transform;
                                    null !== n ? this.target.transform(A.container.bounds.left + n.transformOrigin[0].value, A.container.bounds.top + n.transformOrigin[1].value, n.transform, function() {
                                        return t.renderStackContent(A);
                                    }) : this.renderStackContent(A);
                                }
                            }
                        },
                        {
                            key: "renderStackContent",
                            value: function(A) {
                                var t = h(A), e = r(t, 5), n = e[0], a = e[1], i = e[2], o = e[3], s = e[4], c = f(A), l = r(c, 2), u = l[0], d = l[1];
                                this.renderNodeBackgroundAndBorders(A.container), n.sort(B).forEach(this.renderStack, this), this.renderNodeContent(A.container), d.forEach(this.renderNode, this), o.forEach(this.renderStack, this), s.forEach(this.renderStack, this), u.forEach(this.renderNode, this), a.forEach(this.renderStack, this), i.sort(B).forEach(this.renderStack, this);
                            }
                        },
                        {
                            key: "render",
                            value: function(A) {
                                return this.options.backgroundColor && this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor), this.renderStack(A), this.target.getTarget();
                            }
                        }
                    ]), A;
                }();
                t.default = u;
                var f = function(A) {
                    for(var t = [], e = [], n = A.children.length, r = 0; r < n; r++){
                        var a = A.children[r];
                        a.isInlineLevel() ? t.push(a) : e.push(a);
                    }
                    return [
                        t,
                        e
                    ];
                }, h = function(A) {
                    for(var t = [], e = [], n = [], r = [], a = [], i = A.contexts.length, o = 0; o < i; o++){
                        var s = A.contexts[o];
                        s.container.isPositioned() || s.container.style.opacity < 1 || s.container.isTransformed() ? s.container.style.zIndex.order < 0 ? t.push(s) : s.container.style.zIndex.order > 0 ? n.push(s) : e.push(s) : s.container.isFloating() ? r.push(s) : a.push(s);
                    }
                    return [
                        t,
                        e,
                        n,
                        r,
                        a
                    ];
                }, B = function(A, t) {
                    return A.container.style.zIndex.order > t.container.style.zIndex.order ? 1 : A.container.style.zIndex.order < t.container.style.zIndex.order ? -1 : A.container.index > t.container.index ? 1 : -1;
                };
            },
            6248: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ResourceStore = void 0;
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), a = (n = e(46)) && n.__esModule ? n : {
                    default: n
                }, i = e(8409);
                function o(A, t) {
                    if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                }
                var s = function() {
                    function A(t, e, n) {
                        o(this, A), this.options = t, this._window = n, this.origin = this.getOrigin(n.location.href), this.cache = {}, this.logger = e, this._index = 0;
                    }
                    return r(A, [
                        {
                            key: "loadImage",
                            value: function(A) {
                                var t = this;
                                if (this.hasResourceInCache(A)) return A;
                                if (d(A)) return this.cache[A] = w(A, this.options.imageTimeout || 0), A;
                                if (!g(A) || a.default.SUPPORT_SVG_DRAWING) {
                                    if (!0 === this.options.allowTaint || h(A) || this.isSameOrigin(A)) return this.addImage(A, A, !1);
                                    if (!this.isSameOrigin(A)) {
                                        if ("string" == typeof this.options.proxy) return this.cache[A] = (0, i.Proxy)(A, this.options).then(function(A) {
                                            return w(A, t.options.imageTimeout || 0);
                                        }), A;
                                        if (!0 === this.options.useCORS && a.default.SUPPORT_CORS_IMAGES) return this.addImage(A, A, !0);
                                    }
                                }
                            }
                        },
                        {
                            key: "inlineImage",
                            value: function(A) {
                                var t = this;
                                return h(A) ? w(A, this.options.imageTimeout || 0) : this.hasResourceInCache(A) ? this.cache[A] : this.isSameOrigin(A) || "string" != typeof this.options.proxy ? this.xhrImage(A) : this.cache[A] = (0, i.Proxy)(A, this.options).then(function(A) {
                                    return w(A, t.options.imageTimeout || 0);
                                });
                            }
                        },
                        {
                            key: "xhrImage",
                            value: function(A) {
                                var t = this;
                                return this.cache[A] = new Promise(function(e, n) {
                                    var r = new XMLHttpRequest;
                                    if (r.onreadystatechange = function() {
                                        if (4 === r.readyState) {
                                            if (200 !== r.status) n("Failed to fetch image " + A.substring(0, 256) + " with status code " + r.status);
                                            else {
                                                var t = new FileReader;
                                                t.addEventListener("load", function() {
                                                    var A = t.result;
                                                    e(A);
                                                }, !1), t.addEventListener("error", function(A) {
                                                    return n(A);
                                                }, !1), t.readAsDataURL(r.response);
                                            }
                                        }
                                    }, r.responseType = "blob", t.options.imageTimeout) {
                                        var a = t.options.imageTimeout;
                                        r.timeout = a, r.ontimeout = function() {
                                            return n("");
                                        };
                                    }
                                    r.open("GET", A, !0), r.send();
                                }).then(function(A) {
                                    return w(A, t.options.imageTimeout || 0);
                                }), this.cache[A];
                            }
                        },
                        {
                            key: "loadCanvas",
                            value: function(A) {
                                var t = String(this._index++);
                                return this.cache[t] = Promise.resolve(A), t;
                            }
                        },
                        {
                            key: "hasResourceInCache",
                            value: function(A) {
                                return void 0 !== this.cache[A];
                            }
                        },
                        {
                            key: "addImage",
                            value: function(A, t, e) {
                                var n = this, r = function(A) {
                                    return new Promise(function(r, a) {
                                        var i = new Image;
                                        if (i.onload = function() {
                                            return r(i);
                                        }, A && !e || (i.crossOrigin = "anonymous"), i.onerror = a, i.src = t, !0 === i.complete && setTimeout(function() {
                                            r(i);
                                        }, 500), n.options.imageTimeout) {
                                            var o = n.options.imageTimeout;
                                            setTimeout(function() {
                                                return a("");
                                            }, o);
                                        }
                                    });
                                };
                                return this.cache[A] = B(t) && !g(t) ? a.default.SUPPORT_BASE64_DRAWING(t).then(r) : r(!0), A;
                            }
                        },
                        {
                            key: "isSameOrigin",
                            value: function(A) {
                                return this.getOrigin(A) === this.origin;
                            }
                        },
                        {
                            key: "getOrigin",
                            value: function(A) {
                                var t = this._link || (this._link = this._window.document.createElement("a"));
                                return t.href = A, t.href = t.href, t.protocol + t.hostname + t.port;
                            }
                        },
                        {
                            key: "ready",
                            value: function() {
                                var A = this, t = Object.keys(this.cache), e = t.map(function(t) {
                                    return A.cache[t].catch(function(A) {
                                        return null;
                                    });
                                });
                                return Promise.all(e).then(function(A) {
                                    return new c(t, A);
                                });
                            }
                        }
                    ]), A;
                }();
                t.default = s;
                var c = t.ResourceStore = function() {
                    function A(t, e) {
                        o(this, A), this._keys = t, this._resources = e;
                    }
                    return r(A, [
                        {
                            key: "get",
                            value: function(A) {
                                var t = this._keys.indexOf(A);
                                return -1 === t ? null : this._resources[t];
                            }
                        }
                    ]), A;
                }(), l = /^data:image\/svg\+xml/i, u = /^data:image\/.*;base64,/i, f = /^data:image\/.*/i, h = function(A) {
                    return f.test(A);
                }, B = function(A) {
                    return u.test(A);
                }, d = function(A) {
                    return "blob" === A.substr(0, 4);
                }, g = function(A) {
                    return "svg" === A.substr(-3).toLowerCase() || l.test(A);
                }, w = function(A, t) {
                    return new Promise(function(e, n) {
                        var r = new Image;
                        r.onload = function() {
                            return e(r);
                        }, r.onerror = n, r.src = A, !0 === r.complete && setTimeout(function() {
                            e(r);
                        }, 500), t && setTimeout(function() {
                            return n("");
                        }, t);
                    });
                };
            },
            7791: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }();
                (n = e(6915)) && n.__esModule, e(1079);
                var a = function() {
                    function A(t, e, n) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.container = t, this.parent = e, this.contexts = [], this.children = [], this.treatAsRealStackingContext = n;
                    }
                    return r(A, [
                        {
                            key: "getOpacity",
                            value: function() {
                                return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
                            }
                        },
                        {
                            key: "getRealParentStackingContext",
                            value: function() {
                                return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
                            }
                        }
                    ]), A;
                }();
                t.default = a;
            },
            2295: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseTextBounds = t.TextBounds = void 0;
                var n, r = e(2140), a = e(9083), i = (n = e(46)) && n.__esModule ? n : {
                    default: n
                }, o = e(3381), s = t.TextBounds = function A(t, e) {
                    !function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), this.text = t, this.bounds = e;
                }, c = (t.parseTextBounds = function(A, t, e) {
                    for(var n = 0 !== t.style.letterSpacing ? (0, o.toCodePoints)(A).map(function(A) {
                        return (0, o.fromCodePoint)(A);
                    }) : (0, o.breakWords)(A, t), r = n.length, u = e.parentNode ? e.parentNode.ownerDocument.defaultView : null, f = u ? u.pageXOffset : 0, h = u ? u.pageYOffset : 0, B = [], d = 0, g = 0; g < r; g++){
                        var w = n[g];
                        if (t.style.textDecoration !== a.TEXT_DECORATION.NONE || w.trim().length > 0) {
                            if (i.default.SUPPORT_RANGE_BOUNDS) B.push(new s(w, l(e, d, w.length, f, h)));
                            else {
                                var p = e.splitText(w.length);
                                B.push(new s(w, c(e, f, h))), e = p;
                            }
                        } else i.default.SUPPORT_RANGE_BOUNDS || (e = e.splitText(w.length));
                        d += w.length;
                    }
                    return B;
                }, function(A, t, e) {
                    var n = A.ownerDocument.createElement("html2canvaswrapper");
                    n.appendChild(A.cloneNode(!0));
                    var a = A.parentNode;
                    if (a) {
                        a.replaceChild(n, A);
                        var i = (0, r.parseBounds)(n, t, e);
                        return n.firstChild && a.replaceChild(n.firstChild, n), i;
                    }
                    return new r.Bounds(0, 0, 0, 0);
                }), l = function(A, t, e, n, a) {
                    var i = A.ownerDocument.createRange();
                    return i.setStart(A, t), i.setEnd(A, t + e), r.Bounds.fromClientRect(i.getBoundingClientRect(), n, a);
                };
            },
            2204: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = e(6997), a = e(2295), i = function() {
                    function A(t, e, n) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.text = t, this.parent = e, this.bounds = n;
                    }
                    return n(A, null, [
                        {
                            key: "fromTextNode",
                            value: function(t, e) {
                                var n = s(t.data, e.style.textTransform);
                                return new A(n, e, (0, a.parseTextBounds)(n, e, t));
                            }
                        }
                    ]), A;
                }();
                t.default = i;
                var o = /(^|\s|:|-|\(|\))([a-z])/g, s = function(A, t) {
                    switch(t){
                        case r.TEXT_TRANSFORM.LOWERCASE:
                            return A.toLowerCase();
                        case r.TEXT_TRANSFORM.CAPITALIZE:
                            return A.replace(o, c);
                        case r.TEXT_TRANSFORM.UPPERCASE:
                            return A.toUpperCase();
                        default:
                            return A;
                    }
                };
                function c(A, t, e) {
                    return A.length > 0 ? t + e.toUpperCase() : A;
                }
            },
            3381: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.breakWords = t.fromCodePoint = t.toCodePoints = void 0;
                var n = e(2160);
                Object.defineProperty(t, "toCodePoints", {
                    enumerable: !0,
                    get: function() {
                        return n.toCodePoints;
                    }
                }), Object.defineProperty(t, "fromCodePoint", {
                    enumerable: !0,
                    get: function() {
                        return n.fromCodePoint;
                    }
                });
                var r, a = ((r = e(6915)) && r.__esModule, e(6489));
                t.breakWords = function(A, t) {
                    for(var e = (0, n.LineBreaker)(A, {
                        lineBreak: t.style.lineBreak,
                        wordBreak: t.style.overflowWrap === a.OVERFLOW_WRAP.BREAK_WORD ? "break-word" : t.style.wordBreak
                    }), r = [], i = void 0; !(i = e.next()).done;)r.push(i.value.slice());
                    return r;
                };
            },
            5627: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.contains = function(A, t) {
                    return 0 != (A & t);
                }, t.distance = function(A, t) {
                    return Math.sqrt(A * A + t * t);
                }, t.copyCSSStyles = function(A, t) {
                    for(var e = A.length - 1; e >= 0; e--){
                        var n = A.item(e);
                        "content" !== n && t.style.setProperty(n, A.getPropertyValue(n));
                    }
                    return t;
                }, t.SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
            },
            4135: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.renderElement = void 0;
                var n = (f(e(8927)), e(6292)), r = f(e(57)), a = f(e(378)), i = f(e(46)), o = e(2140), s = e(8959), c = e(9539), l = e(8785), u = f(l);
                function f(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                t.renderElement = function A(t, e, f) {
                    var h = t.ownerDocument, B = new o.Bounds(e.scrollX, e.scrollY, e.windowWidth, e.windowHeight), d = h.documentElement ? new u.default(getComputedStyle(h.documentElement).backgroundColor) : l.TRANSPARENT, g = h.body ? new u.default(getComputedStyle(h.body).backgroundColor) : l.TRANSPARENT, w = t === h.documentElement ? d.isTransparent() ? g.isTransparent() ? e.backgroundColor ? new u.default(e.backgroundColor) : null : g : d : e.backgroundColor ? new u.default(e.backgroundColor) : null;
                    return (e.foreignObjectRendering ? i.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(!1)).then(function(i) {
                        var u;
                        return i ? (u = new s.DocumentCloner(t, e, f, !0, A)).inlineFonts(h).then(function() {
                            return u.resourceLoader.ready();
                        }).then(function() {
                            var A = new a.default(u.documentElement), n = h.defaultView, r = n.pageXOffset, i = n.pageYOffset, s = "HTML" === t.tagName || "BODY" === t.tagName ? (0, o.parseDocumentSize)(h) : (0, o.parseBounds)(t, r, i), c = s.width, l = s.height, B = s.left, d = s.top;
                            return A.render({
                                backgroundColor: w,
                                logger: f,
                                scale: e.scale,
                                x: "number" == typeof e.x ? e.x : B,
                                y: "number" == typeof e.y ? e.y : d,
                                width: "number" == typeof e.width ? e.width : Math.ceil(c),
                                height: "number" == typeof e.height ? e.height : Math.ceil(l),
                                windowWidth: e.windowWidth,
                                windowHeight: e.windowHeight,
                                scrollX: e.scrollX,
                                scrollY: e.scrollY
                            });
                        }) : (0, s.cloneWindow)(h, B, t, e, f, A).then(function(A) {
                            var t = function(A, t) {
                                if (Array.isArray(A)) return A;
                                if (Symbol.iterator in Object(A)) return function(A, t) {
                                    var e = [], n = !0, r = !1, a = void 0;
                                    try {
                                        for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                                    } catch (A) {
                                        r = !0, a = A;
                                    } finally{
                                        try {
                                            !n && o.return && o.return();
                                        } finally{
                                            if (r) throw a;
                                        }
                                    }
                                    return e;
                                }(A, t);
                                throw new TypeError("Invalid attempt to destructure non-iterable instance");
                            }(A, 3), a = t[0], i = t[1], s = t[2], u = (0, n.NodeParser)(i, s, f), B = i.ownerDocument;
                            return w === u.container.style.background.backgroundColor && (u.container.style.background.backgroundColor = l.TRANSPARENT), s.ready().then(function(A) {
                                var t = new c.FontMetrics(B), n = B.defaultView, s = n.pageXOffset, l = n.pageYOffset, d = "HTML" === i.tagName || "BODY" === i.tagName ? (0, o.parseDocumentSize)(h) : (0, o.parseBounds)(i, s, l), g = d.width, p = d.height, Q = d.left, U = d.top, v = {
                                    backgroundColor: w,
                                    fontMetrics: t,
                                    imageStore: A,
                                    logger: f,
                                    scale: e.scale,
                                    x: "number" == typeof e.x ? e.x : Q,
                                    y: "number" == typeof e.y ? e.y : U,
                                    width: "number" == typeof e.width ? e.width : Math.ceil(g),
                                    height: "number" == typeof e.height ? e.height : Math.ceil(p)
                                };
                                if (Array.isArray(e.target)) return Promise.all(e.target.map(function(A) {
                                    return new r.default(A, v).render(u);
                                }));
                                var y = new r.default(e.target, v).render(u);
                                return !0 === e.removeContainer && a.parentNode && a.parentNode.removeChild(a), y;
                            });
                        });
                    });
                };
            },
            3150: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n, r = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), a = e(8770), i = (n = e(9811)) && n.__esModule ? n : {
                    default: n
                }, o = function(A, t, e) {
                    return new i.default(A.x + (t.x - A.x) * e, A.y + (t.y - A.y) * e);
                }, s = function() {
                    function A(t, e, n, r) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.type = a.PATH.BEZIER_CURVE, this.start = t, this.startControl = e, this.endControl = n, this.end = r;
                    }
                    return r(A, [
                        {
                            key: "subdivide",
                            value: function(t, e) {
                                var n = o(this.start, this.startControl, t), r = o(this.startControl, this.endControl, t), a = o(this.endControl, this.end, t), i = o(n, r, t), s = o(r, a, t), c = o(i, s, t);
                                return e ? new A(this.start, n, i, c) : new A(c, s, a, this.end);
                            }
                        },
                        {
                            key: "reverse",
                            value: function() {
                                return new A(this.end, this.endControl, this.startControl, this.start);
                            }
                        }
                    ]), A;
                }();
                t.default = s;
            },
            2339: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = e(8770);
                t.default = function A(t, e, r) {
                    !function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), this.type = n.PATH.CIRCLE, this.x = t, this.y = e, this.radius = r;
                };
            },
            8770: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.PATH = {
                    VECTOR: 0,
                    BEZIER_CURVE: 1,
                    CIRCLE: 2
                };
            },
            9126: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function A(t, e) {
                    !function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), this.width = t, this.height = e;
                };
            },
            9811: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = e(8770);
                t.default = function A(t, e) {
                    !function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), this.type = n.PATH.VECTOR, this.x = t, this.y = e;
                };
            },
            7753: (A, t, e)=>{
                "use strict";
                var n = Object.assign || function(A) {
                    for(var t = 1; t < arguments.length; t++){
                        var e = arguments[t];
                        for(var n in e)Object.prototype.hasOwnProperty.call(e, n) && (A[n] = e[n]);
                    }
                    return A;
                }, r = o(e(6875)), a = o(e(8927)), i = e(4135);
                function o(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                var s = function(A, t) {
                    var e = t || {}, o = new a.default("boolean" != typeof e.logging || e.logging);
                    o.log("html2canvas $npm_package_version");
                    var s = A.ownerDocument;
                    if (!s) return Promise.reject("Provided element is not within a Document");
                    var c = s.defaultView, l = {
                        async: !0,
                        allowTaint: !1,
                        backgroundColor: "#ffffff",
                        imageTimeout: 15e3,
                        logging: !0,
                        proxy: null,
                        removeContainer: !0,
                        foreignObjectRendering: !1,
                        scale: c.devicePixelRatio || 1,
                        target: new r.default(e.canvas),
                        useCORS: !1,
                        windowWidth: c.innerWidth,
                        windowHeight: c.innerHeight,
                        scrollX: c.pageXOffset,
                        scrollY: c.pageYOffset
                    };
                    return (0, i.renderElement)(A, n({}, l, e), o);
                };
                s.CanvasRenderer = r.default, A.exports = s;
            },
            389: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseBackgroundImage = t.parseBackground = t.calculateBackgroundRepeatPath = t.calculateBackgroundPosition = t.calculateBackgroungPositioningArea = t.calculateBackgroungPaintingArea = t.calculateGradientBackgroundSize = t.calculateBackgroundSize = t.BACKGROUND_ORIGIN = t.BACKGROUND_CLIP = t.BACKGROUND_SIZE = t.BACKGROUND_REPEAT = void 0;
                var n = c(e(8785)), r = c(e(175)), a = c(e(9126)), i = c(e(9811)), o = e(2140), s = e(5685);
                function c(A) {
                    return A && A.__esModule ? A : {
                        default: A
                    };
                }
                var l = t.BACKGROUND_REPEAT = {
                    REPEAT: 0,
                    NO_REPEAT: 1,
                    REPEAT_X: 2,
                    REPEAT_Y: 3
                }, u = t.BACKGROUND_SIZE = {
                    AUTO: 0,
                    CONTAIN: 1,
                    COVER: 2,
                    LENGTH: 3
                }, f = t.BACKGROUND_CLIP = {
                    BORDER_BOX: 0,
                    PADDING_BOX: 1,
                    CONTENT_BOX: 2
                }, h = t.BACKGROUND_ORIGIN = f, B = "auto", d = function A(t) {
                    switch(function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), t){
                        case "contain":
                            this.size = u.CONTAIN;
                            break;
                        case "cover":
                            this.size = u.COVER;
                            break;
                        case "auto":
                            this.size = u.AUTO;
                            break;
                        default:
                            this.value = new r.default(t);
                    }
                }, g = (t.calculateBackgroundSize = function(A, t, e) {
                    var n = 0, r = 0, i = A.size;
                    if (i[0].size === u.CONTAIN || i[0].size === u.COVER) {
                        var o = e.width / e.height, s = t.width / t.height;
                        return o < s != (i[0].size === u.COVER) ? new a.default(e.width, e.width / s) : new a.default(e.height * s, e.height);
                    }
                    return i[0].value && (n = i[0].value.getAbsoluteValue(e.width)), i[0].size === u.AUTO && i[1].size === u.AUTO ? r = t.height : i[1].size === u.AUTO ? r = n / t.width * t.height : i[1].value && (r = i[1].value.getAbsoluteValue(e.height)), i[0].size === u.AUTO && (n = r / t.height * t.width), new a.default(n, r);
                }, t.calculateGradientBackgroundSize = function(A, t) {
                    var e = A.size, n = e[0].value ? e[0].value.getAbsoluteValue(t.width) : t.width, r = e[1].value ? e[1].value.getAbsoluteValue(t.height) : e[0].value ? n : t.height;
                    return new a.default(n, r);
                }, new d(B)), w = (t.calculateBackgroungPaintingArea = function(A, t) {
                    switch(t){
                        case f.BORDER_BOX:
                            return (0, o.calculateBorderBoxPath)(A);
                        case f.PADDING_BOX:
                        default:
                            return (0, o.calculatePaddingBoxPath)(A);
                    }
                }, t.calculateBackgroungPositioningArea = function(A, t, e, n) {
                    var r = (0, o.calculatePaddingBox)(t, n);
                    switch(A){
                        case h.BORDER_BOX:
                            return t;
                        case h.CONTENT_BOX:
                            var a = e[s.PADDING_SIDES.LEFT].getAbsoluteValue(t.width), i = e[s.PADDING_SIDES.RIGHT].getAbsoluteValue(t.width), c = e[s.PADDING_SIDES.TOP].getAbsoluteValue(t.width), l = e[s.PADDING_SIDES.BOTTOM].getAbsoluteValue(t.width);
                            return new o.Bounds(r.left + a, r.top + c, r.width - a - i, r.height - c - l);
                        case h.PADDING_BOX:
                        default:
                            return r;
                    }
                }, t.calculateBackgroundPosition = function(A, t, e) {
                    return new i.default(A[0].getAbsoluteValue(e.width - t.width), A[1].getAbsoluteValue(e.height - t.height));
                }, t.calculateBackgroundRepeatPath = function(A, t, e, n, r) {
                    switch(A.repeat){
                        case l.REPEAT_X:
                            return [
                                new i.default(Math.round(r.left), Math.round(n.top + t.y)),
                                new i.default(Math.round(r.left + r.width), Math.round(n.top + t.y)),
                                new i.default(Math.round(r.left + r.width), Math.round(e.height + n.top + t.y)),
                                new i.default(Math.round(r.left), Math.round(e.height + n.top + t.y))
                            ];
                        case l.REPEAT_Y:
                            return [
                                new i.default(Math.round(n.left + t.x), Math.round(r.top)),
                                new i.default(Math.round(n.left + t.x + e.width), Math.round(r.top)),
                                new i.default(Math.round(n.left + t.x + e.width), Math.round(r.height + r.top)),
                                new i.default(Math.round(n.left + t.x), Math.round(r.height + r.top))
                            ];
                        case l.NO_REPEAT:
                            return [
                                new i.default(Math.round(n.left + t.x), Math.round(n.top + t.y)),
                                new i.default(Math.round(n.left + t.x + e.width), Math.round(n.top + t.y)),
                                new i.default(Math.round(n.left + t.x + e.width), Math.round(n.top + t.y + e.height)),
                                new i.default(Math.round(n.left + t.x), Math.round(n.top + t.y + e.height))
                            ];
                        default:
                            return [
                                new i.default(Math.round(r.left), Math.round(r.top)),
                                new i.default(Math.round(r.left + r.width), Math.round(r.top)),
                                new i.default(Math.round(r.left + r.width), Math.round(r.height + r.top)),
                                new i.default(Math.round(r.left), Math.round(r.height + r.top))
                            ];
                    }
                }, t.parseBackground = function(A, t) {
                    return {
                        backgroundColor: new n.default(A.backgroundColor),
                        backgroundImage: U(A, t),
                        backgroundClip: w(A.backgroundClip),
                        backgroundOrigin: p(A.backgroundOrigin)
                    };
                }, function(A) {
                    switch(A){
                        case "padding-box":
                            return f.PADDING_BOX;
                        case "content-box":
                            return f.CONTENT_BOX;
                    }
                    return f.BORDER_BOX;
                }), p = function(A) {
                    switch(A){
                        case "padding-box":
                            return h.PADDING_BOX;
                        case "content-box":
                            return h.CONTENT_BOX;
                    }
                    return h.BORDER_BOX;
                }, Q = function(A) {
                    switch(A.trim()){
                        case "no-repeat":
                            return l.NO_REPEAT;
                        case "repeat-x":
                        case "repeat no-repeat":
                            return l.REPEAT_X;
                        case "repeat-y":
                        case "no-repeat repeat":
                            return l.REPEAT_Y;
                        case "repeat":
                            return l.REPEAT;
                    }
                    return l.REPEAT;
                }, U = function(A, t) {
                    var e = C(A.backgroundImage).map(function(A) {
                        if ("url" === A.method) {
                            var e = t.loadImage(A.args[0]);
                            A.args = e ? [
                                e
                            ] : [];
                        }
                        return A;
                    }), n = A.backgroundPosition.split(","), r = A.backgroundRepeat.split(","), a = A.backgroundSize.split(",");
                    return e.map(function(A, t) {
                        var e = (a[t] || B).trim().split(" ").map(v), i = (n[t] || B).trim().split(" ").map(y);
                        return {
                            source: A,
                            repeat: Q("string" == typeof r[t] ? r[t] : r[0]),
                            size: e.length < 2 ? [
                                e[0],
                                g
                            ] : [
                                e[0],
                                e[1]
                            ],
                            position: i.length < 2 ? [
                                i[0],
                                i[0]
                            ] : [
                                i[0],
                                i[1]
                            ]
                        };
                    });
                }, v = function(A) {
                    return "auto" === A ? g : new d(A);
                }, y = function(A) {
                    switch(A){
                        case "bottom":
                        case "right":
                            return new r.default("100%");
                        case "left":
                        case "top":
                            return new r.default("0%");
                        case "auto":
                            return new r.default("0");
                    }
                    return new r.default(A);
                }, C = t.parseBackgroundImage = function(A) {
                    var t = /^\s$/, e = [], n = [], r = "", a = null, i = "", o = 0, s = 0, c = function() {
                        var A = "";
                        if (r) {
                            '"' === i.substr(0, 1) && (i = i.substr(1, i.length - 2)), i && n.push(i.trim());
                            var t = r.indexOf("-", 1) + 1;
                            "-" === r.substr(0, 1) && t > 0 && (A = r.substr(0, t).toLowerCase(), r = r.substr(t)), "none" !== (r = r.toLowerCase()) && e.push({
                                prefix: A,
                                method: r,
                                args: n
                            });
                        }
                        n = [], r = i = "";
                    };
                    return A.split("").forEach(function(A) {
                        if (0 !== o || !t.test(A)) {
                            switch(A){
                                case '"':
                                    a ? a === A && (a = null) : a = A;
                                    break;
                                case "(":
                                    if (a) break;
                                    if (0 === o) return void (o = 1);
                                    s++;
                                    break;
                                case ")":
                                    if (a) break;
                                    if (1 === o) {
                                        if (0 === s) return o = 0, void c();
                                        s--;
                                    }
                                    break;
                                case ",":
                                    if (a) break;
                                    if (0 === o) return void c();
                                    if (1 === o && 0 === s && !r.match(/^url$/i)) return n.push(i.trim()), void (i = "");
                            }
                            0 === o ? r += A : i += A;
                        }
                    }), c(), e;
                };
            },
            4591: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseBorder = t.BORDER_SIDES = t.BORDER_STYLE = void 0;
                var n, r = (n = e(8785)) && n.__esModule ? n : {
                    default: n
                }, a = t.BORDER_STYLE = {
                    NONE: 0,
                    SOLID: 1
                }, i = t.BORDER_SIDES = {
                    TOP: 0,
                    RIGHT: 1,
                    BOTTOM: 2,
                    LEFT: 3
                }, o = Object.keys(i).map(function(A) {
                    return A.toLowerCase();
                });
                t.parseBorder = function(A) {
                    return o.map(function(t) {
                        var e = new r.default(A.getPropertyValue("border-" + t + "-color")), n = function(A) {
                            switch(A){
                                case "none":
                                    return a.NONE;
                            }
                            return a.SOLID;
                        }(A.getPropertyValue("border-" + t + "-style")), i = parseFloat(A.getPropertyValue("border-" + t + "-width"));
                        return {
                            borderColor: e,
                            borderStyle: n,
                            borderWidth: isNaN(i) ? 0 : i
                        };
                    });
                };
            },
            4022: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseBorderRadius = void 0;
                var n, r = (n = e(175)) && n.__esModule ? n : {
                    default: n
                }, a = [
                    "top-left",
                    "top-right",
                    "bottom-right",
                    "bottom-left"
                ];
                t.parseBorderRadius = function(A) {
                    return a.map(function(t) {
                        var e = function(A, t) {
                            if (Array.isArray(A)) return A;
                            if (Symbol.iterator in Object(A)) return function(A, t) {
                                var e = [], n = !0, r = !1, a = void 0;
                                try {
                                    for(var i, o = A[Symbol.iterator](); !(n = (i = o.next()).done) && (e.push(i.value), !t || e.length !== t); n = !0);
                                } catch (A) {
                                    r = !0, a = A;
                                } finally{
                                    try {
                                        !n && o.return && o.return();
                                    } finally{
                                        if (r) throw a;
                                    }
                                }
                                return e;
                            }(A, t);
                            throw new TypeError("Invalid attempt to destructure non-iterable instance");
                        }(A.getPropertyValue("border-" + t + "-radius").split(" ").map(r.default.create), 2), n = e[0], a = e[1];
                        return void 0 === a ? [
                            n,
                            n
                        ] : [
                            n,
                            a
                        ];
                    });
                };
            },
            1040: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.DISPLAY = {
                    NONE: 1,
                    BLOCK: 2,
                    INLINE: 4,
                    RUN_IN: 8,
                    FLOW: 16,
                    FLOW_ROOT: 32,
                    TABLE: 64,
                    FLEX: 128,
                    GRID: 256,
                    RUBY: 512,
                    SUBGRID: 1024,
                    LIST_ITEM: 2048,
                    TABLE_ROW_GROUP: 4096,
                    TABLE_HEADER_GROUP: 8192,
                    TABLE_FOOTER_GROUP: 16384,
                    TABLE_ROW: 32768,
                    TABLE_CELL: 65536,
                    TABLE_COLUMN_GROUP: 131072,
                    TABLE_COLUMN: 262144,
                    TABLE_CAPTION: 524288,
                    RUBY_BASE: 1048576,
                    RUBY_TEXT: 2097152,
                    RUBY_BASE_CONTAINER: 4194304,
                    RUBY_TEXT_CONTAINER: 8388608,
                    CONTENTS: 16777216,
                    INLINE_BLOCK: 33554432,
                    INLINE_LIST_ITEM: 67108864,
                    INLINE_TABLE: 134217728,
                    INLINE_FLEX: 268435456,
                    INLINE_GRID: 536870912
                }, n = function(A, t) {
                    return A | function(A) {
                        switch(A){
                            case "block":
                                return e.BLOCK;
                            case "inline":
                                return e.INLINE;
                            case "run-in":
                                return e.RUN_IN;
                            case "flow":
                                return e.FLOW;
                            case "flow-root":
                                return e.FLOW_ROOT;
                            case "table":
                                return e.TABLE;
                            case "flex":
                                return e.FLEX;
                            case "grid":
                                return e.GRID;
                            case "ruby":
                                return e.RUBY;
                            case "subgrid":
                                return e.SUBGRID;
                            case "list-item":
                                return e.LIST_ITEM;
                            case "table-row-group":
                                return e.TABLE_ROW_GROUP;
                            case "table-header-group":
                                return e.TABLE_HEADER_GROUP;
                            case "table-footer-group":
                                return e.TABLE_FOOTER_GROUP;
                            case "table-row":
                                return e.TABLE_ROW;
                            case "table-cell":
                                return e.TABLE_CELL;
                            case "table-column-group":
                                return e.TABLE_COLUMN_GROUP;
                            case "table-column":
                                return e.TABLE_COLUMN;
                            case "table-caption":
                                return e.TABLE_CAPTION;
                            case "ruby-base":
                                return e.RUBY_BASE;
                            case "ruby-text":
                                return e.RUBY_TEXT;
                            case "ruby-base-container":
                                return e.RUBY_BASE_CONTAINER;
                            case "ruby-text-container":
                                return e.RUBY_TEXT_CONTAINER;
                            case "contents":
                                return e.CONTENTS;
                            case "inline-block":
                                return e.INLINE_BLOCK;
                            case "inline-list-item":
                                return e.INLINE_LIST_ITEM;
                            case "inline-table":
                                return e.INLINE_TABLE;
                            case "inline-flex":
                                return e.INLINE_FLEX;
                            case "inline-grid":
                                return e.INLINE_GRID;
                        }
                        return e.NONE;
                    }(t);
                };
                t.parseDisplay = function(A) {
                    return A.split(" ").reduce(n, 0);
                };
            },
            8905: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.FLOAT = {
                    NONE: 0,
                    LEFT: 1,
                    RIGHT: 2,
                    INLINE_START: 3,
                    INLINE_END: 4
                };
                t.parseCSSFloat = function(A) {
                    switch(A){
                        case "left":
                            return e.LEFT;
                        case "right":
                            return e.RIGHT;
                        case "inline-start":
                            return e.INLINE_START;
                        case "inline-end":
                            return e.INLINE_END;
                    }
                    return e.NONE;
                };
            },
            5299: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseFont = function(A) {
                    return {
                        fontFamily: A.fontFamily,
                        fontSize: A.fontSize,
                        fontStyle: A.fontStyle,
                        fontVariant: A.fontVariant,
                        fontWeight: function(A) {
                            switch(A){
                                case "normal":
                                    return 400;
                                case "bold":
                                    return 700;
                            }
                            var t = parseInt(A, 10);
                            return isNaN(t) ? 400 : t;
                        }(A.fontWeight)
                    };
                };
            },
            8700: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseLetterSpacing = function(A) {
                    if ("normal" === A) return 0;
                    var t = parseFloat(A);
                    return isNaN(t) ? 0 : t;
                };
            },
            3198: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.LINE_BREAK = {
                    NORMAL: "normal",
                    STRICT: "strict"
                };
                t.parseLineBreak = function(A) {
                    switch(A){
                        case "strict":
                            return e.STRICT;
                        case "normal":
                        default:
                            return e.NORMAL;
                    }
                };
            },
            2584: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseListStyle = t.parseListStyleType = t.LIST_STYLE_TYPE = t.LIST_STYLE_POSITION = void 0;
                var n = e(389), r = t.LIST_STYLE_POSITION = {
                    INSIDE: 0,
                    OUTSIDE: 1
                }, a = t.LIST_STYLE_TYPE = {
                    NONE: -1,
                    DISC: 0,
                    CIRCLE: 1,
                    SQUARE: 2,
                    DECIMAL: 3,
                    CJK_DECIMAL: 4,
                    DECIMAL_LEADING_ZERO: 5,
                    LOWER_ROMAN: 6,
                    UPPER_ROMAN: 7,
                    LOWER_GREEK: 8,
                    LOWER_ALPHA: 9,
                    UPPER_ALPHA: 10,
                    ARABIC_INDIC: 11,
                    ARMENIAN: 12,
                    BENGALI: 13,
                    CAMBODIAN: 14,
                    CJK_EARTHLY_BRANCH: 15,
                    CJK_HEAVENLY_STEM: 16,
                    CJK_IDEOGRAPHIC: 17,
                    DEVANAGARI: 18,
                    ETHIOPIC_NUMERIC: 19,
                    GEORGIAN: 20,
                    GUJARATI: 21,
                    GURMUKHI: 22,
                    HEBREW: 22,
                    HIRAGANA: 23,
                    HIRAGANA_IROHA: 24,
                    JAPANESE_FORMAL: 25,
                    JAPANESE_INFORMAL: 26,
                    KANNADA: 27,
                    KATAKANA: 28,
                    KATAKANA_IROHA: 29,
                    KHMER: 30,
                    KOREAN_HANGUL_FORMAL: 31,
                    KOREAN_HANJA_FORMAL: 32,
                    KOREAN_HANJA_INFORMAL: 33,
                    LAO: 34,
                    LOWER_ARMENIAN: 35,
                    MALAYALAM: 36,
                    MONGOLIAN: 37,
                    MYANMAR: 38,
                    ORIYA: 39,
                    PERSIAN: 40,
                    SIMP_CHINESE_FORMAL: 41,
                    SIMP_CHINESE_INFORMAL: 42,
                    TAMIL: 43,
                    TELUGU: 44,
                    THAI: 45,
                    TIBETAN: 46,
                    TRAD_CHINESE_FORMAL: 47,
                    TRAD_CHINESE_INFORMAL: 48,
                    UPPER_ARMENIAN: 49,
                    DISCLOSURE_OPEN: 50,
                    DISCLOSURE_CLOSED: 51
                }, i = t.parseListStyleType = function(A) {
                    switch(A){
                        case "disc":
                            return a.DISC;
                        case "circle":
                            return a.CIRCLE;
                        case "square":
                            return a.SQUARE;
                        case "decimal":
                            return a.DECIMAL;
                        case "cjk-decimal":
                            return a.CJK_DECIMAL;
                        case "decimal-leading-zero":
                            return a.DECIMAL_LEADING_ZERO;
                        case "lower-roman":
                            return a.LOWER_ROMAN;
                        case "upper-roman":
                            return a.UPPER_ROMAN;
                        case "lower-greek":
                            return a.LOWER_GREEK;
                        case "lower-alpha":
                            return a.LOWER_ALPHA;
                        case "upper-alpha":
                            return a.UPPER_ALPHA;
                        case "arabic-indic":
                            return a.ARABIC_INDIC;
                        case "armenian":
                            return a.ARMENIAN;
                        case "bengali":
                            return a.BENGALI;
                        case "cambodian":
                            return a.CAMBODIAN;
                        case "cjk-earthly-branch":
                            return a.CJK_EARTHLY_BRANCH;
                        case "cjk-heavenly-stem":
                            return a.CJK_HEAVENLY_STEM;
                        case "cjk-ideographic":
                            return a.CJK_IDEOGRAPHIC;
                        case "devanagari":
                            return a.DEVANAGARI;
                        case "ethiopic-numeric":
                            return a.ETHIOPIC_NUMERIC;
                        case "georgian":
                            return a.GEORGIAN;
                        case "gujarati":
                            return a.GUJARATI;
                        case "gurmukhi":
                            return a.GURMUKHI;
                        case "hebrew":
                            return a.HEBREW;
                        case "hiragana":
                            return a.HIRAGANA;
                        case "hiragana-iroha":
                            return a.HIRAGANA_IROHA;
                        case "japanese-formal":
                            return a.JAPANESE_FORMAL;
                        case "japanese-informal":
                            return a.JAPANESE_INFORMAL;
                        case "kannada":
                            return a.KANNADA;
                        case "katakana":
                            return a.KATAKANA;
                        case "katakana-iroha":
                            return a.KATAKANA_IROHA;
                        case "khmer":
                            return a.KHMER;
                        case "korean-hangul-formal":
                            return a.KOREAN_HANGUL_FORMAL;
                        case "korean-hanja-formal":
                            return a.KOREAN_HANJA_FORMAL;
                        case "korean-hanja-informal":
                            return a.KOREAN_HANJA_INFORMAL;
                        case "lao":
                            return a.LAO;
                        case "lower-armenian":
                            return a.LOWER_ARMENIAN;
                        case "malayalam":
                            return a.MALAYALAM;
                        case "mongolian":
                            return a.MONGOLIAN;
                        case "myanmar":
                            return a.MYANMAR;
                        case "oriya":
                            return a.ORIYA;
                        case "persian":
                            return a.PERSIAN;
                        case "simp-chinese-formal":
                            return a.SIMP_CHINESE_FORMAL;
                        case "simp-chinese-informal":
                            return a.SIMP_CHINESE_INFORMAL;
                        case "tamil":
                            return a.TAMIL;
                        case "telugu":
                            return a.TELUGU;
                        case "thai":
                            return a.THAI;
                        case "tibetan":
                            return a.TIBETAN;
                        case "trad-chinese-formal":
                            return a.TRAD_CHINESE_FORMAL;
                        case "trad-chinese-informal":
                            return a.TRAD_CHINESE_INFORMAL;
                        case "upper-armenian":
                            return a.UPPER_ARMENIAN;
                        case "disclosure-open":
                            return a.DISCLOSURE_OPEN;
                        case "disclosure-closed":
                            return a.DISCLOSURE_CLOSED;
                        case "none":
                        default:
                            return a.NONE;
                    }
                }, o = (t.parseListStyle = function(A) {
                    var t = (0, n.parseBackgroundImage)(A.getPropertyValue("list-style-image"));
                    return {
                        listStyleType: i(A.getPropertyValue("list-style-type")),
                        listStyleImage: t.length ? t[0] : null,
                        listStylePosition: o(A.getPropertyValue("list-style-position"))
                    };
                }, function(A) {
                    switch(A){
                        case "inside":
                            return r.INSIDE;
                        case "outside":
                        default:
                            return r.OUTSIDE;
                    }
                });
            },
            4944: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseMargin = void 0;
                var n, r = (n = e(175)) && n.__esModule ? n : {
                    default: n
                }, a = [
                    "top",
                    "right",
                    "bottom",
                    "left"
                ];
                t.parseMargin = function(A) {
                    return a.map(function(t) {
                        return new r.default(A.getPropertyValue("margin-" + t));
                    });
                };
            },
            2570: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.OVERFLOW = {
                    VISIBLE: 0,
                    HIDDEN: 1,
                    SCROLL: 2,
                    AUTO: 3
                };
                t.parseOverflow = function(A) {
                    switch(A){
                        case "hidden":
                            return e.HIDDEN;
                        case "scroll":
                            return e.SCROLL;
                        case "auto":
                            return e.AUTO;
                        case "visible":
                        default:
                            return e.VISIBLE;
                    }
                };
            },
            6489: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.OVERFLOW_WRAP = {
                    NORMAL: 0,
                    BREAK_WORD: 1
                };
                t.parseOverflowWrap = function(A) {
                    switch(A){
                        case "break-word":
                            return e.BREAK_WORD;
                        case "normal":
                        default:
                            return e.NORMAL;
                    }
                };
            },
            5685: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parsePadding = t.PADDING_SIDES = void 0;
                var n, r = (n = e(175)) && n.__esModule ? n : {
                    default: n
                };
                t.PADDING_SIDES = {
                    TOP: 0,
                    RIGHT: 1,
                    BOTTOM: 2,
                    LEFT: 3
                };
                var a = [
                    "top",
                    "right",
                    "bottom",
                    "left"
                ];
                t.parsePadding = function(A) {
                    return a.map(function(t) {
                        return new r.default(A.getPropertyValue("padding-" + t));
                    });
                };
            },
            1079: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.POSITION = {
                    STATIC: 0,
                    RELATIVE: 1,
                    ABSOLUTE: 2,
                    FIXED: 3,
                    STICKY: 4
                };
                t.parsePosition = function(A) {
                    switch(A){
                        case "relative":
                            return e.RELATIVE;
                        case "absolute":
                            return e.ABSOLUTE;
                        case "fixed":
                            return e.FIXED;
                        case "sticky":
                            return e.STICKY;
                    }
                    return e.STATIC;
                };
            },
            9083: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseTextDecoration = t.TEXT_DECORATION_LINE = t.TEXT_DECORATION = t.TEXT_DECORATION_STYLE = void 0;
                var n, r = (n = e(8785)) && n.__esModule ? n : {
                    default: n
                }, a = t.TEXT_DECORATION_STYLE = {
                    SOLID: 0,
                    DOUBLE: 1,
                    DOTTED: 2,
                    DASHED: 3,
                    WAVY: 4
                }, i = t.TEXT_DECORATION = {
                    NONE: null
                }, o = t.TEXT_DECORATION_LINE = {
                    UNDERLINE: 1,
                    OVERLINE: 2,
                    LINE_THROUGH: 3,
                    BLINK: 4
                }, s = function(A) {
                    switch(A){
                        case "underline":
                            return o.UNDERLINE;
                        case "overline":
                            return o.OVERLINE;
                        case "line-through":
                            return o.LINE_THROUGH;
                    }
                    return o.BLINK;
                };
                t.parseTextDecoration = function(A) {
                    var t, e = "none" === (t = A.textDecorationLine ? A.textDecorationLine : A.textDecoration) ? null : t.split(" ").map(s);
                    return null === e ? i.NONE : {
                        textDecorationLine: e,
                        textDecorationColor: A.textDecorationColor ? new r.default(A.textDecorationColor) : null,
                        textDecorationStyle: function(A) {
                            switch(A){
                                case "double":
                                    return a.DOUBLE;
                                case "dotted":
                                    return a.DOTTED;
                                case "dashed":
                                    return a.DASHED;
                                case "wavy":
                                    return a.WAVY;
                            }
                            return a.SOLID;
                        }(A.textDecorationStyle)
                    };
                };
            },
            8917: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseTextShadow = void 0;
                var n, r = (n = e(8785)) && n.__esModule ? n : {
                    default: n
                }, a = /^([+-]|\d|\.)$/i;
                t.parseTextShadow = function(A) {
                    if ("none" === A || "string" != typeof A) return null;
                    for(var t = "", e = !1, n = [], i = [], o = 0, s = null, c = function() {
                        t.length && (e ? n.push(parseFloat(t)) : s = new r.default(t)), e = !1, t = "";
                    }, l = function() {
                        n.length && null !== s && i.push({
                            color: s,
                            offsetX: n[0] || 0,
                            offsetY: n[1] || 0,
                            blur: n[2] || 0
                        }), n.splice(0, n.length), s = null;
                    }, u = 0; u < A.length; u++){
                        var f = A[u];
                        switch(f){
                            case "(":
                                t += f, o++;
                                break;
                            case ")":
                                t += f, o--;
                                break;
                            case ",":
                                0 === o ? (c(), l()) : t += f;
                                break;
                            case " ":
                                0 === o ? c() : t += f;
                                break;
                            default:
                                0 === t.length && a.test(f) && (e = !0), t += f;
                        }
                    }
                    return c(), l(), 0 === i.length ? null : i;
                };
            },
            6997: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.TEXT_TRANSFORM = {
                    NONE: 0,
                    LOWERCASE: 1,
                    UPPERCASE: 2,
                    CAPITALIZE: 3
                };
                t.parseTextTransform = function(A) {
                    switch(A){
                        case "uppercase":
                            return e.UPPERCASE;
                        case "lowercase":
                            return e.LOWERCASE;
                        case "capitalize":
                            return e.CAPITALIZE;
                    }
                    return e.NONE;
                };
            },
            5809: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseTransform = void 0;
                var n, r = (n = e(175)) && n.__esModule ? n : {
                    default: n
                }, a = function(A) {
                    return parseFloat(A.trim());
                }, i = /(matrix|matrix3d)\((.+)\)/, o = (t.parseTransform = function(A) {
                    var t = s(A.transform || A.webkitTransform || A.mozTransform || A.msTransform || A.oTransform);
                    return null === t ? null : {
                        transform: t,
                        transformOrigin: o(A.transformOrigin || A.webkitTransformOrigin || A.mozTransformOrigin || A.msTransformOrigin || A.oTransformOrigin)
                    };
                }, function(A) {
                    if ("string" != typeof A) {
                        var t = new r.default("0");
                        return [
                            t,
                            t
                        ];
                    }
                    var e = A.split(" ").map(r.default.create);
                    return [
                        e[0],
                        e[1]
                    ];
                }), s = function(A) {
                    if ("none" === A || "string" != typeof A) return null;
                    var t = A.match(i);
                    if (t) {
                        if ("matrix" === t[1]) {
                            var e = t[2].split(",").map(a);
                            return [
                                e[0],
                                e[1],
                                e[2],
                                e[3],
                                e[4],
                                e[5]
                            ];
                        }
                        var n = t[2].split(",").map(a);
                        return [
                            n[0],
                            n[1],
                            n[4],
                            n[5],
                            n[12],
                            n[13]
                        ];
                    }
                    return null;
                };
            },
            9897: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.VISIBILITY = {
                    VISIBLE: 0,
                    HIDDEN: 1,
                    COLLAPSE: 2
                };
                t.parseVisibility = function(A) {
                    switch(A){
                        case "hidden":
                            return e.HIDDEN;
                        case "collapse":
                            return e.COLLAPSE;
                        case "visible":
                        default:
                            return e.VISIBLE;
                    }
                };
            },
            9265: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = t.WORD_BREAK = {
                    NORMAL: "normal",
                    BREAK_ALL: "break-all",
                    KEEP_ALL: "keep-all"
                };
                t.parseWordBreak = function(A) {
                    switch(A){
                        case "break-all":
                            return e.BREAK_ALL;
                        case "keep-all":
                            return e.KEEP_ALL;
                        case "normal":
                        default:
                            return e.NORMAL;
                    }
                };
            },
            4526: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.parseZIndex = function(A) {
                    var t = "auto" === A;
                    return {
                        auto: t,
                        order: t ? 0 : parseInt(A, 10)
                    };
                };
            },
            6875: (A, t, e)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var n = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), r = e(8770), a = e(9083), i = function(A, t) {
                    var e = Math.max.apply(null, A.colorStops.map(function(A) {
                        return A.stop;
                    })), n = 1 / Math.max(1, e);
                    A.colorStops.forEach(function(A) {
                        t.addColorStop(n * A.stop, A.color.toString());
                    });
                }, o = function() {
                    function A(t) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.canvas = t || document.createElement("canvas");
                    }
                    return n(A, [
                        {
                            key: "render",
                            value: function(A) {
                                this.ctx = this.canvas.getContext("2d"), this.options = A, this.canvas.width = Math.floor(A.width * A.scale), this.canvas.height = Math.floor(A.height * A.scale), this.canvas.style.width = A.width + "px", this.canvas.style.height = A.height + "px", this.ctx.scale(this.options.scale, this.options.scale), this.ctx.translate(-A.x, -A.y), this.ctx.textBaseline = "bottom", A.logger.log("Canvas renderer initialized (" + A.width + "x" + A.height + " at " + A.x + "," + A.y + ") with scale " + this.options.scale);
                            }
                        },
                        {
                            key: "clip",
                            value: function(A, t) {
                                var e = this;
                                A.length && (this.ctx.save(), A.forEach(function(A) {
                                    e.path(A), e.ctx.clip();
                                })), t(), A.length && this.ctx.restore();
                            }
                        },
                        {
                            key: "drawImage",
                            value: function(A, t, e) {
                                this.ctx.drawImage(A, t.left, t.top, t.width, t.height, e.left, e.top, e.width, e.height);
                            }
                        },
                        {
                            key: "drawShape",
                            value: function(A, t) {
                                this.path(A), this.ctx.fillStyle = t.toString(), this.ctx.fill();
                            }
                        },
                        {
                            key: "fill",
                            value: function(A) {
                                this.ctx.fillStyle = A.toString(), this.ctx.fill();
                            }
                        },
                        {
                            key: "getTarget",
                            value: function() {
                                return this.canvas.getContext("2d").setTransform(1, 0, 0, 1, 0, 0), Promise.resolve(this.canvas);
                            }
                        },
                        {
                            key: "path",
                            value: function(A) {
                                var t = this;
                                this.ctx.beginPath(), Array.isArray(A) ? A.forEach(function(A, e) {
                                    var n = A.type === r.PATH.VECTOR ? A : A.start;
                                    0 === e ? t.ctx.moveTo(n.x, n.y) : t.ctx.lineTo(n.x, n.y), A.type === r.PATH.BEZIER_CURVE && t.ctx.bezierCurveTo(A.startControl.x, A.startControl.y, A.endControl.x, A.endControl.y, A.end.x, A.end.y);
                                }) : this.ctx.arc(A.x + A.radius, A.y + A.radius, A.radius, 0, 2 * Math.PI, !0), this.ctx.closePath();
                            }
                        },
                        {
                            key: "rectangle",
                            value: function(A, t, e, n, r) {
                                this.ctx.fillStyle = r.toString(), this.ctx.fillRect(A, t, e, n);
                            }
                        },
                        {
                            key: "renderLinearGradient",
                            value: function(A, t) {
                                var e = this.ctx.createLinearGradient(A.left + t.direction.x1, A.top + t.direction.y1, A.left + t.direction.x0, A.top + t.direction.y0);
                                i(t, e), this.ctx.fillStyle = e, this.ctx.fillRect(A.left, A.top, A.width, A.height);
                            }
                        },
                        {
                            key: "renderRadialGradient",
                            value: function(A, t) {
                                var e = this, n = A.left + t.center.x, r = A.top + t.center.y, a = this.ctx.createRadialGradient(n, r, 0, n, r, t.radius.x);
                                if (a) {
                                    if (i(t, a), this.ctx.fillStyle = a, t.radius.x !== t.radius.y) {
                                        var o = A.left + .5 * A.width, s = A.top + .5 * A.height, c = t.radius.y / t.radius.x, l = 1 / c;
                                        this.transform(o, s, [
                                            1,
                                            0,
                                            0,
                                            c,
                                            0,
                                            0
                                        ], function() {
                                            return e.ctx.fillRect(A.left, l * (A.top - s) + s, A.width, A.height * l);
                                        });
                                    } else this.ctx.fillRect(A.left, A.top, A.width, A.height);
                                }
                            }
                        },
                        {
                            key: "renderRepeat",
                            value: function(A, t, e, n, r) {
                                this.path(A), this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(t, e), "repeat"), this.ctx.translate(n, r), this.ctx.fill(), this.ctx.translate(-n, -r);
                            }
                        },
                        {
                            key: "renderTextNode",
                            value: function(A, t, e, n, r) {
                                var i = this;
                                this.ctx.font = [
                                    e.fontStyle,
                                    e.fontVariant,
                                    e.fontWeight,
                                    e.fontSize,
                                    e.fontFamily
                                ].join(" "), A.forEach(function(A) {
                                    if (i.ctx.fillStyle = t.toString(), r && A.text.trim().length ? r.slice(0).reverse().forEach(function(t) {
                                        i.ctx.shadowColor = t.color.toString(), i.ctx.shadowOffsetX = t.offsetX * i.options.scale, i.ctx.shadowOffsetY = t.offsetY * i.options.scale, i.ctx.shadowBlur = t.blur, i.ctx.fillText(A.text, A.bounds.left, A.bounds.top + A.bounds.height);
                                    }) : i.ctx.fillText(A.text, A.bounds.left, A.bounds.top + A.bounds.height), null !== n) {
                                        var o = n.textDecorationColor || t;
                                        n.textDecorationLine.forEach(function(t) {
                                            switch(t){
                                                case a.TEXT_DECORATION_LINE.UNDERLINE:
                                                    var n = i.options.fontMetrics.getMetrics(e).baseline;
                                                    i.rectangle(A.bounds.left, Math.round(A.bounds.top + n), A.bounds.width, 1, o);
                                                    break;
                                                case a.TEXT_DECORATION_LINE.OVERLINE:
                                                    i.rectangle(A.bounds.left, Math.round(A.bounds.top), A.bounds.width, 1, o);
                                                    break;
                                                case a.TEXT_DECORATION_LINE.LINE_THROUGH:
                                                    var r = i.options.fontMetrics.getMetrics(e).middle;
                                                    i.rectangle(A.bounds.left, Math.ceil(A.bounds.top + r), A.bounds.width, 1, o);
                                            }
                                        });
                                    }
                                });
                            }
                        },
                        {
                            key: "resizeImage",
                            value: function(A, t) {
                                if (A.width === t.width && A.height === t.height) return A;
                                var e = this.canvas.ownerDocument.createElement("canvas");
                                return e.width = t.width, e.height = t.height, e.getContext("2d").drawImage(A, 0, 0, A.width, A.height, 0, 0, t.width, t.height), e;
                            }
                        },
                        {
                            key: "setOpacity",
                            value: function(A) {
                                this.ctx.globalAlpha = A;
                            }
                        },
                        {
                            key: "transform",
                            value: function(A, t, e, n) {
                                this.ctx.save(), this.ctx.translate(A, t), this.ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]), this.ctx.translate(-A, -t), n(), this.ctx.restore();
                            }
                        }
                    ]), A;
                }();
                t.default = o;
            },
            378: (A, t)=>{
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                });
                var e = function() {
                    function A(A, t) {
                        for(var e = 0; e < t.length; e++){
                            var n = t[e];
                            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                        }
                    }
                    return function(t, e, n) {
                        return e && A(t.prototype, e), n && A(t, n), t;
                    };
                }(), n = function() {
                    function A(t) {
                        !function(A, t) {
                            if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, A), this.element = t;
                    }
                    return e(A, [
                        {
                            key: "render",
                            value: function(A) {
                                var t = this;
                                this.options = A, this.canvas = document.createElement("canvas"), this.ctx = this.canvas.getContext("2d"), this.canvas.width = Math.floor(A.width) * A.scale, this.canvas.height = Math.floor(A.height) * A.scale, this.canvas.style.width = A.width + "px", this.canvas.style.height = A.height + "px", A.logger.log("ForeignObject renderer initialized (" + A.width + "x" + A.height + " at " + A.x + "," + A.y + ") with scale " + A.scale);
                                var e = r(Math.max(A.windowWidth, A.width) * A.scale, Math.max(A.windowHeight, A.height) * A.scale, A.scrollX * A.scale, A.scrollY * A.scale, this.element);
                                return a(e).then(function(e) {
                                    return A.backgroundColor && (t.ctx.fillStyle = A.backgroundColor.toString(), t.ctx.fillRect(0, 0, A.width * A.scale, A.height * A.scale)), t.ctx.drawImage(e, -A.x * A.scale, -A.y * A.scale), t.canvas;
                                });
                            }
                        }
                    ]), A;
                }();
                t.default = n;
                var r = t.createForeignObjectSVG = function(A, t, e, n, r) {
                    var a = "http://www.w3.org/2000/svg", i = document.createElementNS(a, "svg"), o = document.createElementNS(a, "foreignObject");
                    return i.setAttributeNS(null, "width", A), i.setAttributeNS(null, "height", t), o.setAttributeNS(null, "width", "100%"), o.setAttributeNS(null, "height", "100%"), o.setAttributeNS(null, "x", e), o.setAttributeNS(null, "y", n), o.setAttributeNS(null, "externalResourcesRequired", "true"), i.appendChild(o), o.appendChild(r), i;
                }, a = t.loadSerializedSVG = function(A) {
                    return new Promise(function(t, e) {
                        var n = new Image;
                        n.onload = function() {
                            return t(n);
                        }, n.onerror = e, n.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent((new XMLSerializer).serializeToString(A));
                    });
                };
            },
            5171: (A)=>{
                A.exports = function(A) {
                    return !(!A || "string" == typeof A) && (A instanceof Array || Array.isArray(A) || A.length >= 0 && (A.splice instanceof Function || Object.getOwnPropertyDescriptor(A, A.length - 1) && "String" !== A.constructor.name));
                };
            },
            399: (A, t, e)=>{
                var n = "__lodash_hash_undefined__", r = /^\[object .+?Constructor\]$/, a = "object" == typeof e.g && e.g && e.g.Object === Object && e.g, i = "object" == typeof self && self && self.Object === Object && self, o = a || i || Function("return this")();
                function s(A, t, e) {
                    switch(e.length){
                        case 0:
                            return A.call(t);
                        case 1:
                            return A.call(t, e[0]);
                        case 2:
                            return A.call(t, e[0], e[1]);
                        case 3:
                            return A.call(t, e[0], e[1], e[2]);
                    }
                    return A.apply(t, e);
                }
                function c(A, t) {
                    return !(!A || !A.length) && function(A, t, e) {
                        if (t != t) return function(A, t, e, n) {
                            for(var r = A.length, a = -1; ++a < r;)if (t(A[a], a, A)) return a;
                            return -1;
                        }(A, f);
                        for(var n = -1, r = A.length; ++n < r;)if (A[n] === t) return n;
                        return -1;
                    }(A, t) > -1;
                }
                function l(A, t, e) {
                    for(var n = -1, r = A ? A.length : 0; ++n < r;)if (e(t, A[n])) return !0;
                    return !1;
                }
                function u(A, t) {
                    for(var e = -1, n = t.length, r = A.length; ++e < n;)A[r + e] = t[e];
                    return A;
                }
                function f(A) {
                    return A != A;
                }
                function h(A, t) {
                    return A.has(t);
                }
                function B(A) {
                    var t = -1, e = Array(A.size);
                    return A.forEach(function(A) {
                        e[++t] = A;
                    }), e;
                }
                var d, g = Array.prototype, w = Function.prototype, p = Object.prototype, Q = o["__core-js_shared__"], U = (d = /[^.]+$/.exec(Q && Q.keys && Q.keys.IE_PROTO || "")) ? "Symbol(src)_1." + d : "", v = w.toString, y = p.hasOwnProperty, C = p.toString, m = RegExp("^" + v.call(y).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), E = g.splice, F = Math.max, _ = L(o, "Map"), b = L(o, "Set"), H = L(Object, "create");
                function N(A) {
                    var t = -1, e = A ? A.length : 0;
                    for(this.clear(); ++t < e;){
                        var n = A[t];
                        this.set(n[0], n[1]);
                    }
                }
                function I(A) {
                    var t = -1, e = A ? A.length : 0;
                    for(this.clear(); ++t < e;){
                        var n = A[t];
                        this.set(n[0], n[1]);
                    }
                }
                function M(A) {
                    var t = -1, e = A ? A.length : 0;
                    for(this.clear(); ++t < e;){
                        var n = A[t];
                        this.set(n[0], n[1]);
                    }
                }
                function T(A) {
                    var t = -1, e = A ? A.length : 0;
                    for(this.__data__ = new M; ++t < e;)this.add(A[t]);
                }
                function x(A, t) {
                    for(var e, n, r = A.length; r--;)if ((e = A[r][0]) === (n = t) || e != e && n != n) return r;
                    return -1;
                }
                function K(A, t, e, n) {
                    var r, a = -1, i = c, o = !0, s = A.length, u = [], f = t.length;
                    if (!s) return u;
                    e && (t = function(A, t) {
                        for(var e = -1, n = A ? A.length : 0, r = Array(n); ++e < n;)r[e] = t(A[e], e, A);
                        return r;
                    }(t, (r = e, function(A) {
                        return r(A);
                    }))), n ? (i = l, o = !1) : t.length >= 200 && (i = h, o = !1, t = new T(t));
                    A: for(; ++a < s;){
                        var B = A[a], d = e ? e(B) : B;
                        if (B = n || 0 !== B ? B : 0, o && d == d) {
                            for(var g = f; g--;)if (t[g] === d) continue A;
                            u.push(B);
                        } else i(t, d, n) || u.push(B);
                    }
                    return u;
                }
                N.prototype.clear = function() {
                    this.__data__ = H ? H(null) : {};
                }, N.prototype.delete = function(A) {
                    return this.has(A) && delete this.__data__[A];
                }, N.prototype.get = function(A) {
                    var t = this.__data__;
                    if (H) {
                        var e = t[A];
                        return e === n ? void 0 : e;
                    }
                    return y.call(t, A) ? t[A] : void 0;
                }, N.prototype.has = function(A) {
                    var t = this.__data__;
                    return H ? void 0 !== t[A] : y.call(t, A);
                }, N.prototype.set = function(A, t) {
                    return this.__data__[A] = H && void 0 === t ? n : t, this;
                }, I.prototype.clear = function() {
                    this.__data__ = [];
                }, I.prototype.delete = function(A) {
                    var t = this.__data__, e = x(t, A);
                    return !(e < 0 || (e == t.length - 1 ? t.pop() : E.call(t, e, 1), 0));
                }, I.prototype.get = function(A) {
                    var t = this.__data__, e = x(t, A);
                    return e < 0 ? void 0 : t[e][1];
                }, I.prototype.has = function(A) {
                    return x(this.__data__, A) > -1;
                }, I.prototype.set = function(A, t) {
                    var e = this.__data__, n = x(e, A);
                    return n < 0 ? e.push([
                        A,
                        t
                    ]) : e[n][1] = t, this;
                }, M.prototype.clear = function() {
                    this.__data__ = {
                        hash: new N,
                        map: new (_ || I),
                        string: new N
                    };
                }, M.prototype.delete = function(A) {
                    return S(this, A).delete(A);
                }, M.prototype.get = function(A) {
                    return S(this, A).get(A);
                }, M.prototype.has = function(A) {
                    return S(this, A).has(A);
                }, M.prototype.set = function(A, t) {
                    return S(this, A).set(A, t), this;
                }, T.prototype.add = T.prototype.push = function(A) {
                    return this.__data__.set(A, n), this;
                }, T.prototype.has = function(A) {
                    return this.__data__.has(A);
                };
                var O = b && 1 / B(new b([
                    ,
                    -0
                ]))[1] == 1 / 0 ? function(A) {
                    return new b(A);
                } : function() {};
                function S(A, t) {
                    var e, n, r = A.__data__;
                    return ("string" == (n = typeof (e = t)) || "number" == n || "symbol" == n || "boolean" == n ? "__proto__" !== e : null === e) ? r["string" == typeof t ? "string" : "hash"] : r.map;
                }
                function L(A, t) {
                    var e = function(A, t) {
                        return null == A ? void 0 : A[t];
                    }(A, t);
                    return function(A) {
                        var t;
                        return !(!X(A) || (t = A, U && U in t)) && (z(A) || function(A) {
                            var t = !1;
                            if (null != A && "function" != typeof A.toString) try {
                                t = !!(A + "");
                            } catch (A) {}
                            return t;
                        }(A) ? m : r).test(function(A) {
                            if (null != A) {
                                try {
                                    return v.call(A);
                                } catch (A) {}
                                try {
                                    return A + "";
                                } catch (A) {}
                            }
                            return "";
                        }(A));
                    }(e) ? e : void 0;
                }
                var k, P, D = (k = function(A) {
                    return function(A, t, e) {
                        for(var n = -1, r = A.length; ++n < r;)var a = a ? u(K(a, A[n], t, e), K(A[n], a, t, e)) : A[n];
                        return a && a.length ? function(A, t, e) {
                            var n = -1, r = c, a = A.length, i = !0, o = [], s = o;
                            if (e) i = !1, r = l;
                            else if (a >= 200) {
                                var u = t ? null : O(A);
                                if (u) return B(u);
                                i = !1, r = h, s = new T;
                            } else s = t ? [] : o;
                            A: for(; ++n < a;){
                                var f = A[n], d = t ? t(f) : f;
                                if (f = e || 0 !== f ? f : 0, i && d == d) {
                                    for(var g = s.length; g--;)if (s[g] === d) continue A;
                                    t && s.push(d), o.push(f);
                                } else r(s, d, e) || (s !== o && s.push(d), o.push(f));
                            }
                            return o;
                        }(a, t, e) : [];
                    }(function(A, t) {
                        for(var e = -1, n = A ? A.length : 0, r = 0, a = []; ++e < n;){
                            var i = A[e];
                            t(i, e, A) && (a[r++] = i);
                        }
                        return a;
                    }(A, R));
                }, P = F(void 0 === P ? k.length - 1 : P, 0), function() {
                    for(var A = arguments, t = -1, e = F(A.length - P, 0), n = Array(e); ++t < e;)n[t] = A[P + t];
                    t = -1;
                    for(var r = Array(P + 1); ++t < P;)r[t] = A[t];
                    return r[P] = n, s(k, this, r);
                });
                function R(A) {
                    return function(A) {
                        return !!A && "object" == typeof A;
                    }(A) && function(A) {
                        return null != A && function(A) {
                            return "number" == typeof A && A > -1 && A % 1 == 0 && A <= 9007199254740991;
                        }(A.length) && !z(A);
                    }(A);
                }
                function z(A) {
                    var t = X(A) ? C.call(A) : "";
                    return "[object Function]" == t || "[object GeneratorFunction]" == t;
                }
                function X(A) {
                    var t = typeof A;
                    return !!A && ("object" == t || "function" == t);
                }
                A.exports = D;
            },
            5666: (A)=>{
                var t = function(A) {
                    "use strict";
                    var t, e = Object.prototype, n = e.hasOwnProperty, r = "function" == typeof Symbol ? Symbol : {}, a = r.iterator || "@@iterator", i = r.asyncIterator || "@@asyncIterator", o = r.toStringTag || "@@toStringTag";
                    function s(A, t, e) {
                        return Object.defineProperty(A, t, {
                            value: e,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0
                        }), A[t];
                    }
                    try {
                        s({}, "");
                    } catch (A) {
                        s = function(A, t, e) {
                            return A[t] = e;
                        };
                    }
                    function c(A, t, e, n) {
                        var r = t && t.prototype instanceof g ? t : g, a = Object.create(r.prototype), i = new b(n || []);
                        return a._invoke = function(A, t, e) {
                            var n = u;
                            return function(r, a) {
                                if (n === h) throw new Error("Generator is already running");
                                if (n === B) {
                                    if ("throw" === r) throw a;
                                    return N();
                                }
                                for(e.method = r, e.arg = a;;){
                                    var i = e.delegate;
                                    if (i) {
                                        var o = E(i, e);
                                        if (o) {
                                            if (o === d) continue;
                                            return o;
                                        }
                                    }
                                    if ("next" === e.method) e.sent = e._sent = e.arg;
                                    else if ("throw" === e.method) {
                                        if (n === u) throw n = B, e.arg;
                                        e.dispatchException(e.arg);
                                    } else "return" === e.method && e.abrupt("return", e.arg);
                                    n = h;
                                    var s = l(A, t, e);
                                    if ("normal" === s.type) {
                                        if (n = e.done ? B : f, s.arg === d) continue;
                                        return {
                                            value: s.arg,
                                            done: e.done
                                        };
                                    }
                                    "throw" === s.type && (n = B, e.method = "throw", e.arg = s.arg);
                                }
                            };
                        }(A, e, i), a;
                    }
                    function l(A, t, e) {
                        try {
                            return {
                                type: "normal",
                                arg: A.call(t, e)
                            };
                        } catch (A) {
                            return {
                                type: "throw",
                                arg: A
                            };
                        }
                    }
                    A.wrap = c;
                    var u = "suspendedStart", f = "suspendedYield", h = "executing", B = "completed", d = {};
                    function g() {}
                    function w() {}
                    function p() {}
                    var Q = {};
                    Q[a] = function() {
                        return this;
                    };
                    var U = Object.getPrototypeOf, v = U && U(U(H([])));
                    v && v !== e && n.call(v, a) && (Q = v);
                    var y = p.prototype = g.prototype = Object.create(Q);
                    function C(A) {
                        [
                            "next",
                            "throw",
                            "return"
                        ].forEach(function(t) {
                            s(A, t, function(A) {
                                return this._invoke(t, A);
                            });
                        });
                    }
                    function m(A, t) {
                        function e(r, a, i, o) {
                            var s = l(A[r], A, a);
                            if ("throw" !== s.type) {
                                var c = s.arg, u = c.value;
                                return u && "object" == typeof u && n.call(u, "__await") ? t.resolve(u.__await).then(function(A) {
                                    e("next", A, i, o);
                                }, function(A) {
                                    e("throw", A, i, o);
                                }) : t.resolve(u).then(function(A) {
                                    c.value = A, i(c);
                                }, function(A) {
                                    return e("throw", A, i, o);
                                });
                            }
                            o(s.arg);
                        }
                        var r;
                        this._invoke = function(A, n) {
                            function a() {
                                return new t(function(t, r) {
                                    e(A, n, t, r);
                                });
                            }
                            return r = r ? r.then(a, a) : a();
                        };
                    }
                    function E(A, e) {
                        var n = A.iterator[e.method];
                        if (n === t) {
                            if (e.delegate = null, "throw" === e.method) {
                                if (A.iterator.return && (e.method = "return", e.arg = t, E(A, e), "throw" === e.method)) return d;
                                e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
                            }
                            return d;
                        }
                        var r = l(n, A.iterator, e.arg);
                        if ("throw" === r.type) return e.method = "throw", e.arg = r.arg, e.delegate = null, d;
                        var a = r.arg;
                        return a ? a.done ? (e[A.resultName] = a.value, e.next = A.nextLoc, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, d) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, d);
                    }
                    function F(A) {
                        var t = {
                            tryLoc: A[0]
                        };
                        1 in A && (t.catchLoc = A[1]), 2 in A && (t.finallyLoc = A[2], t.afterLoc = A[3]), this.tryEntries.push(t);
                    }
                    function _(A) {
                        var t = A.completion || {};
                        t.type = "normal", delete t.arg, A.completion = t;
                    }
                    function b(A) {
                        this.tryEntries = [
                            {
                                tryLoc: "root"
                            }
                        ], A.forEach(F, this), this.reset(!0);
                    }
                    function H(A) {
                        if (A) {
                            var e = A[a];
                            if (e) return e.call(A);
                            if ("function" == typeof A.next) return A;
                            if (!isNaN(A.length)) {
                                var r = -1, i = function e() {
                                    for(; ++r < A.length;)if (n.call(A, r)) return e.value = A[r], e.done = !1, e;
                                    return e.value = t, e.done = !0, e;
                                };
                                return i.next = i;
                            }
                        }
                        return {
                            next: N
                        };
                    }
                    function N() {
                        return {
                            value: t,
                            done: !0
                        };
                    }
                    return w.prototype = y.constructor = p, p.constructor = w, w.displayName = s(p, o, "GeneratorFunction"), A.isGeneratorFunction = function(A) {
                        var t = "function" == typeof A && A.constructor;
                        return !!t && (t === w || "GeneratorFunction" === (t.displayName || t.name));
                    }, A.mark = function(A) {
                        return Object.setPrototypeOf ? Object.setPrototypeOf(A, p) : (A.__proto__ = p, s(A, o, "GeneratorFunction")), A.prototype = Object.create(y), A;
                    }, A.awrap = function(A) {
                        return {
                            __await: A
                        };
                    }, C(m.prototype), m.prototype[i] = function() {
                        return this;
                    }, A.AsyncIterator = m, A.async = function(t, e, n, r, a) {
                        void 0 === a && (a = Promise);
                        var i = new m(c(t, e, n, r), a);
                        return A.isGeneratorFunction(e) ? i : i.next().then(function(A) {
                            return A.done ? A.value : i.next();
                        });
                    }, C(y), s(y, o, "Generator"), y[a] = function() {
                        return this;
                    }, y.toString = function() {
                        return "[object Generator]";
                    }, A.keys = function(A) {
                        var t = [];
                        for(var e in A)t.push(e);
                        return t.reverse(), function e() {
                            for(; t.length;){
                                var n = t.pop();
                                if (n in A) return e.value = n, e.done = !1, e;
                            }
                            return e.done = !0, e;
                        };
                    }, A.values = H, b.prototype = {
                        constructor: b,
                        reset: function(A) {
                            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(_), !A) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
                        },
                        stop: function() {
                            this.done = !0;
                            var A = this.tryEntries[0].completion;
                            if ("throw" === A.type) throw A.arg;
                            return this.rval;
                        },
                        dispatchException: function(A) {
                            if (this.done) throw A;
                            var e = this;
                            function r(n, r) {
                                return o.type = "throw", o.arg = A, e.next = n, r && (e.method = "next", e.arg = t), !!r;
                            }
                            for(var a = this.tryEntries.length - 1; a >= 0; --a){
                                var i = this.tryEntries[a], o = i.completion;
                                if ("root" === i.tryLoc) return r("end");
                                if (i.tryLoc <= this.prev) {
                                    var s = n.call(i, "catchLoc"), c = n.call(i, "finallyLoc");
                                    if (s && c) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    } else if (s) {
                                        if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                                    } else {
                                        if (!c) throw new Error("try statement without catch or finally");
                                        if (this.prev < i.finallyLoc) return r(i.finallyLoc);
                                    }
                                }
                            }
                        },
                        abrupt: function(A, t) {
                            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                                var r = this.tryEntries[e];
                                if (r.tryLoc <= this.prev && n.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                                    var a = r;
                                    break;
                                }
                            }
                            a && ("break" === A || "continue" === A) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
                            var i = a ? a.completion : {};
                            return i.type = A, i.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, d) : this.complete(i);
                        },
                        complete: function(A, t) {
                            if ("throw" === A.type) throw A.arg;
                            return "break" === A.type || "continue" === A.type ? this.next = A.arg : "return" === A.type ? (this.rval = this.arg = A.arg, this.method = "return", this.next = "end") : "normal" === A.type && t && (this.next = t), d;
                        },
                        finish: function(A) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var e = this.tryEntries[t];
                                if (e.finallyLoc === A) return this.complete(e.completion, e.afterLoc), _(e), d;
                            }
                        },
                        catch: function(A) {
                            for(var t = this.tryEntries.length - 1; t >= 0; --t){
                                var e = this.tryEntries[t];
                                if (e.tryLoc === A) {
                                    var n = e.completion;
                                    if ("throw" === n.type) {
                                        var r = n.arg;
                                        _(e);
                                    }
                                    return r;
                                }
                            }
                            throw new Error("illegal catch attempt");
                        },
                        delegateYield: function(A, e, n) {
                            return this.delegate = {
                                iterator: H(A),
                                resultName: e,
                                nextLoc: n
                            }, "next" === this.method && (this.arg = t), d;
                        }
                    }, A;
                }(A.exports);
                try {
                    regeneratorRuntime = t;
                } catch (A) {
                    Function("r", "regeneratorRuntime = r")(t);
                }
            },
            6851: (A, t, e)=>{
                "use strict";
                var n = e(5171), r = Array.prototype.concat, a = Array.prototype.slice, i = A.exports = function(A) {
                    for(var t = [], e = 0, i = A.length; e < i; e++){
                        var o = A[e];
                        n(o) ? t = r.call(t, a.call(o)) : t.push(o);
                    }
                    return t;
                };
                i.wrap = function(A) {
                    return function() {
                        return A(i(arguments));
                    };
                };
            }
        }, __webpack_module_cache__ = {}, leafPrototypes, getProto;
        function __webpack_require__(A) {
            var t = __webpack_module_cache__[A];
            if (void 0 !== t) return t.exports;
            var e = __webpack_module_cache__[A] = {
                exports: {}
            };
            return __webpack_modules__[A](e, e.exports, __webpack_require__), e.exports;
        }
        __webpack_require__.n = (A)=>{
            var t = A && A.__esModule ? ()=>A.default : ()=>A;
            return __webpack_require__.d(t, {
                a: t
            }), t;
        }, getProto = Object.getPrototypeOf ? (A)=>Object.getPrototypeOf(A) : (A)=>A.__proto__, __webpack_require__.t = function(A, t) {
            if (1 & t && (A = this(A)), 8 & t) return A;
            if ("object" == typeof A && A) {
                if (4 & t && A.__esModule) return A;
                if (16 & t && "function" == typeof A.then) return A;
            }
            var e = Object.create(null);
            __webpack_require__.r(e);
            var n = {};
            leafPrototypes = leafPrototypes || [
                null,
                getProto({}),
                getProto([]),
                getProto(getProto)
            ];
            for(var r = 2 & t && A; "object" == typeof r && !~leafPrototypes.indexOf(r); r = getProto(r))Object.getOwnPropertyNames(r).forEach((t)=>n[t] = ()=>A[t]);
            return n.default = ()=>A, __webpack_require__.d(e, n), e;
        }, __webpack_require__.d = (A, t)=>{
            for(var e in t)__webpack_require__.o(t, e) && !__webpack_require__.o(A, e) && Object.defineProperty(A, e, {
                enumerable: !0,
                get: t[e]
            });
        }, __webpack_require__.g = function() {
            if ("object" == typeof globalThis) return globalThis;
            try {
                return this || new Function("return this")();
            } catch (A) {
                if ("object" == typeof window) return window;
            }
        }(), __webpack_require__.o = (A, t)=>Object.prototype.hasOwnProperty.call(A, t), __webpack_require__.r = (A)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(A, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(A, "__esModule", {
                value: !0
            });
        };
        var __webpack_exports__ = {};
        return (()=>{
            "use strict";
            function A(A, t) {
                if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function t(A, t) {
                for(var e = 0; e < t.length; e++){
                    var n = t[e];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                }
            }
            __webpack_require__.r(__webpack_exports__), __webpack_require__.d(__webpack_exports__, {
                ChartCreator: ()=>u,
                LineChart: ()=>f.default,
                PieChart: ()=>B.default,
                Snapshot: ()=>Q,
                StackedBarChart: ()=>h.default,
                html2canvas: ()=>v()
            });
            var e = function() {
                function e() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = t.url, r = void 0 === n ? "" : n, a = t.data, i = void 0 === a ? "" : a;
                    A(this, e), this.url = r, this.data = i;
                }
                var n, r;
                return n = e, r = [
                    {
                        key: "giveData",
                        value: function(A) {
                            var t = this, e = A || function(A) {
                                return A;
                            };
                            this.data ? e(this.data) : this.loadData().then(function(A) {
                                t.setData(A), e(t.data);
                            }).catch(function(A) {
                                return new Error(A);
                            });
                        }
                    },
                    {
                        key: "loadData",
                        value: function() {
                            var A = this.url;
                            return fetch(A).then(function(A) {
                                return A.json();
                            }).then(function(A) {
                                return A;
                            });
                        }
                    },
                    {
                        key: "setData",
                        value: function(A) {
                            this.data = A;
                        }
                    },
                    {
                        key: "resetData",
                        value: function() {
                            this.data = null;
                        }
                    }
                ], t(n.prototype, r), e;
            }();
            function n(A, t) {
                if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function r(A, t) {
                for(var e = 0; e < t.length; e++){
                    var n = t[e];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                }
            }
            var a = function() {
                function A() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = t.store, r = void 0 === e ? "" : e, a = t.chart, i = void 0 === a ? "" : a;
                    n(this, A), this.store = r, this.chart = i;
                }
                var t, a;
                return t = A, a = [
                    {
                        key: "linkToStore",
                        value: function(A) {
                            if (!(A instanceof e)) throw new TypeError("The store parameter must refer to an instance of DataStore");
                            this.store = A;
                        }
                    },
                    {
                        key: "fetchData",
                        value: function(A) {
                            if (!this.store) throw new Error("Fetch failed, no data store linked!");
                            this.store.giveData(A);
                        }
                    }
                ], r(t.prototype, a), A;
            }();
            function i(A, t) {
                for(var e = 0; e < t.length; e++){
                    var n = t[e];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                }
            }
            function o(A, t) {
                if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function s(A) {
                return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(A) {
                    return typeof A;
                } : function(A) {
                    return A && "function" == typeof Symbol && A.constructor === Symbol && A !== Symbol.prototype ? "symbol" : typeof A;
                })(A);
            }
            !function(A, t, e) {
                function n(A, t) {
                    return s(A) === t;
                }
                var r = [], a = {
                    _version: "3.6.0",
                    _config: {
                        classPrefix: "",
                        enableClasses: !0,
                        enableJSClass: !0,
                        usePrefixes: !0
                    },
                    _q: [],
                    on: function(A, t) {
                        var e = this;
                        setTimeout(function() {
                            t(e[A]);
                        }, 0);
                    },
                    addTest: function(A, t, e) {
                        r.push({
                            name: A,
                            fn: t,
                            options: e
                        });
                    },
                    addAsyncTest: function(A) {
                        r.push({
                            name: null,
                            fn: A
                        });
                    }
                }, i = function() {};
                i.prototype = a, i = new i;
                var o = [], c = {}.toString;
                i.addTest("svgforeignobject", function() {
                    return !!t.createElementNS && /SVGForeignObject/.test(c.call(t.createElementNS("http://www.w3.org/2000/svg", "foreignObject")));
                }), function() {
                    var A, t, e, a, s, c;
                    for(var l in r)if (r.hasOwnProperty(l)) {
                        if (A = [], (t = r[l]).name && (A.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for(e = 0; e < t.options.aliases.length; e++)A.push(t.options.aliases[e].toLowerCase());
                        for(a = n(t.fn, "function") ? t.fn() : t.fn, s = 0; s < A.length; s++)1 === (c = A[s].split(".")).length ? i[c[0]] = a : (!i[c[0]] || i[c[0]] instanceof Boolean || (i[c[0]] = new Boolean(i[c[0]])), i[c[0]][c[1]] = a), o.push((a ? "" : "no-") + c.join("-"));
                    }
                }(), delete a.addTest, delete a.addAsyncTest;
                for(var l = 0; l < i._q.length; l++)i._q[l]();
                A.Modernizr = i;
            }(window, document);
            var c = function A() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = t.h, n = void 0 === e ? 500 : e, r = t.w, a = void 0 === r ? 960 : r, i = t.margin, s = void 0 === i ? {
                    top: 45,
                    right: 45,
                    bottom: 50,
                    left: 65
                } : i;
                o(this, A), this.h = n, this.w = a, this.margin = s;
            }, l = function() {
                function A() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, e = t.container, n = void 0 === e ? "" : e, r = t.div, a = void 0 === r ? "body" : r;
                    o(this, A), this.container = n, this.div = a, this.draw = this.draw.bind(this);
                }
                var t, e;
                return t = A, e = [
                    {
                        key: "drawLineChart",
                        value: function(A, t) {
                            var e = this;
                            Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 7969)).then(function(n) {
                                var r = new n.default(A, e.container, e.div, t);
                                r.svg = r.draw(), r.drawGoalLines();
                            }).catch(function(A) {
                                return console.log(A);
                            });
                        }
                    },
                    {
                        key: "drawStackedBarChart",
                        value: function(A) {
                            var t = this;
                            return Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 5303)).then(function(e) {
                                new e.default(A, t.container, t.div);
                            }).catch(function(A) {
                                return console.log(A);
                            });
                        }
                    },
                    {
                        key: "drawScatterplot",
                        value: function(A, t) {
                            var e = this;
                            Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 4653)).then(function(n) {
                                var r = new n.default(A, e.container, e.div, t);
                                r.svg = r.draw();
                            }).catch(function(A) {
                                return console.log(A);
                            });
                        }
                    },
                    {
                        key: "drawPieChart",
                        value: function(A, t) {
                            var e = this, n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                            Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 554)).then(function(r) {
                                var a = new r.default(A, e.container, e.div, t);
                                a.svg = a.draw(), n && a.drawSelectMenu([]);
                            }).catch(function(A) {
                                return console.log(A);
                            });
                        }
                    },
                    {
                        key: "drawDoughnutChart",
                        value: function(A, t) {
                            var e = this, n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                            Promise.resolve().then(__webpack_require__.bind(__webpack_require__, 554)).then(function(r) {
                                var a = new r.default(A, e.container, e.div, t);
                                a.svg = a.draw(.5), n && a.drawSelectMenu([]);
                            }).catch(function(A) {
                                return console.log(A);
                            });
                        }
                    },
                    {
                        key: "draw",
                        value: function(A) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], e = A[0].type;
                            switch(("No" !== A[0].showLegend || A[0].showLegend) && (t = A[0].showLegend), e){
                                case "bar chart":
                                case "stacked bar chart":
                                    this.drawStackedBarChart(A, t);
                                    break;
                                case "scatterplot":
                                    this.drawScatterplot(A, t);
                                    break;
                                case "pie chart (percentage)":
                                    this.drawPieChart(A, t);
                                    break;
                                case "doughnut chart":
                                    this.drawDoughnutChart(A, t);
                                    break;
                                case "line chart":
                                    this.drawLineChart(A, t);
                                    break;
                                default:
                                    console.log("We don't have a case for ".concat(e, "..."));
                            }
                            this.div.parentNode.classList.add("loaded");
                        }
                    }
                ], i(t.prototype, e), A;
            }(), u = function A(t, n) {
                !function(A, t) {
                    if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, A);
                var r = {
                    h: t.getBoundingClientRect().height,
                    w: t.getBoundingClientRect().width,
                    margin: {},
                    data: {}
                };
                n = Object.assign({}, r, n);
                var i = new e(n.data);
                delete n.data, (!n.margin || n.margin.constructor === Object && 0 === Object.keys(n.margin).length) && delete n.margin;
                var o = new c(n), s = new l({
                    container: o,
                    div: t
                }), u = new a({
                    store: i,
                    chart: s
                });
                u.fetchData(u.chart.draw);
            }, f = __webpack_require__(7969), h = __webpack_require__(5303), B = __webpack_require__(554), d = __webpack_require__(4017);
            function g(A, t, e, n, r, a, i) {
                try {
                    var o = A[a](i), s = o.value;
                } catch (A) {
                    return void e(A);
                }
                o.done ? t(s) : Promise.resolve(s).then(n, r);
            }
            function w(A) {
                return function() {
                    var t = this, e = arguments;
                    return new Promise(function(n, r) {
                        var a = A.apply(t, e);
                        function i(A) {
                            g(a, n, r, i, o, "next", A);
                        }
                        function o(A) {
                            g(a, n, r, i, o, "throw", A);
                        }
                        i(void 0);
                    });
                };
            }
            function p(A, t) {
                for(var e = 0; e < t.length; e++){
                    var n = t[e];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(A, n.key, n);
                }
            }
            __webpack_require__(5666);
            var Q = function() {
                function A() {
                    !function(A, t) {
                        if (!(A instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, A), this.snap = this.snap.bind(this);
                }
                var t, e, n;
                return t = A, e = [
                    {
                        key: "snap",
                        value: (n = w(regeneratorRuntime.mark(function A(t) {
                            var e, n, r = this, a = arguments;
                            return regeneratorRuntime.wrap(function(A) {
                                for(;;)switch(A.prev = A.next){
                                    case 0:
                                        return e = a.length > 1 && void 0 !== a[1] ? a[1] : "chart", n = a.length > 2 && void 0 !== a[2] ? a[2] : {
                                            allowTaint: !0,
                                            useCORS: !0,
                                            scrollX: -window.scrollX,
                                            scrollY: -window.scrollY
                                        }, this.imgUrl = "", A.next = 5, Promise.resolve().then(__webpack_require__.t.bind(__webpack_require__, 7753, 23)).then(function() {
                                            var A = w(regeneratorRuntime.mark(function A(a) {
                                                var i, o, s, c, l;
                                                return regeneratorRuntime.wrap(function(A) {
                                                    for(;;)switch(A.prev = A.next){
                                                        case 0:
                                                            return i = a.default, (0, d.Z)(t).select("foreignObject").empty() || (0, d.Z)(t).select(".axis--x").selectAll(".tick text").filter(":not(.x-axis-text)").remove(), HTMLCanvasElement.prototype.toBlob || Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
                                                                value: function(A, t, e) {
                                                                    var n = this;
                                                                    setTimeout(function() {
                                                                        for(var r = atob(n.toDataURL(t, e).split(",")[1]), a = r.length, i = new Uint8Array(a), o = 0; o < a; o++)i[o] = r.charCodeAt(o);
                                                                        A(new Blob([
                                                                            i
                                                                        ], {
                                                                            type: t || "image/png"
                                                                        }));
                                                                    });
                                                                }
                                                            }), A.next = 5, i(t, n);
                                                        case 5:
                                                            return o = A.sent, A.next = 8, new Promise(function(A) {
                                                                return o.toBlob(A);
                                                            });
                                                        case 8:
                                                            s = A.sent, c = URL.createObjectURL(s), (l = document.createElement("a")).download = e + ".png", l.href = encodeURI(c), l.hasAttribute("download") ? (document.body.appendChild(l), l.click(), document.body.removeChild(l)) : alert("This function is not supported in Internet Explorer. To download an image file of this chart, please open this webpage in Chrome, Firefox, Edge or another browser."), r.imgUrl = l.href;
                                                        case 15:
                                                        case "end":
                                                            return A.stop();
                                                    }
                                                }, A);
                                            }));
                                            return function(t) {
                                                return A.apply(this, arguments);
                                            };
                                        }());
                                    case 5:
                                        return A.abrupt("return", this.imgUrl);
                                    case 6:
                                    case "end":
                                        return A.stop();
                                }
                            }, A, this);
                        })), function(A) {
                            return n.apply(this, arguments);
                        })
                    }
                ], p(t.prototype, e), A;
            }(), U = __webpack_require__(7753), v = __webpack_require__.n(U);
        })(), __webpack_exports__;
    })();
});

},{}],"8FW5d":[function() {},{}],"9oDve":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = [
    "id"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("figure", {
        class: "data__figure data__figure--chart chart-div",
        ref: "chartDiv",
        id: "chart-" + $props.slug
    }, null, 8, _hoisted_1);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"e1yDx":[function() {},{}],"1f6Gv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"sMIDW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("ff4fc0710d0fe875");
    if (script.__esModule) script = script.default;
    script.render = require("2e6afe1243cec69b").render;
    script.__cssModules = require("e291a50717597025").default;
    require("77c70039d1da237b").default(script);
    script.__scopeId = "data-v-092174";
    script.__file = "Tabs.vue";
};
initialize();
exports.default = script;

},{"ff4fc0710d0fe875":"gSBDy","2e6afe1243cec69b":"2dlZx","e291a50717597025":"aszxR","77c70039d1da237b":"cof4s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gSBDy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _vue = require("vue");
exports.default = {
    __name: "Tabs",
    props: {
        tabs: {
            type: Array,
            default: []
        },
        activeTabIndex: null,
        controls: {
            type: String,
            default: ""
        },
        theme: {
            type: String,
            default: "tabs"
        }
    },
    emits: [
        "tab-changed"
    ],
    setup (__props, { expose: __expose, emit: __emit }) {
        __expose();
        const emit = __emit;
        const props = __props;
        const activeTab = (0, _vue.ref)(null);
        //lifecycle
        (0, _vue.onMounted)(()=>{
            activeTab.value = !props.activeTabIndex ? props.tabs[0].index : props.activeTabIndex;
        });
        //methods
        const changeTab = function(index) {
            activeTab.value = index;
            emit("tab-changed", index);
        };
        //computed
        const tabClasses = (0, _vue.computed)(()=>{
            return props.theme === "tabs" ? [
                "tabs"
            ] : [
                "inlineList"
            ];
        });
        const tabsClasses = (0, _vue.computed)(()=>{
            return props.theme === "tabs" ? [
                "tabs__tab"
            ] : [
                "buttonLink"
            ];
        });
        const __returned__ = {
            emit,
            props,
            activeTab,
            changeTab,
            tabClasses,
            tabsClasses,
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            ref: (0, _vue.ref)
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2dlZx":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = [
    "onClick",
    "aria-controls",
    "aria-selected",
    "innerHTML"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", {
        class: (0, _vue.normalizeClass)($setup.tabClasses),
        role: "tablist"
    }, [
        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.tabs, (tab)=>{
            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                onClick: ($event)=>$setup.changeTab(tab.index),
                class: (0, _vue.normalizeClass)([
                    $setup.activeTab === tab.index ? $props.theme === "tabs" ? "tabs__tab--active" : "activeView" : "",
                    $setup.tabsClasses
                ]),
                role: "tab",
                "aria-controls": $props.controls,
                "aria-selected": $setup.activeTab === tab.index,
                innerHTML: tab.title
            }, null, 10, _hoisted_1);
        }), 256))
    ], 2);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aszxR":[function() {},{}],"cof4s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aCkvK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("bc5cbd3d5278730e");
    if (script.__esModule) script = script.default;
    script.render = require("6ecdb0c5fcae51c2").render;
    script.__cssModules = require("5507363df525bfa1").default;
    require("b929929d8bab7602").default(script);
    script.__scopeId = "data-v-0f5c7e";
    script.__file = "TabTable.vue";
};
initialize();
exports.default = script;

},{"bc5cbd3d5278730e":"gVQDT","6ecdb0c5fcae51c2":"8eZqq","5507363df525bfa1":"21Xzp","b929929d8bab7602":"dC4MO","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gVQDT":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tabsVue = require("./Tabs.vue");
var _tabsVueDefault = parcelHelpers.interopDefault(_tabsVue);
var _trendingIndicatorVue = require("./TrendingIndicator.vue");
var _trendingIndicatorVueDefault = parcelHelpers.interopDefault(_trendingIndicatorVue);
var _vue = require("vue");
exports.default = {
    __name: "TabTable",
    props: {
        tablesData: {
            type: [
                Object,
                String
            ],
            required: true
        },
        tableId: {
            type: String,
            default: new Date().getTime().toString()
        },
        theme: {
            type: String,
            default: "tabs"
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const state = (0, _vue.reactive)({
            activeTableIndex: null,
            tabs: [],
            tables: typeof props.tablesData === "object" ? props.tablesData : JSON.parse(props.tablesData)
        });
        (0, _vue.onMounted)(()=>{
            if (!state.activeTableIndex) state.activeTableIndex = Object.keys(state.tables)[0];
            const tabs = [];
            for(const tableId in state.tables)tabs.push({
                index: tableId,
                title: state.tables[tableId].title
            });
            state.tabs = tabs;
        });
        //computed
        const table = (0, _vue.computed)(()=>{
            return state.tables[state.activeTableIndex];
        });
        const cols = (0, _vue.computed)(()=>{
            return table.value.cols;
        });
        const rows = (0, _vue.computed)(()=>{
            return table.value.rows;
        });
        const dropDownMapping = (0, _vue.computed)(()=>{
            //set up select field value mappings
            const map = {};
            for(let colIndex in cols.value)if (cols.value[colIndex].type === "select") {
                let options = cols.value[colIndex].options;
                map[colIndex] = {};
                options.forEach((option)=>map[colIndex][option.value] = option.label);
            }
            return map;
        });
        //methods
        const tabChanged = function(index) {
            state.activeTableIndex = index;
        };
        const setActiveTable = function(table) {
            state.activeTableIndex = "_" + table.id;
        };
        const getCellAlignment = function(colIndex) {
            return cols.value[colIndex].align;
        };
        const normalizeCell = function(val, colIndex) {
            let colType = cols.value[colIndex].type;
            switch(colType){
                case "select":
                    return dropDownMapping.value[colIndex][val];
                default:
                    return val;
            }
        };
        const __returned__ = {
            props,
            state,
            table,
            cols,
            rows,
            dropDownMapping,
            tabChanged,
            setActiveTable,
            getCellAlignment,
            normalizeCell,
            Tabs: (0, _tabsVueDefault.default),
            TrendingIndicator: (0, _trendingIndicatorVueDefault.default),
            computed: (0, _vue.computed),
            onMounted: (0, _vue.onMounted),
            reactive: (0, _vue.reactive)
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"./Tabs.vue":"sMIDW","./TrendingIndicator.vue":"5HADe","vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5HADe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let script;
let initialize = ()=>{
    script = require("b311ed6d25aacc54");
    if (script.__esModule) script = script.default;
    script.render = require("6984bd07ac93fd3b").render;
    require("f3b6e6a11c480d66").default(script);
    script.__scopeId = "data-v-1198d9";
    script.__file = "TrendingIndicator.vue";
};
initialize();
exports.default = script;

},{"b311ed6d25aacc54":"cabtV","6984bd07ac93fd3b":"8MbZw","f3b6e6a11c480d66":"1vIY5","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cabtV":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _markdownIt = require("markdown-it");
var _markdownItDefault = parcelHelpers.interopDefault(_markdownIt);
var _vue = require("vue");
exports.default = {
    __name: "TrendingIndicator",
    props: {
        input: {
            type: String
        }
    },
    setup (__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const state = (0, _vue.reactive)({
            isMappableValue: false,
            value: props.input,
            randomId: +new Date()
        });
        const map = {
            complete: [
                "complete",
                "completed"
            ],
            inProgress: [
                "in progress"
            ],
            notStarted: [
                "not yet started",
                "not started"
            ]
        };
        const markdown = (0, _markdownItDefault.default)();
        //lifecycle
        (0, _vue.onMounted)(()=>{
            assignValue();
        });
        //methods
        const assignValue = function() {
            let value = props.input.toLowerCase();
            for(let key in map)if (map[key].includes(value)) {
                state.isMappableValue = true;
                state.value = key;
                return;
            }
        };
        const __returned__ = {
            props,
            state,
            map,
            markdown,
            assignValue,
            get markdownit () {
                return 0, _markdownItDefault.default;
            },
            onMounted: (0, _vue.onMounted),
            reactive: (0, _vue.reactive),
            ref: (0, _vue.ref),
            watch: (0, _vue.watch)
        };
        Object.defineProperty(__returned__, "__isScriptSetup", {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
};

},{"markdown-it":"5FKd5","vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5FKd5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _indexMjsDefault.default));
var _indexMjs = require("./lib/index.mjs");
var _indexMjsDefault = parcelHelpers.interopDefault(_indexMjs);

},{"./lib/index.mjs":"bRica","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bRica":[function(require,module,exports) {
// Main parser class
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsMjs = require("./common/utils.mjs");
var _indexMjs = require("./helpers/index.mjs");
var _rendererMjs = require("./renderer.mjs");
var _rendererMjsDefault = parcelHelpers.interopDefault(_rendererMjs);
var _parserCoreMjs = require("./parser_core.mjs");
var _parserCoreMjsDefault = parcelHelpers.interopDefault(_parserCoreMjs);
var _parserBlockMjs = require("./parser_block.mjs");
var _parserBlockMjsDefault = parcelHelpers.interopDefault(_parserBlockMjs);
var _parserInlineMjs = require("./parser_inline.mjs");
var _parserInlineMjsDefault = parcelHelpers.interopDefault(_parserInlineMjs);
var _linkifyIt = require("linkify-it");
var _linkifyItDefault = parcelHelpers.interopDefault(_linkifyIt);
var _mdurl = require("mdurl");
var _punycodeJs = require("punycode.js");
var _punycodeJsDefault = parcelHelpers.interopDefault(_punycodeJs);
var _defaultMjs = require("./presets/default.mjs");
var _defaultMjsDefault = parcelHelpers.interopDefault(_defaultMjs);
var _zeroMjs = require("./presets/zero.mjs");
var _zeroMjsDefault = parcelHelpers.interopDefault(_zeroMjs);
var _commonmarkMjs = require("./presets/commonmark.mjs");
var _commonmarkMjsDefault = parcelHelpers.interopDefault(_commonmarkMjs);
const config = {
    default: (0, _defaultMjsDefault.default),
    zero: (0, _zeroMjsDefault.default),
    commonmark: (0, _commonmarkMjsDefault.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return BAD_PROTO_RE.test(str) ? GOOD_DATA_RE.test(str) : true;
}
const RECODE_HOSTNAME_FOR = [
    "http:",
    "https:",
    "mailto:"
];
function normalizeLink(url) {
    const parsed = _mdurl.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, _punycodeJsDefault.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return _mdurl.encode(_mdurl.format(parsed));
}
function normalizeLinkText(url) {
    const parsed = _mdurl.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, _punycodeJsDefault.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return _mdurl.decode(_mdurl.format(parsed), _mdurl.decode.defaultChars + "%");
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function MarkdownIt(presetName, options) {
    if (!(this instanceof MarkdownIt)) return new MarkdownIt(presetName, options);
    if (!options) {
        if (!_utilsMjs.isString(presetName)) {
            options = presetName || {};
            presetName = "default";
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, _parserInlineMjsDefault.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, _parserBlockMjsDefault.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, _parserCoreMjsDefault.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, _rendererMjsDefault.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, _linkifyItDefault.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = _utilsMjs;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = _utilsMjs.assign({}, _indexMjs);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ MarkdownIt.prototype.set = function(options) {
    _utilsMjs.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if (_utilsMjs.isString(presets)) {
        const presetName = presets;
        presets = config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error("Wrong `markdown-it` preset, can't be empty");
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        "core",
        "block",
        "inline"
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== "string") throw new Error("Input data should be a String");
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
exports.default = MarkdownIt;

},{"./common/utils.mjs":"aLKqx","./helpers/index.mjs":"bmVYy","./renderer.mjs":"19qzg","./parser_core.mjs":"29HmD","./parser_block.mjs":"agWWW","./parser_inline.mjs":"1AWMr","linkify-it":"an4mX","mdurl":"lpljC","punycode.js":"ZahMt","./presets/default.mjs":"8V0NV","./presets/zero.mjs":"yCiad","./presets/commonmark.mjs":"duEbi","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aLKqx":[function(require,module,exports) {
// Utilities
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lib", ()=>lib);
parcelHelpers.export(exports, "assign", ()=>assign);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "has", ()=>has);
parcelHelpers.export(exports, "unescapeMd", ()=>unescapeMd);
parcelHelpers.export(exports, "unescapeAll", ()=>unescapeAll);
parcelHelpers.export(exports, "isValidEntityCode", ()=>isValidEntityCode);
parcelHelpers.export(exports, "fromCodePoint", ()=>fromCodePoint);
parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
parcelHelpers.export(exports, "arrayReplaceAt", ()=>arrayReplaceAt);
parcelHelpers.export(exports, "isSpace", ()=>isSpace);
parcelHelpers.export(exports, "isWhiteSpace", ()=>isWhiteSpace);
parcelHelpers.export(exports, "isMdAsciiPunct", ()=>isMdAsciiPunct);
parcelHelpers.export(exports, "isPunctChar", ()=>isPunctChar);
parcelHelpers.export(exports, "escapeRE", ()=>escapeRE);
parcelHelpers.export(exports, "normalizeReference", ()=>normalizeReference);
var _mdurl = require("mdurl");
var _ucMicro = require("uc.micro");
var _entities = require("entities");
function _class(obj) {
    return Object.prototype.toString.call(obj);
}
function isString(obj) {
    return _class(obj) === "[object String]";
}
const _hasOwnProperty = Object.prototype.hasOwnProperty;
function has(object, key) {
    return _hasOwnProperty.call(object, key);
}
// Merge objects
//
function assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== "object") throw new TypeError(source + "must be object");
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function isValidEntityCode(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function fromCodePoint(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const UNESCAPE_ALL_RE = new RegExp(UNESCAPE_MD_RE.source + "|" + ENTITY_RE.source, "gi");
const DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === "x" ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if (isValidEntityCode(code)) return fromCodePoint(code);
        return match;
    }
    const decoded = (0, _entities.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function unescapeMd(str) {
    if (str.indexOf("\\") < 0) return str;
    return str.replace(UNESCAPE_MD_RE, "$1");
}
function unescapeAll(str) {
    if (str.indexOf("\\") < 0 && str.indexOf("&") < 0) return str;
    return str.replace(UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return replaceEntityPattern(match, entity);
    });
}
const HTML_ESCAPE_TEST_RE = /[&<>"]/;
const HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const HTML_REPLACEMENTS = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;"
};
function replaceUnsafeChar(ch) {
    return HTML_REPLACEMENTS[ch];
}
function escapeHtml(str) {
    if (HTML_ESCAPE_TEST_RE.test(str)) return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
    return str;
}
const REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function escapeRE(str) {
    return str.replace(REGEXP_ESCAPE_RE, "\\$&");
}
function isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function isPunctChar(ch) {
    return _ucMicro.P.test(ch) || _ucMicro.S.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, " ");
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const lib = {
    mdurl: _mdurl,
    ucmicro: _ucMicro
};

},{"mdurl":"lpljC","uc.micro":"jfhGG","entities":"a1e5s","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lpljC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decode", ()=>(0, _decodeMjsDefault.default));
parcelHelpers.export(exports, "encode", ()=>(0, _encodeMjsDefault.default));
parcelHelpers.export(exports, "format", ()=>(0, _formatMjsDefault.default));
parcelHelpers.export(exports, "parse", ()=>(0, _parseMjsDefault.default));
var _decodeMjs = require("./lib/decode.mjs");
var _decodeMjsDefault = parcelHelpers.interopDefault(_decodeMjs);
var _encodeMjs = require("./lib/encode.mjs");
var _encodeMjsDefault = parcelHelpers.interopDefault(_encodeMjs);
var _formatMjs = require("./lib/format.mjs");
var _formatMjsDefault = parcelHelpers.interopDefault(_formatMjs);
var _parseMjs = require("./lib/parse.mjs");
var _parseMjsDefault = parcelHelpers.interopDefault(_parseMjs);

},{"./lib/decode.mjs":"2A9Kq","./lib/encode.mjs":"ilSmR","./lib/format.mjs":"lU5gy","./lib/parse.mjs":"5EojY","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2A9Kq":[function(require,module,exports) {
/* eslint-disable no-bitwise */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const decodeCache = {};
function getDecodeCache(exclude) {
    let cache = decodeCache[exclude];
    if (cache) return cache;
    cache = decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = "%" + ("0" + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function decode(string, exclude) {
    if (typeof exclude !== "string") exclude = decode.defaultChars;
    const cache = getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = "";
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += "\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += "\uFFFD\uFFFD\uFFFD";
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += "\uFFFD\uFFFD\uFFFD\uFFFD";
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += "\uFFFD";
        }
        return result;
    });
}
decode.defaultChars = ";/?:@&=+$,#";
decode.componentChars = "";
exports.default = decode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ilSmR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
    let cache = encodeCache[exclude];
    if (cache) return cache;
    cache = encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push("%" + ("0" + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
    if (typeof exclude !== "string") {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = encode.defaultChars;
    }
    if (typeof keepEscaped === "undefined") keepEscaped = true;
    const cache = getEncodeCache(exclude);
    let result = "";
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += "%EF%BF%BD";
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";
exports.default = encode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lU5gy":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>format);
function format(url) {
    let result = "";
    result += url.protocol || "";
    result += url.slashes ? "//" : "";
    result += url.auth ? url.auth + "@" : "";
    if (url.hostname && url.hostname.indexOf(":") !== -1) // ipv6 address
    result += "[" + url.hostname + "]";
    else result += url.hostname || "";
    result += url.port ? ":" + url.port : "";
    result += url.pathname || "";
    result += url.search || "";
    result += url.hash || "";
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5EojY":[function(require,module,exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const protocolPattern = /^([a-z0-9.+-]+:)/i;
const portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
];
// RFC 2396: characters not allowed for various reasons.
const unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const autoEscape = [
    "'"
].concat(unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape);
const hostEndingChars = [
    "/",
    "?",
    "#"
];
const hostnameMaxLen = 255;
const hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const hostlessProtocol = {
    javascript: true,
    "javascript:": true
};
// protocols that always contain a // bit.
const slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};
function urlParse(url, slashesDenoteHost) {
    if (url && url instanceof Url) return url;
    const u = new Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        const simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < hostEndingChars.length; i++){
            hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < nonHostChars.length; i++){
            hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ":") hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    let newpart = "";
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "";
    return this;
};
Url.prototype.parseHost = function(host) {
    let port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.default = urlParse;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jfhGG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Any", ()=>(0, _regexMjsDefault.default));
parcelHelpers.export(exports, "Cc", ()=>(0, _regexMjsDefault1.default));
parcelHelpers.export(exports, "Cf", ()=>(0, _regexMjsDefault2.default));
parcelHelpers.export(exports, "P", ()=>(0, _regexMjsDefault3.default));
parcelHelpers.export(exports, "S", ()=>(0, _regexMjsDefault4.default));
parcelHelpers.export(exports, "Z", ()=>(0, _regexMjsDefault5.default));
var _regexMjs = require("./properties/Any/regex.mjs");
var _regexMjsDefault = parcelHelpers.interopDefault(_regexMjs);
var _regexMjs1 = require("./categories/Cc/regex.mjs");
var _regexMjsDefault1 = parcelHelpers.interopDefault(_regexMjs1);
var _regexMjs2 = require("./categories/Cf/regex.mjs");
var _regexMjsDefault2 = parcelHelpers.interopDefault(_regexMjs2);
var _regexMjs3 = require("./categories/P/regex.mjs");
var _regexMjsDefault3 = parcelHelpers.interopDefault(_regexMjs3);
var _regexMjs4 = require("./categories/S/regex.mjs");
var _regexMjsDefault4 = parcelHelpers.interopDefault(_regexMjs4);
var _regexMjs5 = require("./categories/Z/regex.mjs");
var _regexMjsDefault5 = parcelHelpers.interopDefault(_regexMjs5);

},{"./properties/Any/regex.mjs":"dxLIN","./categories/Cc/regex.mjs":"6nlal","./categories/Cf/regex.mjs":"8OVb4","./categories/P/regex.mjs":"l1sZu","./categories/S/regex.mjs":"lvtVA","./categories/Z/regex.mjs":"1TrLs","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dxLIN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6nlal":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[\0-\x1F\x7F-\x9F]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8OVb4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l1sZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lvtVA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1TrLs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a1e5s":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encodeXML", ()=>(0, _escapeJs.encodeXML));
parcelHelpers.export(exports, "escape", ()=>(0, _escapeJs.escape));
parcelHelpers.export(exports, "escapeUTF8", ()=>(0, _escapeJs.escapeUTF8));
parcelHelpers.export(exports, "escapeAttribute", ()=>(0, _escapeJs.escapeAttribute));
parcelHelpers.export(exports, "escapeText", ()=>(0, _escapeJs.escapeText));
parcelHelpers.export(exports, "encodeHTML", ()=>(0, _encodeJs.encodeHTML));
parcelHelpers.export(exports, "encodeNonAsciiHTML", ()=>(0, _encodeJs.encodeNonAsciiHTML));
parcelHelpers.export(exports, "encodeHTML4", ()=>(0, _encodeJs.encodeHTML));
parcelHelpers.export(exports, "encodeHTML5", ()=>(0, _encodeJs.encodeHTML));
parcelHelpers.export(exports, "EntityDecoder", ()=>(0, _decodeJs.EntityDecoder));
parcelHelpers.export(exports, "DecodingMode", ()=>(0, _decodeJs.DecodingMode));
parcelHelpers.export(exports, "decodeXML", ()=>(0, _decodeJs.decodeXML));
parcelHelpers.export(exports, "decodeHTML", ()=>(0, _decodeJs.decodeHTML));
parcelHelpers.export(exports, "decodeHTMLStrict", ()=>(0, _decodeJs.decodeHTMLStrict));
parcelHelpers.export(exports, "decodeHTMLAttribute", ()=>(0, _decodeJs.decodeHTMLAttribute));
parcelHelpers.export(exports, "decodeHTML4", ()=>(0, _decodeJs.decodeHTML));
parcelHelpers.export(exports, "decodeHTML5", ()=>(0, _decodeJs.decodeHTML));
parcelHelpers.export(exports, "decodeHTML4Strict", ()=>(0, _decodeJs.decodeHTMLStrict));
parcelHelpers.export(exports, "decodeHTML5Strict", ()=>(0, _decodeJs.decodeHTMLStrict));
parcelHelpers.export(exports, "decodeXMLStrict", ()=>(0, _decodeJs.decodeXML));
parcelHelpers.export(exports, "EntityLevel", ()=>EntityLevel);
parcelHelpers.export(exports, "EncodingMode", ()=>EncodingMode);
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */ parcelHelpers.export(exports, "decode", ()=>decode);
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */ parcelHelpers.export(exports, "decodeStrict", ()=>decodeStrict);
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */ parcelHelpers.export(exports, "encode", ()=>encode);
var _decodeJs = require("./decode.js");
var _encodeJs = require("./encode.js");
var _escapeJs = require("./escape.js");
var EntityLevel;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})(EntityLevel || (EntityLevel = {}));
var EncodingMode;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})(EncodingMode || (EncodingMode = {}));
function decode(data, options = EntityLevel.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === EntityLevel.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, _decodeJs.decodeHTML)(data, mode);
    }
    return (0, _decodeJs.decodeXML)(data);
}
function decodeStrict(data, options = EntityLevel.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, _decodeJs.DecodingMode).Strict;
    return decode(data, opts);
}
function encode(data, options = EntityLevel.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === EncodingMode.UTF8) return (0, _escapeJs.escapeUTF8)(data);
    if (opts.mode === EncodingMode.Attribute) return (0, _escapeJs.escapeAttribute)(data);
    if (opts.mode === EncodingMode.Text) return (0, _escapeJs.escapeText)(data);
    if (opts.level === EntityLevel.HTML) {
        if (opts.mode === EncodingMode.ASCII) return (0, _encodeJs.encodeNonAsciiHTML)(data);
        return (0, _encodeJs.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, _escapeJs.encodeXML)(data);
}

},{"./decode.js":"ksZDD","./encode.js":"kHMC4","./escape.js":"cZFD4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ksZDD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceCodePoint", ()=>(0, _decodeCodepointJs.replaceCodePoint));
parcelHelpers.export(exports, "fromCodePoint", ()=>(0, _decodeCodepointJs.fromCodePoint));
// Re-export for use by eg. htmlparser2
parcelHelpers.export(exports, "htmlDecodeTree", ()=>(0, _decodeDataHtmlJsDefault.default));
parcelHelpers.export(exports, "xmlDecodeTree", ()=>(0, _decodeDataXmlJsDefault.default));
parcelHelpers.export(exports, "decodeCodePoint", ()=>(0, _decodeCodepointJsDefault.default));
parcelHelpers.export(exports, "BinTrieFlags", ()=>BinTrieFlags);
parcelHelpers.export(exports, "DecodingMode", ()=>DecodingMode);
/**
 * Token decoder with support of writing partial entities.
 */ parcelHelpers.export(exports, "EntityDecoder", ()=>EntityDecoder);
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ parcelHelpers.export(exports, "determineBranch", ()=>determineBranch);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ parcelHelpers.export(exports, "decodeHTML", ()=>decodeHTML);
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ parcelHelpers.export(exports, "decodeHTMLAttribute", ()=>decodeHTMLAttribute);
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ parcelHelpers.export(exports, "decodeHTMLStrict", ()=>decodeHTMLStrict);
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ parcelHelpers.export(exports, "decodeXML", ()=>decodeXML);
var _decodeDataHtmlJs = require("./generated/decode-data-html.js");
var _decodeDataHtmlJsDefault = parcelHelpers.interopDefault(_decodeDataHtmlJs);
var _decodeDataXmlJs = require("./generated/decode-data-xml.js");
var _decodeDataXmlJsDefault = parcelHelpers.interopDefault(_decodeDataXmlJs);
var _decodeCodepointJs = require("./decode_codepoint.js");
var _decodeCodepointJsDefault = parcelHelpers.interopDefault(_decodeCodepointJs);
var CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})(CharCodes || (CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const TO_LOWER_BIT = 32;
var BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})(BinTrieFlags || (BinTrieFlags = {}));
function isNumber(code) {
    return code >= CharCodes.ZERO && code <= CharCodes.NINE;
}
function isHexadecimalCharacter(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_F || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_F;
}
function isAsciiAlphaNumeric(code) {
    return code >= CharCodes.UPPER_A && code <= CharCodes.UPPER_Z || code >= CharCodes.LOWER_A && code <= CharCodes.LOWER_Z || isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function isEntityInAttributeInvalidEnd(code) {
    return code === CharCodes.EQUALS || isAsciiAlphaNumeric(code);
}
var EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})(EntityDecoderState || (EntityDecoderState = {}));
var DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})(DecodingMode || (DecodingMode = {}));
class EntityDecoder {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === CharCodes.NUM) {
                    this.state = EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | TO_LOWER_BIT) === CharCodes.LOWER_X) {
            this.state = EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if (isNumber(char) || isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if (isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === DecodingMode.Strict) return 0;
        this.emitCodePoint((0, _decodeCodepointJs.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result, decodeTree } = this;
        const valueLength = (decodeTree[result] & BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function getDecoder(decodeTree) {
    let ret = "";
    const decoder = new EntityDecoder(decodeTree, (str)=>ret += (0, _decodeCodepointJs.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function determineBranch(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & BinTrieFlags.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const htmlDecoder = getDecoder((0, _decodeDataHtmlJsDefault.default));
const xmlDecoder = getDecoder((0, _decodeDataXmlJsDefault.default));
function decodeHTML(str, mode = DecodingMode.Legacy) {
    return htmlDecoder(str, mode);
}
function decodeHTMLAttribute(str) {
    return htmlDecoder(str, DecodingMode.Attribute);
}
function decodeHTMLStrict(str) {
    return htmlDecoder(str, DecodingMode.Strict);
}
function decodeXML(str) {
    return xmlDecoder(str, DecodingMode.Strict);
}

},{"./generated/decode-data-html.js":"2kIDr","./generated/decode-data-xml.js":"ecEcY","./decode_codepoint.js":"1pe6m","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2kIDr":[function(require,module,exports) {
// Generated using scripts/write-decode-map.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\0\0\0\0\0\0\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\0\0\0\u0342\u0354\0\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\0\0\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\0\u0446\0\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\0\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\0\0\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\0\u05BF\0\0\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\0\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\0\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\0\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\0\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\0\u08C3bleBracket;\u67E6n\u01D4\u08C8\0\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\0\u1005bleBracket;\u67E7n\u01D4\u100A\0\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\0\0\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\0\u132C\u1331\0\0\0\0\0\u1338\u133D\u1377\u1385\0\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\0\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\0\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\0\u15B0\u15B6\u15BF\0\0\0\0\u15C6\u15DB\u15EB\u165F\u166D\0\u1695\u169B\u16B2\u16B9\0\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\0\0\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\0\0\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\0\u1833\u01B2\u182F\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\0\u19E8\u1A11\u1A15\u1A32\0\u1A37\u1A50\0\0\u1AB4\0\0\u1AC1\0\0\u1B21\u1B2E\u1B4D\u1B52\0\u1BFD\0\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\0\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\0\0\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\0\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\0\0\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\0\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\0\0\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\0\0\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\0\0\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\0\0\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\0\0\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\0\u1F9E\0\u1FA1\u1FA7\0\0\u1FC6\u1FCC\0\u1FD3\0\u1FE6\u1FEA\u2000\0\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\0\0\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\0\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\0\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\0\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\0\u2036;\u6154;\u6156\u02B4\u203E\u2041\0\0\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\0\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\0\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\0\u22AA\0\u22B8\u22C5\u22CE\0\u22D5\u22F3\0\0\u22F8\u2322\u2367\u2362\u237F\0\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\0\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\0\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\0\u24AA\0\u24B1\0\0\0\0\0\u24B5\u24BA\0\u24C6\u24C8\u24CD\0\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\0\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\0\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\0\0\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2D2D\0\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\0\0\u2D8D\u2DAB\0\u2DC8\u2DCE\0\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\0\0\u2D7C\0\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\0\u2E7D\0\u2E80\u2E9D\0\u2EA2\u2EB9\0\0\u2ECB\u0E9C\0\u2F13\0\0\u2F2B\u2FBC\0\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\0\0\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\0\u337A\u33A4\0\0\u33EC\u33F0\0\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\0\u3616\0\0\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\0\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\0\0\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\0\u367E\u36C2\0\0\0\0\0\u36DB\u3703\0\u3709\u376C\0\0\0\u3787\u0272\u3656\0\0\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\0\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\0\0\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\0\0\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\0\u3A8B\0\u3A90\u3A9B\0\0\u3A9D\u3AA8\u3AAB\u3AAF\0\0\u3AC3\u3ACE\0\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map((c)=>c.charCodeAt(0)));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ecEcY":[function(require,module,exports) {
// Generated using scripts/write-decode-map.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\0\0\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1pe6m":[function(require,module,exports) {
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromCodePoint", ()=>fromCodePoint);
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ parcelHelpers.export(exports, "replaceCodePoint", ()=>replaceCodePoint);
parcelHelpers.export(exports, "default", ()=>decodeCodePoint);
var _a;
const decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
(_a = String.fromCodePoint) !== null && _a !== void 0 ? _a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function decodeCodePoint(codePoint) {
    return fromCodePoint(replaceCodePoint(codePoint));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kHMC4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ parcelHelpers.export(exports, "encodeHTML", ()=>encodeHTML);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ parcelHelpers.export(exports, "encodeNonAsciiHTML", ()=>encodeNonAsciiHTML);
var _encodeHtmlJs = require("./generated/encode-html.js");
var _encodeHtmlJsDefault = parcelHelpers.interopDefault(_encodeHtmlJs);
var _escapeJs = require("./escape.js");
const htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function encodeHTML(data) {
    return encodeHTMLTrieRe(htmlReplacer, data);
}
function encodeNonAsciiHTML(data) {
    return encodeHTMLTrieRe((0, _escapeJs.xmlReplacer), data);
}
function encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, _encodeHtmlJsDefault.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, _escapeJs.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

},{"./generated/encode-html.js":"9meGl","./escape.js":"cZFD4","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9meGl":[function(require,module,exports) {
// Generated using scripts/write-encode-map.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
// prettier-ignore
exports.default = new Map(/* #__PURE__ */ restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cZFD4":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xmlReplacer", ()=>xmlReplacer);
parcelHelpers.export(exports, "getCodePoint", ()=>getCodePoint);
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ parcelHelpers.export(exports, "encodeXML", ()=>encodeXML);
parcelHelpers.export(exports, "escape", ()=>escape);
parcelHelpers.export(exports, "escapeUTF8", ()=>escapeUTF8);
parcelHelpers.export(exports, "escapeAttribute", ()=>escapeAttribute);
parcelHelpers.export(exports, "escapeText", ()=>escapeText);
const xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
const xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function encodeXML(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = xmlReplacer.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${getCodePoint(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const escape = encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const escapeUTF8 = getEscaper(/[&<>'"]/g, xmlCodeMap);
const escapeAttribute = getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const escapeText = getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmVYy":[function(require,module,exports) {
// Just a shortcut for bulk export
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseLinkLabel", ()=>(0, _parseLinkLabelMjsDefault.default));
parcelHelpers.export(exports, "parseLinkDestination", ()=>(0, _parseLinkDestinationMjsDefault.default));
parcelHelpers.export(exports, "parseLinkTitle", ()=>(0, _parseLinkTitleMjsDefault.default));
var _parseLinkLabelMjs = require("./parse_link_label.mjs");
var _parseLinkLabelMjsDefault = parcelHelpers.interopDefault(_parseLinkLabelMjs);
var _parseLinkDestinationMjs = require("./parse_link_destination.mjs");
var _parseLinkDestinationMjsDefault = parcelHelpers.interopDefault(_parseLinkDestinationMjs);
var _parseLinkTitleMjs = require("./parse_link_title.mjs");
var _parseLinkTitleMjsDefault = parcelHelpers.interopDefault(_parseLinkTitleMjs);

},{"./parse_link_label.mjs":"l98X6","./parse_link_destination.mjs":"h55Ft","./parse_link_title.mjs":"8vKPo","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"l98X6":[function(require,module,exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseLinkLabel);
function parseLinkLabel(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"h55Ft":[function(require,module,exports) {
// Parse link destination
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseLinkDestination);
var _utilsMjs = require("../common/utils.mjs");
function parseLinkDestination(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ""
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, _utilsMjs.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, _utilsMjs.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vKPo":[function(require,module,exports) {
// Parse link title
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseLinkTitle);
var _utilsMjs = require("../common/utils.mjs");
function parseLinkTitle(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: "",
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, _utilsMjs.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, _utilsMjs.unescapeAll)(str.slice(start, pos));
    return state;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"19qzg":[function(require,module,exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsMjs = require("./common/utils.mjs");
const default_rules = {};
default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<code" + slf.renderAttrs(token) + ">" + (0, _utilsMjs.escapeHtml)(token.content) + "</code>";
};
default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return "<pre" + slf.renderAttrs(token) + "><code>" + (0, _utilsMjs.escapeHtml)(tokens[idx].content) + "</code></pre>\n";
};
default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, _utilsMjs.unescapeAll)(token.info).trim() : "";
    let langName = "";
    let langAttrs = "";
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join("");
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, _utilsMjs.escapeHtml)(token.content);
    else highlighted = (0, _utilsMjs.escapeHtml)(token.content);
    if (highlighted.indexOf("<pre") === 0) return highlighted + "\n";
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex("class");
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            "class",
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += " " + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex("alt")][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? "<br />\n" : "<br>\n";
};
default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
};
default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, _utilsMjs.escapeHtml)(tokens[idx].content);
};
default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, _utilsMjs.assign)({}, default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return "";
    result = "";
    for(i = 0, l = token.attrs.length; i < l; i++)result += " " + (0, _utilsMjs.escapeHtml)(token.attrs[i][0]) + '="' + (0, _utilsMjs.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = "";
    // Tight list paragraphs
    if (token.hidden) return "";
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += "\n";
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? "</" : "<") + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += " /";
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === "inline" || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? ">\n" : ">";
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = "";
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case "text":
            result += tokens[i].content;
            break;
        case "image":
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case "html_inline":
        case "html_block":
            result += tokens[i].content;
            break;
        case "softbreak":
        case "hardbreak":
            result += "\n";
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ Renderer.prototype.render = function(tokens, options, env) {
    let result = "";
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === "inline") result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== "undefined") result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
exports.default = Renderer;

},{"./common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"29HmD":[function(require,module,exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rulerMjs = require("./ruler.mjs");
var _rulerMjsDefault = parcelHelpers.interopDefault(_rulerMjs);
var _stateCoreMjs = require("./rules_core/state_core.mjs");
var _stateCoreMjsDefault = parcelHelpers.interopDefault(_stateCoreMjs);
var _normalizeMjs = require("./rules_core/normalize.mjs");
var _normalizeMjsDefault = parcelHelpers.interopDefault(_normalizeMjs);
var _blockMjs = require("./rules_core/block.mjs");
var _blockMjsDefault = parcelHelpers.interopDefault(_blockMjs);
var _inlineMjs = require("./rules_core/inline.mjs");
var _inlineMjsDefault = parcelHelpers.interopDefault(_inlineMjs);
var _linkifyMjs = require("./rules_core/linkify.mjs");
var _linkifyMjsDefault = parcelHelpers.interopDefault(_linkifyMjs);
var _replacementsMjs = require("./rules_core/replacements.mjs");
var _replacementsMjsDefault = parcelHelpers.interopDefault(_replacementsMjs);
var _smartquotesMjs = require("./rules_core/smartquotes.mjs");
var _smartquotesMjsDefault = parcelHelpers.interopDefault(_smartquotesMjs);
var _textJoinMjs = require("./rules_core/text_join.mjs");
var _textJoinMjsDefault = parcelHelpers.interopDefault(_textJoinMjs);
const _rules = [
    [
        "normalize",
        (0, _normalizeMjsDefault.default)
    ],
    [
        "block",
        (0, _blockMjsDefault.default)
    ],
    [
        "inline",
        (0, _inlineMjsDefault.default)
    ],
    [
        "linkify",
        (0, _linkifyMjsDefault.default)
    ],
    [
        "replacements",
        (0, _replacementsMjsDefault.default)
    ],
    [
        "smartquotes",
        (0, _smartquotesMjsDefault.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        "text_join",
        (0, _textJoinMjsDefault.default)
    ]
];
/**
 * new Core()
 **/ function Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, _rulerMjsDefault.default)();
    for(let i = 0; i < _rules.length; i++)this.ruler.push(_rules[i][0], _rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ Core.prototype.process = function(state) {
    const rules = this.ruler.getRules("");
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
Core.prototype.State = (0, _stateCoreMjsDefault.default);
exports.default = Core;

},{"./ruler.mjs":"kz4mm","./rules_core/state_core.mjs":"exERW","./rules_core/normalize.mjs":"8k2BV","./rules_core/block.mjs":"8mSqb","./rules_core/inline.mjs":"bt0Pd","./rules_core/linkify.mjs":"iMlrD","./rules_core/replacements.mjs":"bmn6W","./rules_core/smartquotes.mjs":"cxNuu","./rules_core/text_join.mjs":"jDivV","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kz4mm":[function(require,module,exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ""
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error("Parser rule not found: " + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error("Rules manager: invalid rule name " + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
exports.default = Ruler;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"exERW":[function(require,module,exports) {
// Core state object
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tokenMjs = require("../token.mjs");
var _tokenMjsDefault = parcelHelpers.interopDefault(_tokenMjs);
function StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
StateCore.prototype.Token = (0, _tokenMjsDefault.default);
exports.default = StateCore;

},{"../token.mjs":"aeB7F","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aeB7F":[function(require,module,exports) {
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = "";
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = "";
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = "";
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + " " + value;
};
exports.default = Token;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8k2BV":[function(require,module,exports) {
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>normalize);
const NEWLINES_RE = /\r\n?|\n/g;
const NULL_RE = /\0/g;
function normalize(state) {
    let str;
    // Normalize newlines
    str = state.src.replace(NEWLINES_RE, "\n");
    // Replace NULL characters
    str = str.replace(NULL_RE, "\uFFFD");
    state.src = str;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8mSqb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>block);
function block(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token("inline", "", 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bt0Pd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>inline);
function inline(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === "inline") state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"iMlrD":[function(require,module,exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>linkify);
var _utilsMjs = require("../common/utils.mjs");
function isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function linkify(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== "inline" || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === "link_close") {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== "link_open")i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === "html_inline") {
                if (isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if (isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === "text" && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === "text_special") links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText("http://" + urlText).replace(/^http:\/\//, "");
                    else if (links[ln].schema === "mailto:" && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText("mailto:" + urlText).replace(/^mailto:/, "");
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token("text", "", 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token("link_open", "a", 1);
                    token_o.attrs = [
                        [
                            "href",
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = "linkify";
                    token_o.info = "auto";
                    nodes.push(token_o);
                    const token_t = new state.Token("text", "", 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token("link_close", "a", -1);
                    token_c.level = --level;
                    token_c.markup = "linkify";
                    token_c.info = "auto";
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token("text", "", 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, _utilsMjs.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"bmn6W":[function(require,module,exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>replace);
const RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function replaceFn(match, name) {
    return SCOPED_ABBR[name.toLowerCase()];
}
function replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) token.content = token.content.replace(SCOPED_ABBR_RE, replaceFn);
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === "text" && !inside_autolink) {
            if (RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",")// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, "$1\u2014")// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, "$1\u2013").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1\u2013");
        }
        if (token.type === "link_open" && token.info === "auto") inside_autolink--;
        if (token.type === "link_close" && token.info === "auto") inside_autolink++;
    }
}
function replace(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline") continue;
        if (SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) replace_scoped(state.tokens[blkIdx].children);
        if (RARE_RE.test(state.tokens[blkIdx].content)) replace_rare(state.tokens[blkIdx].children);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cxNuu":[function(require,module,exports) {
// Convert straight quotation marks to typographic ones
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>smartquotes);
var _utilsMjs = require("../common/utils.mjs");
const QUOTE_TEST_RE = /['"]/;
const QUOTE_RE = /['"]/g;
const APOSTROPHE = "\u2019" /* ’ */ ;
function replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== "text") continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            QUOTE_RE.lastIndex = pos;
            const t = QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === "softbreak" || tokens[j].type === "hardbreak") break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, _utilsMjs.isMdAsciiPunct)(lastChar) || (0, _utilsMjs.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, _utilsMjs.isMdAsciiPunct)(nextChar) || (0, _utilsMjs.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, _utilsMjs.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, _utilsMjs.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = replaceAt(token.content, t.index, APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
    }
}
function smartquotes(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== "inline" || !QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        process_inlines(state.tokens[blkIdx].children, state);
    }
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"jDivV":[function(require,module,exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>text_join);
function text_join(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== "inline") continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === "text_special") tokens[curr].type = "text";
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"agWWW":[function(require,module,exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rulerMjs = require("./ruler.mjs");
var _rulerMjsDefault = parcelHelpers.interopDefault(_rulerMjs);
var _stateBlockMjs = require("./rules_block/state_block.mjs");
var _stateBlockMjsDefault = parcelHelpers.interopDefault(_stateBlockMjs);
var _tableMjs = require("./rules_block/table.mjs");
var _tableMjsDefault = parcelHelpers.interopDefault(_tableMjs);
var _codeMjs = require("./rules_block/code.mjs");
var _codeMjsDefault = parcelHelpers.interopDefault(_codeMjs);
var _fenceMjs = require("./rules_block/fence.mjs");
var _fenceMjsDefault = parcelHelpers.interopDefault(_fenceMjs);
var _blockquoteMjs = require("./rules_block/blockquote.mjs");
var _blockquoteMjsDefault = parcelHelpers.interopDefault(_blockquoteMjs);
var _hrMjs = require("./rules_block/hr.mjs");
var _hrMjsDefault = parcelHelpers.interopDefault(_hrMjs);
var _listMjs = require("./rules_block/list.mjs");
var _listMjsDefault = parcelHelpers.interopDefault(_listMjs);
var _referenceMjs = require("./rules_block/reference.mjs");
var _referenceMjsDefault = parcelHelpers.interopDefault(_referenceMjs);
var _htmlBlockMjs = require("./rules_block/html_block.mjs");
var _htmlBlockMjsDefault = parcelHelpers.interopDefault(_htmlBlockMjs);
var _headingMjs = require("./rules_block/heading.mjs");
var _headingMjsDefault = parcelHelpers.interopDefault(_headingMjs);
var _lheadingMjs = require("./rules_block/lheading.mjs");
var _lheadingMjsDefault = parcelHelpers.interopDefault(_lheadingMjs);
var _paragraphMjs = require("./rules_block/paragraph.mjs");
var _paragraphMjsDefault = parcelHelpers.interopDefault(_paragraphMjs);
const _rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        "table",
        (0, _tableMjsDefault.default),
        [
            "paragraph",
            "reference"
        ]
    ],
    [
        "code",
        (0, _codeMjsDefault.default)
    ],
    [
        "fence",
        (0, _fenceMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "blockquote",
        (0, _blockquoteMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "hr",
        (0, _hrMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote",
            "list"
        ]
    ],
    [
        "list",
        (0, _listMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "reference",
        (0, _referenceMjsDefault.default)
    ],
    [
        "html_block",
        (0, _htmlBlockMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "heading",
        (0, _headingMjsDefault.default),
        [
            "paragraph",
            "reference",
            "blockquote"
        ]
    ],
    [
        "lheading",
        (0, _lheadingMjsDefault.default)
    ],
    [
        "paragraph",
        (0, _paragraphMjsDefault.default)
    ]
];
/**
 * new ParserBlock()
 **/ function ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, _rulerMjsDefault.default)();
    for(let i = 0; i < _rules.length; i++)this.ruler.push(_rules[i][0], _rules[i][1], {
        alt: (_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error("none of the block rules matched");
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
ParserBlock.prototype.State = (0, _stateBlockMjsDefault.default);
exports.default = ParserBlock;

},{"./ruler.mjs":"kz4mm","./rules_block/state_block.mjs":"1vldj","./rules_block/table.mjs":"hGlBZ","./rules_block/code.mjs":"9V69o","./rules_block/fence.mjs":"4cmUe","./rules_block/blockquote.mjs":"gonwZ","./rules_block/hr.mjs":"9IX7f","./rules_block/list.mjs":"6AQSo","./rules_block/reference.mjs":"fy3MN","./rules_block/html_block.mjs":"9yS7y","./rules_block/heading.mjs":"d2hjA","./rules_block/lheading.mjs":"epZoT","./rules_block/paragraph.mjs":"lscve","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1vldj":[function(require,module,exports) {
// Parser state class
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tokenMjs = require("../token.mjs");
var _tokenMjsDefault = parcelHelpers.interopDefault(_tokenMjs);
var _utilsMjs = require("../common/utils.mjs");
function StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = "root";
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, _utilsMjs.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, _tokenMjsDefault.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, _utilsMjs.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, _utilsMjs.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return "";
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, _utilsMjs.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(" ") + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join("");
};
// re-export Token class to use in block rules
StateBlock.prototype.Token = (0, _tokenMjsDefault.default);
exports.default = StateBlock;

},{"../token.mjs":"aeB7F","../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hGlBZ":[function(require,module,exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>table);
var _utilsMjs = require("../common/utils.mjs");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const MAX_AUTOCOMPLETED_CELLS = 0x10000;
function getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = "";
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = "";
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function table(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, _utilsMjs.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, _utilsMjs.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, _utilsMjs.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = getLine(state, startLine + 1);
    let columns = lineText.split("|");
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? "center" : "right");
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push("left");
        else aligns.push("");
    }
    lineText = getLine(state, startLine).trim();
    if (lineText.indexOf("|") === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = escapedSplit(lineText);
    if (columns.length && columns[0] === "") columns.shift();
    if (columns.length && columns[columns.length - 1] === "") columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = "table";
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const token_to = state.push("table_open", "table", 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push("thead_open", "thead", 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push("tr_open", "tr", 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push("th_open", "th", 1);
        if (aligns[i]) token_ho.attrs = [
            [
                "style",
                "text-align:" + aligns[i]
            ]
        ];
        const token_il = state.push("inline", "", 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push("th_close", "th", -1);
    }
    state.push("tr_close", "tr", -1);
    state.push("thead_close", "thead", -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = escapedSplit(lineText);
        if (columns.length && columns[0] === "") columns.shift();
        if (columns.length && columns[columns.length - 1] === "") columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push("tbody_open", "tbody", 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push("tr_open", "tr", 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push("td_open", "td", 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    "style",
                    "text-align:" + aligns[i]
                ]
            ];
            const token_il = state.push("inline", "", 0);
            token_il.content = columns[i] ? columns[i].trim() : "";
            token_il.children = [];
            state.push("td_close", "td", -1);
        }
        state.push("tr_close", "tr", -1);
    }
    if (tbodyLines) {
        state.push("tbody_close", "tbody", -1);
        tbodyLines[1] = nextLine;
    }
    state.push("table_close", "table", -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9V69o":[function(require,module,exports) {
// Code block (4 spaces padded)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>code);
function code(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push("code_block", "code", 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + "\n";
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"4cmUe":[function(require,module,exports) {
// fences (``` lang, ~~~ lang)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fence);
function fence(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push("fence", "code", 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"gonwZ":[function(require,module,exports) {
// Block quotes
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>blockquote);
var _utilsMjs = require("../common/utils.mjs");
function blockquote(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules("blockquote");
    const oldParentType = state.parentType;
    state.parentType = "blockquote";
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, _utilsMjs.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push("blockquote_open", "blockquote", 1);
    token_o.markup = ">";
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push("blockquote_close", "blockquote", -1);
    token_c.markup = ">";
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9IX7f":[function(require,module,exports) {
// Horizontal rule
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>hr);
var _utilsMjs = require("../common/utils.mjs");
function hr(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, _utilsMjs.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push("hr", "hr", 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"6AQSo":[function(require,module,exports) {
// Lists
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>list);
var _utilsMjs = require("../common/utils.mjs");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, _utilsMjs.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, _utilsMjs.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === "paragraph_open") {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function list(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === "paragraph") // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push("ordered_list_open", "ol", 1);
        if (markerValue !== 1) token.attrs = [
            [
                "start",
                markerValue
            ]
        ];
    } else token = state.push("bullet_list_open", "ul", 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules("list");
    const oldParentType = state.parentType;
    state.parentType = "list";
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push("list_item_open", "li", 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push("list_item_close", "li", -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push("ordered_list_close", "ol", -1);
    else token = state.push("bullet_list_close", "ul", -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) markTightParagraphs(state, listTokIdx);
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"fy3MN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>reference);
var _utilsMjs = require("../common/utils.mjs");
function reference(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules("reference");
            const oldParentType = state.parentType;
            state.parentType = "reference";
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, _utilsMjs.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, _utilsMjs.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = "";
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, _utilsMjs.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = "";
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, _utilsMjs.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, _utilsMjs.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === "undefined") state.env.references = {};
    if (typeof state.env.references[label] === "undefined") state.env.references[label] = {
        title,
        href
    };
    state.line = nextLine;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"9yS7y":[function(require,module,exports) {
// HTML block
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>html_block);
var _htmlBlocksMjs = require("../common/html_blocks.mjs");
var _htmlBlocksMjsDefault = parcelHelpers.interopDefault(_htmlBlocksMjs);
var _htmlReMjs = require("../common/html_re.mjs");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp("^</?(" + (0, _htmlBlocksMjsDefault.default).join("|") + ")(?=(\\s|/?>|$))", "i"),
        /^$/,
        true
    ],
    [
        new RegExp((0, _htmlReMjs.HTML_OPEN_CLOSE_TAG_RE).source + "\\s*$"),
        /^$/,
        false
    ]
];
function html_block(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < HTML_SEQUENCES.length; i++){
        if (HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if (HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push("html_block", "", 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

},{"../common/html_blocks.mjs":"885Fw","../common/html_re.mjs":"2nyGv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"885Fw":[function(require,module,exports) {
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2nyGv":[function(require,module,exports) {
// Regexps to match html elements
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTML_TAG_RE", ()=>HTML_TAG_RE);
parcelHelpers.export(exports, "HTML_OPEN_CLOSE_TAG_RE", ()=>HTML_OPEN_CLOSE_TAG_RE);
const attr_name = "[a-zA-Z_:][a-zA-Z0-9:._-]*";
const unquoted = "[^\"'=<>`\\x00-\\x20]+";
const single_quoted = "'[^']*'";
const double_quoted = '"[^"]*"';
const attr_value = "(?:" + unquoted + "|" + single_quoted + "|" + double_quoted + ")";
const attribute = "(?:\\s+" + attr_name + "(?:\\s*=\\s*" + attr_value + ")?)";
const open_tag = "<[A-Za-z][A-Za-z0-9\\-]*" + attribute + "*\\s*\\/?>";
const close_tag = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>";
const comment = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->";
const processing = "<[?][\\s\\S]*?[?]>";
const declaration = "<![A-Za-z][^>]*>";
const cdata = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>";
const HTML_TAG_RE = new RegExp("^(?:" + open_tag + "|" + close_tag + "|" + comment + "|" + processing + "|" + declaration + "|" + cdata + ")");
const HTML_OPEN_CLOSE_TAG_RE = new RegExp("^(?:" + open_tag + "|" + close_tag + ")");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"d2hjA":[function(require,module,exports) {
// heading (#, ##, ...)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>heading);
var _utilsMjs = require("../common/utils.mjs");
function heading(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, _utilsMjs.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, _utilsMjs.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = "########".slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = "########".slice(0, level);
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"epZoT":[function(require,module,exports) {
// lheading (---, ===)
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>lheading);
function lheading(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = "paragraph" // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push("heading_open", "h" + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push("heading_close", "h" + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lscve":[function(require,module,exports) {
// Paragraph
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>paragraph);
function paragraph(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules("paragraph");
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = "paragraph";
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push("paragraph_open", "p", 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push("inline", "", 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push("paragraph_close", "p", -1);
    state.parentType = oldParentType;
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1AWMr":[function(require,module,exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rulerMjs = require("./ruler.mjs");
var _rulerMjsDefault = parcelHelpers.interopDefault(_rulerMjs);
var _stateInlineMjs = require("./rules_inline/state_inline.mjs");
var _stateInlineMjsDefault = parcelHelpers.interopDefault(_stateInlineMjs);
var _textMjs = require("./rules_inline/text.mjs");
var _textMjsDefault = parcelHelpers.interopDefault(_textMjs);
var _linkifyMjs = require("./rules_inline/linkify.mjs");
var _linkifyMjsDefault = parcelHelpers.interopDefault(_linkifyMjs);
var _newlineMjs = require("./rules_inline/newline.mjs");
var _newlineMjsDefault = parcelHelpers.interopDefault(_newlineMjs);
var _escapeMjs = require("./rules_inline/escape.mjs");
var _escapeMjsDefault = parcelHelpers.interopDefault(_escapeMjs);
var _backticksMjs = require("./rules_inline/backticks.mjs");
var _backticksMjsDefault = parcelHelpers.interopDefault(_backticksMjs);
var _strikethroughMjs = require("./rules_inline/strikethrough.mjs");
var _strikethroughMjsDefault = parcelHelpers.interopDefault(_strikethroughMjs);
var _emphasisMjs = require("./rules_inline/emphasis.mjs");
var _emphasisMjsDefault = parcelHelpers.interopDefault(_emphasisMjs);
var _linkMjs = require("./rules_inline/link.mjs");
var _linkMjsDefault = parcelHelpers.interopDefault(_linkMjs);
var _imageMjs = require("./rules_inline/image.mjs");
var _imageMjsDefault = parcelHelpers.interopDefault(_imageMjs);
var _autolinkMjs = require("./rules_inline/autolink.mjs");
var _autolinkMjsDefault = parcelHelpers.interopDefault(_autolinkMjs);
var _htmlInlineMjs = require("./rules_inline/html_inline.mjs");
var _htmlInlineMjsDefault = parcelHelpers.interopDefault(_htmlInlineMjs);
var _entityMjs = require("./rules_inline/entity.mjs");
var _entityMjsDefault = parcelHelpers.interopDefault(_entityMjs);
var _balancePairsMjs = require("./rules_inline/balance_pairs.mjs");
var _balancePairsMjsDefault = parcelHelpers.interopDefault(_balancePairsMjs);
var _fragmentsJoinMjs = require("./rules_inline/fragments_join.mjs");
var _fragmentsJoinMjsDefault = parcelHelpers.interopDefault(_fragmentsJoinMjs);
// Parser rules
const _rules = [
    [
        "text",
        (0, _textMjsDefault.default)
    ],
    [
        "linkify",
        (0, _linkifyMjsDefault.default)
    ],
    [
        "newline",
        (0, _newlineMjsDefault.default)
    ],
    [
        "escape",
        (0, _escapeMjsDefault.default)
    ],
    [
        "backticks",
        (0, _backticksMjsDefault.default)
    ],
    [
        "strikethrough",
        (0, _strikethroughMjsDefault.default).tokenize
    ],
    [
        "emphasis",
        (0, _emphasisMjsDefault.default).tokenize
    ],
    [
        "link",
        (0, _linkMjsDefault.default)
    ],
    [
        "image",
        (0, _imageMjsDefault.default)
    ],
    [
        "autolink",
        (0, _autolinkMjsDefault.default)
    ],
    [
        "html_inline",
        (0, _htmlInlineMjsDefault.default)
    ],
    [
        "entity",
        (0, _entityMjsDefault.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const _rules2 = [
    [
        "balance_pairs",
        (0, _balancePairsMjsDefault.default)
    ],
    [
        "strikethrough",
        (0, _strikethroughMjsDefault.default).postProcess
    ],
    [
        "emphasis",
        (0, _emphasisMjsDefault.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        "fragments_join",
        (0, _fragmentsJoinMjsDefault.default)
    ]
];
/**
 * new ParserInline()
 **/ function ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, _rulerMjsDefault.default)();
    for(let i = 0; i < _rules.length; i++)this.ruler.push(_rules[i][0], _rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, _rulerMjsDefault.default)();
    for(let i = 0; i < _rules2.length; i++)this.ruler2.push(_rules2[i][0], _rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== "undefined") {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules("");
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules("");
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
ParserInline.prototype.State = (0, _stateInlineMjsDefault.default);
exports.default = ParserInline;

},{"./ruler.mjs":"kz4mm","./rules_inline/state_inline.mjs":"7ngds","./rules_inline/text.mjs":"815K6","./rules_inline/linkify.mjs":"8Sp96","./rules_inline/newline.mjs":"2jfYT","./rules_inline/escape.mjs":"c4LOf","./rules_inline/backticks.mjs":"lwRuE","./rules_inline/strikethrough.mjs":"cHLgz","./rules_inline/emphasis.mjs":"a9Hxm","./rules_inline/link.mjs":"dBw4K","./rules_inline/image.mjs":"2jRFe","./rules_inline/autolink.mjs":"kH6Bh","./rules_inline/html_inline.mjs":"a7Aq2","./rules_inline/entity.mjs":"5bWyI","./rules_inline/balance_pairs.mjs":"aDnOb","./rules_inline/fragments_join.mjs":"dtSuB","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"7ngds":[function(require,module,exports) {
// Inline parser state
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tokenMjs = require("../token.mjs");
var _tokenMjsDefault = parcelHelpers.interopDefault(_tokenMjs);
var _utilsMjs = require("../common/utils.mjs");
function StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = "";
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
StateInline.prototype.pushPending = function() {
    const token = new (0, _tokenMjsDefault.default)("text", "", 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = "";
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, _tokenMjsDefault.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, _utilsMjs.isMdAsciiPunct)(lastChar) || (0, _utilsMjs.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, _utilsMjs.isMdAsciiPunct)(nextChar) || (0, _utilsMjs.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, _utilsMjs.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, _utilsMjs.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open,
        can_close,
        length: count
    };
};
// re-export Token class to use in block rules
StateInline.prototype.Token = (0, _tokenMjsDefault.default);
exports.default = StateInline;

},{"../token.mjs":"aeB7F","../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"815K6":[function(require,module,exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>text);
function isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function text(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8Sp96":[function(require,module,exports) {
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>linkify);
const SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function linkify(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match(SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, "");
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push("link_open", "a", 1);
        token_o.attrs = [
            [
                "href",
                fullUrl
            ]
        ];
        token_o.markup = "linkify";
        token_o.info = "auto";
        const token_t = state.push("text", "", 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push("link_close", "a", -1);
        token_c.markup = "linkify";
        token_c.info = "auto";
    }
    state.pos += url.length - proto.length;
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jfYT":[function(require,module,exports) {
// Proceess '\n'
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>newline);
var _utilsMjs = require("../common/utils.mjs");
function newline(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push("hardbreak", "br", 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push("softbreak", "br", 0);
            }
        } else state.push("softbreak", "br", 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, _utilsMjs.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"c4LOf":[function(require,module,exports) {
// Process escaped chars and hardbreaks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>escape);
var _utilsMjs = require("../common/utils.mjs");
const ESCAPED = [];
for(let i = 0; i < 256; i++)ESCAPED.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(ch) {
    ESCAPED[ch.charCodeAt(0)] = 1;
});
function escape(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push("hardbreak", "br", 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, _utilsMjs.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = "\\" + escapedStr;
    if (!silent) {
        const token = state.push("text_special", "", 0);
        if (ch1 < 256 && ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = "escape";
    }
    state.pos = pos + 1;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"lwRuE":[function(require,module,exports) {
// Parse backticks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>backtick);
function backtick(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf("`", matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push("code_inline", "code", 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"cHLgz":[function(require,module,exports) {
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push("text", "", 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push("text", "", 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = "s_open";
        token.tag = "s";
        token.nesting = 1;
        token.markup = "~~";
        token.content = "";
        token = state.tokens[endDelim.token];
        token.type = "s_close";
        token.tag = "s";
        token.nesting = -1;
        token.markup = "~~";
        token.content = "";
        if (state.tokens[endDelim.token - 1].type === "text" && state.tokens[endDelim.token - 1].content === "~") loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === "s_close")j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess(state, tokens_meta[curr].delimiters);
}
exports.default = {
    tokenize: strikethrough_tokenize,
    postProcess: strikethrough_postProcess
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a9Hxm":[function(require,module,exports) {
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push("text", "", 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? "strong_open" : "em_open";
        token_o.tag = isStrong ? "strong" : "em";
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = "";
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? "strong_close" : "em_close";
        token_c.tag = isStrong ? "strong" : "em";
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = "";
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = "";
            state.tokens[delimiters[startDelim.end + 1].token].content = "";
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) postProcess(state, tokens_meta[curr].delimiters);
}
exports.default = {
    tokenize: emphasis_tokenize,
    postProcess: emphasis_post_process
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dBw4K":[function(require,module,exports) {
// Process [link](<to> "stuff")
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>link);
var _utilsMjs = require("../common/utils.mjs");
function link(state, silent) {
    let code, label, res, ref;
    let href = "";
    let title = "";
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, _utilsMjs.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push("link_open", "a", 1);
        const attrs = [
            [
                "href",
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            "title",
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push("link_close", "a", -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"2jRFe":[function(require,module,exports) {
// Process ![image](<src> "title")
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>image);
var _utilsMjs = require("../common/utils.mjs");
function image(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = "";
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = "";
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, _utilsMjs.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = "";
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === "undefined") return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, _utilsMjs.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push("image", "img", 0);
        const attrs = [
            [
                "src",
                href
            ],
            [
                "alt",
                ""
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            "title",
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

},{"../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"kH6Bh":[function(require,module,exports) {
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>autolink);
const EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function autolink(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if (AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    if (EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink("mailto:" + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push("link_open", "a", 1);
            token_o.attrs = [
                [
                    "href",
                    fullUrl
                ]
            ];
            token_o.markup = "autolink";
            token_o.info = "auto";
            const token_t = state.push("text", "", 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push("link_close", "a", -1);
            token_c.markup = "autolink";
            token_c.info = "auto";
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"a7Aq2":[function(require,module,exports) {
// Process html tags
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>html_inline);
var _htmlReMjs = require("../common/html_re.mjs");
function isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function html_inline(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, _htmlReMjs.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push("html_inline", "", 0);
        token.content = match[0];
        if (isLinkOpen(token.content)) state.linkLevel++;
        if (isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

},{"../common/html_re.mjs":"2nyGv","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"5bWyI":[function(require,module,exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>entity);
var _entities = require("entities");
var _utilsMjs = require("../common/utils.mjs");
const DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function entity(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match(DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === "x" ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push("text_special", "", 0);
                token.content = (0, _utilsMjs.isValidEntityCode)(code) ? (0, _utilsMjs.fromCodePoint)(code) : (0, _utilsMjs.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = "entity";
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match(NAMED_RE);
        if (match) {
            const decoded = (0, _entities.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push("text_special", "", 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = "entity";
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

},{"entities":"a1e5s","../common/utils.mjs":"aLKqx","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"aDnOb":[function(require,module,exports) {
// For each opening emphasis-like marker find a matching closing one
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>link_pairs);
function processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function link_pairs(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) processDelimiters(tokens_meta[curr].delimiters);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"dtSuB":[function(require,module,exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>fragments_join);
function fragments_join(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === "text" && curr + 1 < max && tokens[curr + 1].type === "text") // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"an4mX":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _reMjs = require("./lib/re.mjs");
var _reMjsDefault = parcelHelpers.interopDefault(_reMjs);
//
// Helpers
//
// Merge objects
//
function assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function _class(obj) {
    return Object.prototype.toString.call(obj);
}
function isString(obj) {
    return _class(obj) === "[object String]";
}
function isObject(obj) {
    return _class(obj) === "[object Object]";
}
function isRegExp(obj) {
    return _class(obj) === "[object RegExp]";
}
function isFunction(obj) {
    return _class(obj) === "[object Function]";
}
function escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || defaultOptions.hasOwnProperty(k);
    }, false);
}
const defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, _reMjsDefault.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push(tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if (isObject(val)) {
            if (isRegExp(val.validate)) compiled.validate = createValidator(val.validate);
            else if (isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if (isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = createNormalizer();
            else schemaError(name, val);
            return;
        }
        if (isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map(escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function createMatch(self, shift) {
    const match = new Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function LinkifyIt(schemas, options) {
    if (!(this instanceof LinkifyIt)) return new LinkifyIt(schemas, options);
    if (!options) {
        if (isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = assign({}, defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = assign({}, defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push(createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push(createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ LinkifyIt.prototype.onCompile = function onCompile() {};
exports.default = LinkifyIt;

},{"./lib/re.mjs":"hFyzr","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hFyzr":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(opts) {
        const re = {};
        opts = opts || {};
        re.src_Any = (0, _ucMicro.Any).source;
        re.src_Cc = (0, _ucMicro.Cc).source;
        re.src_Z = (0, _ucMicro.Z).source;
        re.src_P = (0, _ucMicro.P).source;
        // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
        re.src_ZPCc = [
            re.src_Z,
            re.src_P,
            re.src_Cc
        ].join("|");
        // \p{\Z\Cc} (white spaces + control)
        re.src_ZCc = [
            re.src_Z,
            re.src_Cc
        ].join("|");
        // Experimental. List of chars, completely prohibited in links
        // because can separate it from other part of text
        const text_separators = "[><\uFF5C]";
        // All possible word characters (everything without punctuation, spaces & controls)
        // Defined via punctuation & spaces to save space
        // Should be something like \p{\L\N\S\M} (\w but without `_`)
        re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
        // The same as abothe but without [0-9]
        // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
        re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
        // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
        re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
        re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
        re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
        re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
        "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
        // github has ... in commit range links,
        // Restrict to
        // - english
        // - percent-encoded
        // - parts of file path
        // - params separator
        // until more examples found.
        "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
         : "\\-+|") + // allow `,,,` in paths
        ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
        ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
        "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
        // Allow anything in markdown spec, forbid quote (") at the first position
        // because emails enclosed in quotes are far more common
        re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
        re.src_xn = "xn--[a-z0-9\\-]{1,59}";
        // More to read about domain names
        // http://serverfault.com/questions/638260/
        re.src_domain_root = // Allow letters & digits (http://test1)
        "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
        re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
        re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
        re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
        re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
        re.src_host_strict = re.src_host + re.src_host_terminator;
        re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
        re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
        re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
        re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
        //
        // Main rules
        //
        // Rude test fuzzy links by host, for quick deny
        re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
        re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
        re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
        // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
        re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
        // but can start with > (markdown blockquote)
        "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
        return re;
    });
var _ucMicro = require("uc.micro");

},{"uc.micro":"jfhGG","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"ZahMt":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ucs2decode", ()=>ucs2decode);
parcelHelpers.export(exports, "ucs2encode", ()=>ucs2encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "toASCII", ()=>toASCII);
parcelHelpers.export(exports, "toUnicode", ()=>toUnicode);
"use strict";
/** Highest positive signed 32-bit float value */ const maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const base = 36;
const tMin = 1;
const tMax = 26;
const skew = 38;
const damp = 700;
const initialBias = 72;
const initialN = 128; // 0x80
const delimiter = "-"; // '\x2D'
/** Regular expressions */ const regexPunycode = /^xn--/;
const regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const baseMinusTMin = base - tMin;
const floor = Math.floor;
const stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error(type) {
    throw new RangeError(errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function mapDomain(domain, callback) {
    const parts = domain.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace(regexSeparators, ".");
    const labels = domain.split(".");
    const encoded = map(labels, callback).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const ucs2encode = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? floor(delta / damp) : delta >> 1;
    delta += floor(delta / numPoints);
    for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
    return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = initialN;
    let bias = initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf(delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = base;; k += base){
            if (index >= inputLength) error("invalid-input");
            const digit = basicToDigit(input.charCodeAt(index++));
            if (digit >= base) error("invalid-input");
            if (digit > floor((maxInt - i) / w)) error("overflow");
            i += digit * w;
            const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = base - t;
            if (w > floor(maxInt / baseMinusT)) error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (floor(i / out) > maxInt - n) error("overflow");
        n += floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = ucs2decode(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = initialN;
    let delta = 0;
    let bias = initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push(delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > maxInt) error("overflow");
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = base;; k += base){
                    const t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = base - t;
                    output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = floor(qMinusT / baseMinusT);
                }
                output.push(stringFromCharCode(digitToBasic(q, 0)));
                bias = adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const toUnicode = function(input) {
    return mapDomain(input, function(string) {
        return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const toASCII = function(input) {
    return mapDomain(input, function(string) {
        return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.3.1",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": ucs2decode,
        "encode": ucs2encode
    },
    "decode": decode,
    "encode": encode,
    "toASCII": toASCII,
    "toUnicode": toUnicode
};
exports.default = punycode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8V0NV":[function(require,module,exports) {
// markdown-it default options
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"yCiad":[function(require,module,exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "text"
            ],
            rules2: [
                "balance_pairs",
                "fragments_join"
            ]
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"duEbi":[function(require,module,exports) {
// Commonmark default options
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: "language-",
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: "\u201C\u201D\u2018\u2019",
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                "normalize",
                "block",
                "inline",
                "text_join"
            ]
        },
        block: {
            rules: [
                "blockquote",
                "code",
                "fence",
                "heading",
                "hr",
                "html_block",
                "lheading",
                "list",
                "reference",
                "paragraph"
            ]
        },
        inline: {
            rules: [
                "autolink",
                "backticks",
                "emphasis",
                "entity",
                "escape",
                "html_inline",
                "image",
                "link",
                "newline",
                "text"
            ],
            rules2: [
                "balance_pairs",
                "emphasis",
                "fragments_join"
            ]
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8MbZw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = [
    "innerHTML"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return $setup.state.isMappableValue ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        key: 0,
        class: (0, _vue.normalizeClass)({
            barLabel: true,
            "barLabel--primary": $setup.state.value === "complete",
            "barLabel--secondary": $setup.state.value === "inProgress",
            "barLabel--pale": $setup.state.value === "notStarted"
        })
    }, (0, _vue.toDisplayString)($props.input), 3)) : ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", {
        key: 1,
        innerHTML: $setup.markdown.renderInline($props.input)
    }, null, 8, _hoisted_1));
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"1vIY5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8eZqq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "tabTable"
};
const _hoisted_2 = {
    class: "data__figure data__figure--table"
};
const _hoisted_3 = [
    "id"
];
const _hoisted_4 = {
    key: 0,
    class: "table__thead"
};
const _hoisted_5 = {
    class: "table__headerRow"
};
const _hoisted_6 = [
    "align",
    "width"
];
const _hoisted_7 = {
    key: 0
};
const _hoisted_8 = {
    key: 1
};
const _hoisted_9 = {
    key: 1
};
const _hoisted_10 = {
    class: "table__bodyRow"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_1, [
        $setup.state.tabs.length && $setup.state.tabs.length > 1 ? ((0, _vue.openBlock)(), (0, _vue.createBlock)($setup["Tabs"], {
            key: 0,
            tabs: $setup.state.tabs,
            onTabChanged: $setup.tabChanged,
            theme: $props.theme,
            controls: $props.tableId
        }, null, 8, [
            "tabs",
            "theme",
            "controls"
        ])) : (0, _vue.createCommentVNode)("", true),
        (0, _vue.createElementVNode)("div", _hoisted_2, [
            $setup.table ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("table", {
                key: 0,
                class: "table table--stripped",
                id: $props.tableId,
                "aria-live": "polite"
            }, [
                $setup.cols ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("thead", _hoisted_4, [
                    (0, _vue.createElementVNode)("tr", _hoisted_5, [
                        ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.cols, (col, i)=>{
                            return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("th", {
                                align: col.align,
                                width: col.width,
                                class: "table__th table__cell table__colHeader",
                                scope: "col"
                            }, [
                                i > 0 && $setup.table.prefix ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_7, "(" + (0, _vue.toDisplayString)($setup.table.prefix) + ")\xa0", 1)) : (0, _vue.createCommentVNode)("", true),
                                (0, _vue.createTextVNode)((0, _vue.toDisplayString)(col.heading), 1),
                                i > 0 && $setup.table.append ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("span", _hoisted_8, "\xa0(" + (0, _vue.toDisplayString)($setup.table.append) + ")", 1)) : (0, _vue.createCommentVNode)("", true)
                            ], 8, _hoisted_6);
                        }), 256))
                    ])
                ])) : (0, _vue.createCommentVNode)("", true),
                $setup.rows ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("tbody", _hoisted_9, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($setup.rows, (row)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("tr", _hoisted_10, [
                            ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)(row, (cell, cellIndex)=>{
                                return (0, _vue.openBlock)(), (0, _vue.createBlock)((0, _vue.resolveDynamicComponent)($setup.table.firstColAsHeader && cellIndex === 0 ? "th" : "td"), {
                                    class: "table__td table__cell",
                                    scope: $setup.table.firstColAsHeader && cellIndex === 0 ? "row" : "",
                                    style: (0, _vue.normalizeStyle)({
                                        textAlign: $setup.getCellAlignment(cellIndex)
                                    })
                                }, {
                                    default: (0, _vue.withCtx)(()=>[
                                            (0, _vue.createVNode)($setup["TrendingIndicator"], {
                                                input: $setup.normalizeCell(cell, cellIndex)
                                            }, null, 8, [
                                                "input"
                                            ])
                                        ]),
                                    _: 2
                                }, 1032, [
                                    "scope",
                                    "style"
                                ]);
                            }), 256))
                        ]);
                    }), 256))
                ])) : (0, _vue.createCommentVNode)("", true)
            ], 8, _hoisted_3)) : (0, _vue.createCommentVNode)("", true)
        ])
    ]);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"21Xzp":[function() {},{}],"dC4MO":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"8vJM0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "render", ()=>render);
var _vue = require("vue");
const _hoisted_1 = {
    class: "data__header"
};
const _hoisted_2 = {
    class: "data__title"
};
const _hoisted_3 = [
    "href"
];
const _hoisted_4 = [
    "innerHTML"
];
const _hoisted_5 = [
    "id"
];
const _hoisted_6 = {
    class: "data__figureContainer"
};
const _hoisted_7 = {
    class: "data__selectDatasetButtons inlineList"
};
const _hoisted_8 = [
    "value",
    "innerHTML"
];
const _hoisted_9 = {
    key: 0,
    class: "chart-interaction"
};
const _hoisted_10 = [
    "id"
];
const _hoisted_11 = {
    class: "data__figureContainer"
};
const _hoisted_12 = {
    class: "data__controls chartControls",
    "data-html2canvas-ignore": ""
};
const _hoisted_13 = {
    class: "inlineList chartControls__buttons"
};
const _hoisted_14 = [
    "href"
];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)((0, _vue.Fragment), null, [
        (0, _vue.createElementVNode)("header", _hoisted_1, [
            (0, _vue.createElementVNode)("h1", _hoisted_2, [
                (0, _vue.createElementVNode)("a", {
                    href: $props.permalink,
                    class: "waldoLink",
                    target: "_blank",
                    title: "View chart in a new tab."
                }, [
                    (0, _vue.createTextVNode)((0, _vue.toDisplayString)($props.title) + " ", 1),
                    _cache[0] || (_cache[0] = (0, _vue.createElementVNode)("sup", {
                        class: "appendedIcon supIcon"
                    }, [
                        (0, _vue.createTextVNode)("\u200D"),
                        (0, _vue.createElementVNode)("i", {
                            class: "far fa-external-link-alt"
                        }),
                        (0, _vue.createTextVNode)("\u200D")
                    ], -1))
                ], 8, _hoisted_3)
            ]),
            $props.subtitle ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("p", {
                key: 0,
                class: "data__subtitle",
                innerHTML: $props.subtitle
            }, null, 8, _hoisted_4)) : (0, _vue.createCommentVNode)("", true)
        ]),
        (0, _vue.createVNode)($setup["Tabs"], {
            tabs: $setup.state.tabs,
            onTabChanged: $setup.tabChanged,
            controls: "figureContainer-" + $props.slug
        }, null, 8, [
            "tabs",
            "controls"
        ]),
        (0, _vue.createElementVNode)("section", {
            class: "data__figures",
            id: "figureContainer-" + $props.slug
        }, [
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("section", _hoisted_6, [
                (0, _vue.createElementVNode)("div", _hoisted_7, [
                    ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.buttonTitles, (buttonTitle, index)=>{
                        return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("button", {
                            class: (0, _vue.normalizeClass)([
                                "chart-switcher buttonLink",
                                {
                                    activeView: index === 0
                                }
                            ]),
                            value: index,
                            innerHTML: buttonTitle
                        }, null, 10, _hoisted_8);
                    }), 256))
                ]),
                (0, _vue.renderSlot)(_ctx.$slots, "loading", {}, ()=>[
                        _cache[1] || (_cache[1] = (0, _vue.createElementVNode)("div", {
                            class: "figurePlaceholder chartPlaceholder"
                        }, [
                            (0, _vue.createElementVNode)("div", {
                                class: "figurePlaceholder__content"
                            }, [
                                (0, _vue.createElementVNode)("span", {
                                    class: "figurePlaceholder__loading"
                                }, "Loading")
                            ])
                        ], -1))
                    ]),
                (0, _vue.createVNode)($setup["Chart"], {
                    "src-url": $props.jsonUrl,
                    slug: $props.slug,
                    ref: "chart",
                    margin: $props.chartMargin
                }, null, 8, [
                    "src-url",
                    "slug",
                    "margin"
                ]),
                $props.showLegend ? ((0, _vue.openBlock)(), (0, _vue.createElementBlock)("div", _hoisted_9, [
                    (0, _vue.createElementVNode)("div", {
                        class: "chart-legend",
                        id: $props.legendId + "-legend"
                    }, null, 8, _hoisted_10)
                ])) : (0, _vue.createCommentVNode)("", true)
            ], 512), [
                [
                    (0, _vue.vShow),
                    $setup.state.activeTableIndex === 0
                ]
            ]),
            (0, _vue.withDirectives)((0, _vue.createElementVNode)("section", _hoisted_11, [
                (0, _vue.createVNode)($setup["TabTable"], {
                    "tables-data": $props.data,
                    theme: $props.buttonTitles.length > 1 ? "buttons" : ""
                }, null, 8, [
                    "tables-data",
                    "theme"
                ])
            ], 512), [
                [
                    (0, _vue.vShow),
                    $setup.state.activeTableIndex === 1
                ]
            ])
        ], 8, _hoisted_5),
        (0, _vue.createElementVNode)("div", _hoisted_12, [
            (0, _vue.createElementVNode)("div", _hoisted_13, [
                _cache[4] || (_cache[4] = (0, _vue.createElementVNode)("h2", {
                    class: "chartControls__title"
                }, "Downloads:", -1)),
                ((0, _vue.openBlock)(true), (0, _vue.createElementBlock)((0, _vue.Fragment), null, (0, _vue.renderList)($props.downloads, (download)=>{
                    return (0, _vue.openBlock)(), (0, _vue.createElementBlock)("a", {
                        href: download.file,
                        class: "button button--primary button--small"
                    }, [
                        _cache[2] || (_cache[2] = (0, _vue.createElementVNode)("span", {
                            class: "prependedIcon"
                        }, [
                            (0, _vue.createElementVNode)("i", {
                                class: "fas fa-download"
                            }),
                            (0, _vue.createTextVNode)("\u200D")
                        ], -1)),
                        (0, _vue.createTextVNode)((0, _vue.toDisplayString)(download.linkText), 1)
                    ], 8, _hoisted_14);
                }), 256)),
                (0, _vue.createElementVNode)("button", {
                    class: "button button--primary button--small",
                    onClick: $setup.takeSnapshot
                }, _cache[3] || (_cache[3] = [
                    (0, _vue.createElementVNode)("span", {
                        class: "prependedIcon"
                    }, [
                        (0, _vue.createElementVNode)("i", {
                            class: "fas fa-download"
                        }),
                        (0, _vue.createTextVNode)("\u200D")
                    ], -1),
                    (0, _vue.createTextVNode)("Screenshot (.png) ")
                ]))
            ])
        ])
    ], 64);
}

},{"vue":"2IF1a","@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}],"hlYYQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let NOOP = ()=>{};
exports.default = (script)=>{};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"k3151"}]},["fwA1h"], "fwA1h", "parcelRequire89bf")

//# sourceMappingURL=chart-app.js.map
